
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("OCz5m", function(module, exports) {
/* editorSSRExtensionHandlers.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $h9yJL = parcelRequire("h9yJL");


var $bQm3c = parcelRequire("bQm3c");


var $dPJCf = parcelRequire("dPJCf");


var $5kjCz = parcelRequire("5kjCz");


var $dwS6P = parcelRequire("dwS6P");

const $e673ff442c42ddbb$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41ajq _bfhksm61",
            __cmplp.className
        ])
    });
});
const $e673ff442c42ddbb$var$createEditorSSRExtensionHandlers = ({ contentId: contentId, spaceKey: spaceKey, cloudId: cloudId, userId: userId })=>{
    return {
        'com.atlassian.confluence.macro.core': (extension, doc)=>{
            const { extensionKey: extensionKey } = extension;
            const attributes = (0, $5kjCz.getMacroAttributesFromADFNode)(extension);
            const macroDefaultProps = {
                mode: (0, $5kjCz.EDITOR),
                node: extension,
                extensionKey: extensionKey,
                attributes: attributes,
                references: [],
                contentId: contentId,
                spaceKey: spaceKey
            };
            if (extensionKey === 'toc') {
                const editorTransformer = new (0, $h9yJL.JSONTransformer)();
                const adf = editorTransformer.encode(doc);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e673ff442c42ddbb$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dwS6P.TableOfContentsLoader), {
                    isInEditMode: true,
                    adf: adf,
                    userId: userId || '',
                    cloudId: cloudId,
                    macroDefaultProps: macroDefaultProps
                }));
            }
            // Unsupported (yet) extensions should default to existing provider-based handling
            // and rendering on a client side only.
            return null;
        }
    };
};
const $e673ff442c42ddbb$export$206691819bb24df7 = (contentId, spaceKey, extensionProviders)=>{
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const [providersReady, setProvidersReady] = (0, $42omo.useState)(false);
    const isTransition = (0, $dPJCf.useIsTransition)();
    (0, $42omo.useEffect)(()=>{
        const providerPromises = extensionProviders?.map((provider)=>{
            return typeof provider.manifestsPromise !== 'undefined' ? provider.manifestsPromise : provider;
        });
        Promise.all(providerPromises).then(()=>setProvidersReady(true)).catch((_error)=>{
            // NOOP: Here, if any of the provider promises fail, the best we can do is to
            // fall back the original experience where macros are resolved and rendered on
            // the client only, although in this case the extensions experience would likely
            // be hosed anyway.
            setProvidersReady(true);
        });
    }, [
        extensionProviders
    ]);
    const extensionHandlers = (0, $42omo.useMemo)(()=>$e673ff442c42ddbb$var$createEditorSSRExtensionHandlers({
            contentId: contentId,
            spaceKey: spaceKey,
            cloudId: cloudId,
            userId: userId
        }), [
        contentId,
        spaceKey,
        cloudId,
        userId
    ]);
    return isTransition || providersReady ? undefined : extensionHandlers;
};
module.exports["useEditorSSRExtensionHandlers"] = $e673ff442c42ddbb$export$206691819bb24df7;

});

parcelRegister("jFkNO", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9wGTI = parcelRequire("9wGTI");


var $1ITQ3 = parcelRequire("1ITQ3");

const $bbc19db46e52068c$var$FORGE_VIEWPORT_SIZES = [
    'small',
    'medium',
    'default',
    'large',
    'xlarge'
];
const $bbc19db46e52068c$var$FORGE_MANIFEST_VIEWPORT_HEIGHTS = {
    small: '112px',
    medium: '262px',
    default: '262px',
    large: '524px',
    xlarge: '1048px'
};
/**
 * Currently, very few legacy (connect) macros provide their expected rendered height/width
 * values in their macro parameters. Of those that do, there's a slight but consistent
 * margin of error for the height value. Others that don't render dynamic content we can
 * set a default height for (such as Miro embed).
 *
 * Any changes here should be mirrored in content-renderer-legacy-macros/src/useConnectExtensionViewportSize.ts
 * and getCalculatedHeightFromNode.ts
 */ const $bbc19db46e52068c$var$DRAW_IO_HEIGHT_OFFSET = 52;
const $bbc19db46e52068c$var$GOOGLE_DRIVE_EMBED_FILE_OFFSET_HEIGHT = 79;
const $bbc19db46e52068c$var$PLANTUML_OFFSET_HEIGHT = 40;
// Default sizes
const $bbc19db46e52068c$var$MIRO_EMBED_DEFAULT_HEIGHT = 570;
const $bbc19db46e52068c$var$EASY_MATH_BLOCK_DEFAULT_HEIGHT = 47;
const $bbc19db46e52068c$var$MATH_BLOCK_DEFAULT_HEIGHT = 58;
const $bbc19db46e52068c$var$PAGE_SIGNATURES_DEFAULT_HEIGHT = 23;
const $bbc19db46e52068c$var$QUESTIONS_LIST_DEFAULT_HEIGHT = 800;
const $bbc19db46e52068c$var$JIRA_ROADMAP_DEFAULT_HEIGHT = 600;
const $bbc19db46e52068c$var$LUCID_CHART_DEFAULT_HEIGHT = 500;
const $bbc19db46e52068c$var$GLIFFY_DEFAULT_HEIGHT = 150;
const $bbc19db46e52068c$var$AURA_DIVIDER_DEFAULT_HEIGHT = 21;
const $bbc19db46e52068c$var$AURA_CARDS_DEFAULT_HEIGHT = 226;
const $bbc19db46e52068c$var$getForgeExtensionHeight = (extensionId, extensionViewportSizes)=>{
    if (!extensionViewportSizes || !extensionId || !Array.isArray(extensionViewportSizes)) return;
    const viewportSize = extensionViewportSizes.find((ext)=>ext.extensionId === extensionId)?.viewportSize;
    if (!viewportSize) return undefined;
    if ($bbc19db46e52068c$var$FORGE_VIEWPORT_SIZES.includes(viewportSize)) return $bbc19db46e52068c$var$FORGE_MANIFEST_VIEWPORT_HEIGHTS[viewportSize];
    return undefined;
};
const $bbc19db46e52068c$var$getHeightFromNode = (node)=>{
    if (!node) return;
    const extensionKey = node.attrs.extensionKey;
    const params = node.attrs.parameters?.macroParams;
    /**
	 * DrawIo will resize diagrams based on the viewport they are rendered in
	 * if the diagram's width is greater than 530px. This means that the natural dimensions
	 * provided in macro parameters could be the incorrect height to reserve so we will
	 * conservatively exclude them.
	 */ if (extensionKey === 'drawio' || extensionKey === 'inc-drawio' || extensionKey === 'drawio-sketch') {
        const diagramWidth = Number(params?.width?.value);
        const zoomFactor = Number(params?.zoom?.value);
        if (diagramWidth && diagramWidth > 530 || zoomFactor !== 1) // Exclude wide diagrams due to allow resizing by vendor
        return;
    }
    if (extensionKey === 'plantumlcloud') return params?.originalHeight?.value;
    return params?.height?.value;
};
const $bbc19db46e52068c$export$bdad5f6d3f57f201 = ()=>{
    /**
	 * To attribute impact to each ecosystem, we plan to rollout Forge improvements separately
	 * via (confluence_preload_forge_viewport_heights_editor) with Connect improvements after
	 * via (confluence_connect_macro_preset_height). Thus we'll isolate Forge functionality first with
	 * the long term plan to merge both into a single function after successful rollout.
	 */ const extensionViewportSizes = (0, $1ITQ3.useExtensionViewportSizes)(!(0, $9wGTI.fg)('confluence_preload_forge_viewport_heights_editor'));
    const getForgeViewportHeight = (node)=>{
        // Forge in-content macros contain an ARI/environment/appKey extensionId value
        const extensionId = node.attrs.parameters?.extensionId;
        const forgeExtensionHeight = $bbc19db46e52068c$var$getForgeExtensionHeight(extensionId, extensionViewportSizes);
        if (forgeExtensionHeight) return forgeExtensionHeight;
    };
    const getCalculatedHeightFromNode = (0, $42omo.useCallback)((node)=>{
        // Check if it's a Connect extension with macro parameters
        const extensionKey = node.attrs.extensionKey;
        const nodeHeight = $bbc19db46e52068c$var$getHeightFromNode(node);
        let height = Number(nodeHeight);
        if (!Number.isNaN(height)) // for extensions that provide a number, add their offset
        switch(extensionKey){
            case 'drawio':
            case 'inc-drawio':
            case 'drawio-sketch':
                height += $bbc19db46e52068c$var$DRAW_IO_HEIGHT_OFFSET;
                break;
            case 'lref-gdrive-embedded-file':
                height += $bbc19db46e52068c$var$GOOGLE_DRIVE_EMBED_FILE_OFFSET_HEIGHT;
                break;
            case 'plantumlcloud':
                height += $bbc19db46e52068c$var$PLANTUML_OFFSET_HEIGHT;
                break;
            default:
                break;
        }
        else // for extensions that don't resize based on their content, we can set a default height
        switch(extensionKey){
            case 'gliffy':
                height = $bbc19db46e52068c$var$GLIFFY_DEFAULT_HEIGHT;
                break;
            case 'aura-divider':
                height = $bbc19db46e52068c$var$AURA_DIVIDER_DEFAULT_HEIGHT;
                break;
            case 'aura-cards':
                height = $bbc19db46e52068c$var$AURA_CARDS_DEFAULT_HEIGHT;
                break;
            case 'miro-macro-resizing':
                height = $bbc19db46e52068c$var$MIRO_EMBED_DEFAULT_HEIGHT;
                break;
            case 'easy-math-block':
                height = $bbc19db46e52068c$var$EASY_MATH_BLOCK_DEFAULT_HEIGHT;
                break;
            case 'mathblock':
                height = $bbc19db46e52068c$var$MATH_BLOCK_DEFAULT_HEIGHT;
                break;
            case 'page-signatures':
                height = $bbc19db46e52068c$var$PAGE_SIGNATURES_DEFAULT_HEIGHT;
                break;
            case 'questionslist-macro':
                height = $bbc19db46e52068c$var$QUESTIONS_LIST_DEFAULT_HEIGHT;
                break;
            case 'jiraroadmap':
                height = $bbc19db46e52068c$var$JIRA_ROADMAP_DEFAULT_HEIGHT;
                break;
            case 'lucidchart':
                height = $bbc19db46e52068c$var$LUCID_CHART_DEFAULT_HEIGHT;
                break;
            default:
                height = undefined;
                break;
        }
        return height?.toString();
    }, []);
    if ((0, $9wGTI.fg)('confluence_preload_forge_viewport_heights_editor')) return getForgeViewportHeight;
    if ((0, $9wGTI.fg)('confluence_connect_macro_preset_height')) return getCalculatedHeightFromNode;
};
module.exports["useExtensionNodeParams"] = $bbc19db46e52068c$export$bdad5f6d3f57f201;

});

parcelRegister("fthpM", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $b5IZN = parcelRequire("b5IZN");


var $2NcJL = parcelRequire("2NcJL");

function $75195e6585fa4719$export$a15423dd96de66f2(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b5IZN.CoreEditor), {
        ...props,
        appearance: props.appearance ?? 'full-page',
        AppearanceComponent: (0, $2NcJL.FullPageEditor),
        __livePage: props.__livePage
    });
}
module.exports["FullPageEditor"] = $75195e6585fa4719$export$a15423dd96de66f2;

});

parcelRegister("ijGoX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $axAnW = parcelRequire("axAnW");

var $kkQZq = parcelRequire("kkQZq");

var $iPfZG = parcelRequire("iPfZG");

var $hwWwS = parcelRequire("hwWwS");


var $lwNi3 = parcelRequire("lwNi3");

const $e86ccba267113370$export$4d97def4de07dcc1 = ()=>{
    const coordinationClient = (0, $lwNi3.useCoordinationClient)();
    // [ED-27497] IMPORTANT: If you change the code below, please also update the
    // platform/packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/engagementPlatformPluginOptions.ts
    return (0, $42omo.useMemo)(()=>{
        const config = {
            epComponents: {
                EngagementSpotlight: $iPfZG.EngagementSpotlight,
                EngagementInlineDialog: $kkQZq.default,
                Coordination: $axAnW.default
            },
            epHooks: {
                useCoordination: $hwWwS.useCoordination
            },
            coordinationClient: coordinationClient
        };
        return {
            config: config
        };
    }, [
        coordinationClient
    ]);
};
module.exports["useEditorEngagementPlatform"] = $e86ccba267113370$export$4d97def4de07dcc1;

});

parcelRegister("bDgLc", function(module, exports) {

var $5spQU = parcelRequire("5spQU");


var $42omo = parcelRequire("42omo");


var $kyKWe = parcelRequire("kyKWe");


var $c0rhi = parcelRequire("c0rhi");


var $bQm3c = parcelRequire("bQm3c");


var $ep3mz = parcelRequire("ep3mz");

/**
 * @generated SignedSource<<2dad237a1169707979f1c2965a4d4146>>
 * @relayHash d3f124aab91672208e07302d03b07351
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c184940bfc597924791e760a99e4cec505eb44de79daa104a6aa46e6adac4b2b
const $60d3698972303f3d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageARI"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "workspaceId"
        }
    ], v1 = [
        {
            "concreteType": "KnowledgeDiscoveryQueryApi",
            "kind": "LinkedField",
            "name": "knowledgeDiscovery",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "entityAri",
                            "variableName": "pageARI"
                        },
                        {
                            "kind": "Variable",
                            "name": "workspaceId",
                            "variableName": "workspaceId"
                        }
                    ],
                    "kind": "LinkedField",
                    "name": "keyPhrases",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "concreteType": "KnowledgeDiscoveryKeyPhrase",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "keyPhrase"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "category"
                                        }
                                    ]
                                }
                            ],
                            "type": "KnowledgeDiscoveryKeyPhraseConnection"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                }
                            ],
                            "type": "QueryError"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "HighlightKeywordsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "HighlightKeywordsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "d3f124aab91672208e07302d03b07351",
            "id": "c184940bfc597924791e760a99e4cec505eb44de79daa104a6aa46e6adac4b2b",
            "metadata": {},
            "name": "HighlightKeywordsQuery",
            "operationKind": "query",
            "text": "query HighlightKeywordsQuery($pageARI:String,$workspaceId:String){knowledgeDiscovery{keyPhrases(entityAri:$pageARI,workspaceId:$workspaceId)@optIn(to:\"KnowledgeDiscovery Get Key Phrases\"){__typename,...on KnowledgeDiscoveryKeyPhraseConnection{nodes{keyPhrase,category}},...on QueryError{message}}}}"
        }
    };
}();
$60d3698972303f3d$var$node.hash = "2eaa54e2c6daee5ed7b85802235eee06";
var $60d3698972303f3d$export$2e2bcd8739ae039 = $60d3698972303f3d$var$node;


const $770d1260eccad933$export$b855f1e1a990429f = (0, $60d3698972303f3d$export$2e2bcd8739ae039);



var $7rLBD = parcelRequire("7rLBD");

const $70f493264a46a679$var$cachedAcronymRegex = {
    pageARI: '',
    regex: new RegExp('(?!)')
};
const $70f493264a46a679$var$getAcronymRegex = (acronyms, pageARI = '', ignoreCase = false)=>{
    if (pageARI === $70f493264a46a679$var$cachedAcronymRegex.pageARI) return $70f493264a46a679$var$cachedAcronymRegex.regex;
    let regex;
    try {
        regex = new RegExp(acronyms.map((node)=>`\\b${node.phrase}\\b`).join('|'), ignoreCase ? 'gi' : 'g');
    } catch  {
        regex = new RegExp('(?!)');
    }
    $70f493264a46a679$var$cachedAcronymRegex.pageARI = pageARI;
    $70f493264a46a679$var$cachedAcronymRegex.regex = regex;
    return regex;
};
const $70f493264a46a679$export$ce57c3ee398efaad = ()=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const { cloudId: cloudId, activationId: activationId } = (0, $bQm3c.useSessionData)();
    const pageARI = contentId ? (0, $7rLBD.generatePageARI)(contentId, cloudId, contentType) : undefined;
    const workspaceId = (0, $7rLBD.generateWorkspaceId)(activationId, cloudId);
    const queryHighlightAcronyms = (0, $42omo.useCallback)(async ({ cacheKey: cacheKey = (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))() } = {})=>{
        if (!workspaceId || !pageARI) return {
            acronyms: []
        };
        try {
            const { data: data } = await (0, $c0rhi.queryInterop)({
                query: (0, $770d1260eccad933$export$b855f1e1a990429f),
                fetchPolicy: 'network-only',
                errorPolicy: 'ignore',
                variables: {
                    cacheKey: // comment from confluence/next/packages/content-appearance/src/contentAppearance.ts
                    // This is dummy variable is used to force "network-only" requests to only be run as network calls.
                    // A bug in Apollo sometimes makes this query return data from the cache even if the policy is "network-only"
                    // See for more details: https://pug.jira-dev.com/wiki/spaces/~683304838/pages/5971970200/Apollo+Client+-+weird+refetch+behavior
                    // @ts-expect-error
                    cacheKey,
                    pageARI: pageARI,
                    workspaceId: workspaceId
                },
                interopApolloAggClient: true
            });
            const keyPhrasesData = data?.knowledgeDiscovery?.keyPhrases;
            const keyPhrases = keyPhrasesData && keyPhrasesData.__typename === 'KnowledgeDiscoveryKeyPhraseConnection' && keyPhrasesData.nodes ? keyPhrasesData.nodes.filter((phrase)=>phrase != null).map((phrase)=>({
                    phrase: phrase.keyPhrase,
                    category: phrase.category
                })) : [];
            // getAcronymRegex use pageARI to cache the regex for the page
            // but for live edit pages we should be careful with the cache
            // because the page content is changing constantly
            const pageARIWithCacheKey = `${pageARI}-${cacheKey}`;
            let acronymRegex = undefined;
            if (keyPhrases.length) acronymRegex = $70f493264a46a679$var$getAcronymRegex(keyPhrases, pageARIWithCacheKey, true);
            return {
                acronyms: keyPhrases,
                acronymRegex: acronymRegex
            };
        } catch  {
            return {
                acronyms: []
            };
        }
    }, [
        pageARI,
        workspaceId
    ]);
    return {
        queryHighlightAcronyms: queryHighlightAcronyms
    };
};






var $2Jxlo = parcelRequire("2Jxlo");








var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $7mpOv = parcelRequire("7mpOv");

const $5ea2be36e6b2ae4f$export$718b2890e94c1d28 = ()=>{
    /**
	 * see comments in `AIDefinitionsPluginConfig` for more details about why not checking `isLivePage` here
	 * const isLivePage = useIsCurrentPageLive();
	 */ const [contentId] = (0, $ep3mz.usePageContentId)();
    const { isAIEnabledForContent: isAIEnabledForContent, isRovoEnabledForContent: isRovoEnabledForContent } = (0, $7mpOv.useIsAIEnabledForContent)({
        contentId: contentId
    });
    // environment-aware enablement via feature encoding
    const isAIFeatureEnabled = (0, $5spQU.isFeatureEnabled)('confluence', 'confluence-ai');
    const featureEnabled = isAIEnabledForContent || isRovoEnabledForContent;
    return isAIFeatureEnabled && featureEnabled;
};
const $5ea2be36e6b2ae4f$export$eeb7064aa16baa7e = ()=>{
    const { locale: locale } = (0, $bQm3c.useSessionData)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { isAIEnabledForContent: isAIEnabledForContent, isRovoEnabledForContent: isRovoEnabledForContent } = (0, $7mpOv.useIsAIEnabledForContent)({
        contentId: contentId
    });
    return (isAIEnabledForContent || isRovoEnabledForContent) && locale.startsWith('en') && !JSON.parse((0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_READING_AIDS_AUTO_HIGHLIGHT) || '""');
};
const $5ea2be36e6b2ae4f$export$538319b84b3e9de0 = ()=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const enabled = $5ea2be36e6b2ae4f$export$718b2890e94c1d28();
    const autoHighlightEnabled = $5ea2be36e6b2ae4f$export$eeb7064aa16baa7e();
    const { queryHighlightAcronyms: queryHighlightAcronyms } = (0, $70f493264a46a679$export$ce57c3ee398efaad)();
    const { isRovoEnabledForContent: isRovoEnabledForContent } = (0, $7mpOv.useIsAIEnabledForContent)({
        contentId: contentId
    });
    const enablementSource = isRovoEnabledForContent ? 'rovo' : 'general-ai';
    return {
        enabled: enabled,
        contentId: contentId,
        autoHighlightEnabled: autoHighlightEnabled,
        queryHighlightAcronyms: queryHighlightAcronyms,
        ReadingAidsPopup: $2Jxlo.ReadingAidsPopup,
        enablementSource: enablementSource,
        readingAidsMaxWordCount: (0, $7rLBD.READING_AIDS_MAX_WORD_COUNT)
    };
};
module.exports["useEditorPluginAIDefinitionsEnabled"] = $5ea2be36e6b2ae4f$export$718b2890e94c1d28;
module.exports["useEditorPluginAIDefinitionsConfig"] = $5ea2be36e6b2ae4f$export$538319b84b3e9de0;

});

parcelRegister("diJQD", function(module, exports) {

var $4TXTZ = parcelRequire("4TXTZ");


var $hmVoT = parcelRequire("hmVoT");


var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $eiA8Z = parcelRequire("eiA8Z");

const $53b900e6d056eba5$export$92a1a3b7554e9387 = {
    SHOW_IMAGE_EDITOR: 'SHOW_IMAGE_EDITOR',
    HIDE_IMAGE_EDITOR: 'HIDE_IMAGE_EDITOR'
};



var $1S4f7 = parcelRequire("1S4f7");


var $ks2lK = parcelRequire("ks2lK");


const $f4d001cda3671719$export$f00c49e7bdf6721d = new (0, $ks2lK.PluginKey)('mediaEditingPlugin');
const $f4d001cda3671719$export$ae829ec7b2625219 = ()=>{
    return new (0, $1S4f7.SafePlugin)({
        key: $f4d001cda3671719$export$f00c49e7bdf6721d,
        state: {
            init () {
                return {};
            },
            apply: (tr, currentPluginState)=>{
                const meta = tr.getMeta($f4d001cda3671719$export$f00c49e7bdf6721d);
                switch(meta?.type){
                    case (0, $53b900e6d056eba5$export$92a1a3b7554e9387).SHOW_IMAGE_EDITOR:
                        return {
                            ...currentPluginState,
                            imageEditorSelectedMedia: meta.imageEditorSelectedMedia,
                            isImageEditorVisible: meta.isImageEditorVisible
                        };
                    case (0, $53b900e6d056eba5$export$92a1a3b7554e9387).HIDE_IMAGE_EDITOR:
                        return {
                            ...currentPluginState,
                            imageEditorSelectedMedia: undefined,
                            isImageEditorVisible: meta.isImageEditorVisible
                        };
                    default:
                        return currentPluginState;
                }
            }
        }
    });
};


const $9fa213c2875fb91b$export$a0f8e5c5401083f8 = (media)=>({ tr: tr })=>{
        tr.setMeta((0, $f4d001cda3671719$export$f00c49e7bdf6721d), {
            type: (0, $53b900e6d056eba5$export$92a1a3b7554e9387).SHOW_IMAGE_EDITOR,
            imageEditorSelectedMedia: media,
            isImageEditorVisible: true
        });
        tr.setMeta('addToHistory', false);
        return tr;
    };
const $9fa213c2875fb91b$export$ac53b7b0b56dbebd = ({ tr: tr })=>{
    tr.setMeta((0, $f4d001cda3671719$export$f00c49e7bdf6721d), {
        type: (0, $53b900e6d056eba5$export$92a1a3b7554e9387).HIDE_IMAGE_EDITOR,
        imageEditorSelectedMedia: null,
        isImageEditorVisible: false
    });
    tr.setMeta('addToHistory', false);
    return tr;
};







var $42omo = parcelRequire("42omo");


var $9CkUQ = parcelRequire("9CkUQ");

const $040ed71febaf74c3$export$c8d0f9dbb5a183eb = (attrs)=>{
    return attrs.type === 'external';
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $ccHMk = parcelRequire("ccHMk");


var $52EPl = parcelRequire("52EPl");

var $dAYOx = parcelRequire("dAYOx");

var $ahaN7 = parcelRequire("ahaN7");


var $3NvMe = parcelRequire("3NvMe");


var $cvXh8 = parcelRequire("cvXh8");


var $ghftu = parcelRequire("ghftu");


var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $6xdDU = parcelRequire("6xdDU");


var $gdv5Z = parcelRequire("gdv5Z");


var $9hlns = parcelRequire("9hlns");

/* Cropper.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $fFa3V = parcelRequire("fFa3V");

const $6b13fba10800ce5a$var$isSSRRender = ()=>typeof document === 'undefined' || false; /**
                                                                                                         * Props for the Cropper component
                                                                                                         */ 
const $6b13fba10800ce5a$var$CropperCanvas = 'cropper-canvas';
const $6b13fba10800ce5a$var$CropperImage = 'cropper-image';
const $6b13fba10800ce5a$var$CropperSelection = 'cropper-selection';
const $6b13fba10800ce5a$var$CropperShade = 'cropper-shade';
const $6b13fba10800ce5a$var$CropperGrid = 'cropper-grid';
const $6b13fba10800ce5a$var$CropperCrosshair = 'cropper-crosshair';
const $6b13fba10800ce5a$var$CropperHandle = 'cropper-handle'; /**
                                                                                                             * Options for getting the cropped canvas
                                                                                                             */ 

const $6b13fba10800ce5a$export$71ed2b85d4ca43d3 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ src: src, alt: alt = '', crossOrigin: crossOrigin, aspectRatio: aspectRatio, initialAspectRatio: initialAspectRatio, initialCoverage: initialCoverage = 1, background: background = true, rotatable: rotatable = true, scalable: scalable = true, translatable: translatable = true, movable: movable = true, resizable: resizable = true, zoomable: zoomable = true, multiple: multiple = false, outlined: outlined = true, className: className, onImageReady: onImageReady, isCircle: isCircle = false }, ref)=>{
    const canvasRef = (0, $42omo.useRef)(null);
    const selectionRef = (0, $42omo.useRef)(null);
    const imageRef = (0, $42omo.useRef)(null);
    const previousSelectionRef = (0, $42omo.useRef)(null);
    const [isImageReady, setIsImageReady] = (0, $42omo.useState)(false);
    const [isCropperLoaded, setIsCropperLoaded] = (0, $42omo.useState)(false);
    const getCanvas = (0, $42omo.useCallback)(()=>canvasRef.current, []);
    const getImage = (0, $42omo.useCallback)(()=>imageRef.current, []);
    const getSelection = (0, $42omo.useCallback)(()=>selectionRef.current, []);
    const getCroppedCanvas = (0, $42omo.useCallback)((options)=>{
        const selection = selectionRef.current;
        if (!selection) return Promise.resolve(null);
         // Check if the $toCanvas method exists (web component might not be fully initialized)
        if (typeof selection.$toCanvas !== 'function') return Promise.resolve(null);
         // If circular crop, we need to apply a circular mask
        if (isCircle) {
            // For circular crops, force square dimensions to maintain perfect circle
            const squareOptions = {
                ...options,
                height: options?.width // Make height equal to width for a perfect circle
            };
            return selection.$toCanvas({
                ...squareOptions,
                beforeDraw: (context, canvas)=>{
                    // For circles, ensure we have a square canvas
                    const size = Math.min(canvas.width, canvas.height);
                    const radius = size / 2;
                    const centerX = size / 2;
                    const centerY = size / 2; // Enable high-quality image rendering
                    context.imageSmoothingEnabled = true;
                    context.imageSmoothingQuality = 'high'; // Create a circular clipping path with anti-aliasing
                    context.beginPath();
                    context.arc(centerX, centerY, radius, 0, Math.PI * 2);
                    context.clip();
                }
            });
        }
        return selection.$toCanvas(options);
    }, [
        isCircle
    ]);
    const fitStencilToImage = (0, $42omo.useCallback)(()=>{
        const canvas = canvasRef.current;
        const image = imageRef.current;
        const selection = selectionRef.current;
        if (canvas && image && selection) {
            // Get the real time positions
            const canvasRect = canvas.getBoundingClientRect();
            const imageRect = image.getBoundingClientRect(); // Calculate coordinates relative to the canvas
            requestAnimationFrame(()=>{
                const x = imageRect.left - canvasRect.left;
                const y = imageRect.top - canvasRect.top;
                const width = imageRect.width;
                const height = imageRect.height; // Apply these to the selection (the stencil)
                if (typeof selection.$change === 'function') selection.$change(Math.floor(x), Math.floor(y), Math.floor(width), Math.floor(height));
            });
        }
    }, []); // Clamp position to keep crop area within image boundaries
    const clampPosition = (0, $42omo.useCallback)((current)=>{
        const canvas = canvasRef.current;
        const image = imageRef.current;
        if (!canvas || !image) return null;
        const canvasRect = canvas.getBoundingClientRect();
        const imageRect = image.getBoundingClientRect();
        const imageX = imageRect.left - canvasRect.left;
        const imageY = imageRect.top - canvasRect.top;
        const imageWidth = imageRect.width;
        const imageHeight = imageRect.height;
        let clampedX = current.x;
        let clampedY = current.y; // Clamp left/right
        if (clampedX < imageX) clampedX = imageX;
        else if (clampedX + current.width > imageX + imageWidth) clampedX = imageX + imageWidth - current.width;
         // Clamp top/bottom
        if (clampedY < imageY) clampedY = imageY;
        else if (clampedY + current.height > imageY + imageHeight) clampedY = imageY + imageHeight - current.height;
        return {
            x: clampedX,
            y: clampedY
        };
    }, []); // Correct dimensions when resizing with aspect ratio constraints
    const correctResizeDimensions = (0, $42omo.useCallback)((current, selection)=>{
        const canvas = canvasRef.current;
        const image = imageRef.current;
        if (!canvas || !image) return null;
        const canvasRect = canvas.getBoundingClientRect();
        const imageRect = image.getBoundingClientRect();
        const imageX = imageRect.left - canvasRect.left;
        const imageY = imageRect.top - canvasRect.top;
        const imageWidth = imageRect.width;
        const imageHeight = imageRect.height;
        const maxWidthAvailable = imageX + imageWidth - current.x;
        const maxHeightAvailable = imageY + imageHeight - current.y;
        let correctedWidth = current.width;
        let correctedHeight = current.height;
        const hasAspectRatio = selection.aspectRatio && selection.aspectRatio > 0;
        if (hasAspectRatio) {
            const aspectRatio = selection.aspectRatio;
            const heightIfMaxWidth = maxWidthAvailable / aspectRatio;
            const widthIfMaxHeight = maxHeightAvailable * aspectRatio; // Determine which axis is the limiting factor
            if (heightIfMaxWidth <= maxHeightAvailable) {
                correctedWidth = maxWidthAvailable;
                correctedHeight = heightIfMaxWidth;
            } else {
                correctedHeight = maxHeightAvailable;
                correctedWidth = widthIfMaxHeight;
            }
        } else {
            correctedWidth = Math.min(correctedWidth, maxWidthAvailable);
            correctedHeight = Math.min(correctedHeight, maxHeightAvailable);
        } // Ensure positive dimensions
        correctedWidth = Math.max(1, correctedWidth);
        correctedHeight = Math.max(1, correctedHeight);
        return {
            width: correctedWidth,
            height: correctedHeight
        };
    }, []); // Handle move operation (position changed but size stayed same)
    const handleMove = (0, $42omo.useCallback)(()=>{
        requestAnimationFrame(()=>{
            const selection = selectionRef.current;
            if (!selection) return;
            const current = {
                x: selection.x || 0,
                y: selection.y || 0,
                width: selection.width || 0,
                height: selection.height || 0
            };
            const clamped = clampPosition(current);
            if (!clamped) return;
            if (typeof selection.$change === 'function') selection.$change(Math.floor(clamped.x), Math.floor(clamped.y), Math.floor(current.width), Math.floor(current.height));
            previousSelectionRef.current = {
                width: current.width,
                height: current.height
            };
        });
    }, [
        clampPosition
    ]); // Handle resize operation (size changed, may need aspect ratio correction)
    const handleResize = (0, $42omo.useCallback)(()=>{
        requestAnimationFrame(()=>{
            const selection = selectionRef.current;
            if (!selection) return;
            const current = {
                x: selection.x || 0,
                y: selection.y || 0,
                width: selection.width || 0,
                height: selection.height || 0
            };
            const corrected = correctResizeDimensions(current, selection);
            if (!corrected) return;
            const canvas = canvasRef.current;
            const image = imageRef.current;
            if (!canvas || !image) return;
            const canvasRect = canvas.getBoundingClientRect();
            const imageRect = image.getBoundingClientRect();
            const imageX = imageRect.left - canvasRect.left;
            const imageY = imageRect.top - canvasRect.top;
            const correctedX = Math.max(imageX, current.x);
            const correctedY = Math.max(imageY, current.y);
            if (typeof selection.$change === 'function') selection.$change(Math.floor(correctedX), Math.floor(correctedY), Math.floor(corrected.width), Math.floor(corrected.height));
            previousSelectionRef.current = {
                width: corrected.width,
                height: corrected.height
            };
        });
    }, [
        correctResizeDimensions
    ]); // Check if selection is within image boundaries
    const isSelectionOutOfBounds = (0, $42omo.useCallback)((imageX, imageY, imageWidth, imageHeight, selection)=>{
        const tolerance = 1;
        return selection.x < imageX - tolerance || selection.y < imageY - tolerance || selection.x + selection.width > imageX + imageWidth + tolerance || selection.y + selection.height > imageY + imageHeight + tolerance;
    }, []); // Detect if operation is a move or resize based on dimension change
    const isMovingSelection = (0, $42omo.useCallback)(()=>{
        const prev = previousSelectionRef.current;
        const curr = selectionRef.current;
        if (!prev || !curr) return false;
        return prev.width === curr.width && prev.height === curr.height;
    }, []);
    const handleSelectionChange = (0, $42omo.useCallback)((event)=>{
        const canvas = canvasRef.current;
        const image = imageRef.current;
        const customEvent = event;
        const selection = customEvent.detail;
        if (!canvas || !image || !selection) return;
        const canvasRect = canvas.getBoundingClientRect();
        const imageRect = image.getBoundingClientRect();
        const imageX = imageRect.left - canvasRect.left;
        const imageY = imageRect.top - canvasRect.top;
        const imageWidth = imageRect.width;
        const imageHeight = imageRect.height;
        if (!isSelectionOutOfBounds(imageX, imageY, imageWidth, imageHeight, selection)) {
            previousSelectionRef.current = {
                width: selection.width,
                height: selection.height
            };
            return;
        }
        if (isMovingSelection()) handleMove();
        else handleResize();
    }, [
        isSelectionOutOfBounds,
        isMovingSelection,
        handleMove,
        handleResize
    ]); // Lazy load cropperjs only on the client to avoid SSR side effects
    (0, $42omo.useEffect)(()=>{
        if (!$6b13fba10800ce5a$var$isSSRRender()) (parcelRequire("hcAEn")).then(()=>setIsCropperLoaded(true)).catch(()=>{
            setIsCropperLoaded(false);
        });
    }, []); // Auto-fit stencil to image on mount and when src changes
    // Only run after cropperjs has loaded (client-side only, post-hydration)
    (0, $42omo.useEffect)(()=>{
        if (!isCropperLoaded) return;
         // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- Ignored via go/ees017 (to be fixed)
        setIsImageReady(false); // Hide canvas while repositioning
        const image = imageRef.current;
        if (!image) return;
         // Wait for the image to be fully loaded
        if (typeof image.$ready === 'function') image.$ready(()=>{
            const timer = setTimeout(()=>{
                fitStencilToImage();
                setIsImageReady(true);
                onImageReady?.(true);
            }, 500); // Adding a small timeout as there is a rendering issue with webkit
            return ()=>clearTimeout(timer);
        });
        else {
            // Fallback to timeout if $ready is not available
            const timer = setTimeout(()=>{
                fitStencilToImage();
                setIsImageReady(true);
                onImageReady?.(true);
            }, 2000);
            return ()=>clearTimeout(timer);
        }
    }, [
        src,
        isCropperLoaded,
        onImageReady,
        fitStencilToImage
    ]); // Attach selection change listener to enforce boundaries (only after image is ready)
    (0, $42omo.useEffect)(()=>{
        if (!isImageReady) return;
        const selection = selectionRef.current;
        if (!selection) return;
        return (0, $fFa3V.bind)(selection, {
            type: 'change',
            listener: handleSelectionChange
        });
    }, [
        isImageReady,
        handleSelectionChange
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!canvasRef.current || !imageRef.current) return;
        const observer = new ResizeObserver(()=>{
            // This forces the image to recalculate its "contain" logic
            // whenever the canvas wrapper changes size
            if (typeof imageRef.current?.$center === 'function') imageRef.current?.$center('contain');
        });
        observer.observe(canvasRef.current);
        return ()=>observer.disconnect();
    }, [
        canvasRef,
        imageRef
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!canvasRef.current) return;
        const observer = new ResizeObserver(()=>{
            selectionRef.current?.removeAttribute('aspect-ratio');
            fitStencilToImage();
        });
        observer.observe(canvasRef.current);
        return ()=>observer.disconnect();
    }, [
        fitStencilToImage
    ]);
    (0, $42omo.useImperativeHandle)(ref, ()=>({
            fitStencilToImage: fitStencilToImage,
            getCanvas: getCanvas,
            getCroppedCanvas: getCroppedCanvas,
            getImage: getImage,
            isImageReady: isImageReady,
            getSelection: getSelection
        }), [
        getCanvas,
        getCroppedCanvas,
        getImage,
        isImageReady,
        fitStencilToImage,
        getSelection
    ]); // Inject global styles for cropper handles
    (0, $42omo.useEffect)(()=>{
        const style = document.createElement('style');
        const circularStyle = isCircle ? `
			cropper-selection {
				outline: none;
				border-top: 1px solid #0052CC;
				border-right: 1px solid #0052CC;
				border-bottom: 1px solid #0052CC;
				border-left: 1px solid #0052CC;
				box-sizing: border-box;
				border-radius: 50%;
				box-shadow: 0 0 0 9999px rgba(255, 255, 255, 0.6);
			}
		` : `
			cropper-selection {
				outline: none;
				border-top: 1px solid #0052CC;
				border-right: 1px solid #0052CC;
				border-bottom: 1px solid #0052CC;
				border-left: 1px solid #0052CC;
				box-sizing: border-box; 
			}
		`;
        style.textContent = `
				cropper-canvas {
					background-color: #F8F8F8;
					background-image: none;
				}
				cropper-shade {
					outline-color: rgba(255,255,255,0.5);
				}
				cropper-handle[action="move"] {
					opacity: 0;
				}
				cropper-handle[action="ne-resize"] {
					border-radius: 7px 4px 4px 4px;
					border-right: 7px solid rgba(255,255,255,0.6);
					border-top: 7px solid rgba(255,255,255,0.6);
					height: 15px;
					width: 15px;
					background-color: transparent;
					transform: translate(-4px, 4px); 
				}
				cropper-handle[action="ne-resize"]::after {
					border-radius: 5px 4px 4px 4px;
					border-right: 5px solid #0052CC;
					border-top: 5px solid #0052CC;
					height: 15px;
					width: 15px;
					background-color: transparent;
					transform: translate(-7px, -14px); 
				}
				cropper-handle[action="nw-resize"] {
					border-radius: 4px 7px 4px 4px;
					border-left: 7px solid rgba(255,255,255,0.6);
					border-top: 7px solid rgba(255,255,255,0.6);
					height: 15px;
					width: 15px;
					background-color: transparent;
					transform: translate(4px, 4px); 
				}
				cropper-handle[action="nw-resize"]::after {
					border-radius: 4px 5px 4px 4px;
					border-left: 5px solid #0052CC;
					border-top: 5px solid #0052CC;
					height: 15px;
					width: 15px;
					background-color: transparent;
					transform: translate(-14px, -14px); 
				}
				cropper-handle[action="se-resize"] {
					border-radius: 4px 4px 7px 4px;
					border-right: 7px solid rgba(255,255,255,0.6);
					border-bottom: 7px solid rgba(255,255,255,0.6);
					height: 15px;
					width: 15px;
					background-color: transparent;
					transform: translate(-4px, -4px); 
				}
				cropper-handle[action="se-resize"]::after {
					border-radius: 4px 4px 5px 4px;
					border-right: 5px solid #0052CC;
					border-bottom: 5px solid #0052CC;
					height: 15px;
					width: 15px;
					background-color: transparent;
					transform: translate(-7px, -7px); 
				}
				cropper-handle[action="sw-resize"] {
					border-radius: 4px 4px 4px 7px;
					border-left: 7px solid rgba(255,255,255,0.6);
					border-bottom: 7px solid rgba(255,255,255,0.6);
					height: 15px;
					width: 15px;
					background-color: transparent;
					transform: translate(4px, -4px); 
				}
				cropper-handle[action="sw-resize"]::after {
					border-radius: 4px 4px 4px 5px;
					border-left: 5px solid #0052CC;
					border-bottom: 5px solid #0052CC;
					height: 15px;
					width: 15px;
					background-color: transparent;
					transform: translate(-14px, -7px); 
				}
				${circularStyle}
			`;
        document.head.appendChild(style);
        return ()=>style.remove();
    }, [
        isCircle
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)($6b13fba10800ce5a$var$CropperCanvas, {
        ref: canvasRef,
        class: className,
        background: background,
        style: {
            opacity: isImageReady ? 1 : 0
        },
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)($6b13fba10800ce5a$var$CropperImage, {
                ref: imageRef,
                src: src,
                alt: alt,
                crossorigin: crossOrigin,
                rotatable: rotatable,
                scalable: scalable,
                translatable: translatable,
                "initial-center-size": "contain"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)($6b13fba10800ce5a$var$CropperShade, {
                x: 240,
                y: 5,
                width: 160,
                height: 90
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)($6b13fba10800ce5a$var$CropperSelection, {
                ref: selectionRef,
                "initial-coverage": initialCoverage,
                "aspect-ratio": aspectRatio,
                "initial-aspect-ratio": initialAspectRatio,
                movable: movable,
                resizable: resizable,
                zoomable: zoomable,
                multiple: multiple,
                outlined: outlined,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)($6b13fba10800ce5a$var$CropperGrid, {
                        role: "grid",
                        hidden: true
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)($6b13fba10800ce5a$var$CropperCrosshair, {
                        hidden: true
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)($6b13fba10800ce5a$var$CropperHandle, {
                        action: "move"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)($6b13fba10800ce5a$var$CropperHandle, {
                        action: "ne-resize"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)($6b13fba10800ce5a$var$CropperHandle, {
                        action: "nw-resize"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)($6b13fba10800ce5a$var$CropperHandle, {
                        action: "se-resize"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)($6b13fba10800ce5a$var$CropperHandle, {
                        action: "sw-resize"
                    })
                ]
            })
        ]
    });
});
$6b13fba10800ce5a$export$71ed2b85d4ca43d3.displayName = 'Cropper';


/* FlipHorizontalIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");




const $e090d94123374729$var$sizeStyles = {
    small: "_1bsbgktf _4t3igktf",
    medium: "_1bsb1tcg _4t3i1tcg",
    large: "_1bsbzwfg _4t3izwfg",
    xlarge: "_1bsbckbl _4t3ickbl"
};
const $e090d94123374729$var$svgStyles = null;
const $e090d94123374729$export$19f53ac153fdf5c1 = ({ label: label, size: size = 'small', primaryColor: primaryColor = 'currentColor', secondaryColor: secondaryColor, isDisabled: isDisabled })=>/*#__PURE__*/ (0, $l998X.jsx)("svg", {
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            color: primaryColor,
            fill: secondaryColor,
            opacity: isDisabled ? 0.5 : 1
        },
        "aria-label": label || undefined,
        role: label ? 'img' : 'presentation',
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw",
            $e090d94123374729$var$sizeStyles[size]
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
            d: "M8.75 16H7.25V0H8.75V16ZM1.97559 3.99609C2.56238 3.77737 3.22379 3.94656 3.63379 4.41992L5.88379 7.01855L5.92773 7.07129C6.37112 7.63335 6.3567 8.43636 5.88379 8.98242L3.63379 11.5801C3.22379 12.0535 2.56239 12.2226 1.97559 12.0039C1.38909 11.7851 1.00022 11.2246 1 10.5986V5.40234C1.00003 4.77617 1.38894 4.21497 1.97559 3.99609ZM12.3662 4.41992C12.7762 3.94656 13.4376 3.77737 14.0244 3.99609C14.6111 4.21497 15 4.77617 15 5.40234V10.5986C14.9998 11.2246 14.6109 11.7851 14.0244 12.0039C13.4376 12.2226 12.7762 12.0535 12.3662 11.5801L10.1162 8.98242C9.6433 8.43636 9.62888 7.63335 10.0723 7.07129L10.1162 7.01855L12.3662 4.41992ZM2.5 10.5986L4.75 8L2.5 5.40234V10.5986ZM11.25 8L13.5 10.5986V5.40234L11.25 8Z",
            fill: primaryColor
        })
    });


/* FlipVerticalIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");




const $905137a889b7491e$var$sizeStyles = {
    small: "_1bsbgktf _4t3igktf",
    medium: "_1bsb1tcg _4t3i1tcg",
    large: "_1bsbzwfg _4t3izwfg",
    xlarge: "_1bsbckbl _4t3ickbl"
};
const $905137a889b7491e$var$svgStyles = null;
const $905137a889b7491e$export$e97029447c2d07bf = ({ label: label, size: size = 'small', primaryColor: primaryColor = 'currentColor', secondaryColor: secondaryColor, isDisabled: isDisabled })=>/*#__PURE__*/ (0, $l998X.jsx)("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            color: primaryColor,
            fill: secondaryColor,
            opacity: isDisabled ? 0.5 : 1
        },
        "aria-label": label || undefined,
        role: label ? 'img' : 'presentation',
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw",
            $905137a889b7491e$var$sizeStyles[size]
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
            d: "M1.492e-05 8.75L1.49856e-05 7.25L16 7.25L16 8.75L1.492e-05 8.75ZM12.0039 1.97656C12.2224 2.56323 12.0533 3.2239 11.5801 3.63379L8.98146 5.88379L8.92873 5.92871C8.36667 6.37206 7.56364 6.35668 7.01759 5.88379L4.41994 3.63379C3.94669 3.2239 3.77765 2.56325 3.99611 1.97656C4.21484 1.38987 4.77528 1.00022 5.40138 1L10.5977 1C11.224 1.00003 11.7851 1.38973 12.0039 1.97656ZM11.5801 12.3662C12.0533 12.7761 12.2224 13.4368 12.0039 14.0234C11.7851 14.6103 11.224 15 10.5977 15L5.40138 15C4.77528 14.9998 4.21484 14.6101 3.99611 14.0234C3.77765 13.4368 3.94669 12.7761 4.41994 12.3662L7.01759 10.1162C7.56364 9.64332 8.36667 9.62794 8.92873 10.0713L8.98146 10.1162L11.5801 12.3662ZM5.40138 2.5L8.00002 4.75L10.5977 2.5L5.40138 2.5ZM8.00001 11.25L5.40138 13.5L10.5977 13.5L8.00001 11.25Z",
            fill: primaryColor
        })
    });


/* RatioIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");




const $28c0aa1f5d6e5d89$var$sizeStyles = {
    small: "_1bsbgktf _4t3igktf",
    medium: "_1bsb1tcg _4t3i1tcg",
    large: "_1bsbzwfg _4t3izwfg",
    xlarge: "_1bsbckbl _4t3ickbl"
};
const $28c0aa1f5d6e5d89$var$svgStyles = null;
const $28c0aa1f5d6e5d89$export$8dcfa0333e5b427e = ({ label: label, size: size = 'small', primaryColor: primaryColor = 'currentColor', secondaryColor: secondaryColor, isDisabled: isDisabled })=>/*#__PURE__*/ (0, $l998X.jsx)("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            color: primaryColor,
            fill: secondaryColor,
            opacity: isDisabled ? 0.5 : 1
        },
        "aria-label": label || undefined,
        role: label ? 'img' : 'presentation',
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw",
            $28c0aa1f5d6e5d89$var$sizeStyles[size]
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
            d: "M3 10V13H6V14.5H2.875C2.11561 14.5 1.5 13.8844 1.5 13.125V10H3ZM14.5 13.125C14.5 13.8844 13.8844 14.5 13.125 14.5H10V13H13V10H14.5V13.125ZM13.125 1.5C13.8844 1.5 14.5 2.11561 14.5 2.875V6H13V3H10V1.5H13.125ZM6 3H3V6H1.5V2.875C1.5 2.11561 2.11561 1.5 2.875 1.5H6V3Z",
            fill: primaryColor
        })
    });


/* RotateIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");




const $edcc9465064bcfb0$var$sizeStyles = {
    small: "_1bsbgktf _4t3igktf",
    medium: "_1bsb1tcg _4t3i1tcg",
    large: "_1bsbzwfg _4t3izwfg",
    xlarge: "_1bsbckbl _4t3ickbl"
};
const $edcc9465064bcfb0$var$svgStyles = null;
const $edcc9465064bcfb0$export$f48a22e8beb69262 = ({ label: label, size: size = 'small', primaryColor: primaryColor = 'currentColor', secondaryColor: secondaryColor, isDisabled: isDisabled })=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            color: primaryColor,
            fill: secondaryColor,
            opacity: isDisabled ? 0.5 : 1
        },
        "aria-label": label || undefined,
        role: label ? 'img' : 'presentation',
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw",
            $edcc9465064bcfb0$var$sizeStyles[size]
        ]),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.93459 6.72227C7.47156 6.1853 8.34216 6.1853 8.87913 6.72227L12.0914 9.93458C12.6284 10.4716 12.6284 11.3422 12.0914 11.8791L8.87913 15.0914C8.34216 15.6284 7.47156 15.6284 6.93459 15.0914L3.72228 11.8791C3.18531 11.3422 3.18531 10.4716 3.72228 9.93458L6.93459 6.72227ZM7.90686 7.87132L4.87133 10.9069L7.90686 13.9424L10.9424 10.9069L7.90686 7.87132Z",
                fill: primaryColor
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M0 8.5C0 4.08172 3.58172 0.5 8 0.5C10.6789 0.5 13.0485 1.81718 14.5 3.83691V0.75H16V5.5C16 5.91421 15.6642 6.25 15.25 6.25H10.5V4.75H13.3086C12.1308 3.08578 10.192 2 8 2C4.41015 2 1.5 4.91015 1.5 8.5V9.25H0V8.5Z",
                fill: primaryColor
            })
        ]
    });









var $1cfRh = parcelRequire("1cfRh");

const $ccfae6ffb4dd15f3$var$ASPECT_RATIOS = {
    original: null,
    custom: null,
    square: {
        x: 1,
        y: 1
    },
    circle: {
        x: 1,
        y: 1
    },
    landscape: {
        x: 4,
        y: 3
    },
    portrait: {
        x: 3,
        y: 4
    },
    wide: {
        x: 16,
        y: 9
    }
};
const $ccfae6ffb4dd15f3$export$873aefdf6f4e5566 = ()=>{
    // no ratio = undefined = custom cropping selection
    const getAspectRatioValue = (ratio)=>{
        const aspectRatioValue = $ccfae6ffb4dd15f3$var$ASPECT_RATIOS[ratio];
        if (aspectRatioValue) return aspectRatioValue.x / aspectRatioValue.y;
        return undefined;
    };
    return {
        getAspectRatioValue: getAspectRatioValue
    };
};
const $ccfae6ffb4dd15f3$export$b331ea965923cd1f = (cropperRef)=>{
    const flipHorizontal = ()=>{
        const image = cropperRef.current?.getImage();
        if (image?.$scale) image.$scale(-1, 1);
    };
    const flipVertical = ()=>{
        const image = cropperRef.current?.getImage();
        if (image?.$scale) image.$scale(1, -1);
    };
    return {
        flipHorizontal: flipHorizontal,
        flipVertical: flipVertical
    };
};
const $ccfae6ffb4dd15f3$export$9202d595fd82f22e = (cropperRef)=>{
    const rotateRight = ()=>{
        const canvas = cropperRef.current?.getCanvas();
        const image = cropperRef.current?.getImage();
        if (!canvas || !image) return;
        const selectionEl = canvas.querySelector('cropper-selection');
        if (selectionEl instanceof HTMLElement) selectionEl.style.opacity = '0';
        image.$rotate('90deg');
        image.$center('contain');
        cropperRef.current?.fitStencilToImage();
        if (selectionEl instanceof HTMLElement) selectionEl.style.opacity = '1';
    };
    return {
        rotateRight: rotateRight
    };
};


const $a89f238659bf60f5$export$c9acda86a2363b01 = ()=>{
    const cropperRef = (0, $42omo.useRef)(null);
    const doneButtonRef = (0, $42omo.useRef)(null);
    const aspectRatioResolverRef = (0, $42omo.useRef)(null);
    const isInitialSetupRef = (0, $42omo.useRef)(true);
    const [isImageReady, setIsImageReady] = (0, $42omo.useState)(false);
    const [currentAspectRatio, setCurrentAspectRatio] = (0, $42omo.useState)(undefined);
    const [aspectRatioSelection, setAspectRatioSelection] = (0, $42omo.useState)('custom');
    const { flipHorizontal: flipHorizontal, flipVertical: flipVertical } = (0, $ccfae6ffb4dd15f3$export$b331ea965923cd1f)(cropperRef);
    const { rotateRight: rotateRight } = (0, $ccfae6ffb4dd15f3$export$9202d595fd82f22e)(cropperRef);
    const { getAspectRatioValue: getAspectRatioValue } = (0, $ccfae6ffb4dd15f3$export$873aefdf6f4e5566)();
    const intl = (0, $1cfRh.default)();
    // Initialize editor state and track canvas size changes
    (0, $42omo.useEffect)(()=>{
        if (!isImageReady) return;
        // Get the canvas element to observe for size changes
        const canvas = cropperRef.current?.getCanvas();
        if (!canvas) return;
        // Track initial canvas dimensions before any state updates
        let lastWidth = canvas.clientWidth;
        let lastHeight = canvas.clientHeight;
        // Canvas size will change when the viewport size changes
        // Monitor canvas resizing to detect when user manually adjusts the crop area
        const observer = new ResizeObserver((entries)=>{
            // Skip the first observation during setup
            if (isInitialSetupRef.current) {
                isInitialSetupRef.current = false;
                return;
            }
            const entry = entries[0];
            const { width: width, height: height } = entry.contentRect;
            // If canvas size changes, switch to custom aspect ratio mode
            if (width !== lastWidth || height !== lastHeight) {
                lastWidth = width;
                lastHeight = height;
                setAspectRatioSelection('custom');
            }
        });
        observer.observe(canvas);
        // Calculate and set the original aspect ratio based on the image dimensions
        setAspectRatioSelection('custom');
        // Focus on the done button as soon as image loads
        if (doneButtonRef.current) doneButtonRef.current.focus();
        return ()=>observer.disconnect();
    }, [
        isImageReady
    ]);
    // Listen for aspect ratio selection changes and update current aspect ratio
    // This effect monitors the cropper's selection element for any changes
    // and updates the currentAspectRatio state accordingly
    (0, $42omo.useEffect)(()=>{
        if (isImageReady && aspectRatioSelection !== '') {
            const selection = cropperRef.current?.getSelection();
            if (!selection) return;
            // Update aspect ratio whenever aspect ratio selection changes
            const handleSelectionChange = ()=>{
                const selectionAspectRatio = selection.aspectRatio ? selection.aspectRatio : undefined;
                setCurrentAspectRatio(selectionAspectRatio);
            };
            // Call once to set initial value
            // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- Ignored via go/ees017 (to be fixed)
            handleSelectionChange();
            // Attach change listener to selection element
            return (0, $fFa3V.bind)(selection, {
                type: 'change',
                listener: handleSelectionChange
            });
        }
    }, [
        isImageReady,
        aspectRatioSelection
    ]);
    // Resolve pending aspect ratio changes
    // This effect watches for when the aspect ratio reaches its target value
    // and resolves the corresponding promise to allow animations to proceed
    (0, $42omo.useEffect)(()=>{
        const pending = aspectRatioResolverRef.current;
        if (pending && currentAspectRatio === pending.target) {
            // Resolve the promise stored in the ref when target is reached
            pending.resolve();
            aspectRatioResolverRef.current = null;
        }
    }, [
        currentAspectRatio
    ]);
    // Calculate the original aspect ratio of the image
    // Gets the image element's dimensions and computes width/height ratio
    const calculateOriginalRatio = ()=>{
        const image = cropperRef.current?.getImage();
        if (image) {
            const img = image.getBoundingClientRect();
            const ratio = img.width / img.height;
            setCurrentAspectRatio(ratio);
        }
    };
    // Wait for the aspect ratio to reach a target value
    // Used to coordinate aspect ratio changes with animation frames
    // Returns a promise that resolves when the target ratio is reached
    const waitForCurrentAspectRatio = (target)=>new Promise((resolve)=>{
            // If already at target, resolve on next animation frame
            if (currentAspectRatio === target) {
                requestAnimationFrame(()=>resolve());
                return;
            }
            // Otherwise, store resolve callback to be called when target is reached
            aspectRatioResolverRef.current = {
                resolve: resolve,
                target: target
            };
        });
    // Change the aspect ratio selection and animate the transition
    // This function handles smooth transitions between different aspect ratios
    const setSelectionArea = async (selectedRatio)=>{
        // Custom ratio mode: free-form selection without constraints
        if (selectedRatio === 'custom') {
            setAspectRatioSelection(selectedRatio);
            setCurrentAspectRatio(undefined);
            await waitForCurrentAspectRatio(undefined);
            return;
        }
        const selection = cropperRef.current?.getSelection();
        const canvas = cropperRef.current?.getCanvas();
        const shade = canvas?.querySelector('cropper-shade');
        // Fade out selection and shade during transition for smooth animation
        if (selection) selection.style.opacity = '0';
        if (shade) shade.style.opacity = '0';
        // Reset aspect ratio and wait for the crop area to clear
        setCurrentAspectRatio(undefined);
        await waitForCurrentAspectRatio(undefined);
        cropperRef.current?.fitStencilToImage();
        // Wait for DOM to update
        await new Promise((resolve)=>requestAnimationFrame(resolve));
        // Set the new aspect ratio
        if (selectedRatio === 'original') calculateOriginalRatio();
        else {
            const ratioVal = getAspectRatioValue(selectedRatio);
            setCurrentAspectRatio(ratioVal);
            await waitForCurrentAspectRatio(ratioVal);
        }
        setAspectRatioSelection(selectedRatio);
        // Allow time for the new crop area to be positioned and rendered
        await new Promise((resolve)=>setTimeout(resolve, 300));
        // Center the selection and fade back in
        if (selection) {
            selection.$center();
            selection.style.opacity = '1';
        }
        if (shade) shade.style.opacity = '1';
    };
    // Extract the cropped image and save it
    // Converts the cropped canvas to a blob and calls the onSave callback
    const handleSave = async (onSave, onClose, errorReporter)=>{
        try {
            // Get the selection to determine the crop size relative to original image
            const selection = cropperRef.current?.getSelection();
            const image = cropperRef.current?.getImage();
            let canvasWidth;
            if (selection && image) {
                // Try to get the actual <img> from shadow DOM
                const actualImg = image.shadowRoot?.querySelector('img') || null;
                if (actualImg) {
                    // Get the natural (original) image dimensions
                    const naturalWidth = actualImg.naturalWidth;
                    // Get the displayed image dimensions
                    const displayedRect = image.getBoundingClientRect();
                    const displayedWidth = displayedRect.width;
                    // Calculate the scale factor between displayed and original image
                    const scaleX = naturalWidth / displayedWidth;
                    // Get selection dimensions in displayed coordinates
                    const selectionWidth = selection.width || 0;
                    // Calculate the crop width in original image coordinates
                    const cropWidthInOriginal = selectionWidth * scaleX;
                    // Use the crop width from original image, capped at a reasonable maximum
                    canvasWidth = Math.min(cropWidthInOriginal, 1500);
                }
            }
            // Get the cropped canvas with calculated width
            // Fallback to width = 1500 (a reasonable size for keeping high quality images relatively high quality)
            const canvas = await cropperRef.current?.getCroppedCanvas(canvasWidth ? {
                width: canvasWidth
            } : {
                width: 1500
            });
            if (canvas) {
                const outWidth = canvas.width;
                const outHeight = canvas.height;
                // Convert canvas to blob (defaults to png)
                canvas.toBlob((blob)=>{
                    if (blob) onSave?.(blob, outWidth, outHeight);
                });
            }
        } catch (error) {
            // Report any errors to the error reporter
            if (errorReporter) errorReporter.captureException(error instanceof Error ? error : new Error(String(error)));
        }
    };
    return {
        cropperRef: cropperRef,
        doneButtonRef: doneButtonRef,
        isImageReady: isImageReady,
        setIsImageReady: setIsImageReady,
        currentAspectRatio: currentAspectRatio,
        aspectRatioSelection: aspectRatioSelection,
        flipHorizontal: flipHorizontal,
        flipVertical: flipVertical,
        rotateRight: rotateRight,
        setSelectionArea: setSelectionArea,
        handleSave: handleSave,
        formatMessage: intl.formatMessage
    };
};


const $9b27642e6562e0a0$var$imageWrapper = null;
const $9b27642e6562e0a0$var$cropper = null;
const $9b27642e6562e0a0$var$modalFooter = null;
const $9b27642e6562e0a0$var$ratioBtn = null;
const $9b27642e6562e0a0$var$ratioSelect = null;
const $9b27642e6562e0a0$var$loadingImageStyle = null;
const $9b27642e6562e0a0$var$dropdownItemGroup = null;
const $9b27642e6562e0a0$var$btnGroupStyle = {
    box: "_zulpu2gc _1e0c1txw"
};
const $9b27642e6562e0a0$var$aspectRatioLabelMap = {
    original: 'aspectRatioSelectionOriginal',
    custom: 'aspectRatioSelectionCustom',
    square: 'aspectRatioSelectionSquare',
    circle: 'aspectRatioSelectionCircle',
    landscape: 'aspectRatioSelectionLandscape',
    portrait: 'aspectRatioSelectionPortrait',
    wide: 'aspectRatioSelectionWide'
};
const $9b27642e6562e0a0$export$d0486c7a5136628 = ({ imageUrl: imageUrl, isOpen: isOpen, isSaving: isSaving = false, onClose: onClose, onSave: onSave, errorReporter: errorReporter })=>{
    const { cropperRef: cropperRef, doneButtonRef: doneButtonRef, isImageReady: isImageReady, setIsImageReady: setIsImageReady, currentAspectRatio: currentAspectRatio, aspectRatioSelection: aspectRatioSelection, flipHorizontal: flipHorizontal, flipVertical: flipVertical, handleSave: handleSave, setSelectionArea: setSelectionArea, formatMessage: formatMessage, rotateRight: rotateRight } = (0, $a89f238659bf60f5$export$c9acda86a2363b01)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6xdDU.default), {
        children: isOpen && /*#__PURE__*/ (0, $l998X.jsxs)((0, $8CZUH.default), {
            onClose: isSaving ? ()=>{} : onClose,
            height: 800,
            width: "x-large",
            testId: "image-editor-modal",
            label: "Image editor modal",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("br", {}),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $1DHa6.default), {
                    children: /*#__PURE__*/ (0, $l998X.jsxs)("div", {
                        className: (0, $gMc0m.default)([
                            "_1reo15vq _18m915vq _4t3i1osq _1bsb1osq _1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o"
                        ]),
                        children: [
                            !isImageReady && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                                className: (0, $gMc0m.default)([
                                    "_1e0c1txw _1bah1h6o _4cvr1h6o _kqswstnw"
                                ]),
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {
                                    size: "large",
                                    testId: "spinner",
                                    interactionName: "load",
                                    label: "Loading"
                                })
                            }),
                            imageUrl && /*#__PURE__*/ (0, $l998X.jsx)((0, $6b13fba10800ce5a$export$71ed2b85d4ca43d3), {
                                ref: cropperRef,
                                src: imageUrl,
                                alt: "Crop me",
                                crossOrigin: "anonymous",
                                initialCoverage: 1,
                                aspectRatio: currentAspectRatio,
                                isCircle: aspectRatioSelection === 'circle',
                                onImageReady: setIsImageReady,
                                className: (0, $gMc0m.default)([
                                    "_p12f1osq _1bsb1osq _4t3i1osq"
                                ])
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $8o1lj.default), {
                    children: /*#__PURE__*/ (0, $l998X.jsxs)("div", {
                        className: (0, $gMc0m.default)([
                            "_1e0c1txw _1bah1yb4 _4cvr1h6o _1bsb1osq"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $52EPl.default), {
                                        appearance: "default",
                                        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                                ref: triggerRef,
                                                appearance: "subtle",
                                                isDisabled: !isImageReady || isSaving,
                                                isSelected: props.isSelected,
                                                onClick: props.onClick,
                                                onFocus: props.onFocus,
                                                onBlur: props.onBlur,
                                                "aria-expanded": props['aria-expanded'],
                                                "aria-haspopup": props['aria-haspopup'],
                                                "aria-controls": props['aria-controls'],
                                                testId: props.testId,
                                                children: /*#__PURE__*/ (0, $l998X.jsxs)("div", {
                                                    className: (0, $gMc0m.default)([
                                                        "_zulpu2gc _1e0c1txw _4cvr1h6o"
                                                    ]),
                                                    children: [
                                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $28c0aa1f5d6e5d89$export$8dcfa0333e5b427e), {
                                                            label: "change aspect ratio button",
                                                            isDisabled: !isImageReady || isSaving
                                                        }),
                                                        aspectRatioSelection && formatMessage((0, $3NvMe.mediaEditingMessages)[$9b27642e6562e0a0$var$aspectRatioLabelMap[aspectRatioSelection]]),
                                                        /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                                                            label: "",
                                                            size: "small"
                                                        })
                                                    ]
                                                })
                                            }),
                                        children: /*#__PURE__*/ (0, $l998X.jsxs)("div", {
                                            className: (0, $gMc0m.default)([
                                                "_1ul9uuw1"
                                            ]),
                                            children: [
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $ahaN7.default), {
                                                    children: [
                                                        'original',
                                                        'custom'
                                                    ].map((item)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $dAYOx.default), {
                                                            onClick: ()=>{
                                                                setSelectionArea(item);
                                                            },
                                                            children: /*#__PURE__*/ (0, $l998X.jsxs)("div", {
                                                                className: (0, $gMc0m.default)([
                                                                    "_1e0c1txw _1bah1yb4 _4cvr1h6o"
                                                                ]),
                                                                children: [
                                                                    formatMessage((0, $3NvMe.mediaEditingMessages)[$9b27642e6562e0a0$var$aspectRatioLabelMap[item]]),
                                                                    aspectRatioSelection === item && /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
                                                                        label: "selected"
                                                                    })
                                                                ]
                                                            })
                                                        }, item))
                                                }),
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $ahaN7.default), {
                                                    hasSeparator: true,
                                                    children: [
                                                        'square',
                                                        'circle',
                                                        'landscape',
                                                        'portrait',
                                                        'wide'
                                                    ].map((item)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $dAYOx.default), {
                                                            onClick: ()=>{
                                                                setSelectionArea(item);
                                                            },
                                                            children: /*#__PURE__*/ (0, $l998X.jsxs)("div", {
                                                                className: (0, $gMc0m.default)([
                                                                    "_1e0c1txw _1bah1yb4 _4cvr1h6o"
                                                                ]),
                                                                children: [
                                                                    formatMessage((0, $3NvMe.mediaEditingMessages)[`${item}Button`]),
                                                                    aspectRatioSelection === item && /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
                                                                        label: "selected"
                                                                    })
                                                                ]
                                                            })
                                                        }, item))
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                                    ), {
                                        onClick: async ()=>{
                                            rotateRight();
                                            await setSelectionArea('custom');
                                            cropperRef.current?.fitStencilToImage();
                                        },
                                        isDisabled: !isImageReady || isSaving,
                                        testId: "image-editor-rotate-right-btn",
                                        appearance: "subtle",
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $edcc9465064bcfb0$export$f48a22e8beb69262), {
                                            label: "rotate right button",
                                            isDisabled: !isImageReady || isSaving
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                        onClick: flipVertical,
                                        isDisabled: !isImageReady || isSaving,
                                        testId: "image-editor-flip-vertical-btn",
                                        appearance: "subtle",
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $905137a889b7491e$export$e97029447c2d07bf), {
                                            label: "flip vertical button",
                                            isDisabled: !isImageReady || isSaving
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                        onClick: flipHorizontal,
                                        isDisabled: !isImageReady || isSaving,
                                        testId: "image-editor-flip-horizontal-btn",
                                        appearance: "subtle",
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $e090d94123374729$export$19f53ac153fdf5c1), {
                                            label: "flip horizontal button",
                                            isDisabled: !isImageReady || isSaving
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                                xcss: $9b27642e6562e0a0$var$btnGroupStyle.box,
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                        appearance: "subtle",
                                        onClick: onClose,
                                        isDisabled: isSaving,
                                        children: formatMessage((0, $3NvMe.mediaEditingMessages).cancelButton)
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                        appearance: "primary",
                                        onClick: ()=>handleSave(onSave, onClose, errorReporter),
                                        isDisabled: !isImageReady || isSaving,
                                        isLoading: isSaving,
                                        ref: doneButtonRef,
                                        children: isSaving ? formatMessage((0, $3NvMe.mediaEditingMessages).savingButton) : formatMessage((0, $3NvMe.mediaEditingMessages).doneButton)
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};


const $6a12d0ea26926c30$export$8ac4c72242e73a4e = ({ mediaClientConfig: mediaClientConfig, onClose: onClose, selectedNodeAttrs: selectedNodeAttrs, errorReporter: errorReporter, editorView: editorView })=>{
    const [imageUrl, setImageUrl] = (0, $42omo.useState)('');
    const [isSaving, setIsSaving] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        const getImageUrl = ()=>{
            if ((0, $040ed71febaf74c3$export$c8d0f9dbb5a183eb)(selectedNodeAttrs)) {
                // Fall back in case editing button shows by mistake
                onClose();
                errorReporter?.captureException(new Error('Cannot edit external media due to CORS restrictions'));
            } else {
                // File media - use MediaClient to get the image URL
                const { id: id, collection: collection = '' } = selectedNodeAttrs;
                try {
                    const mediaClient = new (0, $9CkUQ.MediaClient)(mediaClientConfig);
                    // Subscribe to file state to get file information
                    const subscription = mediaClient.file.getFileState(id, {
                        collectionName: collection
                    }).subscribe((fileState)=>{
                        if (fileState.status === 'processed' || fileState.status === 'processing') // Get the image URL from the processed file
                        mediaClient.file.getFileBinaryURL(id, collection).then((url)=>{
                            setImageUrl(url);
                        });
                    });
                    // Cleanup subscription on unmount
                    return ()=>subscription.unsubscribe();
                } catch (error) {
                    if (errorReporter) errorReporter.captureException(error instanceof Error ? error : new Error(String(error)));
                    setImageUrl('');
                }
            }
        };
        getImageUrl();
    }, [
        selectedNodeAttrs,
        mediaClientConfig,
        errorReporter,
        onClose
    ]);
    const handleSave = (blob, width, height)=>{
        const mediaClient = new (0, $9CkUQ.MediaClient)(mediaClientConfig);
        const collection = 'collection' in selectedNodeAttrs ? selectedNodeAttrs.collection || '' : '';
        // Ensure blob has MIME type
        const typedBlob = blob.type ? blob : new Blob([
            blob
        ], {
            type: 'image/png'
        });
        const localId = !(0, $040ed71febaf74c3$export$c8d0f9dbb5a183eb)(selectedNodeAttrs) ? selectedNodeAttrs.localId : undefined;
        // Upload the edited image as a new file with a different filename
        const originalFileName = !(0, $040ed71febaf74c3$export$c8d0f9dbb5a183eb)(selectedNodeAttrs) ? selectedNodeAttrs.__fileName : undefined;
        let editedFileName = 'edited-image.png'; // fallback if the filename doesn't exist
        if (originalFileName) {
            const lastDotIndex = originalFileName.lastIndexOf('.');
            if (lastDotIndex > 0) {
                const baseName = originalFileName.substring(0, lastDotIndex);
                editedFileName = `${baseName}-edited-${localId}`;
            } else editedFileName = `${originalFileName}-edited-${localId}`;
        }
        const uploadableFile = {
            content: typedBlob,
            collection: collection,
            mimeType: typedBlob.type,
            name: editedFileName,
            size: typedBlob.size
        };
        // Show saving state in modal
        setIsSaving(true);
        const uploadSubscription = mediaClient.file.upload(uploadableFile).subscribe({
            next: (fileState)=>{
                if (fileState.status === 'error') {
                    setIsSaving(false);
                    onClose();
                    uploadSubscription.unsubscribe();
                    return;
                }
                // Only update document when upload is complete
                if (fileState.status !== 'uploading' && fileState.status !== 'processing') {
                    const updatedAttrs = (0, $040ed71febaf74c3$export$c8d0f9dbb5a183eb)(selectedNodeAttrs) ? selectedNodeAttrs : {
                        ...selectedNodeAttrs,
                        id: fileState.id,
                        __fileName: fileState.name,
                        __fileMimeType: fileState.mimeType,
                        __fileSize: fileState.size,
                        width: width,
                        height: height
                    };
                    // Find the media node position and update it
                    const { state: state, dispatch: dispatch } = editorView;
                    const { doc: doc } = state;
                    let nodePos = null;
                    const selectedLocalId = !(0, $040ed71febaf74c3$export$c8d0f9dbb5a183eb)(selectedNodeAttrs) ? selectedNodeAttrs.localId : undefined;
                    doc.descendants((node, pos)=>{
                        if ((0, $040ed71febaf74c3$export$c8d0f9dbb5a183eb)(selectedNodeAttrs)) return true;
                        // Find by localId (unique per node instance)
                        if (selectedLocalId && node.attrs.localId === selectedLocalId) {
                            nodePos = pos;
                            return false;
                        }
                        return true;
                    });
                    if (nodePos !== null) {
                        const node = doc.nodeAt(nodePos);
                        if (node) {
                            const tr = state.tr.setNodeMarkup(nodePos, undefined, updatedAttrs);
                            dispatch(tr);
                        }
                    }
                    uploadSubscription.unsubscribe();
                    setIsSaving(false);
                    onClose();
                }
            },
            error: (error)=>{
                if (errorReporter) errorReporter.captureException(error instanceof Error ? error : new Error(String(error)));
                uploadSubscription.unsubscribe();
                setIsSaving(false);
                onClose();
            }
        });
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9b27642e6562e0a0$export$d0486c7a5136628), {
        isOpen: true,
        onClose: onClose,
        imageUrl: imageUrl,
        onSave: handleSave,
        errorReporter: errorReporter,
        isSaving: isSaving
    });
};


const $616343a1d45d9a96$var$imageEditorStateSelector = (states)=>{
    return {
        isImageEditorVisible: states.mediaEditingState?.isImageEditorVisible,
        imageEditorSelectedMedia: states.mediaEditingState?.imageEditorSelectedMedia,
        uploadMediaClientConfig: states.mediaState?.uploadMediaClientConfig
    };
};
const $616343a1d45d9a96$var$ImageEditorFunctionalComponent = ({ api: api, editorView: editorView })=>{
    const { isImageEditorVisible: isImageEditorVisible, imageEditorSelectedMedia: imageEditorSelectedMedia, uploadMediaClientConfig: uploadMediaClientConfig } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'mediaEditing',
        'media'
    ], $616343a1d45d9a96$var$imageEditorStateSelector);
    if (!isImageEditorVisible || !imageEditorSelectedMedia || !uploadMediaClientConfig) return null;
    const handleOnClose = ()=>{
        api?.core.actions.execute(api?.mediaEditing.commands.hideImageEditor);
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6a12d0ea26926c30$export$8ac4c72242e73a4e), {
        mediaClientConfig: uploadMediaClientConfig,
        onClose: handleOnClose,
        selectedNodeAttrs: imageEditorSelectedMedia,
        editorView: editorView
    });
};
const $616343a1d45d9a96$export$c84116e7ea204952 = ({ api: api })=>({
        name: 'mediaEditing',
        getSharedState (editorState) {
            if (!editorState) return null;
            return (0, $f4d001cda3671719$export$f00c49e7bdf6721d).getState(editorState) || null;
        },
        commands: {
            showImageEditor: $9fa213c2875fb91b$export$a0f8e5c5401083f8,
            hideImageEditor: $9fa213c2875fb91b$export$ac53b7b0b56dbebd
        },
        pmPlugins () {
            return [
                {
                    name: 'mediaEditingPlugin',
                    plugin: (0, $f4d001cda3671719$export$ae829ec7b2625219)
                }
            ];
        },
        contentComponent ({ editorView: editorView }) {
            if (!editorView) return null;
            return /*#__PURE__*/ (0, $l998X.jsx)($616343a1d45d9a96$var$ImageEditorFunctionalComponent, {
                api: api,
                editorView: editorView
            });
        }
    });



var $lGoD9 = parcelRequire("lGoD9");




parcelRequire("42omo");


var $h82at = parcelRequire("h82at");

const $95fcf8bb61fa82af$export$e4f30354a76c156b = (0, $h82at.defineMessages)({
    suggestionsToolbarButtonLabel: {
        id: "fabric.editor.ai.suggestions.toolbarButton.label.non-final",
        defaultMessage: "Suggestions"
    },
    suggestionsToolbarButtonLoadingLabel: {
        id: "fabric.editor.ai.suggestions.toolbarButton.loadingLabel.non-final",
        defaultMessage: "Loading"
    },
    suggestionsToolbarButtonReadyLabel: {
        id: "fabric.editor.ai.suggestions.toolbarButton.readyLabel.non-final",
        defaultMessage: "View"
    },
    suggestionsToolbarButtonErrorLabel: {
        id: "fabric.editor.ai.suggestions.toolbarButton.errorLabel.non-final",
        defaultMessage: "Retry"
    },
    previewLabel: {
        id: "fabric.editor.ai.suggestions.stagingArea.previewLabel.non-final",
        defaultMessage: "Preview"
    },
    viewLabel: {
        id: "fabric.editor.ai.suggestions.stagingArea.viewLabel.non-final",
        defaultMessage: "View"
    },
    titleLabel: {
        id: "fabric.editor.ai.suggestions.stagingArea.titleLabel.non-final",
        defaultMessage: "Title"
    },
    reviewNote: {
        id: "fabric.editor.ai.suggestions.stagingArea.reviewNote.non-final",
        defaultMessage: "Review \u2022 Only visible to you"
    },
    applyChangesButtonLabel: {
        id: "fabric.editor.ai.suggestions.stagingArea.applyChangesButtonLabel.non-final",
        defaultMessage: "Apply changes"
    },
    fetchSuggestionsButtonLabel: {
        id: "fabric.editor.ai.suggestions.stagingArea.fetchSuggestionsButtonLabel.non-final",
        defaultMessage: "Fetch suggestions"
    },
    fetchSuggestionsButtonLoadingLabel: {
        id: "fabric.editor.ai.suggestions.stagingArea.fetchSuggestionsButtonLoadingLabel.non-final",
        defaultMessage: "Loading\u2026"
    },
    fetchGenerateFromDocument: {
        id: "fabric.editor.ai.suggestions.quickInsert.generateFromDocument.non-final",
        defaultMessage: "Suggested edits (generate)"
    },
    fetchGenerateFromAdf: {
        id: "fabric.editor.ai.suggestions.quickInsert.generateFromAdf.non-final",
        defaultMessage: "Suggested edits (generate from ADF)"
    },
    originalViewLabel: {
        id: "fabric.editor.ai.suggestions.stagingArea.originalViewLabel.non-final",
        defaultMessage: "Original \u2022 View only"
    },
    suggestedLabel: {
        id: "fabric.editor.ai.suggestions.stagingArea.suggestedLabel.non-final",
        defaultMessage: "Suggested"
    },
    suggestionsLabel: {
        id: "fabric.editor.ai.suggestions.stagingArea.suggestionsLabel.non-final",
        defaultMessage: "Suggestions"
    },
    cardCloseButtonLabel: {
        id: "fabric.editor.ai.suggestions.card.closeButtonLabel.non-final",
        defaultMessage: "Close"
    },
    cardExpandButtonLabel: {
        id: "fabric.editor.ai.suggestions.card.expandButtonLabel.non-final",
        defaultMessage: "Expand"
    },
    cardCollapseButtonLabel: {
        id: "fabric.editor.ai.suggestions.card.collapseButtonLabel.non-final",
        defaultMessage: "Collapse"
    },
    cardRovoTitle: {
        id: "fabric.editor.ai.suggestions.card.rovoTitle.non-final",
        defaultMessage: "Rovo"
    },
    cardPrivateLabel: {
        id: "fabric.editor.ai.suggestions.card.privateLabel.non-final",
        defaultMessage: "Private"
    },
    cardAcceptButtonLabel: {
        id: "fabric.editor.ai.suggestions.card.acceptButtonLabel.non-final",
        defaultMessage: "Accept"
    },
    cardDiscardButtonLabel: {
        id: "fabric.editor.ai.suggestions.card.discardButtonLabel.non-final",
        defaultMessage: "Discard"
    }
});



var $h7YX1 = parcelRequire("h7YX1");




parcelRequire("42omo");


var $24P9d = parcelRequire("24P9d");








var $ftzrq = parcelRequire("ftzrq");

/* SuggestionIconButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $30lHU = parcelRequire("30lHU");


var $1qfLF = parcelRequire("1qfLF");









var $6tl2G = parcelRequire("6tl2G");


var $5SAOw = parcelRequire("5SAOw");


var $aXG5V = parcelRequire("aXG5V");







function $4c37aae2f1ec7493$var$wrapChild(fragment, type, attrs) {
    if (!fragment.firstChild) return null;
    const wrappingNodeTypes = type.contentMatch.findWrapping(fragment.firstChild.type);
    let currentChildNodes = null;
    if (wrappingNodeTypes) {
        currentChildNodes = fragment.content;
        for(let i = wrappingNodeTypes.length - 1; i >= 0; i--){
            const wrappingNodeType = wrappingNodeTypes[i];
            const nextChildNode = wrappingNodeType.createAndFill(null, currentChildNodes);
            if (nextChildNode) currentChildNodes = [
                nextChildNode
            ];
            else {
                currentChildNodes = null;
                break;
            }
        }
    }
    if (currentChildNodes) return type.createAndFill(attrs, currentChildNodes);
    return null;
}
function $4c37aae2f1ec7493$var$findPosForNode(node, $to) {
    for(let depth = $to.depth; depth >= 0; depth--){
        const ancestor = $to.node(depth);
        if (ancestor.type.contentMatch.matchType(node.type)) return $to.after(depth + 1);
    }
    return null;
}
const $4c37aae2f1ec7493$export$5a065b4e594c5a9c = ({ toolCallArguments: toolCallArguments, tr: tr, pos: pos })=>{
    const $from = tr.doc.resolve(pos);
    const node = tr.doc.nodeAt(pos);
    if (!node) return tr;
    const $to = tr.doc.resolve(pos + node.nodeSize);
    const range = $from.blockRange($to);
    if (range) {
        const type = tr.doc.type.schema.nodes[toolCallArguments.wrapperType];
        const attrs = toolCallArguments.wrapperAttrs;
        try {
            const wrapping = (0, $aXG5V.findWrapping)(range, type, attrs);
            if (wrapping !== null) tr.wrap(range, wrapping);
            else {
                const slice = tr.doc.slice(range.$from.pos, range.$to.pos);
                const fragment = slice.content;
                let node = type.createAndFill(attrs, fragment);
                if (!node) node = $4c37aae2f1ec7493$var$wrapChild(fragment, type, attrs);
                if (node) {
                    const insertPos = $4c37aae2f1ec7493$var$findPosForNode(node, $to);
                    if (insertPos !== null) {
                        tr.insert(insertPos, node);
                        tr.replaceRange(range.$from.pos, range.$to.pos, (0, $5SAOw.Slice).empty);
                    }
                }
            }
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    }
    return tr;
};


function $f4f309f882685735$var$createNodeFromToolCallValue(schema, value) {
    try {
        const parsed = typeof value === 'string' ? JSON.parse(value) : value;
        const node = (0, $6tl2G.processRawValue)(schema, parsed);
        return node;
    } catch  {
        return undefined;
    }
}
const $f4f309f882685735$export$4163bdb44341f987 = (tr, suggestion)=>{
    const localIdToPos = new Map();
    tr.doc.descendants((node, pos)=>{
        const localId = node.attrs?.localId;
        if (localId) localIdToPos.set(localId, {
            from: pos,
            to: pos + node.nodeSize
        });
        return true;
    });
    /**
	 * For some reason, without transforming the doc back and forth,
	 * the steps are missing in subsequent transforms.
	 */ const transform = new (0, $aXG5V.Transform)((0, $5SAOw.Node).fromJSON(tr.doc.type.schema, tr.doc.toJSON()));
    suggestion.toolCalls.forEach((toolCall)=>{
        const localId = toolCall.arguments?.localId;
        if (localId === undefined) return;
        const pos = localIdToPos.get(localId);
        if (!pos) return;
        if ('value' in toolCall.arguments) {
            const value = toolCall.arguments.value;
            const node = $f4f309f882685735$var$createNodeFromToolCallValue(tr.doc.type.schema, value);
            if (!node) return;
            switch(toolCall.name){
                case 'replaceNode':
                    transform.replaceWith(pos.from, pos.to, node);
                    break;
                case 'insertNodeBefore':
                    transform.insert(pos.from, node);
                    break;
                case 'insertNodeAfter':
                    transform.insert(pos.to, node);
                    break;
            }
        } else switch(toolCall.name){
            case 'removeNode':
                transform.delete(pos.from, pos.to);
                break;
            case 'wrap':
            case 'wrapNode':
                (0, $4c37aae2f1ec7493$export$5a065b4e594c5a9c)({
                    toolCallArguments: toolCall.arguments,
                    tr: transform,
                    pos: pos.from
                });
                break;
            case 'setAttrs':
                const node = transform.doc.nodeAt(pos.from);
                if (!node) break;
                transform.setNodeMarkup(pos.from, undefined, node.attrs);
                break;
            default:
                break;
        }
    });
    return transform;
};


const $cbd7514796298a2b$var$buttonContainer = null;
function $cbd7514796298a2b$export$b6eb36123ab7ffdf({ suggestion: suggestion, isSelected: isSelected, api: api, intl: intl }) {
    const { baseLocalIdBySuggestionId: baseLocalIdBySuggestionId } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'aiSuggestions'
    ], (state)=>{
        const { baseLocalIdBySuggestionId: baseLocalIdBySuggestionId } = state?.aiSuggestionsState ?? {};
        return {
            baseLocalIdBySuggestionId: baseLocalIdBySuggestionId
        };
    });
    const onSelectSuggestion = ()=>{
        api?.core?.actions.execute(({ tr: tr })=>{
            const invertedTr = (0, $f4f309f882685735$export$4163bdb44341f987)(tr, suggestion);
            api?.showDiff?.commands.showDiff({
                steps: invertedTr.steps.map((step)=>step.invert(invertedTr.before)),
                originalDoc: invertedTr.doc,
                isInverted: true
            })({
                tr: tr
            });
            tr.setMeta((0, $4eed6fc998ed6bbf$export$dbbefe45c19011aa), {
                action: 'SELECT_SUGGESTION',
                id: suggestion.id
            });
            return tr;
        });
    };
    const tooltip = (0, $42omo.useMemo)(()=>({
            content: suggestion.shortDescription,
            position: 'right'
        }), [
        suggestion.shortDescription
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $30lHU.default), {
        defaultLocale: intl?.defaultLocale || 'en-US',
        locale: intl?.locale || 'en-US',
        messages: intl?.messages,
        formats: intl?.formats,
        children: /*#__PURE__*/ (0, $l998X.jsx)("span", {
            style: {
                anchorName: `--button-${baseLocalIdBySuggestionId?.get(suggestion.id)}`
            },
            className: (0, $gMc0m.default)([
                "_kqswstnw _154iidpf _1xi2c7mi _1pbykb7n _t9ecxwn4"
            ]),
            children: // We keep the anchorName span rendered so that the suggestion card can reference it
            !isSelected && /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                isTooltipDisabled: false,
                tooltip: tooltip,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($h7YX1))),
                appearance: "subtle",
                label: "",
                spacing: "compact",
                onClick: onSelectSuggestion
            })
        })
    });
}


function $ffa0ca393e54921b$export$8eb2ba4e0b5d0f47(params) {
    const suggestionById = new Map();
    const suggestionIdsByLocalId = new Map();
    const baseLocalIdBySuggestionId = new Map();
    const suggestionIdsByBaseLocalId = new Map();
    const orderedSuggestionIds = [];
    if (!params) return {
        suggestionById: suggestionById,
        baseLocalIdBySuggestionId: baseLocalIdBySuggestionId,
        orderedSuggestionIds: orderedSuggestionIds,
        suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId
    };
    const { suggestions: suggestions, doc: doc } = params;
    for (const suggestion of suggestions){
        suggestionById.set(suggestion.id, suggestion);
        const firstToolCall = suggestion.toolCalls[0];
        /**
		 * Only add the first tool call to the suggestionIdsByLocalId map
		 * to simplify navigation, stacking, and getting logic.
		 */ if (firstToolCall) {
            const { localId: localId } = firstToolCall.arguments;
            const ids = suggestionIdsByLocalId.get(localId) ?? new Set();
            ids.add(suggestion.id);
            suggestionIdsByLocalId.set(localId, ids);
        }
    }
    // Map each top-level block position (doc depth 1) to suggestion IDs that target any localId
    // under that block — same docLevelPos as `doc.resolve(pos).before(1)` in the decorations plugin.
    doc.descendants((node, pos)=>{
        const nodeLocalId = node.attrs?.localId;
        if (!nodeLocalId) return true;
        const suggestionIdsAtLocalId = suggestionIdsByLocalId.get(nodeLocalId);
        if (suggestionIdsAtLocalId?.size) {
            const $pos = doc.resolve(pos);
            const baseLocalId = doc.nodeAt($pos.before(1))?.attrs?.localId;
            if (!baseLocalId) return true;
            suggestionIdsAtLocalId.forEach((suggestionId)=>{
                // each suggestion maps to a base local id
                baseLocalIdBySuggestionId.set(suggestionId, baseLocalId);
                // we use doc.descendants order to determine the order of the suggestions
                orderedSuggestionIds.push(suggestionId);
            });
            const baseSet = suggestionIdsByBaseLocalId.get(baseLocalId) ?? new Set();
            const childSet = suggestionIdsByLocalId.get(nodeLocalId);
            if (childSet) // concat it into the base set
            suggestionIdsByBaseLocalId.set(baseLocalId, new Set([
                ...baseSet,
                ...childSet
            ]));
        }
        return true;
    });
    return {
        suggestionById: suggestionById,
        baseLocalIdBySuggestionId: baseLocalIdBySuggestionId,
        orderedSuggestionIds: orderedSuggestionIds,
        suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId
    };
}



/**
 * Streaming response types for ConvoAI
 */ function $4bf5ab6f56ba7ee1$export$9167f99f9be83b24() {
    const { origin: origin = '', port: port = '', hostname: hostname = '' } = typeof window.location !== 'undefined' ? window.location : {};
    if (hostname === 'localhost' && port !== '8081' || [
        'atlaskit-website-staging.stg-east.frontend.public.atl-paas.net',
        'statlas.prod.atl-paas.net',
        'atlaskit.atlassian.com'
    ].some((h)=>hostname === h)) return 'https://pug.jira-dev.com';
    return origin;
}
async function $4bf5ab6f56ba7ee1$export$7ba546d072711b5d(body, options = {}) {
    const { onChunk: onChunk, onFinalResponse: onFinalResponse, onError: onError, signal: signal } = options;
    const reader = body.getReader();
    const decoder = new TextDecoder('utf-8');
    let buffer = '';
    let finalResponse = null;
    const chunks = [];
    try {
        while(!signal?.aborted){
            const { value: value, done: done } = await reader.read();
            if (done) break;
            const chunk = decoder.decode(value, {
                stream: true
            });
            buffer += chunk;
            // Split by newlines and process complete lines
            // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
            const lines = buffer.split('\n');
            // Keep the last potentially incomplete line in the buffer
            buffer = lines.pop() || '';
            for (const line of lines){
                if (!line.trim()) continue;
                try {
                    const data = JSON.parse(line);
                    chunks.push(data);
                    onChunk?.(data);
                    // Check for FINAL_RESPONSE type (ConvoAI pattern)
                    if (data.type === 'FINAL_RESPONSE') {
                        finalResponse = data;
                        onFinalResponse?.(data);
                    }
                } catch (parseError) {
                    const error = new Error(`Failed to parse JSON line: ${parseError instanceof Error ? parseError.message : String(parseError)}`);
                    onError?.(error);
                }
            }
        }
        // Check if aborted
        if (signal?.aborted) reader.cancel();
        // Process any remaining buffer content
        if (buffer.trim()) try {
            const data = JSON.parse(buffer);
            chunks.push(data);
            onChunk?.(data);
            if (data.type === 'FINAL_RESPONSE') {
                finalResponse = data;
                onFinalResponse?.(data);
            }
        } catch  {
        // Ignore incomplete final chunk
        }
    } catch (error) {
        const streamError = error instanceof Error ? error : new Error(String(error));
        onError?.(streamError);
        throw streamError;
    }
    return {
        finalResponse: finalResponse,
        chunks: chunks
    };
}
async function $4bf5ab6f56ba7ee1$export$95b9987b6ac049ec(options) {
    const { url: url, fetchOptions: fetchOptions = {}, signal: signal, onChunk: onChunk, onError: onError, onFinalResponse: onFinalResponse } = options;
    const response = await fetch(url, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'X-Channel-Id': 'editor',
            'X-Product': 'confluence',
            'X-Experience-Id': 'editor'
        },
        ...fetchOptions,
        signal: signal
    });
    if (!response.ok) {
        const error = new Error(`Response not OK: ${response.status}`);
        onError?.(error);
        throw error;
    }
    if (!response.body) {
        const error = new Error('No response body');
        onError?.(error);
        throw error;
    }
    return $4bf5ab6f56ba7ee1$export$7ba546d072711b5d(response.body, {
        onChunk: onChunk,
        onError: onError,
        onFinalResponse: onFinalResponse,
        signal: signal
    });
}


async function $6a053ad034f62fd4$export$ebf2f44fe450da2b({ contentAri: contentAri, contentAdf: contentAdf, generate: generate = true, signal: signal }) {
    const payload = {
        experience_id: 'ai-content-suggested-edits',
        ai_feature_input: {
            generate: generate,
            debug: false,
            skip_ers: false,
            generator_overrides: generate ? [
                'SUGGESTED_SECTIONS',
                'EVIDENCE_AND_ACCURACY',
                'FORMATTING_AND_REMIX',
                'WRITING_TONE',
                'POSITIONING_AND_FLOW',
                'CLARITY_AND_CONCISENESS',
                'SPELLING_AND_GRAMMAR',
                'FORMATTING_POLISH'
            ] : [],
            ...contentAdf ? {
                content_adf: contentAdf,
                content_ari: ''
            } : {
                content_ari: contentAri
            }
        }
    };
    const url = `${(0, $4bf5ab6f56ba7ee1$export$9167f99f9be83b24)()}/gateway/api/assist/api/ai/v2/ai-feature/content-suggested-edits`;
    const response = await fetch(url, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'X-Channel-Id': 'editor',
            'X-Product': 'confluence',
            'X-Experience-Id': 'editor'
        },
        body: JSON.stringify(payload),
        signal: signal
    });
    if (!response.ok) throw new Error(`Content suggested edits request failed: ${response.status}`);
    const data = await response.json();
    const items = data?.ai_feature_output?.items;
    return Array.isArray(items) ? items : [];
}


const $072616480be2cdf6$export$740daa9a9ce77ea8 = async ({ api: api, contentAri: contentAri, forceAdf: forceAdf, generate: generate, signal: signal })=>{
    if (!api) return;
    /**
	 * If the contentAri is not provided OR
	 * if forceAdf is true, we fetch the suggestions using ADF and update the suggestions.
	 */ if (!contentAri || forceAdf) {
        const doc = await api?.core?.actions.requestDocumentAsync();
        const suggestions = await (0, $6a053ad034f62fd4$export$ebf2f44fe450da2b)({
            contentAdf: JSON.stringify(doc),
            contentAri: '',
            generate: generate,
            signal: signal
        });
        api?.core?.actions?.execute(({ tr: tr })=>{
            tr.setMeta((0, $4eed6fc998ed6bbf$export$dbbefe45c19011aa), {
                action: 'SET_SUGGESTIONS',
                suggestions: suggestions
            });
            return tr;
        });
        return;
    }
    const suggestions = await (0, $6a053ad034f62fd4$export$ebf2f44fe450da2b)({
        contentAri: contentAri,
        generate: generate,
        signal: signal
    });
    api?.core?.actions?.execute(({ tr: tr })=>{
        tr.setMeta((0, $4eed6fc998ed6bbf$export$dbbefe45c19011aa), {
            action: 'SET_SUGGESTIONS',
            suggestions: suggestions
        });
        return tr;
    });
};


const $4eed6fc998ed6bbf$export$dbbefe45c19011aa = new (0, $ks2lK.PluginKey)('aiSuggestionsPlugin');
function $4eed6fc998ed6bbf$var$calculateSuggestionsDecorations({ doc: doc, suggestionById: suggestionById, suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId, api: api, intl: intl, selectedSuggestion: selectedSuggestion, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI }) {
    if (suggestionById.size === 0) return (0, $ftzrq.DecorationSet).empty;
    const decorations = [];
    doc.descendants((node, pos)=>{
        const { localId: localId } = node.attrs;
        if (localId) {
            const suggestionsAtLocalId = suggestionIdsByBaseLocalId.get(localId);
            if (suggestionsAtLocalId?.size) {
                const firstSuggestionId = suggestionsAtLocalId.values().next().value;
                const firstSuggestion = firstSuggestionId ? suggestionById.get(firstSuggestionId) : undefined;
                if (firstSuggestion) {
                    const element = document.createElement('span');
                    element.setAttribute('style', (0, $24P9d.convertToInlineCss)({
                        position: 'relative',
                        width: '100%',
                        display: 'block'
                    }));
                    const key = crypto.randomUUID();
                    const isSelected = Boolean(selectedSuggestion && suggestionsAtLocalId.has(selectedSuggestion));
                    decorations.push((0, $ftzrq.Decoration).widget(pos, ()=>{
                        nodeViewPortalProviderAPI.render(()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $cbd7514796298a2b$export$b6eb36123ab7ffdf), {
                                suggestion: firstSuggestion,
                                isSelected: isSelected,
                                api: api,
                                intl: intl
                            }), element, key);
                        return element;
                    }, {
                        side: 1,
                        key: key,
                        destroy: ()=>{
                        // Clean up properly
                        // nodeViewPortalProviderAPI.remove(key);
                        }
                    }));
                }
            }
        }
        return false;
    });
    if (!decorations.length) return (0, $ftzrq.DecorationSet).empty;
    return (0, $ftzrq.DecorationSet).create(doc, decorations);
}
const { suggestionById: $4eed6fc998ed6bbf$var$initSuggestionById, suggestionIdsByBaseLocalId: $4eed6fc998ed6bbf$var$initSuggestionIdsByBaseLocalId, baseLocalIdBySuggestionId: $4eed6fc998ed6bbf$var$initBaseLocalIdBySuggestionId, orderedSuggestionIds: $4eed6fc998ed6bbf$var$initOrderedSuggestionIds } = (0, $ffa0ca393e54921b$export$8eb2ba4e0b5d0f47)(undefined);
const $4eed6fc998ed6bbf$var$initState = {
    decorations: (0, $ftzrq.DecorationSet).empty,
    selectedSuggestion: undefined,
    suggestionById: $4eed6fc998ed6bbf$var$initSuggestionById,
    suggestionIdsByBaseLocalId: $4eed6fc998ed6bbf$var$initSuggestionIdsByBaseLocalId,
    baseLocalIdBySuggestionId: $4eed6fc998ed6bbf$var$initBaseLocalIdBySuggestionId,
    orderedSuggestionIds: $4eed6fc998ed6bbf$var$initOrderedSuggestionIds
};
function $4eed6fc998ed6bbf$export$ae829ec7b2625219({ api: api, intl: intl, contentAri: contentAri, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI }) {
    return new (0, $1S4f7.SafePlugin)({
        key: $4eed6fc998ed6bbf$export$dbbefe45c19011aa,
        state: {
            init (_config, _state) {
                return $4eed6fc998ed6bbf$var$initState;
            },
            apply (tr, pluginState, _oldState, newState) {
                const meta = tr.getMeta($4eed6fc998ed6bbf$export$dbbefe45c19011aa);
                let nextState = pluginState;
                if (meta) switch(meta.action){
                    case 'SET_SUGGESTIONS':
                        {
                            const { suggestionById: suggestionById, baseLocalIdBySuggestionId: baseLocalIdBySuggestionId, suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId, orderedSuggestionIds: orderedSuggestionIds } = (0, $ffa0ca393e54921b$export$8eb2ba4e0b5d0f47)({
                                suggestions: meta.suggestions,
                                doc: newState.doc
                            });
                            nextState = {
                                ...pluginState,
                                suggestionById: suggestionById,
                                suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId,
                                baseLocalIdBySuggestionId: baseLocalIdBySuggestionId,
                                orderedSuggestionIds: orderedSuggestionIds,
                                decorations: $4eed6fc998ed6bbf$var$calculateSuggestionsDecorations({
                                    doc: newState.doc,
                                    suggestionById: suggestionById,
                                    suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId,
                                    api: api,
                                    intl: intl,
                                    selectedSuggestion: pluginState.selectedSuggestion,
                                    nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
                                })
                            };
                            break;
                        }
                    case 'CLEAR_SUGGESTIONS':
                        {
                            const { suggestionById: suggestionById, baseLocalIdBySuggestionId: baseLocalIdBySuggestionId, suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId, orderedSuggestionIds: orderedSuggestionIds } = (0, $ffa0ca393e54921b$export$8eb2ba4e0b5d0f47)({
                                doc: newState.doc,
                                suggestions: []
                            });
                            nextState = {
                                ...pluginState,
                                suggestionById: suggestionById,
                                suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId,
                                baseLocalIdBySuggestionId: baseLocalIdBySuggestionId,
                                orderedSuggestionIds: orderedSuggestionIds,
                                selectedSuggestion: undefined,
                                decorations: (0, $ftzrq.DecorationSet).empty
                            };
                            break;
                        }
                    case 'SELECT_SUGGESTION':
                        nextState = {
                            ...pluginState,
                            selectedSuggestion: meta.id,
                            decorations: $4eed6fc998ed6bbf$var$calculateSuggestionsDecorations({
                                doc: newState.doc,
                                suggestionById: pluginState.suggestionById,
                                suggestionIdsByBaseLocalId: pluginState.suggestionIdsByBaseLocalId,
                                api: api,
                                intl: intl,
                                selectedSuggestion: meta.id,
                                nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
                            })
                        };
                        break;
                    case 'REMOVE_SUGGESTION':
                        {
                            const { suggestionById: suggestionById, baseLocalIdBySuggestionId: baseLocalIdBySuggestionId, suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId, orderedSuggestionIds: orderedSuggestionIds } = pluginState;
                            const removedId = meta.id;
                            const suggestion = suggestionById.get(removedId);
                            if (!suggestion) {
                                nextState = {
                                    ...pluginState,
                                    selectedSuggestion: undefined,
                                    decorations: $4eed6fc998ed6bbf$var$calculateSuggestionsDecorations({
                                        doc: newState.doc,
                                        suggestionById: suggestionById,
                                        suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId,
                                        api: api,
                                        intl: intl,
                                        selectedSuggestion: undefined,
                                        nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
                                    })
                                };
                                break;
                            }
                            const nextSuggestionById = new Map(suggestionById);
                            suggestionById.delete(removedId);
                            const baseLocalId = baseLocalIdBySuggestionId.get(removedId);
                            baseLocalIdBySuggestionId.delete(removedId);
                            if (baseLocalId) suggestionIdsByBaseLocalId.get(baseLocalId)?.delete(removedId);
                            nextState = {
                                ...pluginState,
                                suggestionById: nextSuggestionById,
                                baseLocalIdBySuggestionId: baseLocalIdBySuggestionId,
                                suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId,
                                orderedSuggestionIds: orderedSuggestionIds.filter((id)=>id !== removedId),
                                selectedSuggestion: undefined,
                                decorations: $4eed6fc998ed6bbf$var$calculateSuggestionsDecorations({
                                    doc: newState.doc,
                                    suggestionById: nextSuggestionById,
                                    suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId,
                                    api: api,
                                    intl: intl,
                                    selectedSuggestion: undefined,
                                    nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
                                })
                            };
                            break;
                        }
                    default:
                        break;
                }
                else nextState = {
                    ...pluginState,
                    decorations: pluginState.decorations.map(tr.mapping, tr.doc)
                };
                return nextState;
            }
        },
        props: {
            decorations (state) {
                return $4eed6fc998ed6bbf$export$dbbefe45c19011aa.getState(state)?.decorations ?? (0, $ftzrq.DecorationSet).empty;
            }
        },
        view: ()=>{
            const abortController = new AbortController();
            if (contentAri && api) (0, $072616480be2cdf6$export$740daa9a9ce77ea8)({
                contentAri: contentAri,
                api: api,
                generate: false,
                signal: abortController.signal
            });
            return {
                destroy: ()=>{
                    abortController.abort();
                }
            };
        }
    });
}


/* SuggestionCardContentComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 












var $jwWgu = parcelRequire("jwWgu");


function $05fd2bd9ebeb5b7e$export$b632b48a7eefd3bb({ api: api, suggestion: suggestion }) {
    api?.core.actions.execute(({ tr: tr })=>{
        api?.aiStreamingOrchestrator?.actions.startSession();
        suggestion.toolCalls.forEach((toolCall)=>{
            let id;
            const initOptions = {
                hideLoadingScreen: true
            };
            switch(toolCall.name){
                case 'wrap':
                case 'wrapNode':
                    id = api?.aiStreamingOrchestrator?.actions.initAction({
                        type: toolCall.name,
                        localId: toolCall.arguments.localId,
                        wrapperAttrs: toolCall.arguments.wrapperAttrs,
                        wrapperType: toolCall.arguments.wrapperType
                    }, initOptions);
                    break;
                case 'setAttrs':
                    id = api?.aiStreamingOrchestrator?.actions.initAction({
                        type: toolCall.name,
                        localId: toolCall.arguments.localId,
                        attrs: toolCall.arguments.attrs
                    }, initOptions);
                    break;
                case 'removeNode':
                case 'replaceNode':
                case 'insertNodeBefore':
                case 'insertNodeAfter':
                    id = api?.aiStreamingOrchestrator?.actions.initAction({
                        type: toolCall.name,
                        localId: toolCall.arguments.localId
                    }, initOptions);
                    break;
                default:
                    break;
            }
            if (id) {
                if ('value' in toolCall.arguments) api?.aiStreamingOrchestrator?.actions.streamValue(id, toolCall.arguments.value);
                api?.aiStreamingOrchestrator?.actions.finishAction(id, undefined);
            }
        });
        api?.aiStreamingOrchestrator?.actions.endSession();
        return tr;
    });
}



/* SuggestionCard.tsx generated by @compiled/babel-plugin v0.36.1 */ 





parcelRequire("42omo");











var $cO1el = parcelRequire("cO1el");


var $7642E = parcelRequire("7642E");








var $2AytZ = parcelRequire("2AytZ");


var $hmuev = parcelRequire("hmuev");


var $gKvd9 = parcelRequire("gKvd9");


var $9Q2dU = parcelRequire("9Q2dU");


var $lAFHW = parcelRequire("lAFHW");


var $1s5hv = parcelRequire("1s5hv");

var $u9agA = parcelRequire("u9agA");

var $iXCQx = parcelRequire("iXCQx");

const $626f4055e58aa33e$var$stackTiltIn = null;
const $626f4055e58aa33e$var$cardStyles = null;
const $626f4055e58aa33e$var$cardStackStyles = null;
function $626f4055e58aa33e$export$5864b77b647e728c({ onAccept: onAccept, onDiscard: onDiscard, onNavigate: onNavigate, onClose: onClose, suggestion: suggestion, isStacked: isStacked }) {
    const { formatMessage: formatMessage } = (0, $1cfRh.default)();
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        className: (0, $gMc0m.default)([
            "_2rkopb1k _zulppxbi _kqswh2mm _bfhkvuon _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _16qs130s _1bsb1178 _1e0c1txw _2lx21bp4",
            isStacked && "",
            isStacked && "_rfx3pb1k _1cs8stnw _1kt9b3bt _1rusvuon _txdo130s _19woidpf _qnecidpf _1mp41osq _kfgt1osq _8kay14zx _1g0v1mrw _1088nkej _joxlfnf5 _zo246ui8 _1f25q7pw _1xoxglyw _1kky1w3d"
        ]),
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                alignItems: "center",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                        space: "space.0",
                        alignBlock: "center",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default /* eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed) */ ), {
                                icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))), {
                                        label: formatMessage((0, $95fcf8bb61fa82af$export$e4f30354a76c156b).cardExpandButtonLabel),
                                        size: "small"
                                    }),
                                label: formatMessage((0, $95fcf8bb61fa82af$export$e4f30354a76c156b).cardExpandButtonLabel),
                                appearance: "subtle",
                                spacing: "compact",
                                isDisabled: !onNavigate,
                                onClick: onNavigate ? ()=>onNavigate('up') : undefined
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default /* eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed) */ ), {
                                icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                                        label: formatMessage((0, $95fcf8bb61fa82af$export$e4f30354a76c156b).cardCollapseButtonLabel),
                                        size: "small"
                                    }),
                                label: formatMessage((0, $95fcf8bb61fa82af$export$e4f30354a76c156b).cardCollapseButtonLabel),
                                appearance: "subtle",
                                spacing: "compact",
                                isDisabled: !onNavigate,
                                onClick: onNavigate ? ()=>onNavigate('down') : undefined
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
                        label: formatMessage((0, $95fcf8bb61fa82af$export$e4f30354a76c156b).cardCloseButtonLabel),
                        appearance: "subtle",
                        spacing: "compact",
                        onClick: onClose
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                space: "space.100",
                alignBlock: "center",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.RovoIcon), {
                        label: formatMessage((0, $95fcf8bb61fa82af$export$e4f30354a76c156b).cardRovoTitle),
                        size: "small",
                        shouldUseNewLogoDesign: true,
                        shouldUseHexLogo: true
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                        size: "xsmall",
                        children: formatMessage((0, $95fcf8bb61fa82af$export$e4f30354a76c156b).cardRovoTitle)
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $7642E.IconTile), {
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9Q2dU))),
                        label: formatMessage((0, $95fcf8bb61fa82af$export$e4f30354a76c156b).cardPrivateLabel),
                        appearance: "gray",
                        size: "xsmall"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                as: "p",
                color: "color.text.subtle",
                children: suggestion
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                alignItems: "center",
                justifyContent: "start",
                gap: "space.050",
                wrap: "wrap",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))),
                        appearance: "default",
                        onClick: onAccept,
                        children: formatMessage((0, $95fcf8bb61fa82af$export$e4f30354a76c156b).cardAcceptButtonLabel)
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))),
                        appearance: "subtle",
                        onClick: onDiscard,
                        children: formatMessage((0, $95fcf8bb61fa82af$export$e4f30354a76c156b).cardDiscardButtonLabel)
                    })
                ]
            })
        ]
    });
}


const $b71ad3bab76820ab$var$containerStyle = null; /**
                              * We render this in a content component because rendering directly in a Decoration widget
                              * will cause it to inherit font stylings from Editor which is not appropriate for this component.
                              */ 
const $b71ad3bab76820ab$export$b9f1c5d82af9ea41 = ({ api: api })=>{
    /**
   * We use useState & useCallback to set the ref so that the popup will mount correctly after the
   * anchor mounts.
   */ const [target, setTarget] = (0, $42omo.useState)();
    const targetRef = (0, $42omo.useCallback)((node)=>{
        setTarget(node);
    }, []);
    const { suggestionById: suggestionById, selectedSuggestion: selectedSuggestion, baseLocalIdBySuggestionId: baseLocalIdBySuggestionId, hasMultipleSuggestions: hasMultipleSuggestions, orderedSuggestionIds: orderedSuggestionIds } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'aiSuggestions'
    ], (state)=>{
        const { suggestionById: suggestionById, suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId, baseLocalIdBySuggestionId: baseLocalIdBySuggestionId, selectedSuggestion: selectedId, orderedSuggestionIds: orderedSuggestionIds } = state?.aiSuggestionsState ?? {};
        const selectedSuggestion = selectedId !== undefined && suggestionById !== undefined ? suggestionById.get(selectedId) : undefined;
        const baseLocalId = baseLocalIdBySuggestionId && selectedId ? baseLocalIdBySuggestionId.get(selectedId) : undefined;
        const hasMultipleSuggestions = baseLocalId ? (suggestionIdsByBaseLocalId?.get(baseLocalId)?.size || 1) > 1 : false;
        return {
            suggestionById: suggestionById,
            hasMultipleSuggestions: hasMultipleSuggestions,
            selectedSuggestion: selectedSuggestion,
            orderedSuggestionIds: orderedSuggestionIds,
            baseLocalIdBySuggestionId: baseLocalIdBySuggestionId
        };
    });
    if (selectedSuggestion === undefined) return;
    const onClose = ()=>{
        api?.core?.actions.execute(({ tr: tr })=>{
            tr.setMeta((0, $4eed6fc998ed6bbf$export$dbbefe45c19011aa), {
                action: 'SELECT_SUGGESTION',
                id: undefined
            });
            api?.showDiff?.commands.hideDiff?.({
                tr: tr
            });
            return tr;
        });
    };
    const onDiscard = ()=>{
        api?.core?.actions.execute(({ tr: tr })=>{
            tr.setMeta((0, $4eed6fc998ed6bbf$export$dbbefe45c19011aa), {
                action: 'REMOVE_SUGGESTION',
                id: selectedSuggestion.id
            });
            api?.showDiff?.commands.hideDiff?.({
                tr: tr
            });
            return tr;
        });
    };
    const onAccept = ()=>{
        api?.core?.actions.execute(({ tr: tr })=>{
            api?.showDiff?.commands.hideDiff?.({
                tr: tr
            });
            tr.setMeta((0, $4eed6fc998ed6bbf$export$dbbefe45c19011aa), {
                action: 'REMOVE_SUGGESTION',
                id: selectedSuggestion.id
            });
            return tr;
        });
        setTimeout(()=>{
            (0, $05fd2bd9ebeb5b7e$export$b632b48a7eefd3bb)({
                api: api,
                suggestion: selectedSuggestion
            });
        }, 0);
    };
    const onNavigate = (direction)=>{
        const currentId = selectedSuggestion.id;
        if (!orderedSuggestionIds || orderedSuggestionIds?.length === 0) return undefined;
        const idx = orderedSuggestionIds.indexOf(currentId);
        if (idx === -1) return undefined;
        const delta = direction === 'up' ? -1 : 1;
        const nextIdx = (idx + delta + orderedSuggestionIds.length) % orderedSuggestionIds.length;
        const nextSuggestion = suggestionById?.get(orderedSuggestionIds[nextIdx]);
        if (!nextSuggestion) return undefined;
        api?.core?.actions.execute(({ tr: tr })=>{
            const invertedTr = (0, $f4f309f882685735$export$4163bdb44341f987)(tr, nextSuggestion);
            api?.showDiff?.commands.showDiff({
                steps: invertedTr.steps.map((step)=>step.invert(invertedTr.before)),
                originalDoc: invertedTr.doc,
                isInverted: true
            })({
                tr: tr
            });
            const nextId = orderedSuggestionIds[nextIdx];
            if (nextId === undefined) return tr;
            tr.setMeta((0, $4eed6fc998ed6bbf$export$dbbefe45c19011aa), {
                action: 'SELECT_SUGGESTION',
                id: nextId
            });
            return tr;
        });
    };
    /**
   * We create an anchor that is positioned to match the anchor created in Decoration.widget.
   * We also use a Popup and mount it onto this anchor so that we get the benefits of
   * boundary detection and easier positioning.
   */ return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("span", {
                ref: targetRef,
                style: {
                    positionAnchor: `--button-${baseLocalIdBySuggestionId?.get(selectedSuggestion.id)}`,
                    insetBlockStart: `anchor(start)`,
                    insetInlineStart: `anchor(end)`
                },
                className: (0, $gMc0m.default)([
                    "_1e0c1ule _kqswstnw _1pbycs5v"
                ])
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $jwWgu.default), {
                target: target,
                stick: true,
                minPopupMargin: 24,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $626f4055e58aa33e$export$5864b77b647e728c), {
                    suggestion: selectedSuggestion?.description,
                    onNavigate: orderedSuggestionIds && orderedSuggestionIds.length > 1 ? onNavigate : undefined,
                    onClose: onClose,
                    onDiscard: onDiscard,
                    onAccept: onAccept,
                    isStacked: hasMultipleSuggestions
                })
            })
        ]
    });
};



const $5d6abfec5f8b86f9$export$e4fa509a217898d8 = ({ api: api, config: config })=>{
    const { contentAri: contentAri } = config;
    const quickInsert = ({ formatMessage: formatMessage })=>contentAri ? [
            {
                title: formatMessage((0, $95fcf8bb61fa82af$export$e4f30354a76c156b).fetchGenerateFromDocument),
                keywords: [
                    'ai',
                    'suggest',
                    'rovo'
                ],
                icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($h7YX1))), {
                        label: ""
                    }),
                action (_insert, state) {
                    (0, $072616480be2cdf6$export$740daa9a9ce77ea8)({
                        api: api,
                        contentAri: contentAri,
                        generate: true,
                        forceAdf: false
                    });
                    return state.tr;
                }
            }
        ] : [
            {
                title: formatMessage((0, $95fcf8bb61fa82af$export$e4f30354a76c156b).fetchGenerateFromAdf),
                keywords: [
                    'ai',
                    'suggest',
                    'page',
                    'adf'
                ],
                icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($h7YX1))), {
                        label: ""
                    }),
                action (_insert, state) {
                    (0, $072616480be2cdf6$export$740daa9a9ce77ea8)({
                        api: api,
                        contentAri: contentAri,
                        generate: true,
                        forceAdf: true
                    });
                    return state.tr;
                }
            }
        ];
    return {
        name: 'aiSuggestions',
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const pluginState = (0, $4eed6fc998ed6bbf$export$dbbefe45c19011aa).getState(editorState);
            if (!pluginState) return undefined;
            return {
                selectedSuggestion: pluginState.selectedSuggestion,
                suggestionById: pluginState.suggestionById,
                baseLocalIdBySuggestionId: pluginState.baseLocalIdBySuggestionId,
                suggestionIdsByBaseLocalId: pluginState.suggestionIdsByBaseLocalId,
                orderedSuggestionIds: pluginState.orderedSuggestionIds
            };
        },
        pmPlugins () {
            return [
                {
                    name: 'aiSuggestionsPlugin',
                    plugin: ({ getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>{
                        const intl = getIntl?.();
                        return (0, $4eed6fc998ed6bbf$export$ae829ec7b2625219)({
                            api: api,
                            intl: intl,
                            contentAri: contentAri,
                            nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
                        });
                    }
                }
            ];
        },
        contentComponent ({}) {
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $b71ad3bab76820ab$export$b9f1c5d82af9ea41), {
                api: api
            });
        },
        pluginsOptions: {
            quickInsert: quickInsert
        }
    };
};






var $dus6D = parcelRequire("dus6D");




const $311d92b3b6eb92ca$export$56937bf89365f70d = new (0, $ks2lK.PluginKey)('aiAutocompletePlugin');


const $038bd350e498990f$export$92a1a3b7554e9387 = {
    TRIGGER_MANUAL: 'TRIGGER_MANUAL',
    TRIGGER_AUTO: 'TRIGGER_AUTO',
    SET_SUGGESTION: 'SET_SUGGESTION',
    REVEAL_SUGGESTION: 'REVEAL_SUGGESTION',
    DISMISS: 'DISMISS'
};



var $d925B = parcelRequire("d925B");

const $e9233283002d8aa0$export$37798a7ff6f20cd2 = (editorAnalyticsAPI)=>(transaction, triggerType)=>{
        const payload = {
            action: (0, $d925B.ACTION).INVOKED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).AI_AUTOCOMPLETE,
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            attributes: {
                triggerType: triggerType
            }
        };
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(transaction);
        return transaction;
    };
const $e9233283002d8aa0$export$edd7849651b2a74a = (editorAnalyticsAPI)=>(transaction)=>{
        const payload = {
            action: (0, $d925B.ACTION).SUGGESTION_VIEWED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).AI_AUTOCOMPLETE,
            eventType: (0, $d925B.EVENT_TYPE).TRACK
        };
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(transaction);
        return transaction;
    };
const $e9233283002d8aa0$export$c26e1e4a084cdc9e = (editorAnalyticsAPI)=>(transaction)=>{
        const payload = {
            action: (0, $d925B.ACTION).SUGGESTION_INSERTED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).AI_AUTOCOMPLETE,
            eventType: (0, $d925B.EVENT_TYPE).TRACK
        };
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(transaction);
        return transaction;
    };
const $e9233283002d8aa0$export$61436ea80e595f1a = (editorAnalyticsAPI)=>(transaction)=>{
        const payload = {
            action: (0, $d925B.ACTION).SUGGESTION_DISMISSED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).AI_AUTOCOMPLETE,
            eventType: (0, $d925B.EVENT_TYPE).TRACK
        };
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(transaction);
        return transaction;
    };



var $c6GJD = parcelRequire("c6GJD");

function $20d0f4c91e5cc1c5$var$isStringList(value) {
    return Array.isArray(value) && value.every((item)=>typeof item === 'string');
}
const $20d0f4c91e5cc1c5$var$STRING_LIST_CONFIG_KEY = 'value';
function $20d0f4c91e5cc1c5$export$f1de66450aeccbb6(configName, token) {
    if (!(0, $c6GJD.default).initializeCompleted()) return false;
    try {
        // Dynamic configs are exposed through the same client surface as experiments.
        // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        const config = (0, $c6GJD.default).getExperiment(configName);
        const listCandidate = config.value[$20d0f4c91e5cc1c5$var$STRING_LIST_CONFIG_KEY];
        if (!$20d0f4c91e5cc1c5$var$isStringList(listCandidate)) return false;
        return listCandidate.includes(token);
    } catch  {
        return false;
    }
}


function $371ce3c3ecf3dace$export$7e72d5dcc9007fb(state) {
    const { $from: $from } = state.selection;
    const parent = $from.parent;
    if (parent.type !== state.schema.nodes.heading) return {
        cursorInHeading: false,
        headingPos: -1,
        headingText: '',
        headingLevel: 0
    };
    // $from.before($from.depth) gives us the absolute position of the start of
    // the heading node (the opening token position).
    const headingPos = $from.before($from.depth);
    const headingText = parent.textContent.trim();
    const headingLevel = parent.attrs['level'] ?? 1;
    return {
        cursorInHeading: true,
        headingPos: headingPos,
        headingText: headingText,
        headingLevel: headingLevel
    };
}


/** Default minimum words when `platform_editor_ai_autocomplete_ux_config` has no word-count token. */ const $a33bacd3740d6e5a$var$MIN_DOCUMENT_WORDS = 400;
/** On Enter: dismiss if the cursor block exceeds this length (non-heading). */ const $a33bacd3740d6e5a$var$AUTO_DISMISS_MAX_CHARS_NON_HEADING = 20;
/** On Enter: dismiss if the cursor block exceeds this length (heading). */ const $a33bacd3740d6e5a$var$AUTO_DISMISS_MAX_CHARS_HEADING = 50;
const $a33bacd3740d6e5a$var$AI_AUTOCOMPLETE_UX_DYNAMIC_CONFIG = 'platform_editor_ai_autocomplete_ux_config';
/**
 * Minimum words in the whole document before autocomplete trigger may fire.
 * Driven by Statsig dynamic config `platform_editor_ai_autocomplete_ux_config`
 * string list (`value` key); first matching token wins if several are present.
 */ function $a33bacd3740d6e5a$var$getMinDocumentWords() {
    if ((0, $20d0f4c91e5cc1c5$export$f1de66450aeccbb6)($a33bacd3740d6e5a$var$AI_AUTOCOMPLETE_UX_DYNAMIC_CONFIG, 'word-count-300')) return 300;
    if ((0, $20d0f4c91e5cc1c5$export$f1de66450aeccbb6)($a33bacd3740d6e5a$var$AI_AUTOCOMPLETE_UX_DYNAMIC_CONFIG, 'word-count-200')) return 200;
    if ((0, $20d0f4c91e5cc1c5$export$f1de66450aeccbb6)($a33bacd3740d6e5a$var$AI_AUTOCOMPLETE_UX_DYNAMIC_CONFIG, 'word-count-350')) return 350;
    return $a33bacd3740d6e5a$var$MIN_DOCUMENT_WORDS;
}
function $a33bacd3740d6e5a$export$6f212eb1ee72d86a(doc) {
    return doc.textBetween(0, doc.content.size, '\n', ' ');
}
/**
 * Word count for the full document, aligned with editor analytics style:
 * normalize whitespace, then `Intl.Segmenter` word + `isWordLike`, else whitespace split.
 */ function $a33bacd3740d6e5a$var$countWordsInDocument(doc) {
    // @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    const normalized = $a33bacd3740d6e5a$export$6f212eb1ee72d86a(doc).replace(/\s+/gu, ' ').trim();
    if (!normalized) return 0;
    if (typeof Intl !== 'undefined' && typeof Intl.Segmenter === 'function') try {
        const seg = new Intl.Segmenter('und', {
            granularity: 'word'
        });
        let n = 0;
        for (const part of seg.segment(normalized))if (part.isWordLike) n++;
        return n;
    } catch  {
    // fall through
    }
    // @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    return normalized.split(/\s+/u).length;
}
function $a33bacd3740d6e5a$export$203aad1d4d95d0de(state) {
    const inHeading = (0, $371ce3c3ecf3dace$export$7e72d5dcc9007fb)(state).cursorInHeading;
    const len = state.selection.$from.parent.textContent.length;
    const maxChars = inHeading ? $a33bacd3740d6e5a$var$AUTO_DISMISS_MAX_CHARS_HEADING : $a33bacd3740d6e5a$var$AUTO_DISMISS_MAX_CHARS_NON_HEADING;
    return len > maxChars;
}
function $a33bacd3740d6e5a$export$8532deffc62f2372(state) {
    const wordCount = $a33bacd3740d6e5a$var$countWordsInDocument(state.doc);
    return wordCount >= $a33bacd3740d6e5a$var$getMinDocumentWords();
}


/** How many lines from the top of the doc still count for Summary auto-trigger (first line = 1). */ const $42b59b5039e481b9$var$MAX_LINES_FROM_DOC_START = 4;
/** How many lines from the end of the doc count for Conclusion auto-trigger. */ const $42b59b5039e481b9$var$MAX_LINES_FROM_DOC_END = 4;
function $42b59b5039e481b9$export$faff1b56818221b9(doc, pos) {
    const maxPos = doc.content.size;
    const clamped = Math.max(1, Math.min(pos, maxPos));
    const slice = doc.textBetween(1, clamped, '\n', ' ');
    if (!slice) return 1;
    return slice.split('\n').length;
}
function $42b59b5039e481b9$export$86e2c649a3fb270b(state) {
    return $42b59b5039e481b9$export$faff1b56818221b9(state.doc, state.selection.from) <= $42b59b5039e481b9$var$MAX_LINES_FROM_DOC_START;
}
function $42b59b5039e481b9$export$a0cc97e2eec5e2c9(state) {
    const { doc: doc } = state;
    const cursorLine = $42b59b5039e481b9$export$faff1b56818221b9(doc, state.selection.from);
    const totalLines = $42b59b5039e481b9$export$faff1b56818221b9(doc, doc.content.size);
    return totalLines - cursorLine < $42b59b5039e481b9$var$MAX_LINES_FROM_DOC_END;
}



function $0d9b827195d68a18$export$430bd2456e5b9d09(event) {
    if (event.metaKey || event.ctrlKey || event.altKey) return false;
    if (event.key === 'Enter') return true;
    if (event.key.length === 1) return /[\s.,;:!?)\]}"'»«/\\]/u.test(event.key);
    return false;
}
function $0d9b827195d68a18$export$32dfe294464a680b(state) {
    const { $from: $from } = state.selection;
    if (!$from.parent.isTextblock || $from.parentOffset === 0) return null;
    const textBefore = $from.parent.textBetween(0, $from.parentOffset, undefined, '\ufffc');
    const withoutTrailingSeparators = textBefore.replace(RegExp("[\\s\\p{P}]+$", "u"), '');
    if (!withoutTrailingSeparators) return null;
    const words = withoutTrailingSeparators.split(RegExp("[\\s\\p{P}]+", "u"));
    const last = words[words.length - 1];
    if (!last || !RegExp("^[\\p{L}\\p{N}_]+$", "u").test(last)) return null;
    return last;
}
function $0d9b827195d68a18$export$38f22e55366a41d0(word, keywordSet) {
    return keywordSet.includes(word.toLowerCase());
}





const $0142429418a04af3$export$ee1116f260b39d9b = (0, $h82at.defineMessages)({
    summaryKeywords: {
        id: "fabric.editor.ai.autocomplete.summary.trigger.keywords.non-final",
        defaultMessage: "summary, tldr, tl;dr, tl dr, overview, synopsis, recap, abstract, brief, outline, quick, in short, rundown, review, roundup, highlights, key points, snapshot, at a glance, in essence, takeaways, to summarize, to summarise"
    },
    conclusionKeywords: {
        id: "fabric.editor.ai.autocomplete.conclusion.trigger.keywords.non-final",
        defaultMessage: "conclusion, conclusions, findings, results, outcome, outcomes, final thoughts, takeaway, takeaways, verdict, determination, resolution, final analysis, deduction, judgment, decision, culmination, end result, bottom line, final word, closing, to conclude, final notes, learnings, what we learned, overall"
    },
    nextStepsKeywords: {
        id: "fabric.editor.ai.autocomplete.next.steps.trigger.keywords.non-final",
        defaultMessage: "recommendations, follow-through, implementation, moving forward, going forward, deliverables, path forward, what is next, way forward, what's next, next steps, priorities, whats next, task list, follow-up, follow up, next step, followup, priority, next up, up next, roadmap, actions, action, tasks, todos, to do, to-do, todo, plan"
    }
});


/**
 * Parses the formatted trigger-keywords string (comma-separated phrases) into trimmed tokens.
 */ function $4e14c2a9f109857c$var$splitAutocompleteTriggerKeywords(intl, messages) {
    return intl().formatMessage(messages).split(',').map((s)=>s.trim()).filter((s)=>s.length > 0);
}
function $4e14c2a9f109857c$export$d5883a29c5e2615e(intl) {
    return $4e14c2a9f109857c$var$splitAutocompleteTriggerKeywords(intl, (0, $0142429418a04af3$export$ee1116f260b39d9b).summaryKeywords);
}
function $4e14c2a9f109857c$export$ec1e17d2784ef29d(intl) {
    return $4e14c2a9f109857c$var$splitAutocompleteTriggerKeywords(intl, (0, $0142429418a04af3$export$ee1116f260b39d9b).conclusionKeywords);
}
function $4e14c2a9f109857c$export$840323b8f6b537aa(intl) {
    return $4e14c2a9f109857c$var$splitAutocompleteTriggerKeywords(intl, (0, $0142429418a04af3$export$ee1116f260b39d9b).nextStepsKeywords);
}


/**
 * True for keys that typically mutate document text (printable chars,
 * Backspace, Delete, Enter) when not combined with meta/ctrl modifiers.
 */ function $e09ae141c8fa8668$var$isDocMutatingKey(event) {
    if (event.isComposing || event.key === 'Process') return false;
    if (event.key === 'Backspace' || event.key === 'Delete') return true;
    if (event.key === 'Enter' && !event.metaKey && !event.ctrlKey) return true;
    return event.key.length === 1 && !event.metaKey && !event.ctrlKey;
}
function $e09ae141c8fa8668$export$a57bf7fb2aa68075({ api: api, getIntl: getIntl, autoTriggerSharedState: autoTriggerSharedState }) {
    const editorAnalyticsAPI = api?.analytics?.actions;
    /** Per-editor instance: coalesced idle check for summary keyword detection. */ let pendingSummaryKeywordIdleId;
    const summaryKeywords = (0, $4e14c2a9f109857c$export$d5883a29c5e2615e)(getIntl);
    const cancelPendingSummaryKeywordCheck = ()=>{
        if (pendingSummaryKeywordIdleId === undefined) return;
        if (typeof cancelIdleCallback === 'function') cancelIdleCallback(pendingSummaryKeywordIdleId);
        else cancelAnimationFrame(pendingSummaryKeywordIdleId);
        pendingSummaryKeywordIdleId = undefined;
    };
    /**
   * Pattern matching runs in an idle callback (see block-controls / insert-block)
   * so we do not add work on the critical key path; DOM + doc are up to date by then.
   */ const scheduleSummaryKeywordCheckOnIdle = (view)=>{
        cancelPendingSummaryKeywordCheck();
        const flush = ()=>{
            pendingSummaryKeywordIdleId = undefined;
            if (view.isDestroyed) return;
            const word = (0, $0d9b827195d68a18$export$32dfe294464a680b)(view.state);
            if (word && (0, $0d9b827195d68a18$export$38f22e55366a41d0)(word, summaryKeywords) && !(0, $a33bacd3740d6e5a$export$203aad1d4d95d0de)(view.state)) {
                const pluginState = (0, $311d92b3b6eb92ca$export$56937bf89365f70d).getState(view.state);
                if (pluginState && pluginState.status !== 'idle') api?.core?.actions?.execute?.(api?.aiAutocomplete?.commands?.dismissSuggestion?.());
                const { from: resolvedCursorPos } = view.state.selection;
                const invokeTr = view.state.tr.setMeta((0, $311d92b3b6eb92ca$export$56937bf89365f70d), {
                    type: (0, $038bd350e498990f$export$92a1a3b7554e9387).TRIGGER_AUTO,
                    cursorPos: resolvedCursorPos,
                    triggerType: 'summary'
                });
                const summaryTriggerType = (0, $371ce3c3ecf3dace$export$7e72d5dcc9007fb)(view.state).cursorInHeading ? 'summary-heading' : 'summary-first-lines';
                (0, $e9233283002d8aa0$export$37798a7ff6f20cd2)(editorAnalyticsAPI)(invokeTr, summaryTriggerType);
                view.dispatch(invokeTr);
            }
        };
        if (typeof requestIdleCallback === 'function') pendingSummaryKeywordIdleId = requestIdleCallback(flush, {
            timeout: 2000
        });
        else pendingSummaryKeywordIdleId = requestAnimationFrame(flush);
    };
    const triggerManualInline = (state, dispatch, view)=>{
        if (!dispatch || !view) return false;
        const pluginState = (0, $311d92b3b6eb92ca$export$56937bf89365f70d).getState(state);
        if (pluginState && pluginState.status !== 'idle') api?.core?.actions?.execute?.(api?.aiAutocomplete?.commands?.dismissSuggestion?.());
        const freshState = view.state;
        const resolvedCursorPos = freshState.selection.from;
        const invokeTr = freshState.tr.setMeta((0, $311d92b3b6eb92ca$export$56937bf89365f70d), {
            type: (0, $038bd350e498990f$export$92a1a3b7554e9387).TRIGGER_MANUAL,
            cursorPos: resolvedCursorPos
        });
        (0, $e9233283002d8aa0$export$37798a7ff6f20cd2)(editorAnalyticsAPI)(invokeTr, 'cmd+shift+space');
        view.dispatch(invokeTr);
        return true;
    };
    // ── Enter: auto-trigger Enter-reveal flow ─────────────────────────
    // Returns `false` in every branch so ProseMirror still processes
    // the Enter key (new paragraph / split node).  Side effects (flag
    // set, dismiss, scheduled reveal) happen before that.
    const handleEnter = (state, _dispatch, view)=>{
        const pluginState = (0, $311d92b3b6eb92ca$export$56937bf89365f70d).getState(state);
        // Active state + exceeds char limit → dismiss, let Enter through
        if (pluginState && pluginState.status !== 'idle' && (0, $a33bacd3740d6e5a$export$203aad1d4d95d0de)(state)) {
            api?.core?.actions?.execute?.(api?.aiAutocomplete?.commands?.dismissSuggestion?.());
            return false;
        }
        // Loading + auto: flag that Enter was pressed so the API
        // response handler can show the suggestion immediately
        if (pluginState?.status === 'loading' && pluginState.trigger === 'auto') {
            autoTriggerSharedState.userPressedEnter = true;
            return false;
        }
        // suggestion_pending: reveal ghost at new cursor after Enter creates a new block
        if (pluginState?.status === 'suggestion_pending' && view) {
            setTimeout(()=>{
                if (view.isDestroyed) return;
                const pending = (0, $311d92b3b6eb92ca$export$56937bf89365f70d).getState(view.state);
                if (pending?.status !== 'suggestion_pending') return;
                const cursorPos = view.state.selection.from;
                const revealTr = view.state.tr.setMeta((0, $311d92b3b6eb92ca$export$56937bf89365f70d), {
                    type: (0, $038bd350e498990f$export$92a1a3b7554e9387).REVEAL_SUGGESTION,
                    cursorPos: cursorPos
                });
                (0, $e9233283002d8aa0$export$edd7849651b2a74a)(editorAnalyticsAPI)(revealTr);
                view.dispatch(revealTr);
            }, 0);
            return false;
        }
        return false;
    };
    const bindings = {
        ['Mod-Shift-Space']: triggerManualInline,
        ['Meta-Shift-Space']: triggerManualInline,
        ['Enter']: handleEnter,
        ['Tab']: (state, dispatch)=>{
            const pluginState = (0, $311d92b3b6eb92ca$export$56937bf89365f70d).getState(state);
            if (pluginState?.status !== 'suggestion') return false;
            if (!dispatch) return false;
            return api?.core?.actions?.execute?.(api?.aiAutocomplete?.commands?.acceptSuggestion?.({
                cursorPos: pluginState.cursorPos,
                suggestion: pluginState.suggestion
            })) ?? false;
        },
        ['Escape']: (state, dispatch)=>{
            const pluginState = (0, $311d92b3b6eb92ca$export$56937bf89365f70d).getState(state);
            if (!pluginState || pluginState.status === 'idle') return false;
            if (!dispatch) return false;
            return api?.core?.actions?.execute?.(api?.aiAutocomplete?.commands?.dismissSuggestion?.()) ?? false;
        }
    };
    return new (0, $1S4f7.SafePlugin)({
        view () {
            return {
                destroy () {
                    cancelPendingSummaryKeywordCheck();
                }
            };
        },
        props: {
            handleKeyDown (view, event) {
                if ((0, $dus6D.keydownHandler)(bindings)(view, event)) return true;
                // Re-read state: the Enter binding may have dispatched a
                // dismiss (char-limit case), making the state idle already.
                const pluginState = (0, $311d92b3b6eb92ca$export$56937bf89365f70d).getState(view.state);
                // The Enter binding returns false (to let the default Enter
                // through) but already set flags / scheduled reveal for these
                // states — don't let the generic dismiss undo that work.
                if (event.key === 'Enter' && !event.shiftKey && pluginState && (pluginState.status === 'loading' || pluginState.status === 'suggestion_pending')) return false;
                // ── Auto loading / pending: same-line editing tolerance ────────
                // Allow document-mutating keys on the trigger line without
                // dismissing the session; once the cursor moves below the trigger
                // line, further typing dismisses.
                if (pluginState && (pluginState.status === 'loading' || pluginState.status === 'suggestion_pending') && pluginState.trigger === 'auto' && autoTriggerSharedState.triggerLineIndex !== null && $e09ae141c8fa8668$var$isDocMutatingKey(event)) {
                    const lineNow = (0, $42b59b5039e481b9$export$faff1b56818221b9)(view.state.doc, view.state.selection.from);
                    if (lineNow <= autoTriggerSharedState.triggerLineIndex) return false;
                }
                // ── Generic: dismiss any active state ─────────────────────────
                if (pluginState && pluginState.status !== 'idle') api?.core?.actions?.execute?.(api?.aiAutocomplete?.commands?.dismissSuggestion?.());
                // ── Schedule keyword check ────────────────────────────────────
                if ((0, $a33bacd3740d6e5a$export$8532deffc62f2372)(view.state) && (0, $42b59b5039e481b9$export$86e2c649a3fb270b)(view.state)) scheduleSummaryKeywordCheckOnIdle(view);
                return false;
            }
        }
    });
}






function $e687d8470d23775c$var$isSuggestionVisibleState(state) {
    return state?.status === 'suggestion';
}
const $e687d8470d23775c$export$f87341fc5281ec6c = (options)=>{
    const { api: api } = options;
    return new (0, $1S4f7.SafePlugin)({
        view () {
            let previousSuggestionVisible = false;
            return {
                update (view) {
                    if (!api?.placeholder || !api?.core) return;
                    const pluginState = (0, $311d92b3b6eb92ca$export$56937bf89365f70d).getState(view.state);
                    const suggestionVisible = $e687d8470d23775c$var$isSuggestionVisibleState(pluginState);
                    if (suggestionVisible !== previousSuggestionVisible) {
                        previousSuggestionVisible = suggestionVisible;
                        api.core.actions.execute(api.placeholder.commands.setPlaceholderHidden(suggestionVisible));
                    }
                }
            };
        }
    });
};


/**
 * Mutable state shared between the keymap plugin (keydown handling) and the
 * main autocomplete plugin (API lifecycle + appendTransaction).
 *
 * Both plugins live in the same editor instance and run synchronously on the
 * same JS thread, so a plain object is safe — no locking required.
 *
 * A single instance is created per editor in the top-level plugin factory and
 * passed to both sub-plugins via their constructors.
 */ function $a5e9aefac3add1ee$export$6691711a081bd09a() {
    return {
        userPressedEnter: false,
        postEnterPlainTextBaseline: null,
        triggerLineIndex: null
    };
}








const $b30d2a251c70d654$export$bb9c6e4618c88231 = ({ cursorPos: cursorPos, suggestion: suggestion }, editorAnalyticsAPI)=>({ tr: tr })=>{
        (0, $e9233283002d8aa0$export$c26e1e4a084cdc9e)(editorAnalyticsAPI)(tr);
        tr.insert(cursorPos, tr.doc.type.schema.text(suggestion));
        tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, cursorPos + suggestion.length));
        tr.setMeta((0, $311d92b3b6eb92ca$export$56937bf89365f70d), {
            type: (0, $038bd350e498990f$export$92a1a3b7554e9387).DISMISS
        });
        tr.setMeta('addToHistory', true);
        return tr;
    };
const $b30d2a251c70d654$export$82b68e9b2902c23d = (editorAnalyticsAPI)=>({ tr: tr })=>{
        (0, $e9233283002d8aa0$export$61436ea80e595f1a)(editorAnalyticsAPI)(tr);
        return tr.setMeta((0, $311d92b3b6eb92ca$export$56937bf89365f70d), {
            type: (0, $038bd350e498990f$export$92a1a3b7554e9387).DISMISS
        });
    };







const $c2e11dbc5bd85e2f$var$MAX_TOKENS = 400;
/**
 * Derives the correct API host, matching the pattern used by other editor AI
 * features in editor-plugin-ai/src/ui/prebuilt/utils.ts.
 *
 * On localhost (non-port-8081) and Atlaskit storybook hosts, routes to
 * pug.jira-dev.com so API calls work without a local backend.
 * In all other environments (staging, prod) uses window.location.origin.
 */ function $c2e11dbc5bd85e2f$var$deriveHost() {
    const { origin: origin = '', port: port = '', hostname: hostname = '' } = typeof window !== 'undefined' && window.location ? window.location : {};
    if (hostname === 'localhost' && port !== '8081' || [
        'atlaskit-website-staging.stg-east.frontend.public.atl-paas.net',
        'statlas.prod.atl-paas.net',
        'atlaskit.atlassian.com'
    ].some((h)=>hostname === h)) return 'https://pug.jira-dev.com';
    return origin;
}
function $c2e11dbc5bd85e2f$var$getApiEndpoint() {
    return `${$c2e11dbc5bd85e2f$var$deriveHost()}/gateway/api/assist/api/ai/v2/ai-feature/heading-autocomplete`;
}
async function $c2e11dbc5bd85e2f$export$9384628242350716(pageContentMarkdown, signal) {
    const response = await fetch($c2e11dbc5bd85e2f$var$getApiEndpoint(), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Experience-Id': 'editor',
            'X-Product': 'confluence'
        },
        credentials: 'include',
        signal: signal,
        body: JSON.stringify({
            ai_feature_input: {
                page_content_markdown: pageContentMarkdown,
                max_tokens: $c2e11dbc5bd85e2f$var$MAX_TOKENS
            }
        })
    });
    if (!response.ok) throw new Error(`Heading autocomplete API error: ${response.status} ${response.statusText}`);
    const data = await response.json();
    const generatedParagraph = data?.ai_feature_output?.generated_paragraph;
    if (!generatedParagraph) throw new Error('Heading autocomplete API returned an empty or malformed response');
    return generatedParagraph;
}





var $6eZqW = parcelRequire("6eZqW");

const $517b90048513d413$var$GENERATE_MARKER = '<!-- GENERATE_HERE -->';
function $517b90048513d413$export$99167e00e2d4f9dd(view, cursorPos) {
    const doc = view.state.doc;
    // Serialize content before the cursor
    const beforeSlice = doc.slice(0, cursorPos);
    const { markdown: mdBefore } = (0, $6eZqW.convertProsemirrorToMarkdown)({
        editorView: view,
        fragment: beforeSlice.content,
        featureToggles: {}
    });
    // Serialize content after the cursor
    const afterSlice = doc.slice(cursorPos);
    const { markdown: mdAfter } = (0, $6eZqW.convertProsemirrorToMarkdown)({
        editorView: view,
        fragment: afterSlice.content,
        featureToggles: {}
    });
    const before = mdBefore.trimEnd();
    const after = mdAfter.trimStart();
    if (after) return `${before} ${$517b90048513d413$var$GENERATE_MARKER}\n${after}`;
    return `${before} ${$517b90048513d413$var$GENERATE_MARKER}`;
}








const $54331ed359655e88$var$GHOST_INLINE_CLASS = 'heading-autocomplete-ghost-inline';
const $54331ed359655e88$var$GHOST_HINT_CLASS = 'heading-autocomplete-ghost-text-hint';
const $54331ed359655e88$var$ghostInlineStyle = (0, $24P9d.convertToInlineCss)({
    color: "var(--ds-text-subtlest, #6B6E76)",
    opacity: '0.95',
    pointerEvents: 'none',
    userSelect: 'none',
    whiteSpace: 'pre-wrap'
});
const $54331ed359655e88$var$ghostHintStyle = (0, $24P9d.convertToInlineCss)({
    backgroundColor: "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
    borderRadius: "var(--ds-radius-small, 4px)",
    padding: "var(--ds-space-050, 4px)",
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    marginLeft: "var(--ds-space-050, 4px)",
    verticalAlign: '3px'
});
const $54331ed359655e88$var$ghostHintTabStyle = (0, $24P9d.convertToInlineCss)({
    border: `1px solid ${"var(--ds-border-bold, #7D818A)"}`,
    borderRadius: "var(--ds-radius-small, 4px)",
    padding: `0 ${"var(--ds-space-025, 2px)"}`
});
function $54331ed359655e88$export$ec5102320006649a(state, pluginState) {
    return $54331ed359655e88$var$buildInlineGhostDecoration(state, pluginState.cursorPos, pluginState.suggestion);
}
/**
 * Inline ghost text at the cursor position (manual Cmd+Shift+Space trigger).
 * Accepted with Tab.
 */ function $54331ed359655e88$var$buildInlineGhostDecoration(state, cursorPos, suggestion) {
    const widget = (0, $ftzrq.Decoration).widget(cursorPos, ()=>{
        const span = document.createElement('span');
        span.className = $54331ed359655e88$var$GHOST_INLINE_CLASS;
        span.setAttribute('aria-hidden', 'true');
        span.setAttribute('contenteditable', 'false');
        span.setAttribute('data-testid', 'heading-autocomplete-ghost-inline');
        span.setAttribute('style', $54331ed359655e88$var$ghostInlineStyle);
        const text = document.createTextNode(suggestion);
        span.appendChild(text);
        const hint = document.createElement('span');
        hint.className = $54331ed359655e88$var$GHOST_HINT_CLASS;
        hint.setAttribute('style', $54331ed359655e88$var$ghostHintStyle);
        span.appendChild(hint);
        const tab = document.createElement('span');
        tab.className = $54331ed359655e88$var$GHOST_HINT_CLASS;
        tab.setAttribute('style', $54331ed359655e88$var$ghostHintTabStyle);
        tab.textContent = 'Tab';
        hint.appendChild(tab);
        const toAcceptText = document.createTextNode(' to accept');
        hint.appendChild(toAcceptText);
        return span;
    }, {
        side: 1,
        key: 'heading-autocomplete-ghost-inline'
    });
    return (0, $ftzrq.DecorationSet).create(state.doc, [
        widget
    ]);
}



const $dd023753b5f7ac8f$export$ae829ec7b2625219 = ({ api: api, autoTriggerSharedState: autoTriggerSharedState })=>{
    let abortController = null;
    const editorAnalyticsAPI = api?.analytics?.actions;
    return new (0, $1S4f7.SafePlugin)({
        key: (0, $311d92b3b6eb92ca$export$56937bf89365f70d),
        // -----------------------------------------------------------------------
        // Plugin state — pure synchronous transitions
        // -----------------------------------------------------------------------
        state: {
            init () {
                return {
                    status: 'idle'
                };
            },
            apply (tr, pluginState) {
                const action = tr.getMeta((0, $311d92b3b6eb92ca$export$56937bf89365f70d));
                if (action) switch(action.type){
                    case (0, $038bd350e498990f$export$92a1a3b7554e9387).TRIGGER_MANUAL:
                        return {
                            status: 'loading',
                            trigger: 'manual',
                            cursorPos: action.cursorPos
                        };
                    case (0, $038bd350e498990f$export$92a1a3b7554e9387).TRIGGER_AUTO:
                        return {
                            status: 'loading',
                            trigger: 'auto',
                            cursorPos: action.cursorPos
                        };
                    case (0, $038bd350e498990f$export$92a1a3b7554e9387).SET_SUGGESTION:
                        if (pluginState.status === 'loading') {
                            if (pluginState.trigger === 'auto') {
                                if ('displaySuggestionImmediately' in action && action.displaySuggestionImmediately === true) {
                                    const cursorPos = 'suggestionCursorPos' in action && action.suggestionCursorPos !== undefined ? action.suggestionCursorPos : pluginState.cursorPos;
                                    return {
                                        status: 'suggestion',
                                        trigger: 'auto',
                                        cursorPos: cursorPos,
                                        suggestion: action.suggestion
                                    };
                                }
                                return {
                                    status: 'suggestion_pending',
                                    trigger: 'auto',
                                    cursorPos: pluginState.cursorPos,
                                    suggestion: action.suggestion
                                };
                            }
                            return {
                                status: 'suggestion',
                                trigger: 'manual',
                                cursorPos: pluginState.cursorPos,
                                suggestion: action.suggestion
                            };
                        }
                        return pluginState;
                    case (0, $038bd350e498990f$export$92a1a3b7554e9387).REVEAL_SUGGESTION:
                        if (pluginState.status === 'suggestion_pending') {
                            const revealCursorPos = 'cursorPos' in action && action.cursorPos !== undefined ? action.cursorPos : pluginState.cursorPos;
                            return {
                                status: 'suggestion',
                                trigger: 'auto',
                                cursorPos: revealCursorPos,
                                suggestion: pluginState.suggestion
                            };
                        }
                        return pluginState;
                    case (0, $038bd350e498990f$export$92a1a3b7554e9387).DISMISS:
                        return {
                            status: 'idle'
                        };
                    default:
                        return pluginState;
                }
                if (tr.docChanged && pluginState.status !== 'idle') {
                    const state = pluginState;
                    return {
                        ...state,
                        ...state.status === 'loading' || state.status === 'suggestion' || state.status === 'suggestion_pending' ? {
                            cursorPos: tr.mapping.map(state.cursorPos)
                        } : {}
                    };
                }
                return pluginState;
            }
        },
        // -----------------------------------------------------------------------
        // Decorations
        // -----------------------------------------------------------------------
        props: {
            decorations (state) {
                const pluginState = (0, $311d92b3b6eb92ca$export$56937bf89365f70d).getState(state);
                if (pluginState?.status !== 'suggestion') return null;
                return (0, $54331ed359655e88$export$ec5102320006649a)(state, pluginState);
            },
            handleDOMEvents: {
                blur: (view)=>{
                    const pluginState = (0, $311d92b3b6eb92ca$export$56937bf89365f70d).getState(view.state);
                    if (pluginState && pluginState.status !== 'idle') api?.core?.actions?.execute?.(api?.aiAutocomplete?.commands?.dismissSuggestion?.());
                    return false;
                }
            }
        },
        // -----------------------------------------------------------------------
        // view() — owns all side effects (fetch lifecycle + shared state resets)
        // -----------------------------------------------------------------------
        view () {
            return {
                update (view, prevState) {
                    const newPluginState = (0, $311d92b3b6eb92ca$export$56937bf89365f70d).getState(view.state);
                    const prevPluginState = (0, $311d92b3b6eb92ca$export$56937bf89365f70d).getState(prevState);
                    if (newPluginState === prevPluginState) return;
                    // Reset shared trigger-line index on idle
                    if (newPluginState?.status === 'idle') autoTriggerSharedState.triggerLineIndex = null;
                    // Reset trigger-line index when switching to manual loading
                    if (newPluginState?.status === 'loading' && newPluginState.trigger === 'manual' && prevPluginState?.status !== 'loading') autoTriggerSharedState.triggerLineIndex = null;
                    // Entering auto loading: initialise shared state
                    if (newPluginState?.status === 'loading' && prevPluginState?.status !== 'loading' && newPluginState.trigger === 'auto') {
                        autoTriggerSharedState.userPressedEnter = false;
                        autoTriggerSharedState.postEnterPlainTextBaseline = null;
                        autoTriggerSharedState.triggerLineIndex = (0, $42b59b5039e481b9$export$faff1b56818221b9)(view.state.doc, newPluginState.cursorPos);
                    }
                    // Leaving 'loading' — cancel in-flight fetch
                    if (prevPluginState?.status === 'loading' && newPluginState?.status !== 'loading') {
                        abortController?.abort();
                        abortController = null;
                    }
                    // Entering 'loading' — fire the API call
                    if (newPluginState?.status === 'loading' && prevPluginState?.status !== 'loading') {
                        abortController = new AbortController();
                        const markdown = (0, $517b90048513d413$export$99167e00e2d4f9dd)(view, newPluginState.cursorPos);
                        (0, $c2e11dbc5bd85e2f$export$9384628242350716)(markdown, abortController.signal).then((suggestion)=>{
                            const loading = (0, $311d92b3b6eb92ca$export$56937bf89365f70d).getState(view.state);
                            if (loading?.status !== 'loading') {
                                autoTriggerSharedState.userPressedEnter = false;
                                autoTriggerSharedState.postEnterPlainTextBaseline = null;
                                return;
                            }
                            const showImmediately = loading.trigger === 'auto' && autoTriggerSharedState.userPressedEnter;
                            autoTriggerSharedState.userPressedEnter = false;
                            // If showing immediately, verify doc hasn't changed beyond the Enter
                            if (showImmediately && autoTriggerSharedState.postEnterPlainTextBaseline !== null) {
                                const currentPlain = (0, $a33bacd3740d6e5a$export$6f212eb1ee72d86a)(view.state.doc);
                                if (currentPlain !== autoTriggerSharedState.postEnterPlainTextBaseline) {
                                    autoTriggerSharedState.postEnterPlainTextBaseline = null;
                                    view.dispatch(view.state.tr.setMeta((0, $311d92b3b6eb92ca$export$56937bf89365f70d), {
                                        type: (0, $038bd350e498990f$export$92a1a3b7554e9387).DISMISS
                                    }));
                                    return;
                                }
                            }
                            autoTriggerSharedState.postEnterPlainTextBaseline = null;
                            const tr = view.state.tr.setMeta((0, $311d92b3b6eb92ca$export$56937bf89365f70d), {
                                type: (0, $038bd350e498990f$export$92a1a3b7554e9387).SET_SUGGESTION,
                                suggestion: suggestion,
                                ...showImmediately ? {
                                    displaySuggestionImmediately: true,
                                    suggestionCursorPos: view.state.selection.from
                                } : {}
                            });
                            if (loading.trigger === 'manual' || showImmediately) (0, $e9233283002d8aa0$export$edd7849651b2a74a)(editorAnalyticsAPI)(tr);
                            view.dispatch(tr);
                        }).catch((err)=>{
                            if (err instanceof Error && err.name === 'AbortError') return;
                            view.dispatch(view.state.tr.setMeta((0, $311d92b3b6eb92ca$export$56937bf89365f70d), {
                                type: (0, $038bd350e498990f$export$92a1a3b7554e9387).DISMISS
                            }));
                        });
                    }
                },
                destroy () {
                    abortController?.abort();
                    abortController = null;
                }
            };
        },
        // -----------------------------------------------------------------------
        // appendTransaction — doc change → dismiss (accept is handled in command)
        // -----------------------------------------------------------------------
        appendTransaction (transactions, _oldState, newState) {
            const currentPluginState = (0, $311d92b3b6eb92ca$export$56937bf89365f70d).getState(newState);
            // Use structural doc equality, not `tr.docChanged`: the latter is true for any
            // step (including AnalyticsStep from attachAnalyticsEvent on invoke), which would
            // incorrectly dismiss loading state before the API runs.
            const documentChanged = transactions.some((tr)=>!tr.before.eq(tr.doc));
            // Visible suggestion or pending auto reveal: don't dismiss on doc
            // change — keydown already dismisses on typing before the doc mutates.
            if (currentPluginState?.status === 'suggestion' || currentPluginState?.status === 'suggestion_pending') return null;
            // Auto loading: allow doc changes (Enter / same-line edits).
            // Capture a plain-text baseline on the first doc change after the
            // user pressed Enter so we can verify the doc is untouched when the
            // API response arrives.
            if (currentPluginState?.status === 'loading' && currentPluginState.trigger === 'auto') {
                if (documentChanged && autoTriggerSharedState.userPressedEnter && autoTriggerSharedState.postEnterPlainTextBaseline === null) autoTriggerSharedState.postEnterPlainTextBaseline = (0, $a33bacd3740d6e5a$export$6f212eb1ee72d86a)(newState.doc);
                return null;
            }
            if (!documentChanged) return null;
            return newState.tr.setMeta((0, $311d92b3b6eb92ca$export$56937bf89365f70d), {
                type: (0, $038bd350e498990f$export$92a1a3b7554e9387).DISMISS
            });
        }
    });
};


const $9bdb7ad03a409b2b$export$52b2e012ce18dd1 = ({ api: api })=>{
    const autoTriggerSharedState = (0, $a5e9aefac3add1ee$export$6691711a081bd09a)();
    return {
        name: 'aiAutocomplete',
        commands: {
            acceptSuggestion: (params)=>(0, $b30d2a251c70d654$export$bb9c6e4618c88231)(params, api?.analytics?.actions),
            dismissSuggestion: ()=>(0, $b30d2a251c70d654$export$82b68e9b2902c23d)(api?.analytics?.actions)
        },
        pmPlugins () {
            return [
                {
                    name: 'aiAutocompletePlugin',
                    plugin: ()=>(0, $dd023753b5f7ac8f$export$ae829ec7b2625219)({
                            api: api,
                            autoTriggerSharedState: autoTriggerSharedState
                        })
                },
                {
                    name: 'ai-autocomplete-keymap',
                    plugin: (params)=>(0, $e09ae141c8fa8668$export$a57bf7fb2aa68075)({
                            api: api,
                            getIntl: params.getIntl,
                            autoTriggerSharedState: autoTriggerSharedState
                        })
                },
                {
                    name: 'ai-autocomplete-placeholder-controller',
                    plugin: ()=>(0, $e687d8470d23775c$export$f87341fc5281ec6c)({
                            api: api
                        })
                }
            ];
        }
    };
};





parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $dZ8uq = parcelRequire("dZ8uq");







const $cfddc4cc14c7297d$export$66b514a792884e0c = new (0, $ks2lK.PluginKey)('malleableUiPlugin');
function $cfddc4cc14c7297d$export$11ad8b64b26867df(dispatch) {
    return new (0, $1S4f7.SafePlugin)({
        key: $cfddc4cc14c7297d$export$66b514a792884e0c,
        state: {
            init () {
                return {
                    isRemixModalOpen: false,
                    remixModalMetadata: undefined
                };
            },
            apply (tr, pluginState) {
                const meta = tr.getMeta($cfddc4cc14c7297d$export$66b514a792884e0c);
                if (meta && meta.isRemixModalOpen !== undefined) {
                    const result = {
                        isRemixModalOpen: meta.isRemixModalOpen,
                        remixModalMetadata: meta.remixModalMetadata,
                        remixSource: meta.remixSource
                    };
                    dispatch($cfddc4cc14c7297d$export$66b514a792884e0c, result);
                    return result;
                }
                return pluginState;
            }
        }
    });
}


const $3cbafda77e1252b9$export$8818f9db6e7370f7 = (api)=>()=>({ tr: tr })=>{
            // Clear the block selection so stale ak-editor-selected-node decorations
            // are removed when the modal is dismissed.
            api?.selection?.commands?.clearBlockSelection()({
                tr: tr
            });
            tr.setMeta((0, $cfddc4cc14c7297d$export$66b514a792884e0c), {
                isRemixModalOpen: false,
                remixModalMetadata: undefined,
                remixSource: undefined
            });
            return tr;
        };






const $140c07dc09e2d405$export$e01f52b7ef73f07b = (api)=>({ nodePos: nodePos, nodeType: nodeType, metadata: metadata, source: source } = {})=>({ tr: tr })=>{
            if (nodePos !== undefined && nodeType) {
                api?.blockControls?.commands.expandAndUpdateSelection({
                    startPos: nodePos,
                    nodeType: nodeType,
                    selection: tr.selection,
                    isShiftPressed: false
                })({
                    tr: tr
                });
                // If a multi-block TextSelection was set, signal to the selection plugin
                // so that ak-editor-selected-node decorations are applied to all selected nodes.
                if (tr.selection instanceof (0, $ks2lK.TextSelection)) api?.selection?.commands?.setBlockSelection(tr.selection)({
                    tr: tr
                });
            }
            tr.setMeta((0, $cfddc4cc14c7297d$export$66b514a792884e0c), {
                isRemixModalOpen: true,
                remixModalMetadata: metadata,
                remixSource: source
            });
            return tr;
        };



var $8m4tT = parcelRequire("8m4tT");

const $a8bbc3dbab143724$export$4b29030e1d9baeba = (node, previousMauiId)=>{
    return node.type.name === 'extension' && node.attrs.extensionKey === 'native-embed:maui' && node.attrs.parameters?.macroParams?.url?.value.endsWith(previousMauiId);
};
const $a8bbc3dbab143724$export$47dfdc23943fef4 = (attrs, previousMauiId, newMauiId)=>{
    /**
	 * Some older browsers like chrome 97 doesn't support structuredClone.
	 * So using JSON.parse(JSON.stringify()) as a fallback.
	 */ const newAttrs = typeof window !== 'undefined' && typeof window.structuredClone === 'function' ? structuredClone(attrs) : JSON.parse(JSON.stringify(attrs));
    newAttrs.parameters.macroParams.url.value = newAttrs.parameters.macroParams.url.value.replace(previousMauiId, newMauiId);
    return newAttrs;
};
const $a8bbc3dbab143724$export$ff177b3b8713a3ae = ({ previousMauiId: previousMauiId, newMauiId: newMauiId })=>({ tr: tr })=>{
        // Check current selection, if the node is already selected we can skip expensive document traversal
        if ((0, $8m4tT.isNodeSelection)(tr.selection) && $a8bbc3dbab143724$export$4b29030e1d9baeba(tr.selection.node, previousMauiId)) {
            const node = tr.selection.$anchor.node(-1);
            const pos = tr.selection.$anchor.pos;
            return tr.setNodeMarkup(pos, undefined, $a8bbc3dbab143724$export$47dfdc23943fef4(node.attrs, previousMauiId, newMauiId));
        }
        // Find the first node that matches the previous MAUI App ID
        let nodeResult;
        tr.doc.descendants((node, pos)=>{
            if (nodeResult) return false;
            if ($a8bbc3dbab143724$export$4b29030e1d9baeba(node, previousMauiId)) nodeResult = {
                node: node,
                pos: pos
            };
            return !nodeResult;
        });
        if (nodeResult) {
            const { node: node, pos: pos } = nodeResult;
            return tr.setNodeMarkup(pos, undefined, $a8bbc3dbab143724$export$47dfdc23943fef4(node.attrs, previousMauiId, newMauiId));
        }
        return null;
    };






var $7XFGZ = parcelRequire("7XFGZ");














const $ee07456bddbd4c00$var$THINKING_HIGHLIGHT_CLASS = 'remix-thinking-highlight';
const $ee07456bddbd4c00$export$38c8fc373d691b1d = new (0, $ks2lK.PluginKey)('remixThinkingPlugin');
function $ee07456bddbd4c00$export$1c17a47e3daa5065(dispatch) {
    return new (0, $1S4f7.SafePlugin)({
        key: $ee07456bddbd4c00$export$38c8fc373d691b1d,
        state: {
            init () {
                return {
                    isThinking: false,
                    decorationSet: (0, $ftzrq.DecorationSet).empty
                };
            },
            apply (tr, pluginState, _oldState, newState) {
                const meta = tr.getMeta($ee07456bddbd4c00$export$38c8fc373d691b1d);
                if (meta) {
                    if (meta.isThinking === true && meta.thinkingSelectionFrom !== undefined && meta.thinkingSelectionTo !== undefined) {
                        const from = meta.thinkingSelectionFrom;
                        const to = meta.thinkingSelectionTo;
                        let decorations;
                        if (meta.cellSelectionRanges) decorations = meta.cellSelectionRanges.map((range)=>(0, $ftzrq.Decoration).inline(range.from, range.to, {
                                class: $ee07456bddbd4c00$var$THINKING_HIGHLIGHT_CLASS
                            }));
                        else if (meta.isNodeSelection) decorations = [
                            (0, $ftzrq.Decoration).node(from, to, {
                                class: $ee07456bddbd4c00$var$THINKING_HIGHLIGHT_CLASS
                            })
                        ];
                        else decorations = [
                            (0, $ftzrq.Decoration).inline(from, to, {
                                class: $ee07456bddbd4c00$var$THINKING_HIGHLIGHT_CLASS
                            })
                        ];
                        const decorationSet = (0, $ftzrq.DecorationSet).create(newState.doc, decorations);
                        const result = {
                            isThinking: true,
                            decorationSet: decorationSet,
                            savedSelection: {
                                from: from,
                                to: to,
                                isNodeSelection: meta.isNodeSelection ?? false,
                                anchorCellPos: meta.anchorCellPos,
                                headCellPos: meta.headCellPos
                            }
                        };
                        dispatch($ee07456bddbd4c00$export$38c8fc373d691b1d, result);
                        return result;
                    }
                    if (meta.isThinking === false) {
                        const result = {
                            isThinking: false,
                            decorationSet: (0, $ftzrq.DecorationSet).empty,
                            savedSelection: meta.preserveSavedSelection ? pluginState.savedSelection : undefined
                        };
                        dispatch($ee07456bddbd4c00$export$38c8fc373d691b1d, result);
                        return result;
                    }
                }
                if (pluginState.isThinking && pluginState.decorationSet !== (0, $ftzrq.DecorationSet).empty) {
                    const mappedDecorationSet = pluginState.decorationSet.map(tr.mapping, newState.doc);
                    if (mappedDecorationSet !== pluginState.decorationSet) {
                        const mappedSavedSelection = pluginState.savedSelection ? {
                            ...pluginState.savedSelection,
                            from: tr.mapping.map(pluginState.savedSelection.from),
                            to: tr.mapping.map(pluginState.savedSelection.to),
                            anchorCellPos: pluginState.savedSelection.anchorCellPos !== undefined ? tr.mapping.map(pluginState.savedSelection.anchorCellPos) : undefined,
                            headCellPos: pluginState.savedSelection.headCellPos !== undefined ? tr.mapping.map(pluginState.savedSelection.headCellPos) : undefined
                        } : undefined;
                        const result = {
                            ...pluginState,
                            decorationSet: mappedDecorationSet,
                            savedSelection: mappedSavedSelection
                        };
                        dispatch($ee07456bddbd4c00$export$38c8fc373d691b1d, result);
                        return result;
                    }
                }
                return pluginState;
            }
        },
        appendTransaction (_transactions, oldState, newState) {
            const oldPluginState = $ee07456bddbd4c00$export$38c8fc373d691b1d.getState(oldState);
            const newPluginState = $ee07456bddbd4c00$export$38c8fc373d691b1d.getState(newState);
            if (oldPluginState?.isThinking && !newPluginState?.isThinking && newPluginState?.savedSelection) {
                const { savedSelection: savedSelection } = newPluginState;
                const tr = newState.tr;
                if (savedSelection.anchorCellPos !== undefined && savedSelection.headCellPos !== undefined) tr.setSelection((0, $7XFGZ.CellSelection).create(tr.doc, savedSelection.anchorCellPos, savedSelection.headCellPos));
                else if (savedSelection.isNodeSelection) tr.setSelection((0, $ks2lK.NodeSelection).create(tr.doc, savedSelection.from));
                else tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, savedSelection.from, savedSelection.to));
                return tr;
            }
            return null;
        },
        props: {
            decorations (state) {
                return $ee07456bddbd4c00$export$38c8fc373d691b1d.getState(state)?.decorationSet ?? (0, $ftzrq.DecorationSet).empty;
            }
        }
    });
}


const $ccb60ab150962a8e$export$b0011c604093029 = (api)=>()=>({ tr: tr })=>{
            const selection = tr.selection;
            const isNodeSelection = selection instanceof (0, $ks2lK.NodeSelection);
            const isCellSelection = selection instanceof (0, $7XFGZ.CellSelection);
            const thinkingMeta = {
                isThinking: true,
                thinkingSelectionFrom: selection.from,
                thinkingSelectionTo: isNodeSelection ? selection.from + selection.node.nodeSize : selection.to,
                isNodeSelection: isNodeSelection
            };
            if (isCellSelection) {
                thinkingMeta.cellSelectionRanges = selection.ranges.map((range)=>({
                        from: range.$from.pos,
                        to: range.$to.pos
                    }));
                thinkingMeta.anchorCellPos = selection.$anchorCell.pos;
                thinkingMeta.headCellPos = selection.$headCell.pos;
            }
            // Clear block selection decorations before applying the thinking state.
            api?.selection?.commands?.clearBlockSelection()({
                tr: tr
            });
            tr.setMeta((0, $ee07456bddbd4c00$export$38c8fc373d691b1d), thinkingMeta);
            tr.setMeta((0, $cfddc4cc14c7297d$export$66b514a792884e0c), {
                isRemixModalOpen: false
            });
            // Collapse the cursor to the end of the selection so the user can
            // continue editing while the remix is processing.
            const endPos = isNodeSelection ? selection.from + selection.node.nodeSize : selection.to;
            tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, endPos));
            return tr;
        };




const $d462007436924fa2$export$5569fef6b45e570f = ({ reopenModal: reopenModal } = {})=>({ tr: tr })=>{
        const thinkingMeta = {
            isThinking: false,
            preserveSavedSelection: !!reopenModal
        };
        tr.setMeta((0, $ee07456bddbd4c00$export$38c8fc373d691b1d), thinkingMeta);
        if (reopenModal) tr.setMeta((0, $cfddc4cc14c7297d$export$66b514a792884e0c), {
            isRemixModalOpen: true
        });
        return tr;
    };






var $hTKp4 = parcelRequire("hTKp4");







/**
 * Remix block control: positioned at the right edge of the block.
 * Uses anchor(anchorName end) or getRightPositionForRootElement (same coordinate system
 * as left controls). The widget span has no position:relative so position:absolute
 * uses the same containing block as the node.
 */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $9K4OG = parcelRequire("9K4OG");














var $1zav4 = parcelRequire("1zav4");


var $1iRzx = parcelRequire("1iRzx");

var $8ATx9 = parcelRequire("8ATx9");

var $8RppR = parcelRequire("8RppR");

var $5pTQL = parcelRequire("5pTQL");

var $fBMpm = parcelRequire("fBMpm");

var $hnbpK = parcelRequire("hnbpK");


var $jQW4q = parcelRequire("jQW4q");








var $3gadb = parcelRequire("3gadb");


var $16lEl = parcelRequire("16lEl");


var $hUyPY = parcelRequire("hUyPY");




const $82ccc11bb3584e00$export$defe85febe8b728c = (0, $h82at.defineMessages)({
    remixToolbarTooltip: {
        id: "highlight-actions.remix.inline-toolbar-tooltip",
        defaultMessage: "Remix"
    },
    remixToolbarLabel: {
        id: "highlight-actions.remix.inline-toolbar-label",
        defaultMessage: "Remix"
    },
    remixBlockTooltip: {
        id: "block-hover.remix.remix-tooltip",
        defaultMessage: "Remix"
    },
    remixBlockLabel: {
        id: "block-hover.remix.remix-label",
        defaultMessage: "Remix"
    },
    remixDisabledTooltipArchived: {
        id: "highlight-actions.remix.disabled-tooltip-archived",
        defaultMessage: "Content on archived pages can't be remixed"
    },
    remixDisabledTooltipVersionHistory: {
        id: "highlight-actions.remix.disabled-tooltip-version-history",
        defaultMessage: "Remix is unavailable in version history"
    },
    remixInProgressTooltip: {
        id: "highlight-actions.remix.in-progress-tooltip",
        defaultMessage: "Remix in progress..."
    }
});



var $er2Wy = parcelRequire("er2Wy");


const $273077559a9b876d$export$5626baa73ed0afeb = (formatMessage, reason)=>{
    switch(reason){
        case 'version-history':
            return formatMessage((0, $82ccc11bb3584e00$export$defe85febe8b728c).remixDisabledTooltipVersionHistory);
        case 'archived':
        default:
            return formatMessage((0, $82ccc11bb3584e00$export$defe85febe8b728c).remixDisabledTooltipArchived);
    }
};


function $74b1142437cdb6f9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $74b1142437cdb6f9$var$REMIX_BUTTON_HEIGHT = 24;
const $74b1142437cdb6f9$var$REMIX_BUTTON_WIDTH = 24;
const $74b1142437cdb6f9$var$REMIX_BUTTON_DIMENSIONS = {
    width: $74b1142437cdb6f9$var$REMIX_BUTTON_WIDTH,
    height: $74b1142437cdb6f9$var$REMIX_BUTTON_HEIGHT
};
const $74b1142437cdb6f9$var$REMIX_BUTTON_RIGHT_OFFSET = 55;
// Column layout (layoutSection) has breakout resize handles extending to the right; push Remix button further so it doesn't overlap
const $74b1142437cdb6f9$var$REMIX_BUTTON_RIGHT_OFFSET_LAYOUT_SECTION = 91;
const $74b1142437cdb6f9$var$INNER_CONTAINER_SELECTORS = {
    embedCard: '.rich-media-item',
    table: '.resizer-item',
    mediaSingle: '.resizer-item',
    extension: '.extension-container[data-layout]',
    bodiedExtension: '.extension-container[data-layout]',
    blockCard: '.datasourceView-content-inner-wrap'
};
const $74b1142437cdb6f9$var$getInnerContainerAndEdgeCase = (dom, rootNodeType)=>{
    const selector = $74b1142437cdb6f9$var$INNER_CONTAINER_SELECTORS[rootNodeType];
    const innerContainer = selector ? dom.querySelector(selector) : null;
    // Edge case: nodes with nested inner containers (resizer, extension, embedCard, blockCard)
    // require offset-based positioning including dom.offsetLeft because anchor-based positioning
    // doesn't correctly account for the nested layout. Occurs when the inner container exists and
    // the block is not aligned to the right edge of the editor content area.
    const isEdgeCase = selector !== undefined && innerContainer !== null;
    return {
        innerContainer: innerContainer,
        isEdgeCase: isEdgeCase
    };
};
const $74b1142437cdb6f9$var$containerBaseStyles = {
    name: "1sgo8pu",
    styles: "position:absolute;z-index:100;display:flex;align-items:flex-start;justify-content:center"
};
const $74b1142437cdb6f9$var$stickyButtonContainerStyles = {
    name: "cdscbk",
    styles: "top:8px;position:sticky;display:block;z-index:100;button{border-radius:var(--ds-radius-full, 9999px);}"
};
const $74b1142437cdb6f9$var$stickyButtonContainerStylesStickyHeader = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-remix-button-container]:has(~ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: (0, $1zav4.tableControlsSpacing)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-remix-button-container]):has(~ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: (0, $1zav4.tableControlsSpacing)
    }
});
const $74b1142437cdb6f9$var$stickyButtonContainerStylesImprovedStickyHeader = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-remix-button-container]:has(~ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: (0, $1zav4.tableControlsSpacing)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-remix-button-container]:has(~ [data-prosemirror-mark-name="fragment"] >[data-prosemirror-node-name="table"] tr.pm-table-row-native-sticky.pm-table-row-native-sticky-active) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: `${(0, $fBMpm.STICKY_CONTROLS_TOP_MARGIN_FOR_STICKY_HEADER)}px`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-remix-button-container]:has(~ [data-prosemirror-node-name="table"] tr.pm-table-row-native-sticky.pm-table-row-native-sticky-active) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: `${(0, $fBMpm.STICKY_CONTROLS_TOP_MARGIN_FOR_STICKY_HEADER)}px`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-remix-button-container]:has(~ [data-prosemirror-mark-name="fragment"] >[data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: (0, $1zav4.tableControlsSpacing)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-remix-button-container]):has(~ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: (0, $1zav4.tableControlsSpacing)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-remix-button-container]):has(~ [data-prosemirror-mark-name="fragment"] >[data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: (0, $1zav4.tableControlsSpacing)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-remix-button-container]):has(~ [data-prosemirror-node-name="table"] tr.pm-table-row-native-sticky.pm-table-row-native-sticky-active) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: `${(0, $fBMpm.STICKY_CONTROLS_TOP_MARGIN_FOR_STICKY_HEADER)}px`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-remix-button-container]):has(~ [data-prosemirror-mark-name="fragment"] >[data-prosemirror-node-name="table"] tr.pm-table-row-native-sticky.pm-table-row-native-sticky-active) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: `${(0, $fBMpm.STICKY_CONTROLS_TOP_MARGIN_FOR_STICKY_HEADER)}px`
    }
});
const $74b1142437cdb6f9$export$e420cb1e340b26d1 = ({ view: view, api: api, getPos: getPos, anchorName: anchorName, isDisabled: isDisabled, isRovoLLMEnabled: isRovoLLMEnabled, livePage: livePage, remixDisabledReason: remixDisabledReason, rootAnchorName: rootAnchorName, rootNodeType: rootNodeType, rootPos: rootPos })=>{
    const { formatMessage: formatMessage } = (0, $1cfRh.default)();
    const { macroInteractionUpdates: macroInteractionUpdates, editorViewMode: editorViewMode, activeNode: activeNode, rightSideControlsEnabled: rightSideControlsEnabled, hoverSide: hoverSide, contentId: contentId, isRemixing: isRemixing, areAiEntryPointsDisabled: areAiEntryPointsDisabled } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'featureFlags',
        'editorViewMode',
        'blockControls',
        'contextIdentifier',
        'malleableUi',
        'aiExperience'
    ], (states)=>({
            macroInteractionUpdates: states.featureFlagsState?.macroInteractionUpdates,
            editorViewMode: states.editorViewModeState?.mode,
            activeNode: states.blockControlsState?.activeNode,
            rightSideControlsEnabled: states.blockControlsState?.rightSideControlsEnabled ?? false,
            hoverSide: states.blockControlsState?.hoverSide,
            contentId: states.contextIdentifierState?.contextIdentifierProvider?.objectId,
            isRemixing: states.malleableUiState?.isRemixModalOpen || false || states.malleableUiState?.isThinking || false,
            areAiEntryPointsDisabled: (0, $dh538.fg)('platform_editor_ai_toggle_entry_points') ? states.aiExperienceState?.areAiEntryPointsDisabled ?? false : false
        }));
    const isViewMode = editorViewMode === 'view';
    // pageMode for analytics: 'editor' = full page editor, 'liveEdit' = live page edit, 'liveView' = live page view (livePage set by Confluence).
    const pageMode = editorViewMode === 'edit' && !livePage ? 'editor' : editorViewMode === 'edit' && livePage ? 'liveEdit' : editorViewMode === 'view' && livePage ? 'liveView' : undefined;
    // Fire experiment exposure only when the user would see the Remix tool (hover over right side of block)
    const hasFiredExposureRef = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (hasFiredExposureRef.current) return;
        const isActiveBlock = activeNode?.rootPos === rootPos && activeNode?.rootAnchorName === (rootAnchorName ?? anchorName);
        const isRightSideVisible = rightSideControlsEnabled && (hoverSide === 'right' || isViewMode);
        if (isActiveBlock && isRightSideVisible) {
            (0, $dh538.fg)('confluence_remix_button_right_side_block_fg');
            hasFiredExposureRef.current = true;
        }
    }, [
        activeNode?.rootPos,
        activeNode?.rootAnchorName,
        rootPos,
        rootAnchorName,
        anchorName,
        rightSideControlsEnabled,
        hoverSide,
        isViewMode
    ]);
    const [positionStyles, setPositionStyles] = (0, $42omo.useState)({
        display: 'none'
    });
    // Shared offset-based positioning for view mode and edit-mode fallback.
    // Horizontal (left) uses getRightPositionForRootElement; vertical uses getTopPosition.
    const rightOffset = rootNodeType === 'layoutSection' ? $74b1142437cdb6f9$var$REMIX_BUTTON_RIGHT_OFFSET_LAYOUT_SECTION : $74b1142437cdb6f9$var$REMIX_BUTTON_RIGHT_OFFSET;
    const getOffsetBasedPosition = (0, $42omo.useCallback)((dom, safeAnchorName)=>{
        const { innerContainer: innerContainer, isEdgeCase: isEdgeCase } = $74b1142437cdb6f9$var$getInnerContainerAndEdgeCase(dom, rootNodeType);
        const isExtension = rootNodeType === 'extension' || rootNodeType === 'bodiedExtension';
        const isMacroInteractionUpdates = macroInteractionUpdates && isExtension;
        const isSticky = (0, $8ATx9.shouldBeSticky)(rootNodeType);
        const rightEdgeLeft = (0, $8RppR.getRightPositionForRootElement)(dom, rootNodeType, $74b1142437cdb6f9$var$REMIX_BUTTON_DIMENSIONS, innerContainer ?? undefined, isMacroInteractionUpdates);
        const height = (0, $8ATx9.getControlHeightCSSValue)((0, $8ATx9.getNodeHeight)(dom, safeAnchorName) || 0, isSticky, true, `${$74b1142437cdb6f9$var$REMIX_BUTTON_DIMENSIONS.height}`);
        return {
            left: isEdgeCase ? `calc(${dom.offsetLeft}px + (${rightEdgeLeft}) + ${rightOffset}px)` : `calc(${rightEdgeLeft} + ${rightOffset}px)`,
            top: (0, $8ATx9.getTopPosition)(dom, rootNodeType),
            ...height,
            bottom: 'unset'
        };
    }, [
        rootNodeType,
        macroInteractionUpdates,
        rightOffset
    ]);
    // Edit mode: anchor-based when supported, otherwise offset-based (same as view mode).
    const calculatePosition = (0, $42omo.useCallback)(()=>{
        const safeAnchorName = (0, $5pTQL.refreshAnchorName)({
            getPos: getPos,
            view: view,
            anchorName: rootAnchorName ?? anchorName
        });
        let dom = view.dom.querySelector(`[${(0, $1iRzx.getAnchorAttrName)()}="${safeAnchorName}"]`);
        // For layoutSection, the anchor attribute is on the outer ReactNodeView wrapper div which
        // may have a larger offsetWidth than the actual layout section content area.
        // Use the inner [data-layout-section] element for accurate offset-based positioning.
        if (dom && rootNodeType === 'layoutSection') dom = dom.querySelector('[data-layout-section]') ?? dom;
        if (!dom) return {
            display: 'none'
        };
        const isSticky = (0, $8ATx9.shouldBeSticky)(rootNodeType);
        // View mode always uses offset-based (anchor positioning can differ in view mode).
        if (isViewMode) return getOffsetBasedPosition(dom, safeAnchorName);
        const { isEdgeCase: isEdgeCase } = $74b1142437cdb6f9$var$getInnerContainerAndEdgeCase(dom, rootNodeType);
        // Check anchor first (no reflow). Only use offset-based when fallback needed.
        const supportsAnchorRight = CSS.supports('left', `anchor(${safeAnchorName} end)`) && CSS.supports('top', `anchor(${safeAnchorName} start)`);
        if (supportsAnchorRight && !isEdgeCase) return {
            left: `calc(anchor(${safeAnchorName} end) - ${$74b1142437cdb6f9$var$REMIX_BUTTON_DIMENSIONS.width}px - ${(0, $fBMpm.rootElementGap)(rootNodeType)}px + ${rightOffset}px)`,
            top: `calc(anchor(${safeAnchorName} start) + ${(0, $fBMpm.topPositionAdjustment)(rootNodeType)}px)`,
            ...(0, $8ATx9.getControlBottomCSSValue)(safeAnchorName, isSticky, true)
        };
        return getOffsetBasedPosition(dom, safeAnchorName);
    }, [
        view,
        getPos,
        anchorName,
        rootAnchorName,
        rootNodeType,
        isViewMode,
        getOffsetBasedPosition,
        rightOffset
    ]);
    // Recompute button position on mount and when extension/embedCard layout changes (e.g. expand/collapse).
    // For extension/embedCard we listen to transitionend so position updates after CSS transitions finish.
    (0, $42omo.useEffect)(()=>{
        let cleanUpTransitionListener;
        if (rootNodeType === 'extension' || rootNodeType === 'embedCard') {
            const anchorDom = view.dom.querySelector(`[${(0, $1iRzx.getAnchorAttrName)()}="${rootAnchorName ?? anchorName}"]`);
            if (anchorDom) cleanUpTransitionListener = (0, $fFa3V.bind)(anchorDom, {
                type: 'transitionend',
                listener: ()=>setPositionStyles(calculatePosition())
            });
        }
        const id = requestAnimationFrame(()=>setPositionStyles(calculatePosition()));
        return ()=>{
            cancelAnimationFrame(id);
            cleanUpTransitionListener?.();
        };
    }, [
        calculatePosition,
        view.dom,
        rootAnchorName,
        rootNodeType,
        anchorName,
        isViewMode
    ]);
    const experienceTracker = (0, $hUyPY.useAIMateExperienceTracker)();
    const handleClick = (0, $42omo.useCallback)(()=>{
        if (isDisabled) return;
        experienceTracker.start({
            name: (0, $16lEl.ExperienceName).REMIX_START,
            id: (0, $16lEl.ExperienceName).REMIX_START,
            attributes: {
                entryPoint: 'editor',
                remixSource: 'blockNudge',
                product: 'confluence'
            }
        });
        api?.core.actions.execute(api?.malleableUi.commands.openRemixModal({
            nodePos: getPos(),
            nodeType: rootNodeType,
            metadata: {
                interactionSource: 'remixModalFromNudge'
            },
            source: 'blockNudge'
        }));
    }, [
        api,
        getPos,
        isDisabled,
        experienceTracker,
        rootNodeType
    ]);
    // Re-affirm activeNode when entering the remix button to prevent disappearing when moving
    // from block toward the button. Skip if already active to avoid flickering from re-dispatch.
    const handleMouseEnter = (0, $42omo.useCallback)(()=>{
        const anchor = rootAnchorName ?? anchorName;
        if (activeNode?.rootAnchorName === anchor && activeNode?.rootPos === rootPos) return;
        api?.core?.actions.execute(api?.blockControls?.commands.showDragHandleAt(rootPos, anchor, rootNodeType, undefined, rootPos, anchor, rootNodeType));
    }, [
        api,
        rootPos,
        anchorName,
        rootAnchorName,
        rootNodeType,
        activeNode?.rootAnchorName,
        activeNode?.rootPos
    ]);
    const isRemixAvailable = isRovoLLMEnabled && (0, $dZ8uq.expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true);
    // Use block-controls shared state (activeNode) + reusable filter instead of DOM checks for restricted nodes.
    // When activeNode is null (e.g. on initial render), default to showing the button — the anchor/position
    // logic handles visibility. Only block when we have an explicit restricted node type.
    const activeNodeType = activeNode?.rootNodeType ?? activeNode?.nodeType;
    const showRemixButton = activeNodeType === undefined || (0, $er2Wy.shouldShowRemixForSelectionContext)({
        nodeType: activeNodeType
    });
    if (!isRemixAvailable || !showRemixButton || areAiEntryPointsDisabled) return null;
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $hnbpK.VisibilityContainer), {
        api: api,
        controlSide: "right"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $74b1142437cdb6f9$var$containerBaseStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Dynamic positioning (left, top, height) calculated at runtime
        style: positionStyles,
        "data-testid": "block-ctrl-remix-button",
        onMouseEnter: handleMouseEnter,
        onFocus: handleMouseEnter
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        css: [
            $74b1142437cdb6f9$var$stickyButtonContainerStyles,
            (0, $dh538.fg)('confluence_remix_button_right_side_block_fg') ? $74b1142437cdb6f9$var$stickyButtonContainerStylesImprovedStickyHeader : $74b1142437cdb6f9$var$stickyButtonContainerStylesStickyHeader
        ]
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3gadb.default), {
        content: isRemixing ? formatMessage((0, $82ccc11bb3584e00$export$defe85febe8b728c).remixInProgressTooltip) : isDisabled ? (0, $273077559a9b876d$export$5626baa73ed0afeb)(formatMessage, remixDisabledReason) : formatMessage((0, $82ccc11bb3584e00$export$defe85febe8b728c).remixBlockTooltip),
        position: "top"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $1qfLF.default), {
        spacing: "compact",
        appearance: "subtle",
        shape: "circle",
        label: formatMessage((0, $82ccc11bb3584e00$export$defe85febe8b728c).remixBlockLabel),
        icon: ()=>/*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jQW4q))), {
                label: "",
                size: "small"
            }),
        isDisabled: isDisabled || isRemixing,
        testId: "visible-block-ctrl-remix-button",
        analyticsContext: {
            actionSubjectId: 'remix',
            source: 'remixModalFromNudge',
            attributes: {
                ...pageMode !== undefined && {
                    pageMode: pageMode
                },
                nodeType: rootNodeType,
                ...contentId !== undefined && contentId !== '' && {
                    contentId: contentId
                }
            }
        },
        onMouseDown: (e)=>e.preventDefault(),
        onClick: handleClick
    })))));
};


const $18f19acb0a096c62$var$TYPE_REMIX_BUTTON = 'REMIX_BUTTON';
const $18f19acb0a096c62$export$901fb543799e0108 = (decorations, from, to)=>{
    return decorations.find(from, to, (spec)=>spec.type === $18f19acb0a096c62$var$TYPE_REMIX_BUTTON);
};
const $18f19acb0a096c62$export$d411c8f539cb0edd = ({ api: api, isDisabled: isDisabled, isRovoLLMEnabled: isRovoLLMEnabled, livePage: livePage, remixDisabledReason: remixDisabledReason, rootPos: rootPos, anchorName: anchorName, nodeType: nodeType, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI, rootAnchorName: rootAnchorName, rootNodeType: rootNodeType })=>{
    const key = crypto.randomUUID();
    const widgetSpec = {
        side: -4,
        type: $18f19acb0a096c62$var$TYPE_REMIX_BUTTON,
        destroy: (_)=>{
            if ((0, $dh538.fg)('platform_editor_fix_widget_destroy')) nodeViewPortalProviderAPI.remove(key);
        }
    };
    return (0, $ftzrq.Decoration).widget(rootPos, (view, getPos)=>{
        const doc = (0, $hTKp4.getDocument)();
        if (!doc) throw new Error('Document not available');
        const element = doc.createElement('span');
        element.style.display = 'block';
        element.contentEditable = 'false';
        if ((0, $dh538.fg)('confluence_remix_button_right_side_block_fg')) {
            // Generic right-edge control attribute for block-controls hover area (Remix-specific: data-blocks-remix-button-*)
            element.setAttribute('data-blocks-right-edge-button-container', 'true');
            element.setAttribute('data-blocks-right-edge-button-anchor', rootAnchorName ?? anchorName);
            element.setAttribute('data-blocks-remix-button-container', 'true');
            element.setAttribute('data-blocks-remix-button-anchor', rootAnchorName ?? anchorName);
        }
        element.setAttribute('data-testid', 'block-ctrl-remix-button-container');
        nodeViewPortalProviderAPI.render(()=>(0, $42omo.createElement)((0, $74b1142437cdb6f9$export$e420cb1e340b26d1), {
                api: api,
                getPos: getPos,
                view: view,
                anchorName: anchorName,
                rootAnchorName: rootAnchorName,
                rootNodeType: rootNodeType ?? nodeType,
                rootPos: rootPos,
                livePage: livePage,
                isDisabled: isDisabled,
                isRovoLLMEnabled: isRovoLLMEnabled,
                remixDisabledReason: remixDisabledReason
            }), element, key, undefined, true);
        return element;
    }, widgetSpec);
};











/**
 * Matches a Confluence whiteboard URL that includes the `isRemixDiagram=true`
 * query parameter. This parameter is present on whiteboard URLs created by the
 * MAUI/Remix flow. The paste plugin will resolve the actual space to determine
 * whether the whiteboard needs to be moved.
 */ // eslint-disable-next-line require-unicode-regexp
const $02d96fc5e1e97446$var$WHITEBOARD_PATH_REGEX = /\/wiki\/spaces\/([^/]+)\/whiteboard\/(\d+)/;
const $02d96fc5e1e97446$var$REMIX_DIAGRAM_PARAM = 'isRemixDiagram';
/**
 * Matches a MAUI app URL of the form `/remix/ui/{appId}`.
 * The appId can contain alphanumeric characters, hyphens, and underscores.
 */ // eslint-disable-next-line require-unicode-regexp
const $02d96fc5e1e97446$var$MAUI_APP_PATH_REGEX = /\/remix\/ui\/([\w-]+)/;
function $02d96fc5e1e97446$export$6472c78b54a80875(url) {
    const trimmedUrl = url.trim();
    if (!trimmedUrl) return null;
    const pathMatch = $02d96fc5e1e97446$var$WHITEBOARD_PATH_REGEX.exec(trimmedUrl);
    if (!pathMatch) return null;
    const contentId = pathMatch[2];
    try {
        const urlObj = $02d96fc5e1e97446$var$toURL(trimmedUrl);
        if (!urlObj) return null;
        if (urlObj.searchParams.get($02d96fc5e1e97446$var$REMIX_DIAGRAM_PARAM) !== 'true') return null;
        return {
            contentId: contentId,
            originalUrl: trimmedUrl
        };
    } catch  {
        return null;
    }
}
function $02d96fc5e1e97446$export$d58b6fdd356557bd(url, targetSpaceKey) {
    try {
        const replaced = url.replace($02d96fc5e1e97446$var$WHITEBOARD_PATH_REGEX, `/wiki/spaces/${encodeURIComponent(targetSpaceKey)}/whiteboard/$2`);
        return $02d96fc5e1e97446$var$stripRemixDiagramParam(replaced);
    } catch  {
        return url;
    }
}
/**
 * Strips the `isRemixDiagram` query parameter from a URL.
 */ function $02d96fc5e1e97446$var$stripRemixDiagramParam(url) {
    try {
        const urlObj = $02d96fc5e1e97446$var$toURL(url);
        if (!urlObj) return url;
        urlObj.searchParams.delete($02d96fc5e1e97446$var$REMIX_DIAGRAM_PARAM);
        return urlObj.toString();
    } catch  {
        return url;
    }
}
function $02d96fc5e1e97446$var$toURL(urlString) {
    try {
        return new URL(urlString);
    } catch  {
        try {
            return new URL(urlString, window.location.origin);
        } catch  {
            return null;
        }
    }
}
function $02d96fc5e1e97446$export$5f9527958cc0f7be(url) {
    const trimmedUrl = url.trim();
    if (!trimmedUrl) return null;
    const pathMatch = $02d96fc5e1e97446$var$MAUI_APP_PATH_REGEX.exec(trimmedUrl);
    if (!pathMatch) return null;
    return {
        appId: pathMatch[1],
        originalUrl: trimmedUrl
    };
}
function $02d96fc5e1e97446$export$5969f844d7846c47(url, newAppId) {
    try {
        return url.replace($02d96fc5e1e97446$var$MAUI_APP_PATH_REGEX, `/remix/ui/${encodeURIComponent(newAppId)}`);
    } catch  {
        return url;
    }
}
function $02d96fc5e1e97446$export$5497de8ab9c2c871(clipboardData) {
    const text = clipboardData.getData('text/plain');
    if (!text) return null;
    const trimmed = text.trim();
    if (trimmed.includes('\n') || trimmed.includes('\r')) return null;
    if (!trimmed.startsWith('http://') && !trimmed.startsWith('https://') && !trimmed.startsWith('/wiki/') && !trimmed.startsWith('/remix/')) return null;
    return trimmed;
}


var $3429d661aa627b0d$export$61cfd1372c207927 = /*#__PURE__*/ function(MauiDiagramPasteFlagType) {
    MauiDiagramPasteFlagType["ERROR"] = "error";
    return MauiDiagramPasteFlagType;
}({});
var $3429d661aa627b0d$export$e4a712fff93fb00f = /*#__PURE__*/ function(ActionType) {
    ActionType["MOVE_STARTED"] = "MOVE_STARTED";
    ActionType["MOVE_SUCCEEDED"] = "MOVE_SUCCEEDED";
    ActionType["MOVE_FAILED"] = "MOVE_FAILED";
    ActionType["DUPLICATE_STARTED"] = "DUPLICATE_STARTED";
    ActionType["DUPLICATE_SUCCEEDED"] = "DUPLICATE_SUCCEEDED";
    ActionType["DUPLICATE_FAILED"] = "DUPLICATE_FAILED";
    ActionType["DISMISS_FLAG"] = "DISMISS_FLAG";
    return ActionType;
}({});
const $3429d661aa627b0d$export$acc845c5f0893b92 = new (0, $ks2lK.PluginKey)('mauiDiagramPastePlugin');
const $3429d661aa627b0d$var$initialState = {
    isMoving: false,
    activeFlag: null
};
const $3429d661aa627b0d$var$CARD_NODE_NAMES = new Set([
    'inlineCard',
    'blockCard',
    'embedCard'
]);
const $3429d661aa627b0d$var$ROVO_SPACE_PREFIX = '~ROVO';
/**
 * Checks whether the document already contains a reference to the given URL.
 * Only inspects card nodes and extension nodes (both flat and macroParams
 * formats) — link marks and plain text are intentionally skipped.
 *
 * Returns `true` on the first match, stopping traversal early.
 */ function $3429d661aa627b0d$var$docContainsUrl(doc, url) {
    let found = false;
    doc.descendants((node)=>{
        if (found) return false;
        if ($3429d661aa627b0d$var$CARD_NODE_NAMES.has(node.type.name) && node.attrs?.url?.includes(url)) {
            found = true;
            return false;
        }
        if (node.type.name === 'extension') {
            // Flat format: parameters.url
            if (node.attrs?.parameters?.url?.includes(url)) {
                found = true;
                return false;
            }
            // Native embed macro format: parameters.macroParams.url.value
            if (node.attrs?.parameters?.macroParams?.url?.value?.includes(url)) {
                found = true;
                return false;
            }
        }
        return true;
    });
    return found;
}
/**
 * Searches the editor document for any occurrence of the original URL and
 * replaces it with the new URL. Handles:
 * - inlineCard / blockCard / embedCard nodes with a url attribute
 * - extension nodes with a parameters.url attribute (native embeds)
 * - Hyperlink marks with the URL as href
 * - Plain text nodes containing the URL
 *
 * Mutations are collected during traversal and applied in reverse document
 * order so that earlier positions are not invalidated by later mutations.
 */ function $3429d661aa627b0d$var$updateUrlInDoc(tr, originalUrl, newUrl) {
    const cardMutations = [];
    const extensionMutations = [];
    const linkMarkMutations = [];
    const textReplaceMutations = [];
    tr.doc.descendants((node, pos)=>{
        if ($3429d661aa627b0d$var$CARD_NODE_NAMES.has(node.type.name) && node.attrs?.url?.includes(originalUrl)) {
            cardMutations.push({
                pos: pos,
                newAttrs: {
                    ...node.attrs,
                    url: node.attrs.url.replace(originalUrl, newUrl)
                }
            });
            return false;
        }
        // Native embed extension nodes store the URL in parameters.url
        if (node.type.name === 'extension' && node.attrs?.parameters?.url?.includes(originalUrl)) {
            extensionMutations.push({
                pos: pos,
                newAttrs: {
                    ...node.attrs,
                    parameters: {
                        ...node.attrs.parameters,
                        url: node.attrs.parameters.url.replace(originalUrl, newUrl)
                    }
                }
            });
            return false;
        }
        // Native embed macro extension nodes store the URL in parameters.macroParams.url.value
        if (node.type.name === 'extension' && node.attrs?.parameters?.macroParams?.url?.value?.includes(originalUrl)) {
            extensionMutations.push({
                pos: pos,
                newAttrs: {
                    ...node.attrs,
                    parameters: {
                        ...node.attrs.parameters,
                        macroParams: {
                            ...node.attrs.parameters.macroParams,
                            url: {
                                ...node.attrs.parameters.macroParams.url,
                                value: node.attrs.parameters.macroParams.url.value.replace(originalUrl, newUrl)
                            }
                        }
                    }
                }
            });
            return false;
        }
        if (node.isText) {
            node.marks?.forEach((mark)=>{
                if (mark.type.name === 'link' && mark.attrs?.href?.includes(originalUrl)) {
                    const newHref = mark.attrs.href.replace(originalUrl, newUrl);
                    const newMark = mark.type.create({
                        ...mark.attrs,
                        href: newHref
                    });
                    linkMarkMutations.push({
                        from: pos,
                        to: pos + node.nodeSize,
                        oldMark: mark,
                        newMark: newMark
                    });
                }
            });
            if (node.text?.includes(originalUrl)) {
                const startIdx = node.text.indexOf(originalUrl);
                textReplaceMutations.push({
                    from: pos + startIdx,
                    to: pos + startIdx + originalUrl.length,
                    newUrl: newUrl
                });
                return false;
            }
        }
        return true;
    });
    // Apply card node mutations in reverse order (setNodeMarkup doesn't change positions)
    for(let i = cardMutations.length - 1; i >= 0; i--){
        const { pos: pos, newAttrs: newAttrs } = cardMutations[i];
        tr.setNodeMarkup(pos, undefined, newAttrs);
    }
    // Apply extension node mutations in reverse order
    for(let i = extensionMutations.length - 1; i >= 0; i--){
        const { pos: pos, newAttrs: newAttrs } = extensionMutations[i];
        tr.setNodeMarkup(pos, undefined, newAttrs);
    }
    // Apply link mark mutations in reverse order (removeMark/addMark don't change positions)
    for(let i = linkMarkMutations.length - 1; i >= 0; i--){
        const { from: from, to: to, oldMark: oldMark, newMark: newMark } = linkMarkMutations[i];
        tr.removeMark(from, to, oldMark);
        tr.addMark(from, to, newMark);
    }
    // Apply text replacements in reverse order (replaceWith can change text length)
    for(let i = textReplaceMutations.length - 1; i >= 0; i--){
        const { from: from, to: to, newUrl: url } = textReplaceMutations[i];
        tr.replaceWith(from, to, tr.doc.type.schema.text(url));
    }
}
/**
 * Extracts a MAUI app URL from a pasted ProseMirror Slice by inspecting
 * extension nodes for a URL in the macroParams.url.value or parameters.url
 * structure. Returns the URL string if found, or null.
 */ function $3429d661aa627b0d$var$extractMauiAppUrlFromSlice(slice) {
    if (!slice?.content?.descendants) return null;
    let foundUrl = null;
    slice.content.descendants((node)=>{
        if (foundUrl) return false;
        if (node.type.name === 'extension') {
            const macroUrl = node.attrs?.parameters?.macroParams?.url?.value;
            if (macroUrl && typeof macroUrl === 'string') {
                foundUrl = macroUrl;
                return false;
            }
            const flatUrl = node.attrs?.parameters?.url;
            if (flatUrl && typeof flatUrl === 'string') {
                foundUrl = flatUrl;
                return false;
            }
        }
        return true;
    });
    return foundUrl;
}
/**
 * Kicks off the async move workflow:
 * 1. Resolves the whiteboard's actual space key
 * 2. If the space starts with ~ROVO (Rovo system space), proceeds with the move
 * 3. Otherwise, skips the move (whiteboard is already in a real space)
 *
 * On success, updates the URL in the editor document to replace the space
 * key with the target space key.
 */ function $3429d661aa627b0d$var$startMoveWorkflow({ view: view, config: config, linkInfo: linkInfo, currentPageId: currentPageId }) {
    config.resolveContentSpaceKey(linkInfo.contentId).then((spaceKey)=>{
        if (!spaceKey || !spaceKey.startsWith($3429d661aa627b0d$var$ROVO_SPACE_PREFIX)) {
            // Not in a Rovo system space — already moved or not a MAUI diagram.
            // Update the URL in the doc if the space was resolved (so re-paste
            // from the same clipboard doesn't trigger another check).
            if (spaceKey) {
                const movedUrl = (0, $02d96fc5e1e97446$export$d58b6fdd356557bd)(linkInfo.originalUrl, spaceKey);
                const updateTr = view.state.tr;
                $3429d661aa627b0d$var$updateUrlInDoc(updateTr, linkInfo.originalUrl, movedUrl);
                view.dispatch(updateTr);
            }
            return;
        }
        const startTr = view.state.tr;
        startTr.setMeta($3429d661aa627b0d$export$acc845c5f0893b92, {
            type: "MOVE_STARTED"
        });
        view.dispatch(startTr);
        return config.moveWhiteboardToPage(linkInfo.contentId, currentPageId).then(()=>{
            const movedUrl = (0, $02d96fc5e1e97446$export$d58b6fdd356557bd)(linkInfo.originalUrl, config.targetSpaceKey);
            const successTr = view.state.tr;
            $3429d661aa627b0d$var$updateUrlInDoc(successTr, linkInfo.originalUrl, movedUrl);
            successTr.setMeta($3429d661aa627b0d$export$acc845c5f0893b92, {
                type: "MOVE_SUCCEEDED"
            });
            view.dispatch(successTr);
            config.fireAnalyticsEvent?.({
                action: 'moved',
                actionSubject: 'mauiDiagram',
                actionSubjectId: 'move',
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    contentId: linkInfo.contentId,
                    targetPageId: currentPageId
                }
            });
        });
    }).catch((error)=>{
        config.fireAnalyticsEvent?.({
            action: (0, $d925B.ACTION).ERROR,
            actionSubject: 'mauiDiagram',
            actionSubjectId: 'move',
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                contentId: linkInfo.contentId,
                targetPageId: currentPageId,
                errorMessage: error?.message,
                errorStack: error?.stack
            }
        });
        const failTr = view.state.tr;
        failTr.setMeta($3429d661aa627b0d$export$acc845c5f0893b92, {
            type: "MOVE_FAILED",
            errorMessage: "We couldn't move this diagram to your page. It won't be visible to other users until it's moved. Please try again or try pasting the diagram somewhere else."
        });
        view.dispatch(failTr);
    });
}
/**
 * Kicks off the async duplicate workflow for MAUI app links:
 * 1. Calls duplicateMauiApp with the app ID and current page ID
 * 2. On success, updates all URLs in the doc to reference the new app ID
 */ function $3429d661aa627b0d$var$startDuplicateWorkflow({ view: view, config: config, linkInfo: linkInfo, currentPageId: currentPageId }) {
    if (!config.duplicateMauiApp) return;
    const startTr = view.state.tr;
    startTr.setMeta($3429d661aa627b0d$export$acc845c5f0893b92, {
        type: "DUPLICATE_STARTED"
    });
    view.dispatch(startTr);
    config.duplicateMauiApp(linkInfo.appId, currentPageId).then(({ id: newAppId })=>{
        const duplicatedUrl = (0, $02d96fc5e1e97446$export$5969f844d7846c47)(linkInfo.originalUrl, newAppId);
        const successTr = view.state.tr;
        $3429d661aa627b0d$var$updateUrlInDoc(successTr, linkInfo.originalUrl, duplicatedUrl);
        successTr.setMeta($3429d661aa627b0d$export$acc845c5f0893b92, {
            type: "DUPLICATE_SUCCEEDED"
        });
        view.dispatch(successTr);
    }).catch((error)=>{
        const failTr = view.state.tr;
        failTr.setMeta($3429d661aa627b0d$export$acc845c5f0893b92, {
            type: "DUPLICATE_FAILED",
            errorMessage: error?.message || "We couldn't duplicate this component. Please try again."
        });
        view.dispatch(failTr);
    });
}
function $3429d661aa627b0d$export$e46b072e8cabda89(dispatch, config) {
    // Pending moves are tracked outside plugin state to avoid dispatching
    // transactions that would interfere with the card plugin's async
    // URL-to-embedCard resolution (which checks document structure via
    // isFreshlyPastedOnNewLine).
    let pendingMoveTimer = null;
    return new (0, $1S4f7.SafePlugin)({
        key: $3429d661aa627b0d$export$acc845c5f0893b92,
        state: {
            init: ()=>$3429d661aa627b0d$var$initialState,
            apply (tr, pluginState) {
                const meta = tr.getMeta($3429d661aa627b0d$export$acc845c5f0893b92);
                if (!meta) return pluginState;
                let nextState;
                switch(meta.type){
                    case "MOVE_STARTED":
                    case "DUPLICATE_STARTED":
                        nextState = {
                            ...pluginState,
                            isMoving: true,
                            activeFlag: null
                        };
                        break;
                    case "MOVE_SUCCEEDED":
                    case "DUPLICATE_SUCCEEDED":
                        nextState = {
                            isMoving: false,
                            activeFlag: null
                        };
                        break;
                    case "MOVE_FAILED":
                        nextState = {
                            isMoving: false,
                            activeFlag: {
                                id: 'maui-diagram-move-error',
                                type: "error",
                                title: 'Could not move diagram',
                                description: meta.errorMessage || "We couldn't move this diagram to your page. It won't be visible to other users until it's moved out of its temporary space. Please try again or move it manually."
                            }
                        };
                        break;
                    case "DUPLICATE_FAILED":
                        nextState = {
                            isMoving: false,
                            activeFlag: {
                                id: 'maui-app-duplicate-error',
                                type: "error",
                                title: 'Could not duplicate component',
                                description: meta.errorMessage || "We couldn't duplicate this component. Please try again."
                            }
                        };
                        break;
                    case "DISMISS_FLAG":
                        nextState = {
                            ...pluginState,
                            activeFlag: null
                        };
                        break;
                    default:
                        return pluginState;
                }
                dispatch($3429d661aa627b0d$export$acc845c5f0893b92, nextState);
                return nextState;
            }
        },
        props: {
            handlePaste (view, event, slice) {
                const { clipboardData: clipboardData } = event;
                if (!clipboardData) return false;
                const url = (0, $02d96fc5e1e97446$export$5497de8ab9c2c871)(clipboardData);
                const diagramLinkInfo = url ? (0, $02d96fc5e1e97446$export$6472c78b54a80875)(url) : null;
                let appLinkInfo = url && !diagramLinkInfo ? (0, $02d96fc5e1e97446$export$5f9527958cc0f7be)(url) : null;
                // If no MAUI link was found in the plain text, check the pasted
                // Slice for extension nodes containing a MAUI app URL (e.g. when
                // a native embed extension is copy-pasted from another page).
                if (!diagramLinkInfo && !appLinkInfo) {
                    const sliceUrl = $3429d661aa627b0d$var$extractMauiAppUrlFromSlice(slice);
                    if (sliceUrl) appLinkInfo = (0, $02d96fc5e1e97446$export$5f9527958cc0f7be)(sliceUrl);
                }
                if (!diagramLinkInfo && !appLinkInfo) return false;
                const currentPageId = config.getCurrentPageId();
                if (!currentPageId) {
                    // Dispatch the error on the next tick so it doesn't
                    // interfere with the paste transaction pipeline
                    const errorAction = diagramLinkInfo ? "MOVE_FAILED" : "DUPLICATE_FAILED";
                    setTimeout(()=>{
                        const tr = view.state.tr;
                        tr.setMeta($3429d661aa627b0d$export$acc845c5f0893b92, {
                            type: errorAction,
                            errorMessage: 'Could not determine the current page. Please save the page first and try again.'
                        });
                        view.dispatch(tr);
                    }, 0);
                    return false;
                }
                // If this is a MAUI app link that already exists on the page,
                // skip the duplicate workflow and just let the link paste normally.
                if (appLinkInfo && $3429d661aa627b0d$var$docContainsUrl(view.state.doc, appLinkInfo.originalUrl)) return false;
                // Clear any previously scheduled move — if the user pastes
                // back-to-back, only the latest paste triggers a move
                if (pendingMoveTimer !== null) clearTimeout(pendingMoveTimer);
                // Schedule the workflow after a delay to avoid dispatching
                // transactions during the card plugin's async URL → embedCard
                // resolution window. The card plugin's isFreshlyPastedOnNewLine
                // check is sensitive to document/selection state changes.
                pendingMoveTimer = setTimeout(()=>{
                    pendingMoveTimer = null;
                    if (diagramLinkInfo) $3429d661aa627b0d$var$startMoveWorkflow({
                        view: view,
                        config: config,
                        linkInfo: diagramLinkInfo,
                        currentPageId: currentPageId
                    });
                    else if (appLinkInfo) $3429d661aa627b0d$var$startDuplicateWorkflow({
                        view: view,
                        config: config,
                        linkInfo: appLinkInfo,
                        currentPageId: currentPageId
                    });
                }, 0);
                // Return false — let the default paste pipeline handle insertion
                // so the URL is auto-converted to a smart link as normal
                return false;
            }
        }
    });
}














var $eCEXz = parcelRequire("eCEXz");

var $6uGcC = parcelRequire("6uGcC");


var $a3fRD = parcelRequire("a3fRD");


const $85200fa1528e91da$export$2a1e596305c92bc7 = ()=>({ tr: tr })=>{
        tr.setMeta((0, $3429d661aa627b0d$export$acc845c5f0893b92), {
            type: (0, $3429d661aa627b0d$export$e4a712fff93fb00f).DISMISS_FLAG
        });
        return tr;
    };


const $c14e5e6d7f455b31$export$bdca710d02013452 = ({ api: api })=>{
    const activeFlag = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'malleableUi'
    ], (states)=>states.malleableUiState?.diagramPaste?.activeFlag ?? null);
    const onDismissed = (0, $42omo.useCallback)(()=>{
        api?.core.actions.execute((0, $85200fa1528e91da$export$2a1e596305c92bc7)());
    }, [
        api
    ]);
    if (!activeFlag) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6uGcC.default), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $eCEXz.default), {
            onDismissed: onDismissed,
            title: activeFlag.title,
            description: activeFlag.description,
            id: activeFlag.id,
            testId: activeFlag.id,
            icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
                label: "",
                color: "var(--ds-icon-danger, #C9372C)"
            })
        })
    });
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 





function $01fa406e6521134b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $01fa406e6521134b$var$persistedHighlightStyles = {
    name: "i5x8os",
    styles: ".akEditor div.ProseMirror .remix-thinking-highlight{background-color:var(--ds-background-accent-purple-subtlest, #F8EEFE);text-decoration:underline;text-decoration-style:dotted;text-decoration-thickness:var(--ds-space-025, 2px);text-decoration-color:var(--ds-border-accent-purple, #AF59E1);text-decoration-skip-ink:none;}"
};
const $01fa406e6521134b$export$3bccfb6f759a17 = ()=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $9K4OG.Global), {
        styles: $01fa406e6521134b$var$persistedHighlightStyles
    }));
};

















const $6ab95f584bb8fa39$export$9b636cd211668abd = ({ api: api, config: config })=>{
    const { createRemixContentComponent: createRemixContentComponent } = config;
    const isModalOpen = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'malleableUi'
    ], (states)=>states.malleableUiState?.isRemixModalOpen || false);
    const isThinking = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'malleableUi'
    ], (states)=>states.malleableUiState?.isThinking || false);
    const remixModalMetadata = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'malleableUi'
    ], (states)=>states.malleableUiState?.remixModalMetadata);
    const remixSource = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'malleableUi'
    ], (states)=>states.malleableUiState?.remixSource);
    // Start Remix experience for floating toolbar entry point (can't use hooks in toolbar config).
    const experienceTracker = (0, $hUyPY.useAIMateExperienceTracker)();
    const prevIsModalOpen = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (!prevIsModalOpen.current && isModalOpen && remixSource === 'floatingToolbar') experienceTracker.start({
            name: (0, $16lEl.ExperienceName).REMIX_START,
            id: (0, $16lEl.ExperienceName).REMIX_START,
            attributes: {
                entryPoint: 'editor',
                remixSource: 'floatingToolbar',
                product: 'confluence'
            }
        });
        prevIsModalOpen.current = isModalOpen;
    }, [
        isModalOpen,
        remixSource,
        experienceTracker
    ]);
    const Component = (0, $42omo.useMemo)(()=>createRemixContentComponent(), [
        createRemixContentComponent
    ]);
    const handleModalClose = (0, $42omo.useCallback)(()=>{
        api?.core.actions.execute(api?.malleableUi.commands.closeRemixModal());
    }, [
        api
    ]);
    const onStartThinking = (0, $42omo.useCallback)(()=>{
        api?.aiExperience?.actions.toggleAiEntryPoints?.(true);
        api?.core.actions.execute(api?.malleableUi.commands.startRemixThinking());
    }, [
        api
    ]);
    const onStopThinking = (0, $42omo.useCallback)((options)=>{
        api?.aiExperience?.actions.toggleAiEntryPoints?.(false);
        api?.core.actions.execute(api?.malleableUi.commands.stopRemixThinking(options));
    }, [
        api
    ]);
    if (!api || !Component) return null;
    const selectedContext = api?.aiExperience?.actions.getAISelectionContext();
    if (!selectedContext) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)(Component, {
        isModalOpen: isModalOpen,
        isThinking: isThinking,
        handleModalClose: handleModalClose,
        remixSource: remixSource,
        selectedContext: selectedContext,
        editorApi: api,
        onStartThinking: onStartThinking,
        onStopThinking: onStopThinking,
        remixModalMetadata: remixModalMetadata
    });
};









var $l9G9n = parcelRequire("l9G9n");








var $1oCLl = parcelRequire("1oCLl");


var $hXDaB = parcelRequire("hXDaB");







function $93f48c61ee0bdd1a$export$4acd7d829930a56d(schema) {
    return new Set((0, $er2Wy.REMIX_DENY_LIST_V1).map((name)=>schema.nodes[name]).filter(Boolean));
}
function $93f48c61ee0bdd1a$export$81aefa0141c75da9(schema) {
    return new Set((0, $er2Wy.ASK_ROVO_MEDIA_NODE_TYPES).map((name)=>schema.nodes[name]).filter(Boolean));
}
const $93f48c61ee0bdd1a$var$remixFloatingToolbarClickAnalyticsPayload = {
    action: (0, $d925B.ACTION).CLICKED,
    actionSubject: (0, $d925B.ACTION_SUBJECT).BUTTON,
    actionSubjectId: 'remixModalFromToolbar',
    eventType: (0, $d925B.EVENT_TYPE).UI,
    source: 'remix'
};
function $93f48c61ee0bdd1a$export$5b679e92b69e94fb(api) {
    if (!api?.toolbar) return ()=>undefined;
    return (state, intl, _providerFactory, activeConfigs)=>{
        if (!activeConfigs?.length) return;
        const unallowedNodes = $93f48c61ee0bdd1a$export$4acd7d829930a56d(state.schema);
        const isNodeEmpty = (0, $l9G9n.isEmptyNode)(state.schema);
        const malleableUiState = (0, $cfddc4cc14c7297d$export$66b514a792884e0c).getState(state);
        const remixThinkingState = (0, $ee07456bddbd4c00$export$38c8fc373d691b1d).getState(state);
        const isRemixing = malleableUiState?.isRemixModalOpen || false || remixThinkingState?.isThinking || false;
        const areAiEntryPointsDisabled = (0, $dh538.fg)('platform_editor_ai_toggle_entry_points') ? api?.aiExperience?.sharedState.currentState()?.areAiEntryPointsDisabled ?? false : false;
        activeConfigs.forEach((config)=>{
            if (config.className === (0, $hXDaB.InlineSuggestionToolbar).INLINE_SUGGESTION_FLOATING_TOOLBAR_CLASS || !Array.isArray(config.nodeType) && config.nodeType.name === 'table' && config.items.length === 0 || [].concat(config.nodeType).some((nodeType)=>unallowedNodes.has(nodeType) || nodeType.isInline)) return;
            const toolbarItems = config.items;
            if (Array.isArray(toolbarItems)) {
                const remixButton = {
                    id: 'editor.malleable-ui.remix',
                    type: 'button',
                    title: intl.formatMessage((0, $82ccc11bb3584e00$export$defe85febe8b728c).remixToolbarLabel),
                    tooltipContent: isRemixing ? intl.formatMessage((0, $82ccc11bb3584e00$export$defe85febe8b728c).remixInProgressTooltip) : intl.formatMessage((0, $82ccc11bb3584e00$export$defe85febe8b728c).remixToolbarTooltip),
                    showTitle: true,
                    hideTooltipOnClick: false,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($jQW4q))),
                    onClick: ()=>false,
                    disabled: isRemixing || areAiEntryPointsDisabled,
                    testId: 'editor-floating-toolbar__remix-button'
                };
                const remixToolbarItems = [
                    remixButton,
                    {
                        type: 'separator',
                        fullHeight: true
                    }
                ];
                config.items = (node)=>{
                    remixButton.onClick = (editorState)=>{
                        if (isRemixing) return false;
                        const $pos = editorState.selection.$from;
                        let nodePos;
                        for(let depth = $pos.depth; depth > 0; depth--)if ($pos.node(depth) === node) {
                            nodePos = $pos.before(depth);
                            break;
                        }
                        api.analytics?.actions.fireAnalyticsEvent($93f48c61ee0bdd1a$var$remixFloatingToolbarClickAnalyticsPayload);
                        api.core.actions.execute(api.malleableUi.commands.openRemixModal({
                            nodePos: nodePos,
                            nodeType: node.type.name,
                            metadata: {
                                interactionSource: 'remixModalFromFloatingToolbar'
                            },
                            source: 'floatingToolbar'
                        }));
                        return true;
                    };
                    // layoutSection is always remixable even when empty — user can remix to generate content.
                    remixButton.disabled = isRemixing || areAiEntryPointsDisabled || node?.type?.name !== 'layoutSection' && isNodeEmpty(node);
                    return [
                        ...remixToolbarItems,
                        ...toolbarItems
                    ];
                };
            }
        });
        const mediaNodesForAskRovo = $93f48c61ee0bdd1a$export$81aefa0141c75da9(state.schema);
        const askRovoButton = api?.aiExperience?.actions?.getAskRovoFloatingToolbarButton?.({
            intl: intl,
            disabled: false
        });
        if (!mediaNodesForAskRovo.size || !askRovoButton || !(0, $1oCLl.expValEquals)('cc-maui-experiment-phase-2', 'isEnabled', true)) return;
        const askRovoItems = [
            askRovoButton,
            {
                type: 'separator',
                fullHeight: true
            }
        ];
        const shouldShowAskRovoForMediaNode = (node)=>mediaNodesForAskRovo.has(node.type) && !node.type.isInline;
        activeConfigs.forEach((config)=>{
            const nodeTypes = [].concat(config.nodeType);
            const isMediaConfig = nodeTypes.some((nodeType)=>mediaNodesForAskRovo.has(nodeType) && !nodeType.isInline);
            if (!isMediaConfig) return;
            const items = config.items;
            if (Array.isArray(items)) config.items = (node)=>shouldShowAskRovoForMediaNode(node) ? [
                    ...askRovoItems,
                    ...items
                ] : items;
            else if (typeof items === 'function') config.items = (node)=>{
                const baseItems = items(node);
                return shouldShowAskRovoForMediaNode(node) ? [
                    ...askRovoItems,
                    ...baseItems
                ] : baseItems;
            };
        });
    };
}





parcelRequire("42omo");


var $cPCP8 = parcelRequire("cPCP8");

var $4Chin = parcelRequire("4Chin");











var $inPa6 = parcelRequire("inPa6");





var $7ERUE = parcelRequire("7ERUE");

var $iIVVb = parcelRequire("iIVVb");


















const $bd1036ec2a555773$var$testId = 'editor-toolbar__remix-button';
const $bd1036ec2a555773$export$53a35bc3b2402206 = ({ api: api, isDisabled: isDisabled, isRemixHidden: isRemixHidden, remixDisabledReason: remixDisabledReason })=>{
    const { formatMessage: formatMessage } = (0, $1cfRh.default)();
    const experienceTracker = (0, $hUyPY.useAIMateExperienceTracker)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isRemixing: isRemixing, areAiEntryPointsDisabled: areAiEntryPointsDisabled } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'malleableUi',
        'aiExperience'
    ], (states)=>({
            isRemixing: states.malleableUiState?.isRemixModalOpen || false || states.malleableUiState?.isThinking || false,
            areAiEntryPointsDisabled: (0, $dh538.fg)('platform_editor_ai_toggle_entry_points') ? states.aiExperienceState?.areAiEntryPointsDisabled ?? false : false
        }));
    const effectiveDisabled = isDisabled || areAiEntryPointsDisabled;
    const handleClick = (0, $42omo.useCallback)(()=>{
        if (effectiveDisabled || isRemixing) return;
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'remixModalFromToolbar',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'remix',
                attributes: {
                    entryPoint: 'editor'
                }
            }
        }).fire();
        experienceTracker.start({
            name: (0, $16lEl.ExperienceName).REMIX_START,
            id: (0, $16lEl.ExperienceName).REMIX_START,
            attributes: {
                entryPoint: 'editor',
                remixSource: 'selectionToolbar',
                product: 'confluence'
            }
        });
        api?.core.actions.execute(api?.malleableUi.commands.openRemixModal({
            metadata: {
                interactionSource: 'remixModalFromToolbar'
            },
            source: 'selectionToolbar'
        }));
    }, [
        api,
        effectiveDisabled,
        isRemixing,
        experienceTracker,
        createAnalyticsEvent
    ]);
    const tooltipContent = (0, $42omo.useMemo)(()=>{
        if (isRemixing) return formatMessage((0, $82ccc11bb3584e00$export$defe85febe8b728c).remixInProgressTooltip);
        if (effectiveDisabled) return (0, $273077559a9b876d$export$5626baa73ed0afeb)(formatMessage, remixDisabledReason);
        return formatMessage((0, $82ccc11bb3584e00$export$defe85febe8b728c).remixToolbarTooltip);
    }, [
        isRemixing,
        effectiveDisabled,
        formatMessage,
        remixDisabledReason
    ]);
    if (isRemixHidden || !(0, $1oCLl.expValEquals)('cc-maui-experiment', 'isEnabled', true)) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $iIVVb.ToolbarTooltip), {
        content: tooltipContent,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7ERUE.ToolbarButton), {
            iconBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jQW4q))), {
                label: "",
                size: "small"
            }),
            testId: $bd1036ec2a555773$var$testId,
            onClick: handleClick,
            isDisabled: effectiveDisabled || isRemixing,
            children: formatMessage((0, $82ccc11bb3584e00$export$defe85febe8b728c).remixToolbarLabel)
        })
    });
};


const $b25601d685dcddfe$var$MAUI_REMIX_GROUP = {
    type: 'group',
    key: 'malleable-ui-remix-group'
};
const $b25601d685dcddfe$var$MAUI_REMIX_BUTTON = {
    type: 'button',
    key: 'malleable-ui-remix-button'
};
const $b25601d685dcddfe$export$716af56477a0c29a = (api, options)=>{
    return [
        {
            type: $b25601d685dcddfe$var$MAUI_REMIX_GROUP.type,
            key: $b25601d685dcddfe$var$MAUI_REMIX_GROUP.key,
            parents: [
                {
                    type: (0, $cPCP8.AI_SECTION).type,
                    key: (0, $cPCP8.AI_SECTION).key,
                    rank: (0, $4Chin.AI_SECTION_RANK)[(0, $cPCP8.HERO_PROMPT_BUTTON_GROUP).key] + 10
                },
                // View mode (Live Page): AI_VIEW_SECTION
                {
                    type: (0, $cPCP8.AI_VIEW_SECTION).type,
                    key: (0, $cPCP8.AI_VIEW_SECTION).key,
                    rank: (0, $4Chin.AI_SECTION_RANK)[(0, $cPCP8.HERO_PROMPT_BUTTON_GROUP).key] + 10
                }
            ]
        },
        {
            type: $b25601d685dcddfe$var$MAUI_REMIX_BUTTON.type,
            key: $b25601d685dcddfe$var$MAUI_REMIX_BUTTON.key,
            parents: [
                {
                    type: $b25601d685dcddfe$var$MAUI_REMIX_GROUP.type,
                    key: $b25601d685dcddfe$var$MAUI_REMIX_GROUP.key,
                    rank: 100
                }
            ],
            component: ({ parents: parents })=>{
                const onPrimaryToolbar = parents.at(0)?.key === (0, $cPCP8.TOOLBARS).PRIMARY_TOOLBAR;
                if (onPrimaryToolbar) return null;
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $bd1036ec2a555773$export$53a35bc3b2402206), {
                    api: api,
                    isDisabled: options?.isDisabled,
                    isRemixHidden: options?.isRemixHidden,
                    remixDisabledReason: options?.remixDisabledReason
                });
            }
        }
    ];
};


const $042f40d3cc5075b5$var$REMIX_BUTTON_DECORATION_TYPE = 'REMIX_BUTTON';
const $042f40d3cc5075b5$export$90e174b945ae40c7 = ({ api: api, config: config })=>{
    const isRovoLLMEnabled = config?.__isRovoLLMEnabled ?? false;
    const isRemixEnabled = isRovoLLMEnabled && (0, $dZ8uq.expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true);
    const isRightSideEnabled = isRemixEnabled && (0, $dh538.fg)('confluence_remix_button_right_side_block_fg');
    const remixDisabledReason = config?.__remixDisabledReason;
    const isRemixDisabled = !!remixDisabledReason;
    if (api && !config?.__isRemixHidden && isRemixEnabled) api.toolbar?.actions.registerComponents((0, $b25601d685dcddfe$export$716af56477a0c29a)(api, {
        remixDisabledReason: remixDisabledReason,
        isDisabled: isRemixDisabled
    }));
    if (api && !config?.__isRemixHidden && isRightSideEnabled) {
        const livePage = config?.__livePage;
        api.blockControls.actions.registerNodeDecoration({
            type: $042f40d3cc5075b5$var$REMIX_BUTTON_DECORATION_TYPE,
            create: (params)=>(0, $18f19acb0a096c62$export$d411c8f539cb0edd)({
                    ...params,
                    api: api,
                    livePage: livePage,
                    remixDisabledReason: remixDisabledReason,
                    isDisabled: isRemixDisabled,
                    isRovoLLMEnabled: isRovoLLMEnabled
                }),
            showInViewMode: true,
            shouldCreate: (params)=>{
                const { editorState: editorState, rootPos: rootPos } = params;
                if (rootPos === undefined) return false;
                const node = editorState.doc.nodeAt(rootPos);
                return (0, $er2Wy.shouldShowRemixForSelectionContext)({
                    node: node ?? undefined
                });
            }
        });
    }
    return {
        name: 'malleableUi',
        pmPlugins () {
            const plugins = [
                {
                    name: 'malleableUi',
                    plugin: ({ dispatch: dispatch })=>(0, $cfddc4cc14c7297d$export$11ad8b64b26867df)(dispatch)
                },
                {
                    name: 'remixThinking',
                    plugin: ({ dispatch: dispatch })=>(0, $ee07456bddbd4c00$export$1c17a47e3daa5065)(dispatch)
                }
            ];
            if (config?.diagramPaste) {
                const diagramPasteConfig = {
                    ...config.diagramPaste,
                    fireAnalyticsEvent: (payload)=>{
                        api?.analytics?.actions.fireAnalyticsEvent(payload);
                    }
                };
                plugins.push({
                    name: 'mauiDiagramPaste',
                    plugin: ({ dispatch: dispatch })=>(0, $3429d661aa627b0d$export$e46b072e8cabda89)(dispatch, diagramPasteConfig)
                });
            }
            return plugins;
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const malleableUiState = (0, $cfddc4cc14c7297d$export$66b514a792884e0c).getState(editorState);
            const remixThinkingState = (0, $ee07456bddbd4c00$export$38c8fc373d691b1d).getState(editorState);
            if (!malleableUiState || !remixThinkingState) return undefined;
            return {
                isRemixModalOpen: malleableUiState.isRemixModalOpen,
                remixModalMetadata: malleableUiState.remixModalMetadata,
                isThinking: remixThinkingState.isThinking,
                remixSource: malleableUiState.remixSource,
                diagramPaste: (0, $3429d661aa627b0d$export$acc845c5f0893b92).getState(editorState),
                savedSelection: remixThinkingState.savedSelection
            };
        },
        commands: {
            openRemixModal: (0, $140c07dc09e2d405$export$e01f52b7ef73f07b)(api),
            closeRemixModal: (0, $3cbafda77e1252b9$export$8818f9db6e7370f7)(api),
            startRemixThinking: (0, $ccb60ab150962a8e$export$b0011c604093029)(api),
            stopRemixThinking: $d462007436924fa2$export$5569fef6b45e570f,
            replaceMauiApp: $a8bbc3dbab143724$export$ff177b3b8713a3ae
        },
        contentComponent: ()=>{
            return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $01fa406e6521134b$export$3bccfb6f759a17), {}),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6ab95f584bb8fa39$export$9b636cd211668abd), {
                        api: api,
                        config: config
                    }),
                    config?.diagramPaste && /*#__PURE__*/ (0, $l998X.jsx)((0, $c14e5e6d7f455b31$export$bdca710d02013452), {
                        api: api
                    })
                ]
            });
        },
        pluginsOptions: !config?.__isRemixHidden && !config?.__remixDisabledReason && isRemixEnabled ? {
            floatingToolbar: (0, $93f48c61ee0bdd1a$export$5b679e92b69e94fb)(api)
        } : {}
    };
};





parcelRequire("42omo");


var $2FNjD = parcelRequire("2FNjD");


var $cs1vW = parcelRequire("cs1vW");











var $2XqLN = parcelRequire("2XqLN");

const $5c15d883298a980d$export$2073a24f9367a16f = (0, $2XqLN.default)(()=>{
    // directly use CSS would cause failed SSR tests.
    if (typeof window !== 'undefined' && window.CSS && window.CSS.supports) return window.CSS.supports('anchor-name: --a');
    return false;
});
class $5c15d883298a980d$export$e1d230f644ff05aa {
    clear() {
        this.isDirty = true;
        this.anchorRectMap = {};
    }
    getRects() {
        if (this.isDirty) {
            const anchorElements = this.view?.dom.querySelectorAll('[data-section-cta-anchor-name]') || [];
            this.anchorRectMap = Array.from(anchorElements).reduce((prev, curr)=>{
                const anchorName = curr.getAttribute('data-section-cta-anchor-name');
                if (anchorName) return {
                    ...prev,
                    [anchorName]: {
                        height: curr.clientHeight,
                        top: curr.offsetTop,
                        left: curr.offsetLeft,
                        right: curr.offsetLeft + curr.clientWidth,
                        width: curr.clientWidth,
                        bottom: curr.offsetTop + curr.clientHeight
                    }
                };
                return prev;
            }, {});
            this.isDirty = false;
        }
        return this.anchorRectMap;
    }
    setEditorView(view) {
        if (this.view !== view) this.view = view;
    }
    getHeight(anchorName) {
        if (this.isAnchorSupported) return null;
        const rects = this.getRects();
        return rects[anchorName]?.height;
    }
    getWidth(anchorName) {
        if (this.isAnchorSupported) return null;
        const rects = this.getRects();
        return rects[anchorName]?.width;
    }
    getLeft(anchorName) {
        if (this.isAnchorSupported) return null;
        const rects = this.getRects();
        return rects[anchorName]?.left;
    }
    getTop(anchorName) {
        if (this.isAnchorSupported) return null;
        const rects = this.getRects();
        return rects[anchorName]?.top;
    }
    getRight(anchorName) {
        if (this.isAnchorSupported) return null;
        const rects = this.getRects();
        return rects[anchorName]?.right;
    }
    getRect(anchorName) {
        if (this.isAnchorSupported) return null;
        const rects = this.getRects();
        return rects[anchorName];
    }
    constructor(){
        this.anchorRectMap = {};
        this.isAnchorSupported = $5c15d883298a980d$export$2073a24f9367a16f();
        this.isDirty = true;
        this.view = null;
    }
}


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 












var $1Whri = parcelRequire("1Whri");


var $aFUXX = parcelRequire("aFUXX");


var $g5gZt = parcelRequire("g5gZt");




var $fVUfS = parcelRequire("fVUfS");







const $20ed47d9991fb6d4$export$a7357cdd1f0b0168 = (0, $h82at.defineMessages)({
    addSection: {
        id: "company-hub-section-cta.plus-button.add-section",
        defaultMessage: "Add section"
    },
    contentHeader: {
        id: "company-hub-section-cta.section-node.content.header",
        defaultMessage: "Give your section a title"
    },
    contentSubHeader: {
        id: "company-hub-section-cta.section-node.content.sub-header",
        defaultMessage: "Organize elements into sections with customizable backgrounds."
    },
    lozengeTitle: {
        id: "company-hub-section-cta.section-node.lozenge-title",
        defaultMessage: "Section"
    },
    placeHolderTitle: {
        id: "company-hub-section-cta.section-node.content.placeholder-title",
        defaultMessage: "Placeholder"
    }
});



const $43c0e35ecb9920ae$var$styles = {
    containerBaseStyles: "_v5641p41 _18zr1i3y _kqswstnw _1bsb16wv _1e0c1txw _1bah1h6o _4cvr1h6o _4t3izwfg _tzy4idpf _1pbyb4wl _16l4kb7n",
    lineStyles: "_16jlkb7n _1o9zkb7n _i0dlf1ug _4t3iyh40 _bfhk1aqn",
    pressable: "_2rko1rr0 _bfhk1aqn _4t3izwfg _1bsbzwfg _irr31ibz _1di6of27"
};
const $43c0e35ecb9920ae$var$Line = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($43c0e35ecb9920ae$var$styles.lineStyles)
    });
const $43c0e35ecb9920ae$export$e50c8b7ca0cd488e = ({ anchorId: anchorId, onClick: onClick, view: view, prevNodeTypeName: prevNodeTypeName, isLastPosition: isLastPosition, anchorRectCache: anchorRectCache })=>{
    const { formatMessage: formatMessage } = (0, $1cfRh.default)();
    const [dynamicStyles, setDynamicStyles] = (0, $42omo.useState)({});
    (0, $42omo.useEffect)(()=>{
        const calculatePosition = ()=>{
            const isSectionNode = prevNodeTypeName === 'multiBodiedExtension';
            const isParagraphNode = prevNodeTypeName === 'paragraph';
            const isTableNode = prevNodeTypeName === 'table';
            let verticalOffset = '-50%'; // Default for top and after normal nodes
            if (isSectionNode || isTableNode) verticalOffset = '-100%';
            else if (isLastPosition && isParagraphNode) verticalOffset = '0';
            const baseStyles = {
                // Linter errors if we use variables/non-tokens in cssMap so we need to use style prop
                // add 40px to the max width to account for the padding of the editor
                maxWidth: `${(0, $aFUXX.akEditorFullWidthLayoutWidth) + 40}px`
            };
            if ((0, $5c15d883298a980d$export$2073a24f9367a16f)()) {
                setDynamicStyles({
                    ...baseStyles,
                    positionAnchor: `--${anchorId}`,
                    top: 'anchor(bottom)',
                    left: '50%',
                    transform: `translate(-50%, ${verticalOffset})`
                });
                return;
            } // Fallback logic
            anchorRectCache?.clear();
            const rect = anchorRectCache?.getRect(anchorId);
            if (!rect) {
                setDynamicStyles({
                    ...baseStyles,
                    display: 'none'
                });
                return;
            }
            const top = rect.top + rect.height;
            setDynamicStyles({
                ...baseStyles,
                top: `${top}px`,
                left: '50%',
                transform: `translate(-50%, ${verticalOffset})`
            });
        };
        // Set position on initial render and whenever dependencies change.
        calculatePosition(); // Observe for layout changes to recalculate position.
        const observer = new ResizeObserver(calculatePosition);
        observer.observe(view.dom);
        return ()=>{
            observer.disconnect();
        };
    }, [
        anchorId,
        prevNodeTypeName,
        isLastPosition,
        anchorRectCache,
        view.dom
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    , {
        style: dynamicStyles,
        "data-testid": "company-hub-plus-button",
        className: (0, $gMc0m.default)([
            $43c0e35ecb9920ae$var$styles.containerBaseStyles
        ]),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)($43c0e35ecb9920ae$var$Line, {}),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                content: formatMessage((0, $20ed47d9991fb6d4$export$a7357cdd1f0b0168).addSection),
                children: (tooltipProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
                        ...tooltipProps,
                        onClick: onClick,
                        xcss: $43c0e35ecb9920ae$var$styles.pressable,
                        "aria-label": formatMessage((0, $20ed47d9991fb6d4$export$a7357cdd1f0b0168).addSection),
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
                            label: "",
                            color: "var(--ds-icon-inverse, #FFFFFF)"
                        })
                    })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)($43c0e35ecb9920ae$var$Line, {})
        ]
    });
};



var $dQl1W = parcelRequire("dQl1W");


var $f3dd73ebb486855e$export$3130b484681bf8bc = /*#__PURE__*/ function(CONTENT_WIDTH) {
    CONTENT_WIDTH["NARROW"] = "narrow";
    CONTENT_WIDTH["WIDE"] = "wide";
    CONTENT_WIDTH["FULL"] = "full";
    return CONTENT_WIDTH;
}({});
const $f3dd73ebb486855e$export$6cccba5fae1d609d = "wide";
const $f3dd73ebb486855e$export$617cdcc6afaae4f7 = "var(--ds-surface, #FFFFFF)";
const $f3dd73ebb486855e$export$c14e692c91462ed4 = 'com.atlassian.confluence.hub-element-placeholder';
const $f3dd73ebb486855e$export$ca3a94184e0fbd97 = 'hub-element-placeholder';
const $f3dd73ebb486855e$export$b39442728ee427d = 'hub-section';
const $f3dd73ebb486855e$export$12ee1d1507d066e8 = 'com.atlassian.confluence.hub-section';


const $fa22ef03bf87464a$export$993dca3597b448e8 = ({ header: header, subHeader: subHeader, placeholderTitle: placeholderTitle })=>({
        type: 'extensionFrame',
        content: [
            {
                type: 'heading',
                attrs: {
                    level: 1,
                    localId: null
                },
                content: [
                    {
                        type: 'text',
                        text: `${header}`
                    }
                ]
            },
            {
                type: 'paragraph',
                attrs: {
                    localId: null
                },
                content: [
                    {
                        type: 'text',
                        text: `${subHeader}`
                    }
                ]
            },
            {
                type: 'paragraph',
                attrs: {
                    localId: null
                }
            },
            {
                type: 'extension',
                attrs: {
                    extensionKey: (0, $f3dd73ebb486855e$export$ca3a94184e0fbd97),
                    extensionType: (0, $f3dd73ebb486855e$export$c14e692c91462ed4),
                    parameters: {
                        extensionTitle: placeholderTitle
                    },
                    text: null,
                    layout: 'default',
                    localId: null
                }
            }
        ]
    });
const $fa22ef03bf87464a$var$sectionContentNode = (state, initialContentText)=>state.schema.nodeFromJSON($fa22ef03bf87464a$export$993dca3597b448e8(initialContentText));
const $fa22ef03bf87464a$export$3cf963ab3631af75 = (state, intl)=>{
    const initialContentText = {
        header: intl.formatMessage((0, $20ed47d9991fb6d4$export$a7357cdd1f0b0168).contentHeader),
        subHeader: intl.formatMessage((0, $20ed47d9991fb6d4$export$a7357cdd1f0b0168).contentSubHeader),
        placeholderTitle: intl.formatMessage((0, $20ed47d9991fb6d4$export$a7357cdd1f0b0168).placeHolderTitle)
    };
    return state.schema.nodes.multiBodiedExtension.create({
        extensionType: (0, $f3dd73ebb486855e$export$12ee1d1507d066e8),
        extensionKey: (0, $f3dd73ebb486855e$export$b39442728ee427d),
        layout: 'full-width',
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        localId: (0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))(),
        parameters: {
            extensionTitle: intl.formatMessage((0, $20ed47d9991fb6d4$export$a7357cdd1f0b0168).lozengeTitle),
            backgroundColor: (0, $f3dd73ebb486855e$export$617cdcc6afaae4f7),
            contentWidth: (0, $f3dd73ebb486855e$export$6cccba5fae1d609d)
        }
    }, $fa22ef03bf87464a$var$sectionContentNode(state, initialContentText));
};


const $8c3629cd1d541fcd$export$243f82fe09087876 = new (0, $ks2lK.PluginKey)('companyHubSectionCta');
const $8c3629cd1d541fcd$export$53e55076862e2785 = (state, pos)=>{
    const { schema: schema, doc: doc } = state;
    const $pos = doc.resolve(pos);
    const isParentDoc = $pos.parent.type === schema.nodes.doc;
    if (!isParentDoc) return false;
    const nodeBefore = $pos.nodeBefore;
    // The button should only appear at the start of the document or after section extensions.
    const isAtStart = !nodeBefore;
    const isAfterSectionExtension = nodeBefore?.attrs.extensionKey === 'hub-section' && nodeBefore?.attrs.extensionType === 'com.atlassian.confluence.hub-section';
    // The button should also appear at the very end of the document.
    const isAtEnd = !$pos.nodeAfter;
    return (isAtStart || isAfterSectionExtension || isAtEnd) && $pos.parent.canReplaceWith($pos.index(), $pos.index(), schema.nodes.multiBodiedExtension);
};
const $8c3629cd1d541fcd$var$createAnchorDecorations = (state)=>{
    const decs = [];
    const { doc: doc } = state;
    // A map of valid insertion positions to node info.
    const insertPositions = new Map();
    // 1. Check for an insertion point at the very start of the document.
    if ($8c3629cd1d541fcd$export$53e55076862e2785(state, 0)) {
        // It's the last position if the document is empty.
        const isLastPosition = doc.childCount === 0;
        insertPositions.set(0, {
            prevNodeTypeName: undefined,
            isLastPosition: isLastPosition
        });
    }
    // 2. Check for insertion points after each node in the document.
    doc.content.forEach((node, offset, index)=>{
        const insertPos = offset + node.nodeSize;
        if ($8c3629cd1d541fcd$export$53e55076862e2785(state, insertPos)) {
            const isLastPosition = index === doc.childCount - 1;
            insertPositions.set(insertPos, {
                prevNodeTypeName: node.type.name,
                isLastPosition: isLastPosition
            });
        }
    });
    // 3. Create decorations for all collected valid positions.
    insertPositions.forEach(({ prevNodeTypeName: prevNodeTypeName, isLastPosition: isLastPosition }, insertPos)=>{
        const anchorId = `section-cta-anchor-${insertPos}`;
        decs.push((0, $ftzrq.Decoration).widget(insertPos, ()=>{
            const anchorEl = document.createElement('span');
            anchorEl.style.cssText = `position: absolute; anchor-name: --${anchorId};`;
            anchorEl.setAttribute('data-section-cta-anchor-name', anchorId);
            return anchorEl;
        }, {
            key: anchorId,
            side: -1,
            anchorId: anchorId,
            prevNodeTypeName: prevNodeTypeName,
            isLastPosition: isLastPosition
        }));
    });
    return (0, $ftzrq.DecorationSet).create(doc, decs);
};
class $8c3629cd1d541fcd$var$SectionCtaPluginView {
    update(view, prevState) {
        this.view = view;
        this.anchorRectCache.setEditorView(this.view);
        // We re-render only if the decorations have changed - i.e. the user has modified top level nodes
        const oldState = $8c3629cd1d541fcd$export$243f82fe09087876.getState(prevState);
        const newState = $8c3629cd1d541fcd$export$243f82fe09087876.getState(view.state);
        if (oldState !== newState) {
            this.anchorRectCache.clear();
            this.renderButtons(view.state);
        }
    }
    destroy() {
        this.anchorRectCache.clear();
        this.root.unmount();
        this.container.remove();
    }
    renderButtons(state) {
        const decorationSet = $8c3629cd1d541fcd$export$243f82fe09087876.getState(state);
        if (!decorationSet) return;
        const handleClick = (insertPos)=>{
            const command = this.api?.companyHubSectionCtaPlugin?.commands?.insertSection(insertPos, this.intl);
            if (command) command(this.view.state, this.view.dispatch, this.view);
        };
        // Find all our anchor decorations
        const anchorDecos = decorationSet.find();
        this.root.render(/*#__PURE__*/ (0, $l998X.jsx)((0, $cs1vW.Provider), {
            value: this.intl,
            children: anchorDecos.map((deco)=>{
                const anchorId = deco.spec.anchorId;
                const insertPos = deco.from;
                const prevNodeTypeName = deco.spec.prevNodeTypeName;
                const isLastPosition = deco.spec.isLastPosition;
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $43c0e35ecb9920ae$export$e50c8b7ca0cd488e), {
                    anchorId: anchorId,
                    prevNodeTypeName: prevNodeTypeName,
                    isLastPosition: isLastPosition,
                    onClick: ()=>handleClick(insertPos),
                    anchorRectCache: this.anchorRectCache,
                    view: this.view
                }, anchorId);
            })
        }));
    }
    constructor(view, api, intl){
        this.view = void 0;
        this.container = void 0;
        this.root = void 0;
        this.api = void 0;
        this.intl = void 0;
        this.anchorRectCache = void 0;
        this.view = view;
        this.api = api;
        this.intl = intl;
        this.anchorRectCache = new (0, $5c15d883298a980d$export$e1d230f644ff05aa)();
        this.anchorRectCache.setEditorView(this.view);
        this.container = document.createElement('div');
        this.view.dom.parentElement?.appendChild(this.container);
        this.root = (0, (/*@__PURE__*/$parcel$interopDefault($2FNjD))).createRoot(this.container);
        this.renderButtons(this.view.state);
    }
}
const $8c3629cd1d541fcd$export$d82c0e619eaaa2c2 = ({ api: api })=>{
    return {
        name: 'companyHubSectionCtaPlugin',
        pmPlugins () {
            return [
                {
                    name: 'companyHubSectionCtaButton',
                    plugin: ({ getIntl: getIntl })=>{
                        const intl = getIntl();
                        return new (0, $1S4f7.SafePlugin)({
                            key: $8c3629cd1d541fcd$export$243f82fe09087876,
                            state: {
                                init (_, editorState) {
                                    return $8c3629cd1d541fcd$var$createAnchorDecorations(editorState);
                                },
                                apply (tr, oldDecs, newState) {
                                    return $8c3629cd1d541fcd$var$createAnchorDecorations(newState);
                                }
                            },
                            props: {
                                decorations (state) {
                                    // This makes the anchor decorations actually appear in the doc.
                                    return $8c3629cd1d541fcd$export$243f82fe09087876.getState(state);
                                }
                            },
                            view: (editorView)=>new $8c3629cd1d541fcd$var$SectionCtaPluginView(editorView, api, intl)
                        });
                    }
                }
            ];
        },
        commands: {
            insertSection: (position, intl)=>{
                return (state, dispatch)=>{
                    if (dispatch) {
                        const { tr: tr } = state;
                        const nodeToInsert = (0, $fa22ef03bf87464a$export$3cf963ab3631af75)(state, intl);
                        tr.insert(position, nodeToInsert);
                        const selection = (0, $ks2lK.NodeSelection).create(tr.doc, position);
                        tr.setSelection(selection);
                        dispatch(tr);
                    }
                    return true;
                };
            }
        }
    };
};



var $bupcf = parcelRequire("bupcf");


var $3ihIB = parcelRequire("3ihIB");


var $hr8mu = parcelRequire("hr8mu");


var $jmHSv = parcelRequire("jmHSv");


var $cpn0f = parcelRequire("cpn0f");


var $PJ00O = parcelRequire("PJ00O");


var $fi7Vj = parcelRequire("fi7Vj");


var $fPXRH = parcelRequire("fPXRH");


var $55skd = parcelRequire("55skd");


var $2E0F0 = parcelRequire("2E0F0");


var $k2prb = parcelRequire("k2prb");


var $khxQ7 = parcelRequire("khxQ7");


var $hSJYu = parcelRequire("hSJYu");


var $cwPVT = parcelRequire("cwPVT");


var $duFi2 = parcelRequire("duFi2");


var $agrUc = parcelRequire("agrUc");


var $kXH7i = parcelRequire("kXH7i");


var $acwPl = parcelRequire("acwPl");


var $01uqX = parcelRequire("01uqX");


var $7rj2U = parcelRequire("7rj2U");


var $jgFdO = parcelRequire("jgFdO");


var $5AZDw = parcelRequire("5AZDw");


var $gyXPd = parcelRequire("gyXPd");


var $5y9PZ = parcelRequire("5y9PZ");


var $dme7x = parcelRequire("dme7x");


var $2yr9J = parcelRequire("2yr9J");


var $kbe7k = parcelRequire("kbe7k");


var $1nZXu = parcelRequire("1nZXu");


var $kIhx9 = parcelRequire("kIhx9");


var $bS1lJ = parcelRequire("bS1lJ");


var $2nH2Y = parcelRequire("2nH2Y");


var $4iQt6 = parcelRequire("4iQt6");


var $4KTOl = parcelRequire("4KTOl");


var $lgjGE = parcelRequire("lgjGE");


var $3mcWz = parcelRequire("3mcWz");






















var $cO9ey = parcelRequire("cO9ey");

class $b03ef52bfaf548e0$export$7ee2d944cdf187e1 extends (0, $cO9ey.Step) {
    invert(doc) {
        return new $b03ef52bfaf548e0$export$7ee2d944cdf187e1({
            inverted: true,
            from: this.from,
            to: this.to,
            mark: this.mark
        });
    }
    apply(doc) {
        return (0, $aXG5V.StepResult).ok(doc);
    }
    merge() {
        return null;
    }
    map(mapping) {
        const mappedFrom = mapping.mapResult(this.from, 1);
        const mappedTo = mapping.mapResult(this.to, 1);
        if (mappedFrom.deleted || mappedTo.deleted) return null;
        return new $b03ef52bfaf548e0$export$7ee2d944cdf187e1({
            inverted: this.inverted,
            from: mappedFrom.pos,
            to: mappedTo.pos
        });
    }
    getMap() {
        return new (0, $aXG5V.StepMap)([
            0,
            0,
            0
        ]);
    }
    toJSON() {
        // When serialized we should create a noop Replace step
        return {
            stepType: 'replace',
            from: 0,
            to: 0
        };
    }
    static fromJSON() {
        // This is a "local custom step" once serialized
        // we need to transform it in a no-operation action
        return new (0, $aXG5V.ReplaceStep)(0, 0, (0, $5SAOw.Slice).empty);
    }
    static from(step) {
        const { mark: mark, from: from, to: to } = step;
        return new $b03ef52bfaf548e0$export$7ee2d944cdf187e1({
            mark: mark,
            from: from,
            to: to
        });
    }
    constructor({ inverted: inverted, from: from, to: to, mark: mark }){
        super();
        this.inverted = void 0;
        this.from = void 0;
        this.to = void 0;
        this.mark = void 0;
        this.inverted = Boolean(inverted);
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
}
class $b03ef52bfaf548e0$export$2a0a7f94dceaed30 extends (0, $cO9ey.Step) {
    invert(doc) {
        return new $b03ef52bfaf548e0$export$2a0a7f94dceaed30({
            inverted: true,
            pos: this.pos,
            mark: this.mark
        });
    }
    apply(doc) {
        return (0, $aXG5V.StepResult).ok(doc);
    }
    merge() {
        return null;
    }
    map(mapping) {
        const mappedPos = mapping.mapResult(this.pos, 1);
        if (mappedPos.deleted) return null;
        return new $b03ef52bfaf548e0$export$2a0a7f94dceaed30({
            inverted: this.inverted,
            pos: mappedPos.pos
        });
    }
    getMap() {
        return new (0, $aXG5V.StepMap)([
            0,
            0,
            0
        ]);
    }
    toJSON() {
        // When serialized we should create a noop Replace step
        return {
            stepType: 'replace',
            from: 0,
            to: 0
        };
    }
    static fromJSON() {
        // This is a "local custom step" once serialized
        // we need to transform it in a no-operation action
        return new (0, $aXG5V.ReplaceStep)(0, 0, (0, $5SAOw.Slice).empty);
    }
    static from(step) {
        const { mark: mark, pos: pos } = step;
        return new $b03ef52bfaf548e0$export$2a0a7f94dceaed30({
            mark: mark,
            pos: pos
        });
    }
    constructor({ inverted: inverted, pos: pos, mark: mark }){
        super();
        this.inverted = void 0;
        this.pos = void 0;
        this.mark = void 0;
        this.inverted = Boolean(inverted);
        this.pos = pos;
        this.mark = mark;
    }
}


const $50cbf7161ff57c52$var$createFilterStepsPlugin = (api)=>()=>new (0, $1S4f7.SafePlugin)({
            filterTransaction: (tr)=>{
                const mode = api?.editorViewMode?.sharedState.currentState()?.mode;
                if (mode !== 'view') return true;
                if ((0, $1oCLl.expValEquals)('platform_editor_are_nodes_equal_ignore_mark_order', 'isEnabled', true)) {
                    if (tr.getMeta('isRemote') || tr.getMeta('replaceDocument') || tr.getMeta('allowViewModeTransaction') && (0, $dh538.fg)('platform_editor_allow_viewmode_transaction')) return true;
                } else {
                    if (tr.getMeta('isRemote') || tr.getMeta('allowViewModeTransaction') && (0, $dh538.fg)('platform_editor_allow_viewmode_transaction')) return true;
                }
                const viewModeSteps = tr.steps.reduce((acc, s)=>{
                    if (s instanceof (0, $b03ef52bfaf548e0$export$2a0a7f94dceaed30) || s instanceof (0, $b03ef52bfaf548e0$export$7ee2d944cdf187e1)) acc.push(s);
                    return acc;
                }, []);
                if (viewModeSteps.length === 0 || !api) {
                    if (tr.docChanged && // Check if the transaction contains any steps that modify the document (view mode steps do not)
                    tr.steps.filter((s)=>s instanceof (0, $aXG5V.ReplaceAroundStep) || s instanceof (0, $aXG5V.ReplaceStep) || s instanceof (0, $aXG5V.AddMarkStep) || s instanceof (0, $aXG5V.AddNodeMarkStep) || s instanceof (0, $aXG5V.RemoveMarkStep) || s instanceof (0, $aXG5V.RemoveNodeMarkStep)).length) return false;
                    return true;
                }
                viewModeSteps.forEach((step)=>{
                    if (step.inverted || !step.mark) return;
                    if (step.mark.type.name === 'annotation') {
                        if (step instanceof (0, $b03ef52bfaf548e0$export$2a0a7f94dceaed30)) api.collabEdit?.actions.addInlineCommentNodeMark({
                            mark: step.mark,
                            pos: step.pos
                        });
                        else if (step instanceof (0, $b03ef52bfaf548e0$export$7ee2d944cdf187e1)) api.collabEdit?.actions.addInlineCommentMark({
                            mark: step.mark,
                            from: step.from,
                            to: step.to
                        });
                    }
                });
                // Ignored via go/ees007
                // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
                // TODO: Follow-up and improve annotation logic so we can filter out transactions here
                return true;
            }
        });
const $50cbf7161ff57c52$var$createReplaceDocumentTransactionPlugin = (api)=>()=>new (0, $1S4f7.SafePlugin)({
            // Shouldn't need explicit types but sometimes TS can't infer them so 🤷
            appendTransaction: (transactions, _oldState, newState)=>{
                if (!api) return;
                const isViewMode = api?.editorViewMode?.sharedState.currentState()?.mode === 'view';
                if (!isViewMode) return;
                const remoteReplaceDocumentTransaction = transactions.find((tr)=>api.collabEdit?.actions?.isRemoteReplaceDocumentTransaction(tr));
                if (!remoteReplaceDocumentTransaction || !remoteReplaceDocumentTransaction.selectionSet) return;
                const doc = newState.doc;
                const nextTr = newState.tr;
                const emptySelection = new (0, $ks2lK.TextSelection)(doc.resolve(0));
                nextTr.setSelection(emptySelection);
                return nextTr;
            }
        });
const $50cbf7161ff57c52$export$d510e4d48c393847 = ({ api: api })=>({
        name: 'editorViewModeEffects',
        actions: {
            allowViewModeTransaction: (tr)=>{
                tr.setMeta('allowViewModeTransaction', true);
                return tr;
            },
            applyViewModeStepAt: (tr)=>{
                const marksSteps = tr.steps.reduce((acc, s)=>{
                    // Ignored via go/ees007
                    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
                    // TODO: We probably want to check the RemoveMarkStep flow too.
                    if (s instanceof (0, $aXG5V.AddMarkStep) || s instanceof (0, $aXG5V.AddNodeMarkStep)) acc.push(s);
                    return acc;
                }, []);
                if (marksSteps.length === 0) return false;
                marksSteps.reverse().map((s)=>s instanceof (0, $aXG5V.AddNodeMarkStep) ? tr.step((0, $b03ef52bfaf548e0$export$2a0a7f94dceaed30).from(s)) : tr.step((0, $b03ef52bfaf548e0$export$7ee2d944cdf187e1).from(s)));
                return true;
            }
        },
        pmPlugins () {
            return [
                {
                    name: 'editorViewModeEffectsFilterSteps',
                    plugin: $50cbf7161ff57c52$var$createFilterStepsPlugin(api)
                },
                {
                    name: 'editorViewModeEffectsReplaceDocumentTransaction',
                    plugin: $50cbf7161ff57c52$var$createReplaceDocumentTransactionPlugin(api)
                }
            ];
        }
    });



var $hcboS = parcelRequire("hcboS");


var $8ABVP = parcelRequire("8ABVP");


var $fTvEN = parcelRequire("fTvEN");


var $eyggb = parcelRequire("eyggb");


var $l7rln = parcelRequire("l7rln");


var $dtCIm = parcelRequire("dtCIm");


var $7sK9h = parcelRequire("7sK9h");


var $jS0a0 = parcelRequire("jS0a0");


var $6q6xk = parcelRequire("6q6xk");


var $fYKTL = parcelRequire("fYKTL");


var $fCLXZ = parcelRequire("fCLXZ");


var $flknw = parcelRequire("flknw");


var $cu2RD = parcelRequire("cu2RD");


var $HYzBP = parcelRequire("HYzBP");


var $gATpw = parcelRequire("gATpw");


var $aUwPP = parcelRequire("aUwPP");


var $cVhn8 = parcelRequire("cVhn8");


var $6AqNX = parcelRequire("6AqNX");


var $05jmd = parcelRequire("05jmd");


var $b7atO = parcelRequire("b7atO");


var $6qdjm = parcelRequire("6qdjm");














var $aeAfU = parcelRequire("aeAfU");

const $bd6b8d63fb0cd3e9$export$4d696a2f56515a41 = new (0, $ks2lK.PluginKey)('limitedModePlugin');
const $bd6b8d63fb0cd3e9$var$LIMITED_MODE_NODE_SIZE_THRESHOLD = 40000;
/**
 * Gets a numeric experiment param, returning undefined if the value is not a valid number.
 * This guards against test overrides returning booleans or strings for numeric params.
 */ const $bd6b8d63fb0cd3e9$var$getNumericExperimentParam = (paramName, fallbackValue)=>{
    const rawValue = (0, $aeAfU.expVal)('cc_editor_limited_mode_expanded', paramName, fallbackValue);
    if (typeof rawValue === 'number') return rawValue;
    // Handle string values from test overrides
    if (typeof rawValue === 'string') {
        const parsed = parseInt(rawValue, 10);
        if (!isNaN(parsed)) return parsed;
    }
    return undefined;
};
/**
 * Calculates custom document size including LCM ADF lengths (for non-expanded path).
 * This function can be removed when cc_editor_limited_mode_expanded is cleaned up.
 */ const $bd6b8d63fb0cd3e9$var$getCustomDocSize = (doc)=>{
    let lcmAdfLength = 0;
    doc.descendants((node)=>{
        if (node.attrs?.extensionKey === 'legacy-content') lcmAdfLength += node.attrs?.parameters?.adf?.length ?? 0;
    });
    return doc.nodeSize + lcmAdfLength;
};
/**
 * Determines whether limited mode should be enabled under the expanded gate.
 * If this logic changes, update the duplicate in `editor-common/src/node-anchor/node-anchor-provider.ts` to avoid drift.
 *
 * Limited mode is activated when ANY of the following conditions are met:
 * 1. Document size exceeds `docSizeThreshold` (if defined)
 * 2. Node count exceeds `nodeCountThreshold` (if defined)
 * 3. Document contains a legacy-content macro (LCM) (if `includeLcmInThreshold` is true)
 *
 * Performance optimisations:
 * - Doc size is checked first (O(1)) - if it exceeds threshold, we skip traversal entirely.
 * - If `includeLcmInThreshold` is enabled and we find an LCM, we exit traversal early
 *   since we already know limited mode will be enabled.
 * - If neither node count nor LCM conditions are configured, we skip traversal entirely.
 */ const $bd6b8d63fb0cd3e9$var$shouldEnableLimitedModeExpanded = (doc)=>{
    const nodeCountThreshold = $bd6b8d63fb0cd3e9$var$getNumericExperimentParam('nodeCountThreshold', 5000);
    const docSizeThreshold = $bd6b8d63fb0cd3e9$var$getNumericExperimentParam('docSizeThreshold', 30000);
    const includeLcmInThreshold = Boolean((0, $aeAfU.expVal)('cc_editor_limited_mode_expanded', 'includeLcmInThreshold', false));
    // Early exit: doc size exceeds threshold - O(1), no traversal needed
    if (docSizeThreshold !== undefined && doc.nodeSize > docSizeThreshold) return true;
    // Early exit: no traversal needed if neither condition is configured
    const needNodeCount = nodeCountThreshold !== undefined;
    if (!needNodeCount && !includeLcmInThreshold) return false;
    // Single traversal for node count and/or LCM detection
    let nodeCount = 0;
    let hasLcm = false;
    doc.descendants((node)=>{
        nodeCount += 1;
        if (node.attrs?.extensionKey === 'legacy-content') {
            hasLcm = true;
            // Early exit: LCM found and condition is enabled - no need to continue counting
            if (includeLcmInThreshold) return false;
        }
    });
    // LCM condition takes precedence (if we early exited traversal, this is why)
    if (includeLcmInThreshold && hasLcm) return true;
    // Check node count threshold
    if (needNodeCount && nodeCount > nodeCountThreshold) return true;
    return false;
};
const $bd6b8d63fb0cd3e9$export$ae829ec7b2625219 = ()=>{
    return new (0, $1S4f7.SafePlugin)({
        key: $bd6b8d63fb0cd3e9$export$4d696a2f56515a41,
        view: (_view)=>{
            return {};
        },
        state: {
            init (config, editorState) {
                if ((0, $aeAfU.expVal)('cc_editor_limited_mode_expanded', 'isEnabled', false)) return {
                    documentSizeBreachesThreshold: $bd6b8d63fb0cd3e9$var$shouldEnableLimitedModeExpanded(editorState.doc)
                };
                else {
                    // calculates the size of the doc, where when there are legacy content macros, the content
                    // is stored in the attrs.
                    const customDocSize = $bd6b8d63fb0cd3e9$var$getCustomDocSize(editorState.doc);
                    return {
                        documentSizeBreachesThreshold: customDocSize > $bd6b8d63fb0cd3e9$var$LIMITED_MODE_NODE_SIZE_THRESHOLD
                    };
                }
            },
            apply: (tr, currentPluginState, _oldState, _newState)=>{
                // Don't check the document size if we're already in limited mode.
                // We ALWAYS want to re-check the document size if we're replacing the document (e.g. live-to-live page navigation).
                if (currentPluginState.documentSizeBreachesThreshold && !tr.getMeta('replaceDocument')) return currentPluginState;
                if ((0, $aeAfU.expVal)('cc_editor_limited_mode_expanded', 'isEnabled', false)) return {
                    documentSizeBreachesThreshold: $bd6b8d63fb0cd3e9$var$shouldEnableLimitedModeExpanded(tr.doc)
                };
                else {
                    // calculates the size of the doc, where when there are legacy content macros, the content
                    // is stored in the attrs.
                    const customDocSize = $bd6b8d63fb0cd3e9$var$getCustomDocSize(tr.doc);
                    return {
                        documentSizeBreachesThreshold: customDocSize > $bd6b8d63fb0cd3e9$var$LIMITED_MODE_NODE_SIZE_THRESHOLD
                    };
                }
            }
        }
    });
};


const $c6eda9ff2d183267$export$9f825df6a9c9b35b = ({ api: api })=>{
    return {
        name: 'limitedMode',
        pmPlugins () {
            return [
                {
                    name: 'limitedModePlugin',
                    plugin: (0, $bd6b8d63fb0cd3e9$export$ae829ec7b2625219)
                }
            ];
        },
        getSharedState (editorState) {
            if (editorState) return {
                get enabled () {
                    return (0, $bd6b8d63fb0cd3e9$export$4d696a2f56515a41).getState(editorState)?.documentSizeBreachesThreshold ?? false;
                },
                limitedModePluginKey: $bd6b8d63fb0cd3e9$export$4d696a2f56515a41
            };
            return {
                enabled: false,
                limitedModePluginKey: $bd6b8d63fb0cd3e9$export$4d696a2f56515a41
            };
        },
        usePluginHook: ({ editorView: editorView })=>{
            (0, $6qdjm.usePluginStateEffect)(api, [
                'limitedMode'
            ], ({ limitedModeState: limitedModeState })=>{
                if ((0, $1oCLl.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true)) {
                    if ((0, $dh538.fg)('platform_editor_native_anchor_patch_2')) {
                        const isEnabled = limitedModeState?.enabled ?? false;
                        const nodeIdProvider = (0, $b7atO.getNodeIdProvider)(editorView);
                        // When limited mode is enabled first time,
                        // We need to remove all existing data-node-anchor attributes
                        // And nodeIdProvider to limited mode to prevent adding data-node-anchor on new nodes
                        if (isEnabled && nodeIdProvider && !nodeIdProvider.isLimitedMode()) nodeIdProvider.setLimitedMode();
                    }
                }
            });
        }
    };
};



var $5HHoF = parcelRequire("5HHoF");


var $lQotL = parcelRequire("lQotL");


var $80JwR = parcelRequire("80JwR");


var $cWFvG = parcelRequire("cWFvG");


var $2U68K = parcelRequire("2U68K");


var $5u7tz = parcelRequire("5u7tz");


var $dH9DB = parcelRequire("dH9DB");


var $b3BjA = parcelRequire("b3BjA");


var $36iDo = parcelRequire("36iDo");


var $59fTa = parcelRequire("59fTa");


var $kYgUn = parcelRequire("kYgUn");


var $8HLyI = parcelRequire("8HLyI");


var $itirX = parcelRequire("itirX");


var $e6sdP = parcelRequire("e6sdP");


var $5DsxN = parcelRequire("5DsxN");


var $1GAIu = parcelRequire("1GAIu");


var $bULcr = parcelRequire("bULcr");


var $4NiQW = parcelRequire("4NiQW");


var $5Qu3R = parcelRequire("5Qu3R");


var $7nKrc = parcelRequire("7nKrc");


var $84Iqc = parcelRequire("84Iqc");


var $c8680 = parcelRequire("c8680");


var $6borH = parcelRequire("6borH");


var $efDik = parcelRequire("efDik");


var $eeGWn = parcelRequire("eeGWn");


var $jaskt = parcelRequire("jaskt");


var $i2zv0 = parcelRequire("i2zv0");


var $5mDFx = parcelRequire("5mDFx");


var $3JBsx = parcelRequire("3JBsx");


var $1KHo7 = parcelRequire("1KHo7");


var $aB4bz = parcelRequire("aB4bz");


var $fMaLE = parcelRequire("fMaLE");


var $bz4KD = parcelRequire("bz4KD");

const $125e10655abbc4ed$export$b877d3ed23ba6b7a = ()=>{
    const components = [];
    const register = (newComponents)=>{
        components.push(...newComponents);
    };
    return {
        register: register,
        components: components
    };
};


/**
 * Collect all components that belong to the tree rooted at `surfaceKey`.
 *
 * A surface is a root component (one with no `parents`). Starting from that
 * root, every component whose parent chain leads back to it is included.
 */ function $e6ea46e05a87eb23$var$getComponentsForSurface(allComponents, surfaceKey) {
    const root = allComponents.find((c)=>c.key === surfaceKey && (!c.parents || c.parents.length === 0));
    if (!root) return [];
    const includedKeys = new Set([
        surfaceKey
    ]);
    let changed = true;
    while(changed){
        changed = false;
        for (const component of allComponents){
            if (includedKeys.has(component.key)) continue;
            if (component.parents?.some((p)=>includedKeys.has(p.key))) {
                includedKeys.add(component.key);
                changed = true;
            }
        }
    }
    return allComponents.filter((c)=>includedKeys.has(c.key));
}
const $e6ea46e05a87eb23$export$eb211d52411e6f09 = ()=>{
    const registry = (0, $125e10655abbc4ed$export$b877d3ed23ba6b7a)();
    return {
        name: 'uiControlRegistry',
        actions: {
            register: (components)=>{
                registry.register(components);
            },
            getComponents: (surface)=>{
                return $e6ea46e05a87eb23$var$getComponentsForSurface(registry.components, surface);
            }
        }
    };
};



var $kw2eg = parcelRequire("kw2eg");


var $vxKdN = parcelRequire("vxKdN");


var $3O0YV = parcelRequire("3O0YV");


var $hEicH = parcelRequire("hEicH");


var $fI6T7 = parcelRequire("fI6T7");











var $iu6m9 = parcelRequire("iu6m9");




parcelRequire("42omo");





var $bAxHS = parcelRequire("bAxHS");




const $4f3bbf66819555bf$export$ef2bd08fc1b88107 = new (0, $ks2lK.PluginKey)('aiSpeechToText');












var $6VMxF = parcelRequire("6VMxF");


var $gALmy = parcelRequire("gALmy");


var $bEPY6 = parcelRequire("bEPY6");


var $6r4dv = parcelRequire("6r4dv");


var $2qSBW = parcelRequire("2qSBW");


const $6e9f8fa3c2ed9770$export$27e3d771cf5f0905 = ({ api: api, cloudId: cloudId })=>{
    const { isListening: isListening } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'aiSpeechToText'
    ], (states)=>({
            isListening: states.aiSpeechToTextState?.isListening ?? false
        }));
    const { handleTranscriptUpdate: handleTranscriptUpdate, rejectTranscriptedText: rejectTranscriptedText, disposeTranscriptedText: disposeTranscriptedText } = (0, $gALmy.useTranscriptionToEditorText)();
    const onVoiceDictationUpdate = (0, $42omo.useCallback)((result)=>{
        switch(result.state){
            case (0, $6VMxF.VoiceDictationState).Recording:
                if (!api?.core?.actions?.execute) return;
                api.core.actions.execute(({ tr: tr })=>handleTranscriptUpdate(result.transcription, tr));
                break;
            case (0, $6VMxF.VoiceDictationState).Stopped:
                if (result.stopReason === (0, $6VMxF.VoiceDictationStopReason).TimeoutAccepted) {
                    disposeTranscriptedText();
                    api?.core.actions.execute(({ tr: tr })=>{
                        tr.setMeta((0, $4f3bbf66819555bf$export$ef2bd08fc1b88107), {
                            isListening: false
                        });
                        return tr;
                    });
                }
                break;
            default:
                break;
        }
    }, [
        handleTranscriptUpdate,
        api,
        disposeTranscriptedText
    ]);
    const [, { startRecording: startRecording, stopRecording: stopRecording }] = (0, $bEPY6.useVoiceDictation)(onVoiceDictationUpdate, cloudId);
    const handleAccept = (0, $42omo.useCallback)(()=>{
        disposeTranscriptedText();
        stopRecording((0, $6VMxF.VoiceDictationStopReason).StoppedAccepted);
        api?.core.actions.execute(({ tr: tr })=>{
            tr.setMeta((0, $4f3bbf66819555bf$export$ef2bd08fc1b88107), {
                isListening: false
            });
            return tr;
        });
    }, [
        stopRecording,
        disposeTranscriptedText,
        api
    ]);
    const handleReject = (0, $42omo.useCallback)(()=>{
        stopRecording((0, $6VMxF.VoiceDictationStopReason).StoppedRejected);
        api?.core.actions.execute(({ tr: tr })=>{
            tr.setMeta((0, $4f3bbf66819555bf$export$ef2bd08fc1b88107), {
                isListening: false
            });
            return rejectTranscriptedText(tr);
        });
    }, [
        stopRecording,
        rejectTranscriptedText,
        api
    ]);
    (0, $42omo.useEffect)(()=>{
        if (isListening) startRecording();
        else stopRecording();
    }, [
        isListening,
        startRecording,
        stopRecording
    ]);
    if (!isListening) return null;
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6r4dv.VoiceAcceptButton), {
                onClick: handleAccept
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $2qSBW.VoiceRejectButton), {
                onClick: handleReject
            })
        ]
    });
};


// This CLOUD_ID works only for internal usage and POC purposes. Do not use it in production or share it externally.
// TODO: We need to implement here a logic to get the current user's cloudId.
const $0f42ee7f81761719$var$CLOUD_ID_INTERNAL_USE_ONLY = 'a436116f-02ce-4520-8fbb-7301462a1674';
const $0f42ee7f81761719$var$EMPTY_STATE = {
    isListening: false,
    error: null
};
const $0f42ee7f81761719$export$8fc6b5430a555c3d = ({ api: api })=>{
    return {
        name: 'aiSpeechToText',
        getSharedState (editorState) {
            if (!editorState) return $0f42ee7f81761719$var$EMPTY_STATE;
            return (0, $4f3bbf66819555bf$export$ef2bd08fc1b88107).getState(editorState) ?? $0f42ee7f81761719$var$EMPTY_STATE;
        },
        pmPlugins () {
            return [
                {
                    name: 'speechToText',
                    plugin: ()=>new (0, $1S4f7.SafePlugin)({
                            key: (0, $4f3bbf66819555bf$export$ef2bd08fc1b88107),
                            state: {
                                init () {
                                    return $0f42ee7f81761719$var$EMPTY_STATE;
                                },
                                apply (tr, oldPluginState) {
                                    const meta = tr.getMeta((0, $4f3bbf66819555bf$export$ef2bd08fc1b88107));
                                    if (meta) return {
                                        ...oldPluginState,
                                        ...meta
                                    };
                                    return oldPluginState;
                                }
                            }
                        })
                }
            ];
        },
        pluginsOptions: {
            quickInsert: ()=>[
                    {
                        id: 'aiSpeechToText',
                        title: 'Speech to text',
                        description: 'Dictate text using your voice',
                        priority: 600,
                        keywords: [
                            'speech',
                            'voice',
                            'dictation',
                            'microphone',
                            'audio',
                            'speak',
                            'stt'
                        ],
                        icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bAxHS))), {
                                label: "AI Speech to Text"
                            }),
                        action: (insert)=>{
                            const tr = insert('');
                            return tr.setMeta((0, $4f3bbf66819555bf$export$ef2bd08fc1b88107), {
                                isListening: true
                            });
                        }
                    }
                ]
        },
        contentComponent () {
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $6e9f8fa3c2ed9770$export$27e3d771cf5f0905), {
                cloudId: $0f42ee7f81761719$var$CLOUD_ID_INTERNAL_USE_ONLY,
                api: api
            });
        }
    };
};



var $4DEL1 = parcelRequire("4DEL1");


var $1ewUw = parcelRequire("1ewUw");


var $dF1N1 = parcelRequire("dF1N1");


var $dx8CK = parcelRequire("dx8CK");

function $03a647a335c52f20$export$13aeab2a71badd1e({ options: options }) {
    // Options not declared here as they are all nested inside hooks, starting with `useEditorPluginAIDefinitionsConfig`.
    return options;
}


function $0e54a671895f12da$export$a2b90416e38bfd44({ options: options }) {
    // Options not declared here as they are all nested inside hooks, starting with `useEditorPluginAIOptions`.
    return options;
}


function $f116ad07960ba181$export$bc5ff52c1b8ecb7e({ options: options }) {
    return {
        streamFlowPacerEnabled: options?.streamFlowPacerEnabled
    };
}


function $b499f1aa43aeb0ae$export$bfd53895e8497571({}) {
    return {};
}


function $8ed9740f118d687b$export$b3e029fd31f94f55({ options: options, providers: providers }) {
    if (!providers.inlineCommentAnnotationProvider) return undefined;
    return {
        inlineComment: providers.inlineCommentAnnotationProvider,
        createCommentExperience: options.createCommentExperience,
        selectCommentExperience: {
            selectAnnotation: {
                complete: (annotationId)=>{
                    options.selectCommentExperience?.selectAnnotation.complete({
                        pageClass: 'editor',
                        annotationId: annotationId,
                        entryPoint: 'annotation-change'
                    });
                }
            }
        },
        viewInlineCommentTraceUFOPress: options.viewInlineCommentTraceUFOPress,
        annotationManager: options.annotationManager
    };
}


function $ad7357a8ed7dfd42$export$eeaea850bc5c5797({ options: options }) {
    return {
        // Avatars are moved to Confluence codebase for Edit in Context
        // When Edit in Context is enabled primaryToolbarComponents is undefined
        // For more details please check
        // https://hello.atlassian.net/wiki/spaces/PCG/pages/2851572180/Editor+toolbar+for+live+pages+and+edit+in+context+projects
        collabEdit: options.collabEdit,
        // originally depends on !hasBeforePrimaryToolbar(props.primaryToolbarComponents),
        takeFullWidth: true,
        showAvatarGroup: false
    };
}





function $78a1544f00d30a05$export$a23b3fa66082f163({ options: options }) {
    const removeScrollGutter = !(0, $dh538.fg)('confluence_frontend_content_wrapper') && options.__livePage;
    return {
        allowInlineCursorTarget: true,
        allowScrollGutter: removeScrollGutter ? undefined : {
            getScrollElement: ()=>document.querySelector('.fabric-editor-popup-scroll-parent')
        }
    };
}


function $849252e5cfbe6f75$export$817c0e398e6ff750({}) {
    return {
        // rolling out under platform_editor_small_font_size experiment
        allowFontSize: true,
        includeBlockQuoteAsTextstyleOption: true,
        lastNodeMustBeParagraph: false,
        isUndoRedoButtonsEnabled: true,
        allowBlockType: undefined
    };
}


function $18709874e4301e98$export$3be6b735d5cbc3e6({ options: options }) {
    return {
        allowBreakoutButton: options.editorAppearance === 'full-page',
        appearance: options.editorAppearance
    };
}



var $eTj7Y = parcelRequire("eTj7Y");

// SECTION: From confluence/next/packages/editor-features/src/utils/smartCardOptions.ts
/**
 * Supported Jira URLs and Jira Roadmap URLs, GDrive and ODFB will become Smart Links
 * (only supports Cloud single-issue URLs right now)
 */ const $f8013e4ced731918$var$SMART_LINKS_BEFORE_MACROS = 'jira,jiraroadmap,google-drive-sheets,google-drive-docs,OneDrive,google-drive-slides'.split(',');
function $f8013e4ced731918$export$514131654bb897e2({ options: options, providers: providers }) {
    return {
        // From confluence/next/packages/full-page-editor/src/FullPageEditorComponent.tsx `CARD_OPTIONS =`
        allowDatasource: true,
        // END SECTION
        // SECTION: From confluence/next/packages/editor-features/src/utils/smartCardOptions.ts
        provider: providers.cardProvider,
        resolveBeforeMacros: $f8013e4ced731918$var$SMART_LINKS_BEFORE_MACROS,
        allowBlockCards: true,
        allowEmbeds: true,
        // END SECTION
        onClickCallback: options.onClickCallback,
        fullWidthMode: options.editorAppearance === 'full-width',
        linkPicker: options.linkPicker,
        // SECTION: From confluence/next/packages/editor-features/src/hooks/useEditorFeatureFlags.ts
        lpLinkPicker: true,
        // END SECTION
        editorAppearance: options.editorAppearance,
        // @ts-ignore Temporary solution to check for Live Page editor.
        __livePage: options.__livePage,
        isPageSSRed: Boolean((0, $eTj7Y.isSSR)() || window.__SSR_RENDERED__),
        CompetitorPrompt: options.CompetitorPrompt
    };
}


function $c70218b234c6d78f$export$3f0ff0bcf72f4d98({ options: options }) {
    return {
        appearance: options.editorAppearance
    };
}





function $54a86813db4d4780$export$6e32a592ec823802({}) {
    return {
        allowCodeFolding: (0, $1oCLl.expValEquals)('platform_editor_code_block_fold_gutter', 'isEnabled', true)
    };
}


function $de05ec98c0250c98$export$74cc43e84bb9c20({}) {
    return {
        allowCopyToClipboard: true,
        useLongPressSelection: false,
        allowCompositionInputOverride: false
    };
}



var $NPJKR = parcelRequire("NPJKR");




function $e2f5d02097d0844c$export$c1ebe19806bc53b1({ options: options, providers: providers }) {
    return {
        // Core options
        provider: providers.collabEditProvider,
        userId: options.collabEdit?.userId,
        useNativePlugin: options.collabEdit?.useNativePlugin,
        sanitizePrivateContent: true,
        hideTelecursorOnLoad: options.__livePage || (0, $1oCLl.expValEquals)('platform_editor_no_cursor_on_edit_page_init', 'isEnabled', true),
        // Invite to edit related options
        inviteToEditHandler: options.collabEdit?.inviteToEditHandler,
        isInviteToEditButtonSelected: options.collabEdit?.isInviteToEditButtonSelected,
        inviteToEditComponent: options.collabEdit?.inviteToEditComponent,
        // Analytics options
        EXPERIMENTAL_allowInternalErrorAnalytics: options.collabEdit?.EXPERIMENTAL_allowInternalErrorAnalytics ?? (0, $NPJKR.shouldForceTracking)()
    };
}


function $5d0ceab6af17632b$export$8a4106078b67336e({ options: options }) {
    return {
        initialContentMode: options?.initialContentMode ?? 'standard'
    };
}


function $815cf72c0fd01db1$export$2c26eb5ff90afcfd({ providers: providers }) {
    return {
        contextIdentifierProvider: providers.contextIdentifierProvider
    };
}





function $d7dae729776ab102$export$48a60d81b6bb28e3({ options: options }) {
    if (!options) return undefined;
    return(// SECTION: From confluence/next/packages/editor-presets/src/full-page/useFullPageEditorPreset.ts
    // If object-sidebar is not enabled, then we don't need to pass the contextPanelOptions
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    (0, $dh538.fg)('confluence_frontend_content_wrapper') && (0, $dh538.fg)('platform_editor_ai_object_sidebar_injection') ? {
        objectSideBar: options.objectSideBar
    } : undefined);
}


function $0239ddf6db5a0e53$export$f18d68682e981a91({ providers: providers }) {
    return {
        autoformattingProvider: providers.autoformattingProvider
    };
}


function $0105ad9f4c3353d7$export$5598bb2314a53fa8({}) {
    return {
        weekStartDay: undefined
    };
}


function $22bbbcb7ca748783$export$de47eee62065048e({ options: options }) {
    return {
        initialDisabledState: options?.disabled
    };
}


function $f342e2c893778f00$export$36a79e2b5698697a({ options: options }) {
    return {
        mode: options.viewMode
    };
}


function $0ec938d111941985$export$7adcaf18ca5c72c4({ providers: providers }) {
    return {
        emojiProvider: providers.emojiProvider,
        emojiNodeDataProvider: providers.emojiNodeDataProvider
    };
}



var $axAnW = parcelRequire("axAnW");

var $kkQZq = parcelRequire("kkQZq");

var $iPfZG = parcelRequire("iPfZG");

var $hwWwS = parcelRequire("hwWwS");

function $d63a2b43135c498f$export$128eafe7f843e327({ options: options }) {
    return {
        epComponents: {
            EngagementSpotlight: $iPfZG.EngagementSpotlight,
            EngagementInlineDialog: $kkQZq.default,
            Coordination: $axAnW.default
        },
        epHooks: {
            useCoordination: $hwWwS.useCoordination
        },
        coordinationClient: options.coordinationClient
    };
}


function $759d2e4ef0d8b24b$export$ed53f0c49fce09d6({ options: options }) {
    return {
        allowInsertion: true,
        useLongPressSelection: false,
        appearance: options.editorAppearance,
        allowInteractiveExpand: true,
        __livePage: options.__livePage
    };
}


function $2a51a0f7e6ad908c$export$c18b9102cd0790c9({ options: options }) {
    return {
        breakoutEnabled: options.editorAppearance === 'full-page',
        extensionHandlers: options.extensionHandlers,
        useLongPressSelection: false,
        appearance: options.editorAppearance,
        __rendererExtensionOptions: options.__rendererExtensionOptions,
        getExtensionHeight: options.getExtensionHeight,
        getUnsupportedContent: options.getUnsupportedContent
    };
}





function $13d21f4408f33e88$export$3bff061e5229a7({}) {
    /**
	 * @private
	 * @deprecated Don't add any new feature flags here!
	 *             If you need a new feature flag, use:
	 *             - {@link editorExperiment} for new experiments.
	 *             - {@link fg} for new feature gates.
	 */ return {
        // SECTION: From confluence/next/packages/editor-features/src/hooks/useEditorFeatureFlags.ts
        /**
		 * This feature flag has completed rollout in Confluence and is to be cleaned up from LD
		 * but cannot yet be cleaned up from editor component as pending rollout in other products first
		 */ lpLinkPicker: true,
        tableDragAndDrop: true,
        tableWithFixedColumnWidthsOption: true,
        // END SECTION
        // SECTION: From confluence/next/packages/full-page-editor/src/hooks/useEditorFullPageExperiments.ts
        tableSelector: (0, $iu6m9.editorExperiment)('platform_editor_tables_table_selector', true),
        macroInteractionUpdates: true,
        moreElementsInQuickInsertView: true,
        // END SECTION
        // SECTION: From confluence/next/packages/editor-presets/src/utils/createFeatureFlagsFromProps.ts
        catchAllTracking: false,
        showAvatarGroupAsPlugin: false,
        errorBoundaryDocStructure: false,
        synchronyErrorDocStructure: false,
        enableViewUpdateSubscription: false,
        collabAvatarScroll: false,
        twoLineEditorToolbar: false,
        disableSpellcheckByBrowser: undefined
    };
}


function $3434917e042efc57$export$d9e183f0607e1b5d({}) {
    return {
        // originally depends on !!featureFlags.showAvatarGroupAsPlugin === false && !hasBeforePrimaryToolbar(props.primaryToolbarComponents),
        takeFullWidth: true,
        twoLineEditorToolbar: false
    };
}


function $f0763edceecb76c2$export$c66d0d1462a05bd({}) {
    return {
        shouldCalcBreakoutGridLines: true
    };
}





function $eab9055a4a41e7c7$export$2a67100cd9c61f05({ options: options }) {
    if ((0, $iu6m9.editorExperiment)('platform_editor_ai_quickstart_command', true)) return options;
    return false;
}


function $ba2e03c1e9271b78$export$ab9ae3984d5aef33({ options: options }) {
    return {
        editorAppearance: options.editorAppearance,
        // SECTION: From confluence/next/packages/editor-features/src/hooks/useEditorFeatureFlags.ts
        lpLinkPicker: true,
        // END SECTION
        linkPicker: options.linkPicker,
        onClickCallback: options.onClickCallback,
        platform: 'web'
    };
}





function $6e8873e0128315d2$export$1e11b615e9dc119e({ options: options }) {
    return {
        allowTables: true,
        allowExpand: true,
        horizontalRuleEnabled: true,
        tableSelectorSupported: (0, $iu6m9.editorExperiment)('platform_editor_tables_table_selector', true),
        nativeStatusSupported: true,
        showElementBrowserLink: true,
        appearance: options.editorAppearance,
        toolbarButtons: options.toolbarButtons
    };
}


function $0c59805b4172bf23$export$33fb6c6592b2cd5f({ options: options }) {
    return {
        allowBreakout: true,
        UNSAFE_addSidebarLayouts: true,
        useLongPressSelection: false,
        UNSAFE_allowSingleColumnLayout: undefined,
        editorAppearance: options.editorAppearance
    };
}


function $a233792833dda4ec$export$d384a797e800fdbe({ options: options }) {
    return {
        showFlag: options.showFlag,
        contentId: options.contentId,
        killSwitchEnabled: options.killSwitchEnabled
    };
}





function $1bb1e0cb9a7988e8$export$feaee25faac0c640({ options: options }) {
    return {
        // SECTION: From confluence/next/packages/loom-editor-utils/src/hooks/useLoomPluginOptions.tsx
        renderButton: options.renderButton,
        shouldShowToolbarButton: (0, $dh538.fg)('confluence_frontend_content_wrapper') ? false : undefined
    };
}





const $5e5a949da08ce418$export$a7357cdd1f0b0168 = (0, $h82at.defineMessages)({
    invalidAltText: {
        id: "editor-presets-confluence.media.alt-text.invalid",
        defaultMessage: "We aren\u2019t able to accept every possible character in Alt text. All Unicode letters and numbers are OK, but these are the only acceptable symbols: , ' . - _ ( )."
    }
});


function $1412367cad2aa59d$export$484123ae56f6fbd9({ intl: intl, options: options, providers: providers }) {
    return {
        // SECTION: From confluence/next/packages/editor-features/src/utils/mediaOptions.ts
        provider: providers.mediaProvider,
        syncProvider: providers.syncMediaProvider,
        allowMediaSingle: true,
        allowResizing: true,
        allowResizingInTables: true,
        allowLinking: true,
        allowAltTextOnImages: true,
        allowCaptions: true,
        allowMediaInlineImages: true,
        allowPixelResizing: true,
        altTextValidator: (text)=>{
            // @ts-ignore - TS1501 Typescript 5.9.2 upgrade
            const storageSupports = RegExp("^([\\p{L}\\p{N},'\\.\\s\\-_\\(\\)]|&amp;[0-9]{2};)*$", "u");
            if (!storageSupports.test(text)) return [
                intl.formatMessage((0, $5e5a949da08ce418$export$a7357cdd1f0b0168).invalidAltText)
            ];
            return [];
        },
        // END SECTION
        // SECTION: From confluence/next/packages/fabric-media-support/src/mediaFeatureFlags.ts
        featureFlags: {
            mediaInline: true
        },
        // END SECTION
        // SECTION: From confluence/next/packages/editor-presets/src/full-page/createFullPageEditorPreset.ts
        allowLazyLoading: true,
        allowBreakoutSnapPoints: true,
        allowAdvancedToolBarOptions: true,
        // originally value was Boolean(options.annotationProviders),
        allowCommentsOnMedia: true,
        allowDropzoneDropLine: true,
        allowMediaSingleEditable: true,
        allowRemoteDimensionsFetch: true,
        allowMarkingUploadsAsIncomplete: false,
        allowImagePreview: true,
        fullWidthEnabled: options.editorAppearance === 'full-width',
        createCommentExperience: options.createCommentExperience,
        editorAppearance: options.editorAppearance,
        isCopyPasteEnabled: true,
        alignLeftOnInsert: false,
        allowImageEditing: true,
        // END SECTION
        // SECTION: From confluence/next/packages/full-page-editor/src/FullPageEditorComponent.tsx
        waitForMediaUpload: true,
        // END SECTION
        mediaViewerExtensions: options.mediaViewerExtensions
    };
}


function $4c9dc0bddcbec186$export$e15342409979aa19({ options: options, providers: providers }) {
    return {
        sanitizePrivateContent: true,
        insertDisplayName: true,
        allowZeroWidthSpaceAfter: true,
        profilecardProvider: providers.profilecardProvider,
        handleMentionsChanged: options.handleMentionsChanged,
        mentionProvider: providers.mentionProvider,
        currentUserId: options.currentUserId
    };
}


function $85c17a3a2c6c7b85$export$4677177d82484aef({ options: options }) {
    return options;
}


function $fc9f968714fe9c5d$export$c18e432f323b002e({}) {
    return {
        useLongPressSelection: false,
        allowCustomPanel: true,
        allowCustomPanelEdit: true
    };
}


// SECTION: From confluence/next/packages/editor-features/src/utils/smartCardOptions.ts
/**
 * Supported Jira URLs and Jira Roadmap URLs, GDrive and ODFB will become Smart Links
 * (only supports Cloud single-issue URLs right now)
 */ const $49e9bc2589f6c0e6$var$SMART_LINKS_BEFORE_MACROS = 'jira,jiraroadmap,google-drive-sheets,google-drive-docs,OneDrive,google-drive-slides'.split(',');
function $49e9bc2589f6c0e6$export$6b1ad42d09c74964({ providers: providers }) {
    return {
        cardOptions: {
            provider: providers.cardProvider,
            // SECTION: From confluence/next/packages/editor-features/src/utils/smartCardOptions.ts
            allowBlockCards: true,
            allowDatasource: true,
            allowEmbeds: true,
            resolveBeforeMacros: $49e9bc2589f6c0e6$var$SMART_LINKS_BEFORE_MACROS
        },
        sanitizePrivateContent: true,
        isFullPage: true
    };
}



var $iJQnc = parcelRequire("iJQnc");

var $aoDcQ = parcelRequire("aoDcQ");


var $delmI = parcelRequire("delmI");













const $3e5e5c18746b8d36$export$a7357cdd1f0b0168 = (0, $h82at.defineMessages)({
    easyMentionsPlaceholder: {
        id: "editor-presets-confluence.placeholder.easy-mentions-placeholder",
        defaultMessage: "Type / for all elements or @ to mention someone."
    },
    aiPlaceholder: {
        id: "editor-presets-confluence.placeholder.ai-placeholder",
        defaultMessage: "Type /ai for Atlassian Intelligence, / to add elements, or @ to mention someone (we'll let them know)."
    },
    defaultPlaceholder: {
        id: "editor-presets-confluence.placeholder.default-placeholder",
        defaultMessage: "Type / to insert elements"
    },
    editorEmptyDocumentPlaceholderAI: {
        id: "editor-presets-confluence.placeholder.default-placeholder-ai",
        defaultMessage: "Use {key}+' to ask AI, or type / to insert elements"
    },
    editorEmptyDocumentSpaceShortcutPlaceholder: {
        id: "editor-presets-confluence.placeholder.space-shortcut-placeholder",
        defaultMessage: "Press space to Ask Rovo or / to insert elements"
    },
    editorEmptyDocumentSpaceShortcutPlaceholderADFPrefix: {
        id: "editor-presets-confluence.placeholder.space-shortcut-adf-prefix",
        defaultMessage: "Press"
    },
    editorEmptyDocumentSpaceShortcutPlaceholderADFSpaceShortcut: {
        id: "editor-presets-confluence.placeholder.space-shortcut-adf-space-key",
        defaultMessage: "space"
    },
    editorEmptyDocumentSpaceShortcutPlaceholderADFMiddle: {
        id: "editor-presets-confluence.placeholder.space-shortcut-adf-middle",
        defaultMessage: "to Ask Rovo or"
    },
    editorEmptyDocumentSpaceShortcutPlaceholderADFSlashShortcut: {
        id: "editor-presets-confluence.placeholder.space-shortcut-adf-slash-key",
        defaultMessage: "/"
    },
    editorEmptyDocumentSpaceShortcutPlaceholderADFSuffix: {
        id: "editor-presets-confluence.placeholder.space-shortcut-adf-suffix",
        defaultMessage: "to insert elements"
    },
    placeholderADF: {
        id: "editor-presets-confluence.placeholderADF",
        defaultMessage: "Press <code>space</code> to Ask Rovo or <code>/</code> to insert elements"
    }
});


const $01e23cb99d262862$var$createSpaceShortcutPlaceholderADF = ({ formatMessage: formatMessage })=>({
        version: 1,
        type: 'doc',
        content: [
            {
                type: 'paragraph',
                content: [
                    (0, $aoDcQ.text)(formatMessage((0, $3e5e5c18746b8d36$export$a7357cdd1f0b0168).editorEmptyDocumentSpaceShortcutPlaceholderADFPrefix)),
                    (0, $aoDcQ.text)(' '),
                    (0, $iJQnc.code)(formatMessage((0, $3e5e5c18746b8d36$export$a7357cdd1f0b0168).editorEmptyDocumentSpaceShortcutPlaceholderADFSpaceShortcut)),
                    (0, $aoDcQ.text)(' '),
                    (0, $aoDcQ.text)(formatMessage((0, $3e5e5c18746b8d36$export$a7357cdd1f0b0168).editorEmptyDocumentSpaceShortcutPlaceholderADFMiddle)),
                    (0, $aoDcQ.text)(' '),
                    (0, $iJQnc.code)(formatMessage((0, $3e5e5c18746b8d36$export$a7357cdd1f0b0168).editorEmptyDocumentSpaceShortcutPlaceholderADFSlashShortcut)),
                    (0, $aoDcQ.text)(' '),
                    (0, $aoDcQ.text)(formatMessage((0, $3e5e5c18746b8d36$export$a7357cdd1f0b0168).editorEmptyDocumentSpaceShortcutPlaceholderADFSuffix))
                ]
            }
        ]
    });
function $01e23cb99d262862$export$c6841f879d4c8aef({ intl: intl, options: options }) {
    const shouldShowSpaceShortcut = options.isAIEnabled && (0, $dh538.fg)('platform_editor_ai_aifc_streaming');
    const placeholder = (()=>{
        // SECTION: From confluence/next/packages/full-page-editor/src/FullPageEditorComponent.tsx `const placeholderText = `
        if (options.viewMode === 'view') return undefined;
        // END SECTION
        // We disable the placeholder here becuase we want to use the new ADF placeholder, see below.
        if (shouldShowSpaceShortcut) return undefined;
        // SECTION: From confluence/next/packages/full-page-editor/src/FullPageEditorComponent.tsx `_getPlaceholderText()`
        if (!options.isAIEnabled && (0, $iu6m9.editorExperiment)('platform_editor_ai_quickstart_command', true)) return intl.formatMessage((0, $3e5e5c18746b8d36$export$a7357cdd1f0b0168).editorEmptyDocumentPlaceholderAI);
        if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) return intl.formatMessage((0, $3e5e5c18746b8d36$export$a7357cdd1f0b0168).defaultPlaceholder);
        if (!options.isAIEnabled) return intl.formatMessage((0, $3e5e5c18746b8d36$export$a7357cdd1f0b0168).aiPlaceholder);
        return intl.formatMessage((0, $3e5e5c18746b8d36$export$a7357cdd1f0b0168).easyMentionsPlaceholder);
    // END SECTION
    })();
    const placeholderADF = (()=>{
        if (options.viewMode === 'view') return undefined;
        if (shouldShowSpaceShortcut && (0, $dh538.fg)('platform_editor_ai_aifc_space_shortcut')) return (0, $dh538.fg)('platform_editor_ai_aifc_adf_placeholder') ? (0, $delmI.createADFFromHTML)(intl.formatMessage((0, $3e5e5c18746b8d36$export$a7357cdd1f0b0168).placeholderADF, {
            code: (parts)=>`<code>${parts}</code>`
        })) : $01e23cb99d262862$var$createSpaceShortcutPlaceholderADF(intl);
        return undefined;
    })();
    return {
        placeholder: placeholder,
        placeholderADF: placeholderADF,
        isPlaceholderHidden: options.isPlaceholderHidden,
        withEmptyParagraph: (0, $dh538.fg)('platform_editor_ai_aifc_streaming'),
        isRovoLLMEnabled: options.isRovoLLMEnabled,
        enableLoadingSpinner: options.enableLoadingSpinner ?? (0, $1oCLl.expValEquals)('confluence_load_editor_title_on_transition', 'contentPlaceholder', true)
    };
}


function $adb03a718cdd3145$export$8b53e6ddc7cf96b4({}) {
    return {};
}


function $66d5390e1d65d1af$export$44901d053a58e418({ options: options }) {
    return {
        contextualFormattingEnabled: options.contextualFormattingEnabled
    };
}


function $9c8df38044d63cd4$export$26cff1f2fe9f781b({ options: options }) {
    return {
        enableElementBrowser: true,
        elementBrowserHelpUrl: '',
        disableDefaultItems: false,
        headless: false,
        emptyStateHandler: options?.emptyStateHandler,
        prioritySortingFn: typeof options.quickInsert === 'object' ? options.quickInsert.prioritySortingFn : undefined,
        onInsert: typeof options.quickInsert === 'object' ? options.quickInsert.onInsert : undefined
    };
}


function $ed5f509dae6ecf5b$export$13a2743c2a93c688({ options: options }) {
    return {
        api: options.referentialityContext.api ?? undefined,
        // A spread operator of the options.referentialityContext.options was previously used here, now they're all explicitly listed out to make the code more readable.
        appearance: options.referentialityContext.options.appearance,
        extensionHandlers: options.referentialityContext.options.extensionHandlers,
        externalObservers: options.referentialityContext.options.externalObservers,
        nodeNameCallback: options.referentialityContext.options.nodeNameCallback,
        nodeFocusCallback: options.referentialityContext.options.nodeFocusCallback,
        editorAnalyticsAPI: options.referentialityContext.options.editorAnalyticsAPI,
        editorView: options.referentialityContext.options.editorView,
        featureFlags: options.referentialityContext.options.featureFlags,
        __livePage: options.referentialityContext.options.__livePage,
        __rendererExtensionOptions: options.referentialityContext.options.__rendererExtensionOptions,
        getExtensionHeight: options.referentialityContext.options.getExtensionHeight
    };
}


function $70edb4b454693530$export$222c5aa4c9fb0805({ options: options }) {
    return options;
}





function $45e8d9f61045475c$export$197b78e13e8987d2({ options: options }) {
    // SECTION: From confluence/next/packages/editor-presets/src/full-page/createFullPageEditorPreset.ts `.add(['selectionMarkerPlugin', ...])`
    return {
        hideCursorOnInit: options.__livePage || (0, $1oCLl.expValEquals)('platform_editor_no_cursor_on_edit_page_init', 'isEnabled', true)
    };
// END SECTION
}


function $d84bbda11ad6763d$export$ddc2936355c1da67({ options: options }) {
    return {
        useLongPressSelection: false,
        // @ts-ignore Temporary solution to check for Live Page editor.
        __livePage: options.__livePage
    };
}


function $9a57111cbcc407d6$export$bc6dcb3c2a6112e1({ options: options, providers: providers }) {
    return {
        preferenceToolbarAboveSelection: false,
        contextualFormattingEnabled: options.contextualFormattingEnabled,
        userPreferencesProvider: providers.userPreferencesProvider,
        disablePin: options.disablePin
    };
}


function $f5ca45a4f682676c$export$5c1f265f89d46b24({ options: options }) {
    if (!options?.originalDoc || !options?.steps) return undefined;
    return {
        originalDoc: options.originalDoc,
        steps: options.steps,
        colorScheme: options.colorScheme
    };
}


function $c7ddbb7665d2a7d0$export$9d286ea8d36eb908({}) {
    return {
        menuDisabled: false,
        allowZeroWidthSpaceAfter: true
    };
}


function $8660f8880f9cea3b$export$3612ff8a6b94af71({}) {
    return undefined;
}


function $227eaab840448c35$export$b4fe80869e994c19({ options: options }) {
    if (!options) return undefined;
    const { enableSourceCreation: enableSourceCreation, syncedBlockRenderer: syncedBlockRenderer, syncBlockDataProvider: syncBlockDataProvider } = options;
    return {
        enableSourceCreation: enableSourceCreation,
        syncedBlockRenderer: syncedBlockRenderer,
        syncBlockDataProvider: syncBlockDataProvider
    };
}








function $2f3fcd3de4e4a210$export$9868b594778cf535({ options: options }) {
    return {
        // value from next/packages/editor-features/src/hooks/useTableOptions.ts
        tableOptions: {
            allowTableResizing: true,
            allowTableAlignment: true,
            allowBackgroundColor: true,
            allowColumnResizing: true,
            allowColumnSorting: true,
            allowDistributeColumns: true,
            allowHeaderColumn: true,
            allowHeaderRow: true,
            allowMergeCells: true,
            allowNumberColumn: true,
            allowNestedTables: true,
            allowControls: true,
            stickyHeaders: true,
            allowAddColumnWithCustomStep: false
        },
        // SECTION: From confluence/next/packages/editor-features/src/hooks/useEditorFeatureFlags.ts
        dragAndDropEnabled: true,
        // END SECTION
        isTableScalingEnabled: true,
        allowContextualMenu: true,
        fullWidthEnabled: options.editorAppearance === 'full-width',
        maxWidthEnabled: options.editorAppearance === 'max',
        wasFullWidthEnabled: options.prevEditorAppearance && options.prevEditorAppearance === 'full-width',
        getEditorFeatureFlags: ()=>({
                // SECTION: From confluence/next/packages/editor-features/src/hooks/useEditorFeatureFlags.ts
                tableWithFixedColumnWidthsOption: (0, $dh538.fg)('platform_editor_table_fixed_column_width_prop') ? undefined : true,
                // END SECTION
                // SECTION: From confluence/next/packages/full-page-editor/src/hooks/useEditorFullPageExperiments.ts
                tableSelector: (0, $iu6m9.editorExperiment)('platform_editor_tables_table_selector', true)
            }),
        isCommentEditor: false,
        isChromelessEditor: false,
        allowFixedColumnWidthOption: (0, $dh538.fg)('platform_editor_table_fixed_column_width_prop') ? true : undefined
    };
}


function $87c3c57462c09942$export$1d23e03c42bfc1ac({ options: options, providers: providers }) {
    return {
        allowNestedTasks: true,
        consumeTabs: true,
        useLongPressSelection: false,
        taskDecisionProvider: providers.taskDecisionProvider,
        hasEditPermission: options.hasEditPermission,
        requestToEditContent: options.requestToEditContent,
        hasRequestedEditPermission: options.hasRequestedEditPermission,
        allowBlockTaskItem: true
    };
}


function $9a9dacee247babb9$export$a4eedeb4455295f2({}) {
    return true;
}


function $cd23e889f6860a3b$export$cb883a3a9320698e({}) {
    return {
        responsiveToolbarMenu: true
    };
}


function $8ebcccb01b69e781$export$bd221c449644c740({}) {
    return {
        showIndentationButtons: true,
        allowHeadingAndParagraphIndentation: true
    };
}


function $969f212772f8d82f$export$2d206ce8fa0c3d37({ options: options }) {
    return {
        contextualFormattingEnabled: options.contextualFormattingEnabled
    };
}


function $9da95701694c2ca2$export$f8fa1184f7aaa2b3({ options: options }) {
    return {
        ButtonWrapper: options?.ButtonWrapper,
        showOnToolbar: true
    };
}


function $663aa679fccecaaa$export$612ea2d32c3e4c96({}) {
    return {
        isMobile: false
    };
}


function $e2c7c4acf3e187dc$export$abdb0d09187eec69({ providers: providers, options: options }) {
    return {
        userPreferencesProvider: providers.userPreferencesProviderNext,
        // If initialToolbarDockingPosition is set, use it to override any saved user preference
        initialUserPreferences: options.initialToolbarDockingPosition ? {
            toolbarDockingPosition: options.initialToolbarDockingPosition
        } : undefined
    };
}


function $2b80134f192952c5$export$9f1bd789d5e1fd40(props) {
    const { intl: intl, providers: providers, enabledOptionalPlugins: enabledOptionalPlugins } = props;
    // We remove all `never` properties from the FullPagePresetProps.pluginOptions,
    // we need to return them back.
    const pluginOptions = props.pluginOptions;
    return new (0, $bupcf.EditorPresetBuilder)().maybeAdd([
        (0, $c6eda9ff2d183267$export$9f825df6a9c9b35b),
        (0, $a233792833dda4ec$export$d384a797e800fdbe)({
            options: pluginOptions.limitedMode
        })
    ], !pluginOptions.limitedMode.killSwitchEnabled).add([
        (0, $l7rln.featureFlagsPlugin),
        (0, $13d21f4408f33e88$export$3bff061e5229a7)({
            options: pluginOptions.featureFlags
        })
    ]).add([
        (0, $jmHSv.analyticsPlugin),
        (0, $b499f1aa43aeb0ae$export$bfd53895e8497571)({
            options: pluginOptions.analytics
        })
    ]).add((0, $55skd.betterTypeHistoryPlugin)).add([
        (0, $36iDo.pastePlugin),
        (0, $49e9bc2589f6c0e6$export$6b1ad42d09c74964)({
            options: pluginOptions.paste,
            providers: providers
        })
    ]).add((0, $acwPl.default)).add((0, $jS0a0.focusPlugin)).add((0, $gyXPd.compositionPlugin)).add([
        (0, $kbe7k.contextIdentifierPlugin),
        (0, $815cf72c0fd01db1$export$2c26eb5ff90afcfd)({
            options: pluginOptions.contextIdentifier,
            providers: providers
        })
    ]).add([
        (0, $fi7Vj.default),
        (0, $78a1544f00d30a05$export$a23b3fa66082f163)({
            options: pluginOptions.base
        })
    ]).maybeAdd([
        (0, $hEicH.userPreferencesPlugin),
        (0, $e2c7c4acf3e187dc$export$abdb0d09187eec69)({
            providers: providers,
            options: pluginOptions.userPreferencesPlugin
        })
    ], enabledOptionalPlugins.userPreferences).add((0, $4KTOl.decorationsPlugin)).add([
        (0, $fMaLE.typeAheadPlugin),
        (0, $663aa679fccecaaa$export$612ea2d32c3e4c96)({
            options: pluginOptions.typeAhead
        })
    ]).add((0, $HYzBP.default)).add([
        (0, $itirX.primaryToolbarPlugin),
        (0, $66d5390e1d65d1af$export$44901d053a58e418)({
            options: pluginOptions.primaryToolbar
        })
    ]).maybeAdd([
        (0, $3JBsx.toolbarPlugin),
        (0, $969f212772f8d82f$export$2d206ce8fa0c3d37)({
            options: pluginOptions.toolbar
        })
    ], Boolean(enabledOptionalPlugins.toolbar)).maybeAdd([
        (0, $k2prb.blockMenuPlugin),
        {
            getLinkPath: pluginOptions.blockMenu?.getLinkPath,
            blockLinkHashPrefix: pluginOptions.blockMenu?.blockLinkHashPrefix
        }
    ], (0, $iu6m9.editorExperiment)('platform_editor_block_menu', true)).add((0, $kw2eg.undoRedoPlugin)).add([
        (0, $khxQ7.blockTypePlugin),
        (0, $849252e5cfbe6f75$export$817c0e398e6ff750)({
            options: pluginOptions.blockType
        })
    ]).add((0, $kXH7i.clearMarksOnEmptyDocPlugin)).add([
        (0, $7nKrc.selectionToolbarPlugin),
        (0, $9a57111cbcc407d6$export$bc6dcb3c2a6112e1)({
            options: pluginOptions.selectionToolbar,
            providers: providers
        })
    ]).add([
        (0, $gATpw.hyperlinkPlugin),
        (0, $ba2e03c1e9271b78$export$ab9ae3984d5aef33)({
            options: pluginOptions.hyperlink
        })
    ]).add([
        (0, $5mDFx.textFormattingPlugin),
        (0, $cd23e889f6860a3b$export$cb883a3a9320698e)({
            options: pluginOptions.textFormatting
        })
    ]).add((0, $fI6T7.widthPlugin)).add([
        (0, $e6sdP.quickInsertPlugin),
        (0, $9c8df38044d63cd4$export$26cff1f2fe9f781b)({
            options: pluginOptions.quickInsert
        })
    ]).add([
        (0, $kYgUn.placeholderPlugin),
        (0, $01e23cb99d262862$export$c6841f879d4c8aef)({
            intl: intl,
            options: pluginOptions.placeholder
        })
    ]).add((0, $vxKdN.unsupportedContentPlugin)).add([
        (0, $lgjGE.editorDisabledPlugin),
        (0, $22bbbcb7ca748783$export$de47eee62065048e)({
            options: pluginOptions.editorDisabled
        })
    ]).add([
        (0, $6borH.submitEditorPlugin),
        (0, $8660f8880f9cea3b$export$3612ff8a6b94af71)({
            options: pluginOptions.submitEditor
        })
    ]).add((0, $kIhx9.copyButtonPlugin)).maybeAdd((0, $7sK9h.floatingToolbarPlugin), enabledOptionalPlugins.floatingToolbar ?? true).maybeAdd((0, $6AqNX.interactionPlugin), Boolean(enabledOptionalPlugins.interaction)).add([
        (0, $bULcr.selectionPlugin),
        (0, $d84bbda11ad6763d$export$ddc2936355c1da67)({
            options: pluginOptions.selection
        })
    ]).add([
        (0, $7rj2U.default),
        (0, $de05ec98c0250c98$export$74cc43e84bb9c20)({
            options: pluginOptions.codeBlock
        })
    ]).add((0, $bz4KD.ufoPlugin)).add((0, $2nH2Y.dataConsumerPlugin)).add((0, $3ihIB.accessibilityUtilsPlugin)).add((0, $2yr9J.contentInsertionPlugin)).add((0, $fPXRH.batchAttributeUpdatesPlugin)).add([
        (0, $cwPVT.breakoutPlugin),
        (0, $18709874e4301e98$export$3be6b735d5cbc3e6)({
            options: pluginOptions.breakout
        })
    ]).add((0, $hr8mu.alignmentPlugin)).add([
        (0, $i2zv0.textColorPlugin),
        (0, $9a9dacee247babb9$export$a4eedeb4455295f2)({
            options: pluginOptions.textColor
        })
    ]).add((0, $5HHoF.listPlugin)).add((0, $5DsxN.rulePlugin)).add([
        (0, $fTvEN.expandPlugin),
        (0, $759d2e4ef0d8b24b$export$ed53f0c49fce09d6)({
            options: pluginOptions.expand
        })
    ]).add((0, $fCLXZ.guidelinePlugin)).add([
        (0, $fYKTL.gridPlugin),
        (0, $f0763edceecb76c2$export$c66d0d1462a05bd)({
            options: pluginOptions.grid
        })
    ]).add([
        (0, $cpn0f.annotationPlugin),
        (0, $8ed9740f118d687b$export$b3e029fd31f94f55)({
            options: pluginOptions.annotation,
            providers: providers
        })
    ]).add([
        (0, $cWFvG.mediaPlugin),
        (0, $1412367cad2aa59d$export$484123ae56f6fbd9)({
            intl: intl,
            options: pluginOptions.media,
            providers: providers
        })
    ]).add((0, $2U68K.mediaInsertPlugin)).add((0, $duFi2.default)).add([
        (0, $5u7tz.mentionsPlugin),
        (0, $4c9dc0bddcbec186$export$e15342409979aa19)({
            options: pluginOptions.mentions,
            providers: providers
        })
    ]).add([
        (0, $hcboS.emojiPlugin),
        (0, $0ec938d111941985$export$7adcaf18ca5c72c4)({
            options: pluginOptions.emoji,
            providers: providers
        })
    ]).add([
        (0, $eeGWn.default),
        (0, $2f3fcd3de4e4a210$export$9868b594778cf535)({
            options: pluginOptions.table
        })
    ]).add([
        (0, $jaskt.tasksAndDecisionsPlugin),
        (0, $87c3c57462c09942$export$1d23e03c42bfc1ac)({
            options: pluginOptions.tasksAndDecisions,
            providers: providers
        })
    ]).add([
        (0, $flknw.helpDialogPlugin),
        (0, $eab9055a4a41e7c7$export$2a67100cd9c61f05)({
            options: {
                imageUploadProviderExists: false,
                aiEnabled: enabledOptionalPlugins.aiExperience
            }
        })
    ]).maybeAdd([
        (0, $5AZDw.collabEditPlugin),
        (0, $e2f5d02097d0844c$export$c1ebe19806bc53b1)({
            options: pluginOptions.collabEdit,
            providers: providers
        })
    ], (0, $1oCLl.expValEquals)('platform_editor_are_nodes_equal_ignore_mark_order', 'isEnabled', true) ? Boolean(pluginOptions.collabEdit.collabEdit) : true).add([
        (0, $b3BjA.default),
        (0, $fc9f968714fe9c5d$export$c18e432f323b002e)({
            options: pluginOptions.panel
        })
    ]).add([
        (0, $1nZXu.contextPanelPlugin),
        (0, $d7dae729776ab102$export$48a60d81b6bb28e3)({
            options: pluginOptions.contextPanel
        })
    ]).add([
        (0, $eyggb.extensionPlugin),
        (0, $2a51a0f7e6ad908c$export$c18b9102cd0790c9)({
            options: pluginOptions.extension
        })
    ]).add([
        (0, $4iQt6.default),
        (0, $0105ad9f4c3353d7$export$5598bb2314a53fa8)({
            options: pluginOptions.date
        })
    ]).add([
        (0, $8HLyI.default),
        (0, $adb03a718cdd3145$export$8b53e6ddc7cf96b4)({
            options: pluginOptions.placeholderText
        })
    ]).add([
        (0, $05jmd.layoutPlugin),
        (0, $0c59805b4172bf23$export$33fb6c6592b2cd5f)({
            options: pluginOptions.layout
        })
    ]).add([
        (0, $agrUc.cardPlugin),
        (0, $f8013e4ced731918$export$514131654bb897e2)({
            options: pluginOptions.card,
            providers: providers
        })
    ]).add([
        (0, $bS1lJ.customAutoformatPlugin),
        (0, $0239ddf6db5a0e53$export$f18d68682e981a91)({
            options: pluginOptions.customAutoformat,
            providers: providers
        })
    ]).add([
        (0, $c8680.statusPlugin),
        (0, $c7ddbb7665d2a7d0$export$9d286ea8d36eb908)({
            options: pluginOptions.status
        })
    ]).maybeAdd([
        (0, $efDik.syncedBlockPlugin),
        (0, $227eaab840448c35$export$b4fe80869e994c19)({
            options: pluginOptions.syncedBlock
        })
    ], !!pluginOptions.syncedBlock && (0, $iu6m9.editorExperiment)('platform_synced_block', true)).add((0, $aUwPP.indentationPlugin)).add((0, $1GAIu.scrollIntoViewPlugin)).add([
        (0, $1KHo7.toolbarListsIndentationPlugin),
        (0, $8ebcccb01b69e781$export$bd221c449644c740)({
            options: pluginOptions.toolbarListsIndentation
        })
    ]).add([
        (0, $cVhn8.insertBlockPlugin),
        (0, $6e8873e0128315d2$export$1e11b615e9dc119e)({
            options: pluginOptions.insertBlock
        })
    ]).add([
        (0, $PJ00O.avatarGroupPlugin),
        (0, $ad7357a8ed7dfd42$export$eeaea850bc5c5797)({
            options: pluginOptions.avatarGroup
        })
    ]).maybeAdd([
        (0, $dtCIm.findReplacePlugin),
        (0, $3434917e042efc57$export$d9e183f0607e1b5d)({
            options: pluginOptions.findReplace
        })
    ], enabledOptionalPlugins.findReplace).add((0, $hSJYu.borderPlugin)).add((0, $6q6xk.fragmentPlugin)).maybeAdd((0, $e6ea46e05a87eb23$export$eb211d52411e6f09), (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_paste_actions_menu', 'isEnabled', true)).add([
        (0, $59fTa.pasteOptionsToolbarPlugin),
        {
            usePopupBasedPasteActionsMenu: enabledOptionalPlugins.aiExperience && pluginOptions.ai?.isInDocumentStreamingEnabled
        }
    ]).maybeAdd([
        (0, $01uqX.codeBidiWarningPlugin),
        (0, $c70218b234c6d78f$export$3f0ff0bcf72f4d98)({
            options: pluginOptions.codeBidiWarning
        })
    ], !(0, $1oCLl.expValEquals)('platform_editor_remove_bidi_char_warning', 'isEnabled', true))// below plugins moved from legacy preset
    .maybeAdd([
        (0, $dx8CK.referentialityPlugin),
        enabledOptionalPlugins.referentiality ? (0, $ed5f509dae6ecf5b$export$13a2743c2a93c688)({
            options: pluginOptions.referentiality
        }) : undefined
    ], enabledOptionalPlugins.referentiality).maybeAdd([
        (0, $80JwR.loomPlugin),
        (0, $1bb1e0cb9a7988e8$export$feaee25faac0c640)({
            options: pluginOptions.loom
        })
    ], enabledOptionalPlugins.loom).add([
        (0, $3mcWz.editorViewModePlugin),
        (0, $f342e2c893778f00$export$36a79e2b5698697a)({
            options: pluginOptions.editorViewMode
        })
    ]).add((0, $50cbf7161ff57c52$export$d510e4d48c393847))// aiDefinitionsPlugin depends on editorViewModePlugin
    .maybeAdd([
        (0, $1ewUw.aiDefinitionsPlugin),
        (0, $03a647a335c52f20$export$13aeab2a71badd1e)({
            options: pluginOptions.aiDefinitions
        })
    ], enabledOptionalPlugins.aiDefinitions).maybeAdd([
        (0, $4DEL1.aiPlugin),
        (0, $0e54a671895f12da$export$a2b90416e38bfd44)({
            options: pluginOptions.ai
        })
    ], enabledOptionalPlugins.aiExperience).add([
        (0, $5Qu3R.selectionMarkerPlugin),
        (0, $45e8d9f61045475c$export$197b78e13e8987d2)({
            options: pluginOptions.selectionMarker
        })
    ]).add([
        (0, $2E0F0.blockControlsPlugin),
        {
            rightSideControlsEnabled: (0, $dh538.fg)('confluence_remix_button_right_side_block_fg') && (0, $dZ8uq.expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true)
        }
    ]).add((0, $cu2RD.highlightPlugin)).add([
        (0, $8ABVP.engagementPlatformPlugin),
        (0, $d63a2b43135c498f$export$128eafe7f843e327)({
            options: pluginOptions.engagementPlatform
        })
    ]).maybeAdd((0, $5y9PZ.connectivityPlugin), enabledOptionalPlugins.connectivity).maybeAdd([
        (0, $dH9DB.metricsPlugin),
        (0, $85c17a3a2c6c7b85$export$4677177d82484aef)({
            options: pluginOptions.metrics
        })
    ], enabledOptionalPlugins.metrics).maybeAdd([
        (0, $dme7x.contentFormatPlugin),
        (0, $5d0ceab6af17632b$export$8a4106078b67336e)({
            options: pluginOptions.contentFormat
        })
    ], (0, $1oCLl.expValEquals)('confluence_compact_text_format', 'isEnabled', true)).maybeAdd([
        (0, $jgFdO.codeBlockAdvancedPlugin),
        (0, $54a86813db4d4780$export$6e32a592ec823802)({
            options: pluginOptions.codeBlockAdvanced
        })
    ], enabledOptionalPlugins.codeBlockAdvanced).maybeAdd([
        (0, $4NiQW.selectionExtensionPlugin),
        (0, $70edb4b454693530$export$222c5aa4c9fb0805)({
            options: pluginOptions.selectionExtension
        })
    ], enabledOptionalPlugins.selectionExtension).add((0, $3O0YV.userIntentPlugin)).maybeAdd([
        (0, $84Iqc.showDiffPlugin),
        (0, $f5ca45a4f682676c$export$5c1f265f89d46b24)({
            options: pluginOptions.showDiff
        })
    ], enabledOptionalPlugins.showDiff).maybeAdd([
        (0, $aB4bz.trackChangesPlugin),
        (0, $9da95701694c2ca2$export$f8fa1184f7aaa2b3)({
            options: pluginOptions.trackChanges
        })
    ], enabledOptionalPlugins.trackChanges).maybeAdd((0, $lQotL.localIdPlugin), enabledOptionalPlugins.localId).maybeAdd([
        (0, $dF1N1.aiStreamingOrchestratorPlugin),
        (0, $f116ad07960ba181$export$bc5ff52c1b8ecb7e)({
            options: pluginOptions.aiStreamingOrchestrator
        })
    ], enabledOptionalPlugins.aiStreamingOrchestrator).maybeAdd((0, $0f42ee7f81761719$export$8fc6b5430a555c3d), (0, $1oCLl.expValEquals)('ai_speech_to_text_in_editor', 'isEnabled', true));
}



var $dMGoR = parcelRequire("dMGoR");


var $dXIrr = parcelRequire("dXIrr");


var $4EKKB = parcelRequire("4EKKB");


var $3YBks = parcelRequire("3YBks");


var $iHrpD = parcelRequire("iHrpD");


var $6mKj3 = parcelRequire("6mKj3");


var $8pcS0 = parcelRequire("8pcS0");

function $7cb36df2e500ad5f$export$d4ded51d0f0bd2df(extensionParams) {
    const { extensionKey: extensionKey, extensionType: extensionType, parameters: parameters } = extensionParams;
    if (extensionKey === (0, $8pcS0.EXTENSION_KEY).INVALID && extensionType === (0, $8pcS0.EXTENSION_TYPE).MIGRATION) return parameters?.nestedContent;
}






var $3jwuS = parcelRequire("3jwuS");


var $ep3mz = parcelRequire("ep3mz");








var $cqCFf = parcelRequire("cqCFf");

const $4eff3da02bf6b0b9$export$ce9fbb23568613c5 = (_view, event)=>{
    /**
   * We have to use the event.target to indentify that we are dealing with the live search extension
   * instead of the current editor selection because
   *   1. We can’t guarantee the selection won’t change while we are in the extension
   *   2. Often times the selection is not the extension despite currently interacting with the extension
   *
   * As a result, we have to rely on the event.target to identify if the current event is meant for the
   * live search extension.
   */ const isLiveSearchExtensionElement = event.target.classList.contains(`${(0, $cqCFf.LIVE_SEARCH_SELECT_CLASSNAME_PREFIX)}__input`) || event.target.className === (0, $cqCFf.LIVE_SEARCH_BUTTON_CLASSNAME);
    return (event.target instanceof HTMLInputElement || event.target instanceof HTMLButtonElement) && isLiveSearchExtensionElement;
};
const $4eff3da02bf6b0b9$export$c9403d1366bd779d = {
    keydown: $4eff3da02bf6b0b9$export$ce9fbb23568613c5,
    keyup: $4eff3da02bf6b0b9$export$ce9fbb23568613c5,
    keypress: $4eff3da02bf6b0b9$export$ce9fbb23568613c5,
    beforeinput: $4eff3da02bf6b0b9$export$ce9fbb23568613c5
};



var $kyKWe = parcelRequire("kyKWe");




const $73f6dfc0acf21779$export$14e5c8eb6f32c76 = (slice)=>{
    const updatedContent = [];
    slice.content.forEach((node)=>{
        if (node.attrs.extensionType === 'com.atlassian.confluence.macro.core' && node.attrs.extensionKey === 'anchor') {
            // Update the value of the macro param used as anchor name (used as html id in UI) to a unique value, UUID.
            const newAttrs = {
                ...node.attrs,
                parameters: {
                    ...node.attrs.parameters,
                    macroParams: {
                        ...node.attrs.parameters.macroParams,
                        '': {
                            value: (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))()
                        }
                    }
                }
            };
            updatedContent.push(node.type.create(newAttrs, node.content, node.marks));
        } else updatedContent.push(node);
    });
    return new (0, $5SAOw.Slice)((0, $5SAOw.Fragment).fromArray(updatedContent), slice.openStart, slice.openEnd);
};


// Duplicate of TEXTFIELD_ID from @atlassian/dynamic-cards-search-page
const $23f33cc0c92651d7$var$COMPANY_HUB_SEARCH_TEXTFIELD_ID = 'ch-search-text-query-input';
const $23f33cc0c92651d7$export$eb1b190bb6345745 = (_view, event)=>{
    /**
	 * We have to use the event.target to indentify that we are dealing with the Company Hub search extension
	 * instead of the current editor selection because
	 *   1. We can’t guarantee the selection won’t change while we are in the extension
	 *   2. Often times the selection is not the extension despite currently interacting with the extension
	 *
	 * As a result, we have to rely on the event.target to identify if the current event is meant for the
	 * Company Hub search extension.
	 */ return event.target instanceof HTMLInputElement && event.target.id === $23f33cc0c92651d7$var$COMPANY_HUB_SEARCH_TEXTFIELD_ID;
};
const $23f33cc0c92651d7$export$47b865254c03e3eb = {
    keydown: $23f33cc0c92651d7$export$eb1b190bb6345745,
    keyup: $23f33cc0c92651d7$export$eb1b190bb6345745,
    keypress: $23f33cc0c92651d7$export$eb1b190bb6345745,
    beforeinput: $23f33cc0c92651d7$export$eb1b190bb6345745
};


const $1a6e0310908ffd24$export$234cb421a967be1c = 'extensionManager';
const $1a6e0310908ffd24$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)($1a6e0310908ffd24$export$234cb421a967be1c);
const $1a6e0310908ffd24$export$ae829ec7b2625219 = ()=>new (0, $1S4f7.SafePlugin)({
        key: $1a6e0310908ffd24$export$18d4026d1ea86bb1,
        state: {
            init: ()=>({}),
            apply (tr, pluginState) {
                const metadata = tr.getMeta($1a6e0310908ffd24$export$18d4026d1ea86bb1);
                if (metadata) return {
                    ...pluginState,
                    ...metadata
                };
                return pluginState;
            }
        },
        props: {
            handleDOMEvents: {
                ...(0, $4eff3da02bf6b0b9$export$c9403d1366bd779d),
                ...(0, $23f33cc0c92651d7$export$47b865254c03e3eb)
            },
            transformPasted: (0, $73f6dfc0acf21779$export$14e5c8eb6f32c76)
        }
    });









var $cMZNY = parcelRequire("cMZNY");


var $1bY7o = parcelRequire("1bY7o");








var $1NBp8 = parcelRequire("1NBp8");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $cEgMD = parcelRequire("cEgMD");













const $999bd16bdfd9c01c$var$i18n = (0, $h82at.defineMessages)({
    defaultTooltipContent: {
        id: "fabric-extension-manager-plugin.anchor.copy-link-button.tooltip",
        defaultMessage: "Copy link to anchor"
    },
    erroredTooltipContent: {
        id: "fabric-extension-manager-plugin.anchor.copy-link-button.tooltip.disabled",
        defaultMessage: "Edit to create link"
    },
    copySuccessTooltipContent: {
        id: "fabric-extension-manager-plugin.anchor.copy-link-button.tooltip.copied",
        defaultMessage: "Copied!"
    }
});
const $999bd16bdfd9c01c$export$baeb5f600fdaf82a = ()=>({ tr: tr })=>tr.setMeta((0, $1a6e0310908ffd24$export$18d4026d1ea86bb1), {
            showAnchorLinkCopiedTooltip: undefined
        });
const $999bd16bdfd9c01c$export$94a93fd1fcc43123 = ({ node: node, intl: intl, api: api, updateTooltipPosition: updateTooltipPosition })=>{
    const showAnchorLinkCopiedTooltip = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        (0, $1a6e0310908ffd24$export$234cb421a967be1c)
    ], (states)=>states?.extensionManagerState?.showAnchorLinkCopiedTooltip);
    const isValidAnchorName = (0, $a511a7deb986d4c1$export$f57cb5ad5ec9d3a8)(node);
    (0, $42omo.useEffect)(()=>{
        // Reset the state of `showAnchorLinkCopiedTooltip` back to default when the component unmounts
        return ()=>{
            api?.core?.actions?.execute?.($999bd16bdfd9c01c$export$baeb5f600fdaf82a());
        };
    }, [
        api
    ]);
    (0, $42omo.useLayoutEffect)(()=>{
        // When the content of a visible tooltip changes, its' position isn't recalculated
        // and the tooltip may become misaligned. Since we change the tooltip content when
        // the link is copied, we need to manually recalculate the tooltip position.
        if (showAnchorLinkCopiedTooltip) updateTooltipPosition?.();
    }, [
        showAnchorLinkCopiedTooltip,
        updateTooltipPosition
    ]);
    if (!isValidAnchorName) // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("p", null, intl.formatMessage($999bd16bdfd9c01c$var$i18n.erroredTooltipContent));
    return(// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("p", null, !!showAnchorLinkCopiedTooltip ? intl.formatMessage($999bd16bdfd9c01c$var$i18n.copySuccessTooltipContent) : intl.formatMessage($999bd16bdfd9c01c$var$i18n.defaultTooltipContent)));
};


const $a511a7deb986d4c1$var$i18n = (0, $h82at.defineMessages)({
    anchorMacroCopyLinkCTALabel: {
        id: "fabric-extension-manager-plugin.anchor.copy-link-button.label",
        defaultMessage: "Copy link"
    }
});
const $a511a7deb986d4c1$export$f57cb5ad5ec9d3a8 = (node)=>{
    const anchorName = node.attrs.parameters.macroParams['']?.value;
    if (!anchorName) return false;
    try {
        decodeURIComponent(anchorName);
        return true;
    } catch  {
        return false;
    }
};
const $a511a7deb986d4c1$var$getPathName = (isLivePage, contentId, spaceKey)=>{
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    if (isCompanyHub) return (0, $1NBp8.COMPANY_HUB).toUrl();
    if (isLivePage) return window.location.pathname;
    return (0, $1NBp8.VIEW_PAGE).toUrl({
        contentId: contentId,
        spaceKey: spaceKey
    });
};
const $a511a7deb986d4c1$export$548d9151b6657224 = (node, fireAnalyticsEvent)=>(state, dispatch)=>{
        const { tr: tr } = state;
        const { isLivePage: isLivePage, contentId: contentId, spaceKey: spaceKey } = (0, $1a6e0310908ffd24$export$18d4026d1ea86bb1).getState(state)?.pageContext ?? {};
        const anchorName = node.attrs.parameters.macroParams['']?.value;
        const pathName = $a511a7deb986d4c1$var$getPathName(isLivePage, contentId, spaceKey);
        const setShowAnchorLinkCopiedTooltip = (showAnchorLinkCopiedTooltip)=>{
            dispatch?.(tr.setMeta((0, $1a6e0310908ffd24$export$18d4026d1ea86bb1), {
                showAnchorLinkCopiedTooltip: showAnchorLinkCopiedTooltip
            }));
        };
        fireAnalyticsEvent?.({
            action: (0, $d925B.ACTION).CLICKED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).BUTTON,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).COPY_LINK_TO_ANCHOR,
            eventType: (0, $d925B.EVENT_TYPE).UI,
            attributes: {
                inputMethod: (0, $d925B.INPUT_METHOD).FLOATING_TB,
                extensionKey: node.attrs?.extensionKey,
                extensionType: node.attrs?.extensionType,
                isLivePage: isLivePage
            }
        });
        if (dispatch) try {
            decodeURIComponent(anchorName);
            (0, $cMZNY.copyToClipboard)(`${window.location.origin}${pathName}#${anchorName}`).then(()=>{
                setShowAnchorLinkCopiedTooltip(true);
            }).catch((error)=>{
                (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                    attribution: (0, $3IBnw.Attribution).PAGE_EXTENSIONS
                });
                setShowAnchorLinkCopiedTooltip(false);
            });
        } catch  {
            setShowAnchorLinkCopiedTooltip(false);
        }
        return true;
    };
const $a511a7deb986d4c1$export$3178138fc316e9da = (toolbarItems, intl, node, api)=>{
    const updatedToolbarItems = toolbarItems.slice();
    const indexOfFirstSeperator = toolbarItems.map((item)=>item.type).indexOf('separator');
    const { fireAnalyticsEvent: fireAnalyticsEvent } = api?.analytics?.actions ?? {};
    const newItemsToInsert = [
        {
            id: 'editor.anchor.macro.copy-link',
            type: 'button',
            title: intl.formatMessage($a511a7deb986d4c1$var$i18n.anchorMacroCopyLinkCTALabel),
            tooltipContent: ({ update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $999bd16bdfd9c01c$export$94a93fd1fcc43123), {
                    node: node,
                    intl: intl,
                    api: api,
                    updateTooltipPosition: update
                }),
            showTitle: true,
            hideTooltipOnClick: false,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))),
            onClick: $a511a7deb986d4c1$export$548d9151b6657224(node, fireAnalyticsEvent),
            disabled: !$a511a7deb986d4c1$export$f57cb5ad5ec9d3a8(node)
        }
    ];
    /**
   * If there is no separator, 1 group present, add
   * separator before the new items to create a new visual
   */ if (indexOfFirstSeperator === -1) newItemsToInsert.unshift({
        type: 'separator',
        hidden: false
    });
    else if (indexOfFirstSeperator !== 0 && indexOfFirstSeperator !== toolbarItems.length - 1) newItemsToInsert.push({
        type: 'separator',
        hidden: false
    });
    updatedToolbarItems.splice(indexOfFirstSeperator + 1, 0, ...newItemsToInsert);
    return updatedToolbarItems;
};
const $a511a7deb986d4c1$export$1ddc93af5b94ad04 = {
    shouldApplyOverride: (state, config)=>{
        const isCurrentSelectionAnchorMacro = state.selection instanceof (0, $ks2lK.NodeSelection) && state.selection.node.attrs.extensionType === 'com.atlassian.confluence.macro.core' && state.selection.node.attrs.extensionKey === 'anchor';
        return isCurrentSelectionAnchorMacro && (Array.isArray(config.nodeType) ? config.nodeType.includes(state.schema.nodes.inlineExtension) : config.nodeType === state.schema.nodes.inlineExtension);
    },
    applyOverride: (config, intl, api)=>{
        if (Array.isArray(config.items)) {
            const toolbarItems = config.items;
            config.items = (node)=>{
                if (node.attrs.extensionType === 'com.atlassian.confluence.macro.core' && node.attrs.extensionKey === 'anchor') return $a511a7deb986d4c1$export$3178138fc316e9da(toolbarItems, intl, node, api);
                return toolbarItems;
            };
        }
    }
};


const $ea140a6e73833f23$export$86ce8f8241c20a3 = (state, intl, _providerFactory, activeConfigs, api)=>{
    if (!activeConfigs?.length) return;
    const overrides = [
        (0, $a511a7deb986d4c1$export$1ddc93af5b94ad04)
    ];
    activeConfigs.forEach((config)=>{
        overrides.forEach(({ shouldApplyOverride: shouldApplyOverride, applyOverride: applyOverride })=>{
            if (shouldApplyOverride(state, config)) applyOverride(config, intl, api);
        });
    });
};


const $b6333eeaeea6365c$export$53933ef6873e4a9f = ({ api: api })=>({
        name: (0, $1a6e0310908ffd24$export$234cb421a967be1c),
        pmPlugins () {
            return [
                {
                    name: (0, $1a6e0310908ffd24$export$234cb421a967be1c),
                    plugin: ()=>(0, $1a6e0310908ffd24$export$ae829ec7b2625219)()
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const pluginState = (0, $1a6e0310908ffd24$export$18d4026d1ea86bb1).getState(editorState);
            return {
                showAnchorLinkCopiedTooltip: pluginState?.showAnchorLinkCopiedTooltip
            };
        },
        usePluginHook ({ editorView: editorView }) {
            const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
            const [{ contentId: contentId, spaceKey: spaceKey }] = (0, $ep3mz.usePageState)();
            (0, $42omo.useEffect)(()=>{
                const { dispatch: dispatch, state: { tr: tr } } = editorView;
                tr.setMeta((0, $1a6e0310908ffd24$export$18d4026d1ea86bb1), {
                    pageContext: {
                        isLivePage: isLivePage,
                        spaceKey: spaceKey,
                        contentId: contentId
                    }
                });
                dispatch(tr);
            }, [
                editorView,
                isLivePage,
                spaceKey,
                contentId
            ]);
        },
        pluginsOptions: {
            // @ts-expect-error — react-intl v5/v7 type mismatch, will be removed when platform upgrades to react-intl v7
            floatingToolbar: (...args)=>(0, $ea140a6e73833f23$export$86ce8f8241c20a3)(...args, api)
        }
    });



var $9wGTI = parcelRequire("9wGTI");











var $91bcx = parcelRequire("91bcx");


var $9NwnH = parcelRequire("9NwnH");








var $ffQ2A = parcelRequire("ffQ2A");





var $jy7VG = parcelRequire("jy7VG");

var $8EkET = parcelRequire("8EkET");


var $h9yJL = parcelRequire("h9yJL");











var $5spQU = parcelRequire("5spQU");







const $bcc122a52e0f74cf$export$3b87fd119d006909 = new (0, $ks2lK.PluginKey)('editorOfflineStoragePlugin');
const $bcc122a52e0f74cf$export$ae829ec7b2625219 = (stepsDatabase)=>()=>{
        return new (0, $1S4f7.SafePlugin)({
            key: $bcc122a52e0f74cf$export$3b87fd119d006909,
            state: {
                init () {
                    // environment-aware enablement via feature encoding
                    const isEditorFeatureEnabled = (0, $5spQU.isFeatureEnabled)('confluence', 'confluence-editor-offline-storage');
                    return {
                        status: 'pending',
                        disabled: !isEditorFeatureEnabled ? 'disabledEnvironment' : false,
                        inactiveSyncing: false
                    };
                },
                apply: (tr, currentPluginState)=>{
                    const meta = tr.getMeta($bcc122a52e0f74cf$export$3b87fd119d006909);
                    if (meta) return {
                        ...currentPluginState,
                        ...meta
                    };
                    return currentPluginState;
                }
            },
            view: ()=>{
                return {
                    destroy () {
                        return stepsDatabase.closeDB(true);
                    }
                };
            }
        });
    };


class $5c049076093b3a44$export$d15eb9e8bb5d03ea {
    get hasLock() {
        return this._hasLock;
    }
    get lockPurpose() {
        return this._lockPurpose;
    }
    init(dbName) {
        this.dbName = dbName;
    }
    /**
   * Release the lock so it can be used elsewhere
   */ releaseLock() {
        this._releaseLock();
    }
    /**
   * Acquire the lock for the page
   *
   * **Waiting on this function will block until the lock is acquired then released, or the lock request is aborted.**
   * If waitUntilAvailable is set to `true`, the lock request will wait for the lock to become available.
   * If waitUntilAvailable is set to `false`, the lock request will abort if the lock is not available at the time it's requested.
   *
   * @param callback - The callback to run when the lock is acquired or the lock request is aborted
   * @param waitUntilAvailable - When set to true the lock request will wait until the lock is available
   */ async acquireLock(callback, waitUntilAvailable = false, purpose) {
        if (!this.dbName) return Promise.reject(new Error('SynchronisationLock not initialized.'));
        await navigator.locks?.request(this.dbName, {
            ifAvailable: !waitUntilAvailable
        }, async (lock)=>{
            if (lock === null) {
                await callback?.(false);
                return;
            }
            const promise = this.holdLock();
            this._lockPurpose = purpose;
            await callback?.(true);
            return promise;
        });
    }
    /**
   * If the lock is currently taken and therefore we shouldn't send any data
   */ async isLocked() {
        if (!this.dbName) return false;
        const locks = await navigator.locks?.query();
        const relevantLocks = locks?.held ? locks.held.filter((lock)=>lock.name === this.dbName) : [];
        if (relevantLocks && relevantLocks.length > 0) return true;
        else return false;
    }
    constructor(){
        this.dbName = void 0;
        this._hasLock = false;
        this._lockPurpose = void 0;
        this._releaseLock = ()=>{};
        this.holdLock = async ()=>{
            this._hasLock = true;
            let resolve;
            this._releaseLock = ()=>{
                // resolving the promise will release the lock
                resolve({});
                this._hasLock = false;
                this._lockPurpose = undefined;
            };
            return new Promise((res)=>{
                resolve = res;
            });
        };
    }
}





const $1a899df20ad45f18$var$isTrackEvent = (props)=>{
    return props.action === 'OFFLINE_EDITING_SUCCESS_STORE_RECOVERY_VERSION';
};
const $1a899df20ad45f18$export$6bd08bb9f59ca292 = (props)=>{
    const { api: api, action: action, ...otherAttributes } = props;
    if (!api || !api.analytics) return;
    // Get additional context from shared state
    const sharedPluginState = api?.editorOfflineStorage?.sharedState.currentState();
    const { version: version, steps: steps, status: status, disabled: disabled } = sharedPluginState ?? {};
    api.analytics.actions?.fireAnalyticsEvent?.({
        eventType: $1a899df20ad45f18$var$isTrackEvent(props) ? (0, $d925B.EVENT_TYPE).TRACK : (0, $d925B.EVENT_TYPE).OPERATIONAL,
        action: action,
        actionSubject: (0, $d925B.ACTION_SUBJECT).OFFLINE_EDITING,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).OFFLINE_EDITING,
        attributes: {
            version: // Additonal context.
            version,
            stepsCount: steps?.length,
            status: status,
            disabled: disabled,
            // Action specific attributes.
            ...otherAttributes
        }
    });
};
const $1a899df20ad45f18$export$91c32f1b22d29b2d = (error)=>{
    if (!error) return 'Unknown error';
    if (error instanceof Error) return `${error.name}: ${error.message}`;
    return String(error);
};
const $1a899df20ad45f18$export$ff269655d7dc6e77 = (errors)=>{
    return errors.map((e)=>$1a899df20ad45f18$export$91c32f1b22d29b2d(e)).join(';');
};


/**
 * Background cleanup logic for expired offline editor databases.
 *
 * This module handles checking all databases from other documents and taking action:
 * - Deletes fully-expired databases
 * - Clears expired data while preserving fresh data
 * - Migrates pre-migration databases by adding timestamps
 */ 



var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $awSMG = parcelRequire("awSMG");


const $e9c926f713f211d2$var$THIRTY_DAYS_MS = 2592000000;
const $e9c926f713f211d2$var$BACKGROUND_CLEANUP_INTERVAL_MS = 86400000;
const $e9c926f713f211d2$var$MAX_DATABASES_PER_CLEANUP = 100; // Cap to prevent performance issues on first load
/**
 * Extract contentId from database name by removing the prefix.
 */ const $e9c926f713f211d2$var$extractContentId = (dbName)=>dbName.replace((0, $awSMG.OFFLINE_STEPS_DATABASE_NAME_PREFIX), '');
function $e9c926f713f211d2$export$365e5e8d6c8a82b3() {
    try {
        if (!(0, $17wUi.confluenceLocalStorageInstance)) return false;
        const lastAttempt = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).EDITOR_OFFLINE_LAST_BACKGROUND_CLEANUP_ATTEMPT);
        if (!lastAttempt) return true;
        const timeSinceLastAttempt = Date.now() - parseInt(lastAttempt, 10);
        return timeSinceLastAttempt > $e9c926f713f211d2$var$BACKGROUND_CLEANUP_INTERVAL_MS;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
        // Storage access failed - return false to skip cleanup (non-critical)
        return false;
    }
}
function $e9c926f713f211d2$export$df49bbb19630c32d() {
    try {
        if (!(0, $17wUi.confluenceLocalStorageInstance)) return;
        (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).EDITOR_OFFLINE_LAST_BACKGROUND_CLEANUP_ATTEMPT, Date.now().toString());
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
    // Storage access failed - continue silently (non-critical)
    }
}
/**
 * Delete an entire database.
 */ async function $e9c926f713f211d2$var$deleteDatabase(dbName) {
    return new Promise((resolve, reject)=>{
        const request = indexedDB.deleteDatabase(dbName);
        request.onsuccess = ()=>resolve();
        request.onerror = ()=>reject(request.error);
        request.onblocked = ()=>resolve();
    });
}
/**
 * Add timestamp to pre-migration data to migrate it.
 */ async function $e9c926f713f211d2$var$addTimestampToMigrateData(database, metaData) {
    const tx = database.transaction((0, $awSMG.OFFLINE_META_STORE_NAME), 'readwrite');
    const metaStore = tx.objectStore((0, $awSMG.OFFLINE_META_STORE_NAME));
    const updatedMetaData = {
        ...metaData || {
            doc: null,
            version: null
        },
        lastUpdated: Date.now()
    };
    await metaStore.put(updatedMetaData, 1);
    await tx.done;
}
async function $e9c926f713f211d2$export$197ab581d971f15a(dbName) {
    try {
        const db = await (0, $ffQ2A.openDB)(dbName, (0, $awSMG.OFFLINE_STEPS_DATABASE_VERSION), {
            upgrade (database) {
                // Create stores if they don't exist
                if (!database.objectStoreNames.contains((0, $awSMG.OFFLINE_STEPS_STORE_NAME))) database.createObjectStore((0, $awSMG.OFFLINE_STEPS_STORE_NAME), {
                    keyPath: 'id',
                    autoIncrement: true
                });
                if (!database.objectStoreNames.contains((0, $awSMG.OFFLINE_META_STORE_NAME))) database.createObjectStore((0, $awSMG.OFFLINE_META_STORE_NAME), {});
            },
            blocking: (_currentVersion, _blockedVersion, event)=>{
                // Close the database connection if the database is deleted or version changes
                // This is important for Firefox compatibility when deleting databases. See HOT-12395 for more details.
                if (event?.target) event.target.close();
            }
        });
        try {
            // Check if both stores exist - if not, database is invalid
            if (!db.objectStoreNames.contains((0, $awSMG.OFFLINE_META_STORE_NAME)) || !db.objectStoreNames.contains((0, $awSMG.OFFLINE_STEPS_STORE_NAME))) {
                db.close();
                await $e9c926f713f211d2$var$deleteDatabase(dbName);
                return {
                    dbName: dbName,
                    deleted: true,
                    reason: 'invalid',
                    errorMessage: 'Database missing required object stores'
                };
            }
            const tx = db.transaction([
                (0, $awSMG.OFFLINE_META_STORE_NAME),
                (0, $awSMG.OFFLINE_STEPS_STORE_NAME)
            ], 'readonly');
            const metaStore = tx.objectStore((0, $awSMG.OFFLINE_META_STORE_NAME));
            const stepsStore = tx.objectStore((0, $awSMG.OFFLINE_STEPS_STORE_NAME));
            const metaData = await metaStore.get(1);
            const stepsCount = await stepsStore.count();
            // Empty database: No meta data AND no steps. Safe to delete.
            if (!metaData && stepsCount === 0) {
                db.close();
                await $e9c926f713f211d2$var$deleteDatabase(dbName);
                return {
                    dbName: dbName,
                    deleted: true,
                    reason: 'empty'
                };
            }
            // Migration: Missing metadata or missing timestamp. Add timestamp and skip deletion.
            if (!metaData || !metaData.lastUpdated) {
                await $e9c926f713f211d2$var$addTimestampToMigrateData(db, metaData);
                return {
                    dbName: dbName,
                    deleted: false,
                    reason: 'migrated'
                };
            }
            // At this point, metaData.lastUpdated is guaranteed to exist (migrated above)
            const currentTimestamp = Date.now();
            const databaseAge = currentTimestamp - metaData.lastUpdated;
            const isExpired = databaseAge > $e9c926f713f211d2$var$THIRTY_DAYS_MS;
            // Expired: Delete entire database.
            if (isExpired) {
                const daysExpired = Math.floor(databaseAge / 86400000);
                const hasBackup = !!metaData.versionInsertionBackup;
                db.close();
                await $e9c926f713f211d2$var$deleteDatabase(dbName);
                return {
                    dbName: dbName,
                    deleted: true,
                    reason: 'expired',
                    daysExpired: daysExpired,
                    stepsCount: stepsCount,
                    hasBackup: hasBackup
                };
            }
            // Not expired: Database is active.
            return {
                dbName: dbName,
                deleted: false,
                reason: 'active'
            };
        } catch (error) {
            return {
                dbName: dbName,
                deleted: false,
                reason: 'error',
                errorMessage: (0, $1a899df20ad45f18$export$91c32f1b22d29b2d)(error)
            };
        } finally{
            db.close();
        }
    } catch (error) {
        // Can't open the database - treat as error case
        return {
            dbName: dbName,
            deleted: false,
            reason: 'error',
            errorMessage: (0, $1a899df20ad45f18$export$91c32f1b22d29b2d)(error)
        };
    }
}
async function $e9c926f713f211d2$export$1419703707730bf4(currentDbName, api) {
    try {
        if (!window.indexedDB.databases) return;
        const allDatabases = await window.indexedDB.databases();
        const offlineEditorDatabases = allDatabases.filter((dbInfo)=>dbInfo.name?.startsWith((0, $awSMG.OFFLINE_STEPS_DATABASE_NAME_PREFIX)) && dbInfo.name !== currentDbName);
        const totalOfflineDatabases = offlineEditorDatabases.length;
        let databasesProcessed = 0;
        let databasesDeleted = 0;
        const cleanupDetails = [];
        // Early exit if no databases to process
        if (totalOfflineDatabases === 0) {
            (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
                api: api,
                action: 'OFFLINE_EDITING_BACKGROUND_CLEANUP_COMPLETED',
                databasesProcessed: 0,
                databasesDeleted: 0,
                totalOfflineDatabases: 0,
                cleanupDetails: []
            });
            return;
        }
        // We randomise the order to ensure all databases eventually get checked. Otherwise, we'd check the first N databases every time.
        // We also cap the number of databases checked per run to prevent performance issues. For power users with large backlogs, cleanup will happen gradually over multiple days.
        const randomisedDatabases = offlineEditorDatabases.sort(()=>Math.random() - 0.5);
        const databasesToCheck = randomisedDatabases.slice(0, $e9c926f713f211d2$var$MAX_DATABASES_PER_CLEANUP);
        for (const dbInfo of databasesToCheck){
            const dbName = dbInfo.name;
            try {
                const result = await $e9c926f713f211d2$export$197ab581d971f15a(dbName);
                databasesProcessed++;
                // Fire analytics for database deletions (expired, empty, or invalid)
                if (result.reason === 'expired' || result.reason === 'empty' || result.reason === 'invalid') {
                    databasesDeleted++;
                    cleanupDetails.push({
                        contentId: $e9c926f713f211d2$var$extractContentId(dbName),
                        deletionReason: result.reason,
                        daysExpired: result.daysExpired ?? 0,
                        stepsCount: result.stepsCount ?? 0,
                        hasBackup: result.hasBackup ?? false
                    });
                }
                // Fire analytics for database check errors
                if (result.reason === 'error') (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
                    api: api,
                    action: 'OFFLINE_EDITING_BACKGROUND_CLEANUP_ERROR',
                    errorMessage: result.errorMessage ?? 'Unknown error',
                    errorSource: 'database_check',
                    contentId: $e9c926f713f211d2$var$extractContentId(dbName),
                    totalOfflineDatabases: totalOfflineDatabases
                });
            } catch (error) {
                databasesProcessed++;
                (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
                    api: api,
                    action: 'OFFLINE_EDITING_BACKGROUND_CLEANUP_ERROR',
                    errorMessage: (0, $1a899df20ad45f18$export$91c32f1b22d29b2d)(error),
                    errorSource: 'database_check',
                    contentId: $e9c926f713f211d2$var$extractContentId(dbName),
                    totalOfflineDatabases: totalOfflineDatabases
                });
            }
        }
        // Fire completion analytics for every cleanup run
        (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
            api: api,
            action: 'OFFLINE_EDITING_BACKGROUND_CLEANUP_COMPLETED',
            databasesProcessed: databasesProcessed,
            databasesDeleted: databasesDeleted,
            totalOfflineDatabases: totalOfflineDatabases,
            cleanupDetails: cleanupDetails
        });
    } catch (error) {
        (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
            api: api,
            action: 'OFFLINE_EDITING_BACKGROUND_CLEANUP_ERROR',
            errorMessage: (0, $1a899df20ad45f18$export$91c32f1b22d29b2d)(error),
            errorSource: 'cleanup_init'
        });
    }
}





const $f0050ff6ee6f7eb3$var$SYNC_LOCK_TIMEOUT_MS = 20000;
const $f0050ff6ee6f7eb3$var$THIRTY_DAYS_MS = 2592000000;
class $f0050ff6ee6f7eb3$export$c7a2e99e9e26da1c {
    // Used to cache the result of the IndexedDB validation.
    onError(_id, error, disabledReason) {
        // Indicate the steps database is not healthy.
        this.api?.core.actions.execute(({ tr: tr })=>tr.setMeta((0, $bcc122a52e0f74cf$export$3b87fd119d006909), {
                disabled: disabledReason ?? 'stepsDatabaseError'
            }));
        (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
            api: this.api,
            action: (0, $d925B.ACTION).OFFLINE_STORAGE_STEPS_DATABASE_ERROR,
            errorMessage: (0, $1a899df20ad45f18$export$91c32f1b22d29b2d)(error),
            errorSource: _id,
            errorCause: {
                contentIdPresent: !!this.contentId,
                stepsDatabaseInitAttempted: this.initAttempted,
                // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
                isSSR: false,
                isIndexedDBAvailable: this.indexedDBAvailable
            }
        });
    }
    /**
   * The name of the database for the current contentId
   */ get dbName() {
        if (!this.contentId) return undefined;
        return `${0, $awSMG.OFFLINE_STEPS_DATABASE_NAME_PREFIX}${this.contentId}`;
    }
    get hasLock() {
        return this.syncLock.hasLock;
    }
    get lockPurpose() {
        return this.syncLock.lockPurpose;
    }
    isLocked() {
        return this.syncLock.isLocked();
    }
    /**
   * Releases the current sync lock. Returns a promise to check if the lock has been released
   * at this point which can be useful if you want to do other operations (ie. update the DB)
   * based on the lock status and need it to be freed.
   *
   * @returns boolean: The result if the sync is still locked.
   */ async releaseSyncLock() {
        this.syncLock.releaseLock?.();
        return this.syncLock.isLocked();
    }
    /**
   * Attempts to acquire a synchronization lock for the database.
   *
   * @param callback - Optional callback function that is called when the lock is acquired or times out.
   *                  The callback receives a boolean indicating if the lock was granted.
   * @param waitUntilAvailable - If true, waits until the lock becomes available. If false, returns immediately.
   * @param timeoutAfterMS - Optional timeout in milliseconds. If provided and waitUntilAvailable is true,
   *                        the callback will be called with false if the lock isn't acquired within this time.
   *                        When platform_editor_offline_editing_web_ga_fixes is cleaned up, this parameter can be removed.
   * @returns A Promise if waiting for the lock, void if not waiting.
   */ acquireSyncLock(callback, waitUntilAvailable = false, purpose, timeoutAfterMS) {
        const lockPromise = this.syncLock.acquireLock(callback, waitUntilAvailable, purpose).catch((e)=>{
            this.onError('acquireSyncLock()', e);
            // Ensure callback is called with false on error
            return callback?.(false);
        });
        // If we're not waiting for the lock, fire-and-forget
        if (!waitUntilAvailable) return;
        const effectiveTimeout = (0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes') ? $f0050ff6ee6f7eb3$var$SYNC_LOCK_TIMEOUT_MS : timeoutAfterMS;
        // If we have a timeout, race the lock acquisition with a timeout. Redundant check when platform_editor_offline_editing_web_ga_fixes is cleaned up.
        if (effectiveTimeout) {
            const timeoutPromise = new Promise((resolve)=>{
                setTimeout(async ()=>{
                    // Callback invoked with granted = false, failed attempt to acquire lock.
                    await callback?.(false);
                    resolve();
                }, effectiveTimeout);
            });
            return Promise.race([
                lockPromise,
                timeoutPromise
            ]);
        }
        return lockPromise;
    }
    /**
   * Initialize the class for the given contentId.
   * Can be re-initialized with a different contentId, which will close an existing connection.
   * Does not open the database connection.
   * @param contentId The unique page contentId
   * @returns true if initialized successfully, false if indexedDB is not supported.
   */ async init(contentId, api) {
        this.initAttempted = true;
        this.api = api;
        if (window?.indexedDB === undefined) {
            this.onError('init()', new Error('indexedDB is not defined'));
            return false;
        }
        if (this.contentId === contentId && this.dbPromise) return true;
        // This closeDB is redundant, as the DB is immedately reopened after init.
        if (!(0, $9wGTI.fg)('platform_editor_offline_editing_web_closedb_init')) await this.closeDB();
        this.contentId = contentId;
        if (this.dbName) this.syncLock.init(this.dbName);
        return true;
    }
    /**
   * Validates IndexedDB access by attempting a test write.
   * @returns Promise<boolean> - true if validation succeeds, false if it fails
   */ async validateIndexedDBAccess() {
        // Check the cached indexedDBAvailable to avoid validating multiple times.
        if (this.indexedDBAvailable !== undefined) return this.indexedDBAvailable ?? true;
        try {
            if (window?.indexedDB === undefined) throw new Error('indexedDB is not defined');
            const testDbName = 'editor:offline-storage-access-test';
            const testDb = await (0, $ffQ2A.openDB)(testDbName, 1, {
                upgrade (database) {
                    database.createObjectStore('test', {
                        autoIncrement: true
                    });
                }
            });
            // Try a test write
            const tx = testDb.transaction('test', 'readwrite');
            const store = tx.objectStore('test');
            await store.add({
                test: 'test'
            });
            await tx.done;
            // Clean up
            testDb.close();
            window.indexedDB.deleteDatabase(testDbName);
            this.indexedDBAvailable = true;
            return true;
        } catch (error) {
            this.onError('validateIndexedDBAccess()', error, 'indexedDBAccessError');
            this.indexedDBAvailable = false;
            return false;
        }
    }
    /**
   * Gets or creates a database connection for the current contentId.
   * If a connection exists, validates it is still usable before returning.
   * If validation fails or no connection exists, creates and returns a new connection.
   *
   * @throws {Error} When dbName is undefined (not initialized – missing contentId, init not called, or in SSR mode)
   * @returns A promise that resolves to a valid database connection
   */ async openDB() {
        if (this.dbName === undefined) throw new Error('StepsDatabase not initialized. Possibly missing contentId, init hasnt been called or rendering in SSR mode.');
        // If we have a cached connection, we validate it with a quick read transaction.
        // If this transaction fails, we close the connection and create a new one.
        if (this.dbPromise) try {
            const db = await this.dbPromise;
            await db.transaction((0, $awSMG.OFFLINE_META_STORE_NAME), 'readonly').objectStore((0, $awSMG.OFFLINE_META_STORE_NAME)).count();
            // Returning the valid cached database connection.
            return this.dbPromise;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        } catch (_error) {
            // Cleanup before creating a new connection.
            await this.closeDB();
        }
        this.dbPromise = (0, $ffQ2A.openDB)(this.dbName, (0, $awSMG.OFFLINE_STEPS_DATABASE_VERSION), {
            upgrade (database) {
                if (!database.objectStoreNames.contains((0, $awSMG.OFFLINE_STEPS_STORE_NAME))) database.createObjectStore((0, $awSMG.OFFLINE_STEPS_STORE_NAME), {
                    keyPath: 'id',
                    autoIncrement: true
                });
                if (!database.objectStoreNames.contains((0, $awSMG.OFFLINE_META_STORE_NAME))) database.createObjectStore((0, $awSMG.OFFLINE_META_STORE_NAME), {});
            },
            terminated: ()=>{
                this.dbPromise = undefined;
            },
            blocking: (_currentVersion, _blockedVersion, event)=>{
                // Close the database connection when version changes or database is deleted
                // This is important for Firefox compatibility when deleting databases. See HOT-12395 for more details.
                if (event?.target) // event.target is the database object that the versionchange event was fired on
                event.target.close();
            }
        });
        return this.dbPromise;
    }
    sanitizeStep(step) {
        if (step instanceof (0, $jy7VG.AnalyticsStep) || step instanceof (0, $8EkET.LinkMetaStep)) return undefined;
        return step.toJSON();
    }
    /**
   * Update the steps, doc and version in the database if the stored steps are different.
   * It does a full clear and replace with the new steps.
   * @param version The collab version for creating unique key/value pairs in the db
   * @param steps The steps to store in the database
   * @returns true if the steps were updated, false if the steps were the same as the stored steps
   */ async updateIfChanged(version, baseDocJSON, steps) {
        try {
            const isLocked = await this.syncLock.isLocked() && !this.hasLock;
            if (isLocked) return false;
            const db = await this.openDB();
            const tx = db.transaction([
                (0, $awSMG.OFFLINE_STEPS_STORE_NAME),
                (0, $awSMG.OFFLINE_META_STORE_NAME)
            ], 'readwrite');
            const stepsStore = (0, $ffQ2A.unwrap)(tx.objectStore((0, $awSMG.OFFLINE_STEPS_STORE_NAME)));
            const docStore = tx.objectStore((0, $awSMG.OFFLINE_META_STORE_NAME));
            // We breakout of idb here. The reason is it ensures we have a single promise
            // for `updateSteps` and ensures `fake-indexeddb` works as intended here.
            // This allows us to test as close as possible to real indexeddb
            const updateSteps = async ()=>{
                await new Promise((resolve, reject)=>{
                    const localSteps = steps.map(this.sanitizeStep).filter((step)=>!!step);
                    const request = stepsStore.clear();
                    request.onsuccess = ()=>{
                        // Store serialized steps in the database
                        let index = 0;
                        const addNextStep = ()=>{
                            if (index < localSteps.length) {
                                const serializedStep = localSteps[index];
                                const addRequest = stepsStore.add({
                                    step: serializedStep
                                });
                                addRequest.onsuccess = ()=>{
                                    index++;
                                    addNextStep();
                                };
                                addRequest.onerror = (event)=>{
                                    reject(event.target?.error);
                                };
                            } else resolve(undefined);
                        };
                        addNextStep();
                    };
                    request.onerror = (event)=>{
                        reject(event.target?.error);
                    };
                });
            };
            await Promise.all([
                updateSteps(),
                // Store the doc, version, and lastUpdated timestamp
                docStore.put({
                    doc: baseDocJSON,
                    version: version,
                    lastUpdated: Date.now()
                }, 1)
            ]);
            await tx.done;
            return true;
        } catch (e) {
            this.onError('updateIfChanged()', e);
            throw e;
        }
    }
    /**
   * Update the stored docJSON and version in the database.
   * This can be called by the leader after applying steps to save the post-apply state for followers.
   * Extracts the confirmed document state and collaboration version from the editor view.
   * @param editorView The editor view to extract document state and version from
   * @returns Promise<boolean> - true if updated successfully, throws on error
   */ async updateDocAndVersion(editorView) {
        try {
            const newVersion = (0, $9NwnH.getCollabState)(editorView.state)?.version;
            if (newVersion === undefined) return false;
            const db = await this.openDB();
            const tx = db.transaction((0, $awSMG.OFFLINE_META_STORE_NAME), 'readwrite');
            const docStore = tx.objectStore((0, $awSMG.OFFLINE_META_STORE_NAME));
            const transformer = new (0, $h9yJL.JSONTransformer)();
            // We use getDocBeforeUnconfirmedSteps to ensure we get the latest _confirmed_ document, as some
            // ... unconfirmed steps may have come through while clearing the offline steps and updating the docJSON.
            const newDocJSON = transformer.encode((0, $9NwnH.getDocBeforeUnconfirmedSteps)(editorView.state));
            // Update doc, version, and lastUpdated timestamp
            const updatedData = {
                doc: newDocJSON,
                version: newVersion,
                lastUpdated: Date.now()
            };
            await docStore.put(updatedData, 1);
            await tx.done;
            return true;
        } catch (e) {
            this.onError('updateDocAndVersion()', e);
            throw e;
        }
    }
    /**
   * Retrieve the steps, doc and version from the database.
   * Will open a new database connection, if one is not already open.
   * @param pmSchema The current ProseMirror schema
   * @returns The steps stored in the database
   */ async getData(pmSchema) {
        try {
            const db = await this.openDB();
            const tx = db.transaction([
                (0, $awSMG.OFFLINE_STEPS_STORE_NAME),
                (0, $awSMG.OFFLINE_META_STORE_NAME)
            ], 'readonly');
            const stepsStore = tx.objectStore((0, $awSMG.OFFLINE_STEPS_STORE_NAME));
            const docStore = tx.objectStore((0, $awSMG.OFFLINE_META_STORE_NAME));
            // Collect all steps
            const collectSteps = async ()=>{
                const steps = await stepsStore.getAll();
                return steps.map((stepJson)=>(0, $cO9ey.Step).fromJSON(pmSchema, stepJson.step));
            };
            const [storedSteps, data] = await Promise.all([
                collectSteps(),
                docStore.get(1)
            ]);
            await tx.done;
            return data === undefined ? {
                steps: storedSteps,
                docJSON: null,
                version: null
            } : {
                steps: storedSteps,
                docJSON: data.doc,
                version: data.version
            };
        } catch (e) {
            this.onError('getData()', e);
            throw e;
        }
    }
    /**
   * Clear all steps, and stored doc from the database
   * Will open a new database connection, if one is not already open.
   */ async clear(all) {
        try {
            const isLocked = await this.syncLock.isLocked() && !this.hasLock;
            if (isLocked) return false;
            const db = await this.openDB();
            const tx = db.transaction([
                (0, $awSMG.OFFLINE_STEPS_STORE_NAME),
                (0, $awSMG.OFFLINE_META_STORE_NAME)
            ], 'readwrite');
            const stepsStore = tx.objectStore((0, $awSMG.OFFLINE_STEPS_STORE_NAME));
            const docStore = tx.objectStore((0, $awSMG.OFFLINE_META_STORE_NAME));
            if (all) await Promise.all([
                stepsStore.clear(),
                docStore.clear()
            ]);
            else await stepsStore.clear();
            await tx.done;
            return true;
        } catch (e) {
            this.onError('clear()', e);
            throw e;
        }
    }
    /**
   * Check and clear expired data from the current document's database.
   * Also triggers background cleanup of other databases (throttled to once per 24 hours).
   * This should be called after init() but before attempting to restore steps.
   */ async checkAndClearExpiredData() {
        if (!(0, $9wGTI.fg)('platform_editor_offline_editing_web_db_expiry')) return;
        // Check and clear current document's expired data
        await this.checkCurrentDocumentExpiry();
        // Run background cleanup of other document's offline databases (non-blocking, throttled)
        if ((0, $e9c926f713f211d2$export$365e5e8d6c8a82b3)()) {
            // Mark attempted immediately to prevent race condition if multiple tabs open simultaneously
            (0, $e9c926f713f211d2$export$df49bbb19630c32d)();
            (0, $e9c926f713f211d2$export$1419703707730bf4)(this.dbName, this.api);
        }
    }
    /**
   * Check if the current document's offline data has expired and clear it if needed.
   * Uses instance methods (this.openDB(), this.clear()) rather than deleting the database entirely.
   * This preserves the database structure and connection since the current document may be
   * actively written to (e.g. user goes offline). Background cleanup of other databases
   * can safely delete them entirely as they have no active StepsDatabase instance.
   *
   * Backwards compatibility: If data exists but no lastUpdated, adds timestamp = now (30-day window starts from today).
   * Expiry: If lastUpdated > 30 days, clears all data via clear(true)
   */ async checkCurrentDocumentExpiry() {
        try {
            const db = await this.openDB();
            // Early exit if the object stores don't exist yet.
            // This is expected for users who haven't used offline storage before.
            if (!db.objectStoreNames.contains((0, $awSMG.OFFLINE_META_STORE_NAME)) || !db.objectStoreNames.contains((0, $awSMG.OFFLINE_STEPS_STORE_NAME))) return;
            const tx = db.transaction([
                (0, $awSMG.OFFLINE_STEPS_STORE_NAME),
                (0, $awSMG.OFFLINE_META_STORE_NAME)
            ], 'readwrite');
            const metaStore = tx.objectStore((0, $awSMG.OFFLINE_META_STORE_NAME));
            const stepsStore = tx.objectStore((0, $awSMG.OFFLINE_STEPS_STORE_NAME));
            const [metaData, stepsCount] = await Promise.all([
                metaStore.get(1),
                stepsStore.count()
            ]);
            if (!metaData) {
                await tx.done;
                return;
            }
            const now = Date.now();
            // Backwards compatibility: If data exists but no lastUpdated timestamp, add current timestamp
            // This starts the 30-day window from today for existing data
            if (!metaData.lastUpdated) {
                const updatedData = {
                    ...metaData,
                    lastUpdated: now
                };
                await metaStore.put(updatedData, 1);
                await tx.done;
                return;
            }
            // Check if data has expired (>30 days old) - single timestamp for all data
            if (now - metaData.lastUpdated > $f0050ff6ee6f7eb3$var$THIRTY_DAYS_MS) {
                await tx.done;
                // Gather analytics metadata
                const hasBackup = !!metaData.versionInsertionBackup;
                const daysExpired = Math.floor((now - metaData.lastUpdated) / 86400000);
                if (this.contentId) (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
                    api: this.api,
                    action: 'OFFLINE_EDITING_DATA_EXPIRY_CLEANUP',
                    contentId: this.contentId,
                    daysExpired: daysExpired,
                    stepsCount: stepsCount,
                    hasBackup: hasBackup
                });
                await this.clear(true);
                return;
            }
            await tx.done;
        } catch (e) {
            this.onError('checkCurrentDocumentExpiry()', e);
        }
    }
    async closeDB(releaseSyncLock = false) {
        try {
            if (this.dbPromise) {
                const db = await this.dbPromise;
                db.close();
                this.dbPromise = undefined;
                if (releaseSyncLock) this.syncLock.releaseLock?.();
            }
        } catch (e) {
            this.onError('closeDB()', e);
            throw e;
        }
    }
    /**
   * Store a version insertion backup for later retry
   * @param adfContent Stringified ADF content that failed to be inserted
   * @returns Promise<boolean> - true if stored successfully
   */ async storeVersionInsertionBackup(adfContent) {
        if (!(0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes')) return false;
        try {
            const db = await this.openDB();
            const tx = db.transaction((0, $awSMG.OFFLINE_META_STORE_NAME), 'readwrite');
            const docStore = tx.objectStore((0, $awSMG.OFFLINE_META_STORE_NAME));
            const existingData = await docStore.get(1);
            // Only store backup if meta store already exists with doc and version
            // If it doesn't exist, there's no document to store a backup for
            if (!existingData || !existingData.doc || existingData.version === undefined) {
                await tx.done;
                return false;
            }
            // Create the backup object (no timestamp - uses shared lastUpdated)
            const versionInsertionBackup = {
                adfContent: adfContent
            };
            // Preserve all existing data and update both versionInsertionBackup and lastUpdated
            const updatedData = {
                ...existingData,
                versionInsertionBackup: versionInsertionBackup,
                lastUpdated: Date.now()
            };
            await docStore.put(updatedData, 1);
            await tx.done;
            return true;
        } catch (e) {
            this.onError('storeVersionInsertionBackup()', e);
            return false;
        }
    }
    /**
   * Get the stored version insertion backup if one exists
   * @returns Promise<VersionInsertionBackup | null>
   */ async getVersionInsertionBackup() {
        if (!(0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes')) return null;
        try {
            const db = await this.openDB();
            // Early exit if the meta store doesn't exist yet.
            // This is expected for users who haven't used offline storage before.
            if (!db.objectStoreNames.contains((0, $awSMG.OFFLINE_META_STORE_NAME))) return null;
            const tx = db.transaction((0, $awSMG.OFFLINE_META_STORE_NAME), 'readonly');
            const docStore = tx.objectStore((0, $awSMG.OFFLINE_META_STORE_NAME));
            const data = await docStore.get(1);
            await tx.done;
            return data?.versionInsertionBackup ?? null;
        } catch (e) {
            this.onError('getVersionInsertionBackup()', e);
            return null;
        }
    }
    /**
   * Clear the stored version insertion backup and update lastUpdated timestamp
   * @returns Promise<boolean> - true if cleared successfully
   */ async clearVersionInsertionBackup() {
        if (!(0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes')) return false;
        try {
            const db = await this.openDB();
            const tx = db.transaction((0, $awSMG.OFFLINE_META_STORE_NAME), 'readwrite');
            const docStore = tx.objectStore((0, $awSMG.OFFLINE_META_STORE_NAME));
            const existingData = await docStore.get(1);
            // If no data exists or no error field exists, nothing to clear
            if (!existingData || !existingData.versionInsertionBackup) {
                await tx.done;
                return true;
            }
            // Remove the versionInsertionBackup field and update timestamp
            const { versionInsertionBackup: _versionInsertionBackup, ...dataWithoutBackup } = existingData;
            await docStore.put({
                ...dataWithoutBackup,
                lastUpdated: Date.now()
            }, 1);
            await tx.done;
            return true;
        } catch (e) {
            this.onError('clearVersionInsertionBackup()', e);
            return false;
        }
    }
    constructor(){
        this.dbPromise = void 0;
        this.contentId = void 0;
        this.syncLock = new (0, $5c049076093b3a44$export$d15eb9e8bb5d03ea)();
        this.api = void 0;
        this.initAttempted = false;
        this.indexedDBAvailable = void 0;
    }
}












var $ke2AI = parcelRequire("ke2AI");

const $8755c63771d651df$export$43d640f3b62db5ab = (editorView)=>{
    const { state: state } = editorView;
    const newState = state.reconfigure({
        plugins: state.plugins.filter((p)=>{
            return p.spec.key !== (0, $ke2AI.history)().spec.key;
        })
    });
    editorView.updateState(newState);
    const { state: updatedState } = editorView;
    const newerState = updatedState.reconfigure({
        plugins: updatedState.plugins.concat((0, $ke2AI.history)())
    });
    editorView.updateState(newerState);
};



const $c71be5c341006c26$export$e38c76da774a8077 = ({ api: api, editorView: editorView, stepsDatabase: stepsDatabase })=>{
    const isBroadcastChannelSupported = window && 'BroadcastChannel' in window;
    const channelRef = (0, $42omo.useRef)();
    const firstChannelUpdateRef = (0, $42omo.useRef)(false);
    const broadcast = (0, $42omo.useCallback)((messageType = 'resync')=>{
        if (channelRef.current) {
            const message = {
                type: messageType
            };
            channelRef.current.postMessage(message);
        }
    }, []);
    const listener = (0, $42omo.useCallback)(async function(event) {
        const { type: type } = event.data;
        if (type !== 'resync' && type !== 'restore') return;
        const { mode: mode } = api?.connectivity?.sharedState.currentState() ?? {};
        // RESYNC: Only proceed when offline. This happens while syncing tabs when offline.
        // RESTORE: Only proceed when online. We restore on initialisation, when we have a connection.
        if (type === 'resync') {
            if (mode !== 'offline') return;
        } else if (type === 'restore') {
            if (mode !== 'online') return;
        }
        const { steps: steps, docJSON: docJSON, version: cachedVersion } = await stepsDatabase.getData(editorView.state.schema);
        if (!docJSON || cachedVersion === null) return;
        // RESYNC: only proceed when there are steps to sync.
        // RESTORE: only proceed when there are no steps to sync. The docJSON should have the cleared steps already applied.
        if (type === 'resync') {
            if (!steps) return;
        } else if (type === 'restore') {
            if (steps && steps.length > 0) return;
        }
        if (!firstChannelUpdateRef.current) {
            (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
                api: api,
                action: (0, $d925B.ACTION).OFFLINE_STORAGE_BROADCAST_CHANNEL_FIRST_UPDATE
            });
            firstChannelUpdateRef.current = true;
        }
        const historyState = api?.history?.sharedState?.currentState?.();
        const hasHistory = (historyState?.done?.eventCount ?? 0) > 0 || (historyState?.undone?.eventCount ?? 0) > 0;
        if (hasHistory) (0, $8755c63771d651df$export$43d640f3b62db5ab)(editorView);
        const tr = (0, $9NwnH.syncFromAnotherSource)(editorView.state, cachedVersion, docJSON, steps);
        if (hasHistory && api?.history?.commands.updatePluginState) api.history.commands.updatePluginState({
            tr: tr
        });
        editorView.dispatch(tr);
    }, [
        api,
        editorView,
        stepsDatabase
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!isBroadcastChannelSupported || !stepsDatabase.dbName) return;
        channelRef.current = new BroadcastChannel(stepsDatabase.dbName);
        channelRef.current.addEventListener('message', listener);
        return ()=>{
            if (channelRef.current) {
                channelRef.current.removeEventListener('message', listener);
                channelRef.current.close();
            }
        };
    }, [
        isBroadcastChannelSupported,
        stepsDatabase.dbName,
        listener
    ]);
    return broadcast;
};












function $85a440c10c4579b2$export$199006561aceceef() {
    return ({ tr: tr })=>{
        tr.setMeta('addToHistory', false);
        tr.setMeta((0, $bcc122a52e0f74cf$export$3b87fd119d006909), {
            status: 'ready'
        });
        return tr;
    };
}
function $85a440c10c4579b2$export$415f09fb1d3d2a43(steps, api) {
    return ({ tr: tr })=>{
        const failedSteps = [];
        steps.forEach((step)=>{
            try {
                tr.step(step);
            } catch (e) {
                // step failed to apply, ignore it and attempt to apply other steps
                failedSteps.push({
                    step: step,
                    error: e
                });
            }
        });
        if (failedSteps.length > 0) (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
            api: api,
            action: (0, $d925B.ACTION).OFFLINE_STORAGE_FAILED_STEPS,
            errorInfo: (0, $1a899df20ad45f18$export$ff269655d7dc6e77)(failedSteps.map((s)=>s.error)),
            stepsCount: failedSteps.length
        });
        tr.setMeta('addToHistory', false);
        tr.setMeta((0, $bcc122a52e0f74cf$export$3b87fd119d006909), {
            status: 'ready'
        });
        return tr;
    };
}
function $85a440c10c4579b2$export$14dd948c471b3773() {
    return ({ tr: tr })=>{
        tr.setMeta('addToHistory', false);
        tr.setMeta((0, $bcc122a52e0f74cf$export$3b87fd119d006909), {
            status: 'tooManyRetries'
        });
        return tr;
    };
}
function $85a440c10c4579b2$export$e62d02f588ae224b(inactiveSyncing) {
    return ({ tr: tr })=>{
        tr.setMeta('addToHistory', false);
        tr.setMeta((0, $bcc122a52e0f74cf$export$3b87fd119d006909), {
            inactiveSyncing: inactiveSyncing
        });
        return tr;
    };
}



const $9ea4175711f7ca12$var$MAX_APPLY_ATTEMPTS = 3;
const $9ea4175711f7ca12$export$33afc5c2570a827c = (status, granted)=>{
    switch(status){
        case 'init':
            return granted ? 'leader_granted' : 'follower_waiting'; // First tab becomes leader
        case 'follower_waiting':
            return granted ? 'follower_granted' : 'follower_waiting';
        case 'leader_granted':
        case 'follower_granted':
            return status;
    }
};
const $9ea4175711f7ca12$var$recreateOfflineDoc = (jsonDoc, steps, pmSchema)=>{
    try {
        let doc = pmSchema.nodeFromJSON(jsonDoc);
        steps.forEach((step)=>{
            const res = step.apply(doc);
            if (!res.failed && res.doc) doc = res.doc;
        });
        return doc;
    } catch  {
        // TODO: Follow-up error handling
        return undefined;
    }
};
async function $9ea4175711f7ca12$export$5328e866ce5f6eff(api, stepsDatabase, pmSchema, options) {
    try {
        const { steps: steps, docJSON: docJSON } = await stepsDatabase.getData(pmSchema);
        if (steps.length > 0) {
            if (docJSON) {
                const offlineDoc = $9ea4175711f7ca12$var$recreateOfflineDoc(docJSON, steps, pmSchema);
                if (offlineDoc) options?.createOfflineVersion?.({
                    doc: offlineDoc,
                    steps: steps
                });
            }
            const dispatched = api?.core.actions.execute((0, $85a440c10c4579b2$export$415f09fb1d3d2a43)(steps, api));
            if (!dispatched) return false;
        }
        return true;
    } catch  {
        return false;
    }
}
async function $9ea4175711f7ca12$export$272cc1d3c48af723(api, stepsDatabase) {
    api?.core.actions.execute((0, $85a440c10c4579b2$export$199006561aceceef)());
    await stepsDatabase.releaseSyncLock();
    api?.core.actions.execute((0, $85a440c10c4579b2$export$e62d02f588ae224b)(false));
}
async function $9ea4175711f7ca12$export$8d012bece2dd72ad(api, stepsDatabase, pmSchema, options) {
    let attempts = 0;
    while(attempts < $9ea4175711f7ca12$var$MAX_APPLY_ATTEMPTS){
        const hasSyncSucceeded = await $9ea4175711f7ca12$export$5328e866ce5f6eff(api, stepsDatabase, pmSchema, {
            createOfflineVersion: options?.createOfflineVersion
        });
        if (hasSyncSucceeded) // The leader tab relies on the usePluginHook to release their lock and clear the steps from the DB.
        // We do not set the leader as "syncing", so we do not need to call setInactiveSyncingCommand(false).
        return;
        else {
            // Allow 1 second between attempts.
            await new Promise((resolve)=>setTimeout(resolve, 1000));
            attempts++;
        }
    }
    // If we get here, leader path failed after all attempts.
    await $9ea4175711f7ca12$export$272cc1d3c48af723(api, stepsDatabase);
}
async function $9ea4175711f7ca12$export$2685e1bc42d6db28(api, stepsDatabase) {
    // Wait 2 seconds before allowing the follower to complete, as sometimes it can complete too quickly, making the banner flash briefly.
    await new Promise((resolve)=>setTimeout(resolve, 2000));
    api?.core.actions.execute((0, $85a440c10c4579b2$export$199006561aceceef)());
    await stepsDatabase.releaseSyncLock();
    api?.core.actions.execute((0, $85a440c10c4579b2$export$e62d02f588ae224b)(false));
}
async function $9ea4175711f7ca12$export$7ac1d860e1e72b3d(api, stepsDatabase, pmSchema) {
    let attempts = 0;
    while(attempts < $9ea4175711f7ca12$var$MAX_APPLY_ATTEMPTS){
        const hasSyncSucceeded = await $9ea4175711f7ca12$export$5328e866ce5f6eff(api, stepsDatabase, pmSchema);
        if (hasSyncSucceeded) {
            await $9ea4175711f7ca12$export$2685e1bc42d6db28(api, stepsDatabase);
            return;
        } else {
            // Allow 1 second between attempts.
            await new Promise((resolve)=>setTimeout(resolve, 1000));
            attempts++;
        }
    }
    // If we get here, follower path failed after all attempts.
    await $9ea4175711f7ca12$export$272cc1d3c48af723(api, stepsDatabase);
}
async function $9ea4175711f7ca12$export$5c6efac8a19ad9f7(api, stepsDatabase, lockCallback) {
    const LOCK_TIMEOUT = 20000; // Wait for the lock, but only up to 20 seconds.
    api?.core.actions.execute((0, $85a440c10c4579b2$export$e62d02f588ae224b)(true));
    // TODO: Remove the timeoutAfterMS param after cleaning up the platform_editor_offline_editing_web_ga_fixes gate. All sync lock acquisitions have an expiration timer now.
    await stepsDatabase.acquireSyncLock(lockCallback, true, 'restore', LOCK_TIMEOUT);
}
function $9ea4175711f7ca12$export$f0123301da84dec0(api, stepsDatabase, pmSchema, options) {
    let status = 'init';
    let previousStatus = 'init';
    const callback = async (granted)=>{
        previousStatus = status;
        status = $9ea4175711f7ca12$export$33afc5c2570a827c(status, granted);
        // If we're transitioning to the same state, we might be in a loop. For example, if the follower is stuck in a loop of follower_waiting -> follower_waiting.
        if (status === previousStatus) {
            await $9ea4175711f7ca12$export$272cc1d3c48af723(api, stepsDatabase);
            return;
        }
        switch(status){
            case 'leader_granted':
                await $9ea4175711f7ca12$export$8d012bece2dd72ad(api, stepsDatabase, pmSchema, options);
                break;
            case 'follower_waiting':
                await $9ea4175711f7ca12$export$5c6efac8a19ad9f7(api, stepsDatabase, callback);
                break;
            case 'follower_granted':
                await $9ea4175711f7ca12$export$7ac1d860e1e72b3d(api, stepsDatabase, pmSchema);
                break;
        }
    };
    return callback;
}


const $576038989d33c4bf$var$MAX_RETRIES = 2;
const $576038989d33c4bf$var$RETRY_DELAY = 1000;
async function $576038989d33c4bf$export$68ef7af6a41f5e44(stepsDatabase, pmSchema) {
    // If there's an error, the validateIndexedDBAccess will disable the plugin.
    const isIndexedDBAvailable = await stepsDatabase.validateIndexedDBAccess();
    if (!isIndexedDBAvailable) return false;
    const databases = await window.indexedDB.databases();
    const dbExists = Boolean(databases.find((db)=>db.name === stepsDatabase.dbName));
    if (!dbExists) return false;
    // If there are steps, we need to restore them.
    const { steps: steps } = await stepsDatabase.getData(pmSchema);
    if (steps.length > 0) return true;
    return false;
}
async function $576038989d33c4bf$export$d647a8cf160c7fa9(api, stepsDatabase, editorView, pmSchema, retryCount, error) {
    if (retryCount >= $576038989d33c4bf$var$MAX_RETRIES) {
        api?.core.actions.execute((0, $85a440c10c4579b2$export$14dd948c471b3773)());
        (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
            api: api,
            action: (0, $d925B.ACTION).OFFLINE_STORAGE_TOO_MANY_RETRIES_ERROR,
            errorMessage: `Exceeded max retries (${$576038989d33c4bf$var$MAX_RETRIES}) with delay of ${$576038989d33c4bf$var$RETRY_DELAY}ms`,
            errorInfo: (0, $1a899df20ad45f18$export$91c32f1b22d29b2d)(error),
            maxRetries: $576038989d33c4bf$var$MAX_RETRIES,
            retrySource: 'isStepsRestoreRequired'
        });
        return;
    }
    await new Promise((resolve)=>setTimeout(resolve, $576038989d33c4bf$var$RETRY_DELAY));
    $576038989d33c4bf$export$312d5d76abf7691a(api, stepsDatabase, editorView, retryCount + 1)(pmSchema);
}
function $576038989d33c4bf$export$312d5d76abf7691a(api, stepsDatabase, editorView, retryCount = 0, options) {
    return async (pmSchema)=>{
        try {
            const shouldRestore = await $576038989d33c4bf$export$68ef7af6a41f5e44(stepsDatabase, pmSchema);
            if (!shouldRestore) {
                api?.core.actions.execute((0, $85a440c10c4579b2$export$199006561aceceef)());
                return;
            }
        } catch (error) {
            await $576038989d33c4bf$export$d647a8cf160c7fa9(api, stepsDatabase, editorView, pmSchema, retryCount, error);
            return;
        }
        (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
            api: api,
            action: (0, $d925B.ACTION).OFFLINE_STORAGE_RESTORE_STEPS_INITIATED,
            retryCount: retryCount
        });
        const lockCallback = (0, $9ea4175711f7ca12$export$f0123301da84dec0)(api, stepsDatabase, pmSchema, options);
        stepsDatabase.acquireSyncLock(lockCallback, false, 'restore');
    };
}



var $8Yfbq = parcelRequire("8Yfbq");





const $a5de712ae25052da$export$4abb9cd0bdff89ec = async ({ editorView: editorView, stepsDatabase: stepsDatabase, version: version, steps: steps, broadcast: broadcast })=>{
    const baseDocJSON = (0, $9NwnH.getDocBeforeUnconfirmedSteps)(editorView.state).toJSON();
    const hasChanged = await stepsDatabase.updateIfChanged(version, baseDocJSON, steps);
    if (hasChanged) broadcast();
    else editorView.dispatch(editorView.state.tr.setMeta((0, $bcc122a52e0f74cf$export$3b87fd119d006909), {
        disabled: 'unableToSync'
    }));
};
const $a5de712ae25052da$export$fed59d57957883a7 = (0, (/*@__PURE__*/$parcel$interopDefault($8Yfbq)))($a5de712ae25052da$export$4abb9cd0bdff89ec, 200);


















var $h3X17 = parcelRequire("h3X17");













const $de973e9ead6dfe2c$var$ENABLE_EDITOR_TIMEOUT = 3000;
const $de973e9ead6dfe2c$export$33afc5c2570a827c = (status, granted)=>{
    switch(status){
        case 'init':
            return granted ? 'granted_initial' : 'waiting_initial';
        case 'waiting_initial':
        case 'waiting_recovery':
            return granted ? 'granted_recovery' : 'waiting_recovery';
        case 'granted_initial':
        case 'granted_recovery':
        default:
            return status;
    }
};
const $de973e9ead6dfe2c$export$b79afd6d47f11781 = (api)=>{
    const historyState = api?.history?.sharedState?.currentState?.();
    return (historyState?.done?.eventCount ?? 0) > 0 || (historyState?.undone?.eventCount ?? 0) > 0;
};
async function $de973e9ead6dfe2c$export$5ac754b16bef384(api, stepsDatabase, editorView, isActiveTab, options) {
    if ((0, $91bcx.isOfflineMode)(api?.connectivity?.sharedState.currentState()?.mode)) return;
    let status = 'init';
    let previousStatus = 'init';
    const lockCallback = async (granted)=>{
        previousStatus = status;
        status = $de973e9ead6dfe2c$export$33afc5c2570a827c(status, granted);
        // If we're transitioning to the same state, we might be in a loop.
        // This can happen if repeated timeouts occur (e.g., waiting_recovery -> waiting_recovery).
        if ((0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes')) {
            if (status === previousStatus) {
                // Fallback: enable the editor and give up on syncing
                api?.core?.actions?.execute((0, $85a440c10c4579b2$export$e62d02f588ae224b)(false));
                return;
            }
        }
        const { steps: steps, docJSON: docJSON, version: version } = await stepsDatabase.getData(editorView?.state?.schema);
        const sendResyncAnalytics = ()=>{
            (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
                api: api,
                action: (0, $d925B.ACTION).OFFLINE_STORAGE_RESYNC_ONLINE,
                resyncStatus: status,
                isActiveTab: isActiveTab
            });
        };
        const unconfirmedSteps = (0, $9NwnH.getCollabState)(editorView.state)?.unconfirmed ?? [];
        switch(status){
            case 'granted_initial':
                if (steps.length > 0) {
                    sendResyncAnalytics();
                    // Clear offline lock on unconfirmed steps
                    unconfirmedSteps.forEach((s)=>{
                        if (s.origin instanceof (0, $ks2lK.Transaction)) {
                            s.origin.setMeta('isOffline', false);
                            s.origin.setMeta('wasOffline', true);
                        }
                    });
                    // Create the offline version based on a snapshot of the doc at the time of returning online
                    options.createOfflineVersion?.({
                        doc: editorView.state.doc,
                        steps: unconfirmedSteps.map((s)=>s.step)
                    });
                    setTimeout(()=>{
                        api?.core?.actions?.execute((0, $85a440c10c4579b2$export$e62d02f588ae224b)(false));
                    }, $de973e9ead6dfe2c$var$ENABLE_EDITOR_TIMEOUT);
                } else if (docJSON && version !== null && unconfirmedSteps.length !== 0) {
                    // So we're here because another tab has already synced but the steps in the DB have been deleted
                    // In this case we revert to the document before going offline and allow collab to resync us
                    sendResyncAnalytics();
                    if ($de973e9ead6dfe2c$export$b79afd6d47f11781(api)) (0, $8755c63771d651df$export$43d640f3b62db5ab)(editorView);
                    const tr = (0, $9NwnH.syncFromAnotherSource)(editorView.state, version, docJSON, []);
                    (0, $85a440c10c4579b2$export$e62d02f588ae224b)(true)({
                        tr: tr
                    });
                    (0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes') && (0, $h3X17.tintDirtyTransaction)(tr);
                    editorView.dispatch(tr);
                    stepsDatabase.acquireSyncLock(lockCallback, true, 'resync');
                } else // At this point we've synced and can enable the editor
                setTimeout(()=>{
                    api?.core?.actions?.execute((0, $85a440c10c4579b2$export$e62d02f588ae224b)(false));
                }, $de973e9ead6dfe2c$var$ENABLE_EDITOR_TIMEOUT);
                break;
            case 'waiting_initial':
                // Reset to base document so we don't duplicate the unconfirmed steps, when we come back online we'll sync with the latest changes
                if (docJSON && version !== null && unconfirmedSteps?.length !== 0) {
                    sendResyncAnalytics();
                    if ($de973e9ead6dfe2c$export$b79afd6d47f11781(api)) (0, $8755c63771d651df$export$43d640f3b62db5ab)(editorView);
                    const tr = (0, $9NwnH.syncFromAnotherSource)(editorView.state, version, docJSON, []);
                    (0, $85a440c10c4579b2$export$e62d02f588ae224b)(true)({
                        tr: tr
                    });
                    editorView.dispatch(tr);
                    stepsDatabase.acquireSyncLock(lockCallback, true, 'resync');
                }
                break;
            case 'granted_recovery':
                if (steps.length > 0 && docJSON && version !== null) {
                    sendResyncAnalytics();
                    if ($de973e9ead6dfe2c$export$b79afd6d47f11781(api)) (0, $8755c63771d651df$export$43d640f3b62db5ab)(editorView);
                    editorView.dispatch((0, $9NwnH.syncFromAnotherSource)(editorView.state, version, docJSON, steps));
                }
                setTimeout(()=>{
                    api?.core?.actions?.execute((0, $85a440c10c4579b2$export$e62d02f588ae224b)(false));
                }, $de973e9ead6dfe2c$var$ENABLE_EDITOR_TIMEOUT);
                break;
            case 'waiting_recovery':
                if (steps.length > 0 && docJSON && version !== null) sendResyncAnalytics();
                api?.core?.actions?.execute((0, $85a440c10c4579b2$export$e62d02f588ae224b)(false));
                stepsDatabase.acquireSyncLock(lockCallback, true, 'resync');
                break;
            default:
                break;
        }
    };
    stepsDatabase.acquireSyncLock(lockCallback, false, 'resync');
}




/**
 * @generated SignedSource<<2346bf19c45d4aa66630d2a693e94f0b>>
 * @relayHash 147cfb56caf40781fcb1a06a43b2650f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e2044cc1d4d9be7cb653dcf45f27af1fd0edc7eddcd49f51b760e768099e55e0
const $80824365c2b7ecec$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "adfContent"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "versionComment"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "adfContent",
                            "variableName": "adfContent"
                        },
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "versionComment",
                            "variableName": "versionComment"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "ConfluenceInsertOfflineVersionPayload",
            "kind": "LinkedField",
            "name": "confluence_insertOfflineVersion",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "versionNumber"
                },
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useCreateOfflineVersionInsertVersionMutation",
            "selections": v4 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useCreateOfflineVersionInsertVersionMutation",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "147cfb56caf40781fcb1a06a43b2650f",
            "id": "e2044cc1d4d9be7cb653dcf45f27af1fd0edc7eddcd49f51b760e768099e55e0",
            "metadata": {},
            "name": "useCreateOfflineVersionInsertVersionMutation",
            "operationKind": "mutation",
            "text": "mutation useCreateOfflineVersionInsertVersionMutation($cloudId:ID!,$contentId:ID!,$adfContent:String!,$versionComment:String!){confluence_insertOfflineVersion(cloudId:$cloudId,input:{contentId:$contentId,adfContent:$adfContent,versionComment:$versionComment}){versionNumber,success,errors{message}}}"
        }
    };
}();
$80824365c2b7ecec$var$node.hash = "116628d327fa315abf5c5c89f4dd52a8";
var $80824365c2b7ecec$export$2e2bcd8739ae039 = $80824365c2b7ecec$var$node;























var $bQm3c = parcelRequire("bQm3c");


var $308Wd = parcelRequire("308Wd");









var $3sFtD = parcelRequire("3sFtD");


var $744ND = parcelRequire("744ND");

const $bf60d5cebe6d196a$var$i18n = (0, $h82at.defineMessages)({
    errorTitle: {
        id: "editor-offline-storage.version-insertion-error-flag.title",
        defaultMessage: "Error saving version history"
    },
    errorTitleRetry: {
        id: "editor-offline-storage.version-insertion-error-flag.title-retry",
        defaultMessage: "Failed to save"
    },
    errorDescription: {
        id: "editor-offline-storage.version-insertion-error-flag.description",
        defaultMessage: "We couldn't save a version history of your offline edits. Your changes are safe, but if you want a backup please try again."
    },
    errorDescriptionRetry: {
        id: "editor-offline-storage.version-insertion-error-flag.description-retry",
        defaultMessage: "We're still having trouble saving a version history of your offline edits. Please try again."
    },
    retryButton: {
        id: "editor-offline-storage.version-insertion-error-flag.retry-button",
        defaultMessage: "Try again"
    },
    successTitle: {
        id: "editor-offline-storage.version-insertion-success-flag.title",
        defaultMessage: "Version history saved"
    },
    successDescription: {
        id: "editor-offline-storage.version-insertion-success-flag.description",
        defaultMessage: "Your offline edits have been saved to version history."
    }
});
const $bf60d5cebe6d196a$var$ERROR_FLAG_ID = 'version-insertion-error-flag';
const $bf60d5cebe6d196a$var$SUCCESS_FLAG_ID = 'version-insertion-success-flag';
const $bf60d5cebe6d196a$export$ac18e6e44f1970de = (flags, intl, onRetry, onClose, manualRetryCount)=>{
    if (!flags) return;
    flags.showCustomFlag({
        id: $bf60d5cebe6d196a$var$ERROR_FLAG_ID,
        title: intl.formatMessage(manualRetryCount > 0 ? $bf60d5cebe6d196a$var$i18n.errorTitleRetry : $bf60d5cebe6d196a$var$i18n.errorTitle),
        description: intl.formatMessage(manualRetryCount > 0 ? $bf60d5cebe6d196a$var$i18n.errorDescriptionRetry : $bf60d5cebe6d196a$var$i18n.errorDescription),
        customIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($744ND))), {
            color: "var(--ds-icon, #292A2E)",
            label: ""
        }),
        actions: [
            {
                content: intl.formatMessage($bf60d5cebe6d196a$var$i18n.retryButton),
                onClick: onRetry
            }
        ],
        onClose: onClose
    });
};
const $bf60d5cebe6d196a$export$fda504c08c17a634 = (flags, intl)=>{
    if (!flags) return;
    flags.showCustomFlag({
        id: $bf60d5cebe6d196a$var$SUCCESS_FLAG_ID,
        title: intl.formatMessage($bf60d5cebe6d196a$var$i18n.successTitle),
        description: intl.formatMessage($bf60d5cebe6d196a$var$i18n.successDescription),
        customIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
            color: "var(--ds-icon-success, #6A9A23)",
            label: ""
        })
    });
};
const $bf60d5cebe6d196a$export$2e84f8b8ade6c591 = (flags)=>{
    if (!flags) return;
    flags.hideFlag($bf60d5cebe6d196a$var$ERROR_FLAG_ID);
};


const $185ed3c8b342a5b9$var$i18n = (0, $h82at.defineMessages)({
    VersionComment: {
        id: "editor-offline-storage.offline-version-comment",
        defaultMessage: "Offline edits"
    },
    VersionCommentManualRetry: {
        id: "editor-offline-storage.offline-version-comment-manual-retry",
        defaultMessage: "Offline edits (manual retry)"
    }
});
// Tech-spec:
// https://hello.atlassian.net/wiki/spaces/~712020fa3d29df95e344e18f663fa84c3d65c8/pages/5567284738/Tech+Spec+Version+History+Creation+API+with+Offline+Copy
const $185ed3c8b342a5b9$var$EditorOfflineStorageInsertOfflineVersionMutation = (0, $80824365c2b7ecec$export$2e2bcd8739ae039);
// Limit how often we can try to create new versions
// P50 disconnection time is ~7 seconds so this tries to minimise new versions
// if someone's connection is flaky.
const $185ed3c8b342a5b9$var$MAX_INTERVAL = 20000;
const $185ed3c8b342a5b9$export$a47b53017b47e379 = ({ contentId: contentId, api: api, stepsDatabase: stepsDatabase, flags: flags })=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const intl = (0, $1cfRh.default)();
    const manualRetryCountRef = (0, $42omo.useRef)(0);
    const [createOfflineVersion] = (0, $308Wd.useMutationInterop)($185ed3c8b342a5b9$var$EditorOfflineStorageInsertOfflineVersionMutation);
    const createVersionUnthrottled = (0, $42omo.useCallback)(({ cloudId: paramCloudId, contentId: paramContentId, adfContent: adfContent, versionComment: versionComment })=>{
        // Create onRetry callback that will be reused for both error paths
        const onRetry = ()=>{
            if (!flags) return;
            // Increment manual retry count when user clicks retry
            manualRetryCountRef.current += 1;
            (0, $bf60d5cebe6d196a$export$2e84f8b8ade6c591)(flags);
            createVersionUnthrottled({
                cloudId: paramCloudId,
                contentId: paramContentId,
                adfContent: adfContent,
                versionComment: intl.formatMessage($185ed3c8b342a5b9$var$i18n.VersionCommentManualRetry)
            });
        };
        const onClose = ()=>{
            (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
                api: api,
                action: 'OFFLINE_EDITING_VERSION_INSERTION_ERROR_FLAG_DISMISSED',
                manualRetryCount: manualRetryCountRef.current
            });
        };
        createOfflineVersion({
            variables: {
                cloudId: paramCloudId,
                contentId: paramContentId,
                adfContent: adfContent,
                versionComment: versionComment
            }
        }).then(async (res)=>{
            const errors = res.data?.confluence_insertOfflineVersion?.errors;
            if (errors && errors.length > 0) {
                (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
                    api: api,
                    action: 'OFFLINE_EDITING_FAILED_STORE_RECOVERY_VERSION',
                    errorMessage: errors.map((err)=>err.message).join(','),
                    manualRetryCount: manualRetryCountRef.current
                });
                // Store the backup and show flag for later retry
                if ((0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes')) {
                    await stepsDatabase.storeVersionInsertionBackup(adfContent);
                    if (flags && paramContentId) (0, $bf60d5cebe6d196a$export$ac18e6e44f1970de)(flags, intl, onRetry, onClose, manualRetryCountRef.current);
                }
                return;
            }
            (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
                api: api,
                action: 'OFFLINE_EDITING_SUCCESS_STORE_RECOVERY_VERSION',
                success: res.data?.confluence_insertOfflineVersion?.success,
                manualRetryCount: manualRetryCountRef.current
            });
            // Show success flag only after manual retries
            if (manualRetryCountRef.current > 0 && flags) (0, $bf60d5cebe6d196a$export$fda504c08c17a634)(flags, intl);
            // Reset manual retry count on success
            manualRetryCountRef.current = 0;
            // Clear the stored backup on any successful version insertion
            if ((0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes')) await stepsDatabase.clearVersionInsertionBackup();
        }).catch(async (e)=>{
            (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
                api: api,
                action: 'OFFLINE_EDITING_FAILED_STORE_RECOVERY_VERSION',
                errorMessage: (0, $1a899df20ad45f18$export$91c32f1b22d29b2d)(e),
                manualRetryCount: manualRetryCountRef.current
            });
            // Store the backup and show flag for later retry
            if ((0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes')) {
                await stepsDatabase.storeVersionInsertionBackup(adfContent);
                if (flags && paramContentId) (0, $bf60d5cebe6d196a$export$ac18e6e44f1970de)(flags, intl, onRetry, onClose, manualRetryCountRef.current);
            }
        });
    }, [
        createOfflineVersion,
        api,
        stepsDatabase,
        flags,
        intl
    ]);
    /**
   * Manually retry version insertion with stored backup content
   * Hides the flag and calls the core createVersionUnthrottled function
   */ const manualRetryCreateVersion = (0, $42omo.useCallback)((storedAdfContent)=>{
        if (!contentId || !flags) return;
        (0, $bf60d5cebe6d196a$export$2e84f8b8ade6c591)(flags);
        createVersionUnthrottled({
            cloudId: cloudId,
            contentId: contentId,
            adfContent: storedAdfContent,
            versionComment: intl.formatMessage($185ed3c8b342a5b9$var$i18n.VersionCommentManualRetry)
        });
    }, [
        contentId,
        cloudId,
        flags,
        intl,
        createVersionUnthrottled
    ]);
    const throttledCreateVersion = (0, $42omo.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($8Yfbq)))(createVersionUnthrottled, $185ed3c8b342a5b9$var$MAX_INTERVAL, {
            leading: true,
            trailing: false
        }), [
        createVersionUnthrottled
    ]);
    return {
        createVersion: (0, $42omo.useCallback)(({ doc: doc, steps: steps })=>{
            // Only create a new version if there are document changes
            // To avoid noisy versions we filter out any non-ReplaceSteps
            // Ignore ReplaceAroundSteps and other steps that aren't as likely to be intended by the user
            // Note: This is a best-effort approach and may not cover all cases
            if (steps.filter((s)=>s instanceof (0, $aXG5V.ReplaceStep)).length === 0) return;
            if (!contentId) {
                (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
                    api: api,
                    action: 'OFFLINE_EDITING_FAILED_STORE_RECOVERY_VERSION',
                    errorMessage: 'No content id',
                    manualRetryCount: 0
                });
                return;
            }
            const adfContent = new (0, $h9yJL.JSONTransformer)().encode(doc);
            throttledCreateVersion({
                cloudId: cloudId,
                contentId: contentId,
                adfContent: JSON.stringify(adfContent),
                versionComment: intl.formatMessage($185ed3c8b342a5b9$var$i18n.VersionComment)
            });
        }, [
            api,
            contentId,
            throttledCreateVersion,
            cloudId,
            intl
        ]),
        manualRetryCreateVersion: manualRetryCreateVersion
    };
};


/**
 * `usePluginStateEffect` has a debounce - we avoid that here to ensure we
 * catch all states on a critical piece of code
 *
 * @param api
 * @param cb
 */ const $93f027f3fd7090c3$var$useConnectivityEffect = (api, cb)=>{
    // Get the latest effect similar to `usePluginStateEffect` (no debounce)
    const latestEffect = (0, $42omo.useRef)(cb);
    (0, $42omo.useLayoutEffect)(()=>{
        latestEffect.current = cb;
        return ()=>{
            latestEffect.current = undefined;
        };
    }, [
        cb
    ]);
    (0, $42omo.useLayoutEffect)(()=>{
        return api?.connectivity?.sharedState.onChange(({ prevSharedState: prevSharedState, nextSharedState: nextSharedState })=>{
            latestEffect.current?.({
                prevMode: prevSharedState?.mode,
                nextMode: nextSharedState?.mode
            });
        });
    }, [
        api
    ]);
};
const $93f027f3fd7090c3$export$68f4c8eca02a72d7 = ({ api: api, editorView: editorView, stepsDatabase: stepsDatabase, broadcastUpdate: broadcastUpdate, contentId: contentId, flags: flags })=>{
    const { createVersion: createOfflineVersion } = (0, $185ed3c8b342a5b9$export$a47b53017b47e379)({
        contentId: contentId,
        api: api,
        stepsDatabase: stepsDatabase,
        flags: flags
    });
    const isActivelySyncing = (0, $42omo.useRef)(false);
    $93f027f3fd7090c3$var$useConnectivityEffect(api, ({ prevMode: prevMode, nextMode: nextMode })=>{
        const { status: status, disabled: disabled } = (0, $bcc122a52e0f74cf$export$3b87fd119d006909).getState(editorView.state) ?? {};
        if (status !== 'ready' || disabled) return;
        // Only allow one sync at a time. This is to avoid flickering of the connection status causing online and offline resyncs to run at the same time.
        if (isActivelySyncing.current) return;
        isActivelySyncing.current = true;
        if ((0, $91bcx.isOfflineMode)(prevMode) && nextMode === 'online') {
            // Try to prioritise the "active" tab by delaying the inactive tabs, this is to minimise
            // our chance of disrupting the user by the reset
            if (document && !document?.hasFocus?.()) // Give the active document ~1s to connect
            setTimeout(()=>(0, $de973e9ead6dfe2c$export$5ac754b16bef384)(api, stepsDatabase, editorView, false, {
                    createOfflineVersion: createOfflineVersion
                }).finally(()=>{
                    isActivelySyncing.current = false;
                }), document?.visibilityState === 'visible' ? 500 : 1000);
            else (0, $de973e9ead6dfe2c$export$5ac754b16bef384)(api, stepsDatabase, editorView, true, {
                createOfflineVersion: createOfflineVersion
            }).finally(()=>{
                isActivelySyncing.current = false;
            });
        } else if ((0, $91bcx.isOfflineMode)(nextMode)) stepsDatabase.validateIndexedDBAccess().then((isIndexedDBAvailable)=>{
            if (isIndexedDBAvailable) stepsDatabase.clear(true).then(async (cleared)=>{
                if (cleared) await stepsDatabase.releaseSyncLock?.();
            }).finally(()=>{
                // Resync the db with the current state of the unconfirmed steps
                const { version: version, steps: steps } = (0, $9NwnH.sendableSteps)(editorView.state) ?? {};
                if (version !== undefined && steps !== undefined) (0, $a5de712ae25052da$export$4abb9cd0bdff89ec)({
                    editorView: editorView,
                    stepsDatabase: stepsDatabase,
                    version: version,
                    steps: steps,
                    broadcast: broadcastUpdate
                }).finally(()=>{
                    isActivelySyncing.current = false;
                });
                else isActivelySyncing.current = false;
            });
            else isActivelySyncing.current = false;
        });
    });
};









const $1b00d7c59071460d$export$e3acca0d39d792dc = ({ api: api, stepsDatabase: stepsDatabase, disabledRef: disabledRef })=>{
    const queryingSyncLock = (0, $42omo.useRef)(false);
    (0, $6qdjm.usePluginStateEffect)(api, [
        'editorOfflineStorage',
        'connectivity',
        'collabEdit'
    ], ()=>{
        // Check if we're safe to re-enable the lock
        if (disabledRef.current === 'unableToSync' && !queryingSyncLock.current) {
            queryingSyncLock.current = true;
            stepsDatabase.isLocked().then((locked)=>{
                // If we're not locked (and still unable to sync) we can re-enable
                if (!locked && disabledRef.current === 'unableToSync') api?.core.actions.execute(({ tr: tr })=>tr.setMeta((0, $bcc122a52e0f74cf$export$3b87fd119d006909), {
                        disabled: false
                    }));
            }).catch(()=>{}).finally(()=>{
                queryingSyncLock.current = false;
            });
        }
    });
};





const $1d19c6d3b6d5b560$export$ea606e96c5866df5 = ({ api: api, config: config })=>{
    const stepsDatabase = new (0, $f0050ff6ee6f7eb3$export$c7a2e99e9e26da1c)();
    return {
        name: 'editorOfflineStorage',
        pmPlugins () {
            return [
                {
                    name: 'editorOfflineStoragePlugin',
                    plugin: (0, $bcc122a52e0f74cf$export$ae829ec7b2625219)(stepsDatabase)
                }
            ];
        },
        getSharedState (state) {
            if (!state) return undefined;
            const { status: status, disabled: disabled, inactiveSyncing: inactiveSyncing } = (0, $bcc122a52e0f74cf$export$3b87fd119d006909).getState(state) ?? {};
            const { version: version, steps: steps } = (0, $9NwnH.sendableSteps)(state) ?? {};
            return {
                version: version ?? 0,
                steps: steps ?? [],
                status: status ?? 'pending',
                disabled: disabled ?? false,
                inactiveSyncing: inactiveSyncing ?? false
            };
        },
        usePluginHook: ({ editorView: editorView })=>{
            const [contentId] = (0, $ep3mz.usePageContentId)();
            const disabledRef = (0, $42omo.useRef)(false);
            const hasCheckedForVersionInsertionBackupRef = (0, $42omo.useRef)(false);
            const intl = (0, $1cfRh.default)();
            (0, $6qdjm.usePluginStateEffect)(api, [
                'editorOfflineStorage'
            ], ({ editorOfflineStorageState: editorOfflineStorageState })=>{
                disabledRef.current = editorOfflineStorageState?.disabled ?? false;
            });
            const { createVersion: createOfflineVersion, manualRetryCreateVersion: manualRetryCreateVersion } = (0, $185ed3c8b342a5b9$export$a47b53017b47e379)({
                contentId: contentId,
                api: api,
                stepsDatabase: stepsDatabase,
                flags: config?.flags ?? null
            });
            (0, $42omo.useEffect)(()=>{
                if (contentId && !stepsDatabase.dbName && !disabledRef.current) stepsDatabase.init(contentId, api).then(async (initialized)=>{
                    if (!initialized) return;
                    if ((0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes')) {
                        // Check and clear expired data before checking for backup
                        await stepsDatabase.checkAndClearExpiredData();
                        // Check for existing version insertion backup
                        if (!hasCheckedForVersionInsertionBackupRef.current) {
                            hasCheckedForVersionInsertionBackupRef.current = true;
                            const versionInsertionBackup = await stepsDatabase.getVersionInsertionBackup();
                            if (versionInsertionBackup) (0, $bf60d5cebe6d196a$export$ac18e6e44f1970de)(config?.flags, intl, // onRetry: Call manual retry with stored content
                            ()=>{
                                manualRetryCreateVersion(versionInsertionBackup.adfContent);
                            }, // onClose: Track when user dismisses the version insertion error flag
                            ()=>{
                                (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
                                    api: api,
                                    action: 'OFFLINE_EDITING_VERSION_INSERTION_ERROR_FLAG_DISMISSED',
                                    manualRetryCount: 0
                                });
                            }, 0);
                        }
                    }
                });
            // We need stepsDatabase in deps to detect when DB is no longer initialised on re-render, e.g. when page goes full-width.
            }, [
                contentId,
                stepsDatabase,
                api,
                intl,
                manualRetryCreateVersion
            ]); // eslint-disable-line react-hooks/exhaustive-deps
            const broadcastUpdate = (0, $c71be5c341006c26$export$e38c76da774a8077)({
                api: api,
                editorView: editorView,
                stepsDatabase: stepsDatabase
            });
            /**
       * This is to resync the document online once we move from offline -> online
       */ (0, $93f027f3fd7090c3$export$68f4c8eca02a72d7)({
                api: api,
                editorView: editorView,
                broadcastUpdate: broadcastUpdate,
                stepsDatabase: stepsDatabase,
                contentId: contentId,
                flags: config?.flags ?? null
            });
            /**
       * See if it's safe to re-enable the plugin if it's been disabled due to the lock being held
       */ (0, $1b00d7c59071460d$export$e3acca0d39d792dc)({
                api: api,
                stepsDatabase: stepsDatabase,
                disabledRef: disabledRef
            });
            // Clean up the sync timeout on unmount
            // Otherwise its possible that it will fire with stale data after unmount
            (0, $42omo.useEffect)(()=>{
                return ()=>{
                    (0, $a5de712ae25052da$export$fed59d57957883a7).cancel();
                };
            }, [
                contentId,
                editorView
            ]);
            /**
       * This is to handle the initial load of the editor and syncing it from the indexeddb
       */ (0, $6qdjm.usePluginStateEffect)(api, [
                'editorOfflineStorage',
                'connectivity',
                'collabEdit'
            ], ({ editorOfflineStorageState: editorOfflineStorageState, connectivityState: connectivityState, collabEditState: collabEditState })=>{
                const { status: status, steps: steps, version: version, disabled: disabled } = editorOfflineStorageState ?? {};
                if (disabledRef.current) return;
                if (window?.indexedDB === undefined) {
                    // If indexeddb is not available disable offline editing here
                    if (!disabled) api?.core.actions.execute(({ tr: tr })=>tr.setMeta((0, $bcc122a52e0f74cf$export$3b87fd119d006909), {
                            disabled: 'stepsDatabaseError'
                        }));
                    return;
                }
                // Both the restore (init) sync lock and the resync online (online <-> offline) sync lock are released here.
                // We confirm the steps have synced with NCS before clearing the database and releasing the lock.
                if (steps?.length === 0 && stepsDatabase.hasLock) stepsDatabase.clear(false).then(async (cleared)=>{
                    if (cleared) {
                        if (stepsDatabase.lockPurpose === 'restore') // After we've the steps confirmed with NCS, we update the doc and version in the database.
                        await stepsDatabase.updateDocAndVersion(editorView).then((isUpdated)=>{
                            if (isUpdated) // Notify other tabs to sync from the updated doc/version in IndexedDB.
                            broadcastUpdate('restore');
                        });
                        await stepsDatabase.releaseSyncLock?.();
                    }
                });
                switch(status){
                    case 'pending':
                        // Restore steps once collab edit plugin is initialised
                        if (collabEditState?.initialised.collabInitialisedAt) {
                            const tr = editorView.state.tr;
                            tr.setMeta('addToHistory', false);
                            tr.setMeta((0, $bcc122a52e0f74cf$export$3b87fd119d006909), {
                                status: 'restoring'
                            });
                            editorView.dispatch(tr);
                            (0, $576038989d33c4bf$export$312d5d76abf7691a)(api, stepsDatabase, editorView, 0, {
                                createOfflineVersion: createOfflineVersion
                            })(editorView.state.schema);
                        }
                        break;
                    case 'restoring':
                        break;
                    case 'ready':
                        const isFocusedAndVisible = document.visibilityState === 'visible' && document.hasFocus();
                        // If we are offline and we have steps to store, update the steps in the database
                        if (isFocusedAndVisible && steps && version !== undefined && (0, $91bcx.isOfflineMode)(connectivityState?.mode)) (0, $a5de712ae25052da$export$fed59d57957883a7)({
                            editorView: editorView,
                            stepsDatabase: stepsDatabase,
                            version: version,
                            steps: steps,
                            broadcast: broadcastUpdate
                        });
                        break;
                    case 'tooManyRetries':
                        // Unable to restore steps - ensure we disable the offline editing session to be safe
                        // in case there's something wrong with the DB.
                        if (!disabled) api?.core.actions.execute(({ tr: tr })=>tr.setMeta((0, $bcc122a52e0f74cf$export$3b87fd119d006909), {
                                disabled: 'tooManyRetries'
                            }));
                        break;
                    default:
                        break;
                }
            });
        }
    };
};






var $jTxSS = parcelRequire("jTxSS");





var $jSnXV = parcelRequire("jSnXV");







const $d4ec92cbc00adf4b$export$3e69d3882a51f072 = 'heading-links';
const $d4ec92cbc00adf4b$export$2dd355223baa0569 = new (0, $ks2lK.PluginKey)($d4ec92cbc00adf4b$export$3e69d3882a51f072);
var $d4ec92cbc00adf4b$export$ad105db915eb8d4a = /*#__PURE__*/ function(EDITOR_HEADING_LINKS_EXPERIMENT_COHORTS) {
    EDITOR_HEADING_LINKS_EXPERIMENT_COHORTS["NOT_ENROLLED"] = "not-enrolled";
    EDITOR_HEADING_LINKS_EXPERIMENT_COHORTS["CONTROL"] = "control";
    EDITOR_HEADING_LINKS_EXPERIMENT_COHORTS["VARIANT"] = "variant";
    return EDITOR_HEADING_LINKS_EXPERIMENT_COHORTS;
}({});















var $cOrQJ = parcelRequire("cOrQJ");


var $202oG = parcelRequire("202oG");

const $4b64eb8446c0685a$export$9030f1f7cf11a203 = async (node, getHeadingLinkPath)=>{
    try {
        const headingId = (0, $202oG.getHeadingIdForNode)(node);
        if (!headingId) return false;
        const path = getHeadingLinkPath();
        if (!path) return false;
        const url = new URL(location.origin + path);
        url.hash = encodeURIComponent(headingId);
        const href = url.toString();
        if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
            await navigator.clipboard.writeText(href);
            return true;
        }
        return false;
    } catch  {
        return false;
    }
};


const $a9415ea089d2d14f$var$i18n = (0, $h82at.defineMessages)({
    tooltipCopyMessage: {
        id: "editor-heading-links.link-component.tooltip.copy",
        defaultMessage: "Copy link to heading"
    },
    tooltipCopiedMessage: {
        id: "editor-heading-links.link-component.tooltip.copied",
        defaultMessage: "Copied!"
    },
    iconLabel: {
        id: "editor-heading-links.link-component.icon.label",
        defaultMessage: "Link icon"
    }
});
const $a9415ea089d2d14f$export$f356b7f7371242f8 = ({ node: node, intl: intl, analytics: analytics, isRightAligned: isRightAligned, getHeadingLinkPath: getHeadingLinkPath })=>{
    const [didCopy, setDidCopy] = (0, $42omo.useState)(false);
    const updateTooltip = (0, $42omo.useRef)();
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    (0, $42omo.useLayoutEffect)(()=>{
        updateTooltip.current?.();
    }, [
        didCopy
    ]);
    const handleClick = (0, $42omo.useCallback)(async ()=>{
        const didCopySucceed = await (0, $4b64eb8446c0685a$export$9030f1f7cf11a203)(node, getHeadingLinkPath);
        if (didCopySucceed) setDidCopy(true);
        // Should match the event fired for heading links on the view page
        // platform/packages/editor/renderer/src/react/nodes/heading.tsx
        analytics?.fireAnalyticsEvent?.({
            action: (0, $d925B.ACTION).CLICKED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).BUTTON,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).HEADING_ANCHOR_LINK,
            eventType: (0, $d925B.EVENT_TYPE).UI
        });
    }, [
        node,
        analytics,
        getHeadingLinkPath
    ]);
    const tooltipContentFn = (0, $42omo.useCallback)(({ update: update })=>{
        updateTooltip.current = update;
        return didCopy ? intl.formatMessage($a9415ea089d2d14f$var$i18n.tooltipCopiedMessage) : intl.formatMessage($a9415ea089d2d14f$var$i18n.tooltipCopyMessage);
    }, [
        didCopy,
        intl
    ]);
    const handleMouseOut = (0, $42omo.useCallback)(()=>{
        setDidCopy(false);
    }, []);
    const headingLevel = node.attrs['level'];
    const alignmentClass = isRightAligned ? 'link-widget-right' : 'link-widget-left';
    const sizeClass = headingLevel > 3 ? 'link-widget-small' : 'link-widget-medium';
    let colorClass;
    if (didCopy) colorClass = colorMode === 'dark' ? 'link-widget-clicked-dark' : 'link-widget-clicked-light';
    else colorClass = colorMode === 'dark' ? 'link-widget-hovered-dark' : 'link-widget-hovered-light';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        tag: "span",
        delay: 0,
        position: "top",
        content: tooltipContentFn
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        "data-testid": "heading-link-copy-button",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `link-widget ${alignmentClass} ${sizeClass} ${colorClass}`,
        onClick: handleClick,
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseLeave: handleMouseOut
    }));
};


const $61a2a9c96b4df241$export$181fa0f15c7f1584 = (position, node, isRightAligned, intl, analytics, getHeadingLinkPath)=>{
    return (0, $ftzrq.Decoration).widget(position, ()=>{
        const elem = document.createElement('span');
        // Trying to avoid both React and ProseMirror changing the same elements,
        // hence the nested container
        const container = document.createElement('span');
        // eslint-disable-next-line react/no-deprecated
        (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a9415ea089d2d14f$export$f356b7f7371242f8), {
            node: node,
            intl: intl,
            analytics: analytics,
            isRightAligned: isRightAligned,
            getHeadingLinkPath: getHeadingLinkPath
        }), container);
        elem.appendChild(container);
        return elem;
    }, {
        side: isRightAligned ? -1 : 1,
        key: `heading-link-${position}`,
        ignoreSelection: false
    });
};
const $61a2a9c96b4df241$export$ae829ec7b2625219 = (intl, analytics, getHeadingLinkPath)=>{
    const handleMouseOver = (view, event)=>{
        // Get the position of the cursor
        const result = view.posAtCoords({
            left: event.clientX,
            top: event.clientY
        });
        const pos = result?.pos;
        if (pos !== undefined) {
            // Resolve the position to a node
            let range = view.state.doc.resolve(pos);
            if (range.parent.type.name !== 'heading') {
                // There was an issue where, if you hovered over a heading from top to bottom,
                // the position would resolve to the document node rather than the heading.
                // Offsetting by 1 seems to fix the issue. However, we need to check both
                // pos and pos+1. If we only check the latter, there's a similar problem when
                // hovering headings from right to left.
                const adjPos = Math.min(pos + 1, view.state.doc.content.size);
                range = view.state.doc.resolve(adjPos);
            }
            // If the node is a heading, dispatch metadata to add a link decoration
            if (range.parent.type.name === 'heading') view.dispatch(view.state.tr.setMeta((0, $d4ec92cbc00adf4b$export$2dd355223baa0569), {
                applyHoverDecoration: true,
                from: range.start(),
                node: range.parent
            }));
        }
        return false;
    };
    const debouncedHandleMouseOver = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(handleMouseOver, 150);
    const plugin = new (0, $1S4f7.SafePlugin)({
        key: (0, $d4ec92cbc00adf4b$export$2dd355223baa0569),
        state: {
            init () {
                return {
                    hoveredHeading: undefined,
                    start: undefined
                };
            },
            apply: (tr, old, _, newState)=>{
                // Get the metadata that was dispatched from the mouseover event
                const hoverDecoration = tr.getMeta((0, $d4ec92cbc00adf4b$export$2dd355223baa0569));
                // If the metadata `applyHoverDecoration` property is present,
                // add a link decoration to the heading node. Note: Only one
                // decoration will ever exist on the page. When a new heading
                // is hovered, the old decoration will be replaced.
                if (hoverDecoration?.applyHoverDecoration) {
                    const node = hoverDecoration.node;
                    return {
                        hoveredHeading: node,
                        start: hoverDecoration.from
                    };
                }
                if (old.start !== undefined) {
                    const newStart = tr.mapping.map(old.start);
                    const newHeadingNode = newState.doc.resolve(newStart);
                    if (newHeadingNode.parent.content.size === 0 || newHeadingNode.parent.type.name !== 'heading') return {
                        hoveredHeading: undefined,
                        start: undefined
                    };
                    // If the heading is prepended, the start position will be off by 1,
                    // so we need to use the .start() method to get the correct position.
                    return {
                        hoveredHeading: newHeadingNode.parent,
                        start: newHeadingNode.start()
                    };
                }
                return old;
            }
        },
        props: {
            decorations (state) {
                const pluginState = plugin.getState(state);
                const heading = pluginState?.hoveredHeading;
                const start = pluginState?.start;
                if (heading && start !== undefined) {
                    const endMark = heading.marks.find((mark)=>mark.attrs?.align === 'end');
                    const position = endMark ? start : start + heading.content.size;
                    const link = $61a2a9c96b4df241$export$181fa0f15c7f1584(position, heading, endMark !== undefined, intl, analytics, getHeadingLinkPath);
                    return (0, $ftzrq.DecorationSet).create(state.doc, [
                        link
                    ]);
                }
                return (0, $ftzrq.DecorationSet).empty;
            },
            handleDOMEvents: {
                mouseover: debouncedHandleMouseOver
            }
        }
    });
    return plugin;
};
const $61a2a9c96b4df241$export$96df4e1ee1c54b95 = ({ api: api, config: { getHeadingLinkPath: getHeadingLinkPath } })=>({
        name: (0, $d4ec92cbc00adf4b$export$3e69d3882a51f072),
        pmPlugins () {
            return [
                {
                    name: (0, $d4ec92cbc00adf4b$export$3e69d3882a51f072),
                    plugin: ({ getIntl: getIntl })=>{
                        // @ts-expect-error — react-intl v5/v7 type mismatch, will be removed when platform upgrades to react-intl v7
                        return $61a2a9c96b4df241$export$ae829ec7b2625219(getIntl(), api?.analytics?.actions, getHeadingLinkPath);
                    }
                }
            ];
        }
    });












var $2O3ot = parcelRequire("2O3ot");


var $4iTbK = parcelRequire("4iTbK");


var $aXWtB = parcelRequire("aXWtB");


var $jyA9t = parcelRequire("jyA9t");


var $1AJi3 = parcelRequire("1AJi3");


var $3rRes = parcelRequire("3rRes");


var $7eOZ4 = parcelRequire("7eOZ4");

const $3c7fc3da09b0bf1b$export$b0964dba0fad52a4 = ()=>{
    const Component = ({ handleModalClose: handleModalClose, selectedContext: selectedContext, editorApi: editorApi, onStartThinking: onStartThinking, onStopThinking: onStopThinking, remixModalMetadata: remixModalMetadata, remixSource: remixSource })=>{
        const isRemixCancelled = (0, $42omo.useRef)(false);
        const experienceTracker = (0, $hUyPY.useAIMateExperienceTracker)();
        const openAIFCStagingModalRef = (0, $42omo.useRef)(()=>{});
        const { dynamicUiType: dynamicUiType } = (0, $2O3ot.useStagingAreaState)();
        const { showSmartCreationModal: showSmartCreationModal } = (0, $jyA9t.useSmartCreationModalState)();
        const { toggleConversationAssistant: toggleConversationAssistant } = (0, $1AJi3.useToggleConversationAssistant)();
        const onActionReady = (0, $42omo.useCallback)(()=>{
            if (!isRemixCancelled.current) {
                experienceTracker.succeed({
                    name: (0, $16lEl.ExperienceName).REMIX_START
                });
                // Start as early as possible — before the modal content mounts.
                experienceTracker.start({
                    name: (0, $16lEl.ExperienceName).REMIX_RENDERS_IN_MODAL,
                    id: (0, $16lEl.ExperienceName).REMIX_RENDERS_IN_MODAL,
                    attributes: {
                        product: 'confluence',
                        remixType: dynamicUiType,
                        entryPoint: 'editor'
                    }
                });
                openAIFCStagingModalRef.current();
            }
        }, [
            experienceTracker,
            dynamicUiType
        ]);
        const { sendAIFCPrompt: sendAIFCPrompt, stopRemixing: stopRemixing, isRemixError: isRemixError, remixStoreError: remixStoreError, openAIFCStagingModal: openAIFCStagingModal, closeAIFCStagingModal: closeAIFCStagingModal } = (0, $7eOZ4.useRemixToAIFC)({
            onActionReady: onActionReady
        });
        openAIFCStagingModalRef.current = openAIFCStagingModal;
        // Abort experience on unmount (overlay closed without selecting an option).
        // Uses a ref so the cleanup always calls the latest tracker reference.
        const experienceTrackerRef = (0, $42omo.useRef)(experienceTracker);
        experienceTrackerRef.current = experienceTracker;
        (0, $42omo.useEffect)(()=>{
            return ()=>{
                experienceTrackerRef.current.abort({
                    name: (0, $16lEl.ExperienceName).REMIX_START,
                    reason: 'User closed remix overlay',
                    attributes: {
                        reason: 'User closed remix overlay'
                    }
                });
            };
        }, []);
        const onRemixFlowActiveChange = (0, $42omo.useCallback)((active)=>{
            if (active) {
                isRemixCancelled.current = false;
                onStartThinking();
            } else {
                isRemixCancelled.current = true;
                // Abort the current experience before stopping
                experienceTracker.abort({
                    name: (0, $16lEl.ExperienceName).REMIX_START,
                    reason: 'User cancelled remix thinking',
                    attributes: {
                        reason: 'User cancelled remix thinking'
                    }
                });
                stopRemixing();
                // Start a new experience for the reopened overlay
                experienceTracker.start({
                    name: (0, $16lEl.ExperienceName).REMIX_START,
                    id: (0, $16lEl.ExperienceName).REMIX_START,
                    attributes: {
                        entryPoint: 'editor',
                        remixSource: 'cancelledRemixThinking',
                        originalRemixSource: remixSource,
                        product: 'confluence'
                    }
                });
                onStopThinking({
                    reopenModal: true
                });
            }
        }, [
            onStartThinking,
            stopRemixing,
            onStopThinking,
            experienceTracker,
            remixSource
        ]);
        // Fail experience and clean up thinking UI when Rovo encounters an error
        const prevIsRemixError = (0, $42omo.useRef)(isRemixError);
        (0, $42omo.useEffect)(()=>{
            if (!prevIsRemixError.current && isRemixError && !isRemixCancelled.current) {
                const errorMessage = remixStoreError?.content ?? 'Rovo agent error during remix';
                experienceTracker.fail({
                    name: (0, $16lEl.ExperienceName).REMIX_START,
                    error: new Error(errorMessage),
                    attributes: {
                        errorType: remixStoreError?.errorType,
                        traceId: remixStoreError?.traceId
                    }
                });
                onStopThinking({
                    reopenModal: true
                });
            }
            prevIsRemixError.current = isRemixError;
        }, [
            isRemixError,
            remixStoreError,
            onStopThinking,
            experienceTracker
        ]);
        // When an error occurs during remix, close the thinking bar and ephemeral
        // preview, then open the Rovo chat sidebar so the user can see the error.
        (0, $42omo.useEffect)(()=>{
            if (!isRemixCancelled.current && isRemixError) {
                // Close the ephemeral preview (staging modal) if it is open
                if (showSmartCreationModal) closeAIFCStagingModal();
                // Close the thinking bar
                onStopThinking();
                // Open the Rovo chat sidebar to display the error information
                toggleConversationAssistant('sidebar');
            }
        }, [
            isRemixError,
            showSmartCreationModal,
            closeAIFCStagingModal,
            onStopThinking,
            toggleConversationAssistant
        ]);
        const constructDynamicUiSource = (0, $42omo.useCallback)(async ()=>{
            const localIds = selectedContext?.localIds ?? [];
            const startLocalId = localIds[0] ?? '';
            const endLocalId = localIds[localIds.length - 1] ?? '';
            const fragmentAdf = (0, $3rRes.filterRemixFragmentNodes)(selectedContext?.selectionFragment ?? null);
            let fullAdf = {
                type: 'doc',
                version: 1,
                content: []
            };
            if (editorApi) fullAdf = await new Promise((resolve)=>{
                try {
                    editorApi.core?.actions?.requestDocument?.((doc)=>{
                        resolve(doc);
                    }, {
                        alwaysFire: true
                    });
                } catch  {
                    resolve({
                        type: 'doc',
                        version: 1,
                        content: []
                    });
                }
            });
            return {
                contentType: 'page',
                startLocalId: startLocalId,
                endLocalId: endLocalId,
                startIndex: selectedContext?.startIndex ?? 0,
                endIndex: selectedContext?.endIndex ?? -1,
                fragmentAdf: fragmentAdf,
                fullAdf: fullAdf
            };
        }, [
            editorApi,
            selectedContext
        ]);
        const onOptionSelect = (0, $42omo.useCallback)(async ({ type: type, subType: subType, userPrompt: userPrompt })=>{
            experienceTracker.updateAttributes({
                name: (0, $16lEl.ExperienceName).REMIX_START,
                attributes: {
                    remixType: type
                }
            });
            const dynamicUiSource = await constructDynamicUiSource();
            sendAIFCPrompt({
                userPrompt: userPrompt,
                dynamicUiType: type,
                dynamicUiSubtype: subType,
                dynamicUiSource: dynamicUiSource,
                interactionSource: remixModalMetadata?.interactionSource
            });
        }, [
            constructDynamicUiSource,
            sendAIFCPrompt,
            remixModalMetadata,
            experienceTracker
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4iTbK.RemixContainer), {
            onClose: handleModalClose,
            onOptionSelect: onOptionSelect,
            onRemixFlowActiveChange: onRemixFlowActiveChange,
            isEphemeralViewVisible: showSmartCreationModal
        });
    };
    const Wrapper = (props)=>{
        const { onStopThinking: onStopThinking, isThinking: isThinking, isModalOpen: isModalOpen } = props;
        const { showSmartCreationModal: showSmartCreationModal } = (0, $jyA9t.useSmartCreationModalState)();
        const isSmartCreationModalOpen = (0, $42omo.useRef)(false);
        (0, $42omo.useLayoutEffect)(()=>{
            // Selected content should remain highlighted throughout the entire flow even when ephemeral modal is open
            // We deselect the content when the ephemeral modal is closed
            if (isSmartCreationModalOpen.current && !showSmartCreationModal && isThinking) onStopThinking();
            isSmartCreationModalOpen.current = showSmartCreationModal;
        }, [
            showSmartCreationModal,
            isThinking,
            onStopThinking
        ]);
        return isModalOpen || isThinking ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWtB.ConfluenceConversationAssistant), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, props)) : null;
    };
    return Wrapper;
};









var $a4TK8 = parcelRequire("a4TK8");













const $402b4b60c57df829$var$i18n = (0, $h82at.defineMessages)({
    title: {
        id: "editor-presets.conflicts-resolved-flag.title",
        defaultMessage: "All conflicts have been resolved"
    },
    description: {
        id: "editor-presets.conflicts-resolved-flag.description",
        defaultMessage: "Your offline edits have been successfully synced."
    },
    viewHistoryButton: {
        id: "editor-presets.conflicts-resolved-flag.view-history-button",
        defaultMessage: "View version history"
    }
});
const $402b4b60c57df829$var$FLAG_ID = 'conflicts-resolved-flag';
const $402b4b60c57df829$export$f4728fbe8fc5d546 = (flags, intl, contentId, spaceKey)=>{
    if (!flags) return;
    const versionHistoryUrl = (0, $1NBp8.CONTENT_HISTORY).toUrl({
        spaceKey: spaceKey,
        contentId: contentId
    });
    flags.showSuccessFlag({
        id: $402b4b60c57df829$var$FLAG_ID,
        title: intl.formatMessage($402b4b60c57df829$var$i18n.title),
        description: intl.formatMessage($402b4b60c57df829$var$i18n.description),
        actions: [
            {
                content: intl.formatMessage($402b4b60c57df829$var$i18n.viewHistoryButton),
                href: versionHistoryUrl,
                onClick: ()=>{
                    $402b4b60c57df829$export$d04b5033a065369f(flags);
                }
            }
        ]
    });
};
const $402b4b60c57df829$export$d04b5033a065369f = (flags)=>{
    if (!flags) return;
    flags.hideFlag($402b4b60c57df829$var$FLAG_ID);
};















var $djYcq = parcelRequire("djYcq");


var $cyZvy = parcelRequire("cyZvy");










// Apply strike mark to deleted text
function $33fd45b068629a29$var$applyMarkToFragment(fragment, markType) {
    if (!markType) return fragment;
    // Create a mark of the given type
    const mark = markType.create({});
    const nodes = [];
    fragment.forEach((node)=>{
        if (node.isText) nodes.push(node.mark([
            ...node.marks,
            mark
        ]));
        else nodes.push(node.copy($33fd45b068629a29$var$applyMarkToFragment(node.content, markType)));
    });
    // Map over each node in the fragment and apply the mark
    return (0, $5SAOw.Fragment).fromArray(nodes);
}
const $33fd45b068629a29$export$f34037fb3390566b = (conflict, tr, selected = false)=>{
    return (0, $ftzrq.Decoration).widget(conflict.from, ()=>{
        const strikenText = document.createElement('span');
        const style = (0, $24P9d.convertToInlineCss)({
            background: selected ? "var(--ds-background-accent-orange-subtlest-hovered, #FCE4A6)" : "var(--ds-background-accent-orange-subtlest, #FFF5DB)",
            textDecoration: 'underline',
            textDecorationStyle: 'dotted',
            textDecorationThickness: "var(--ds-space-025, 2px)",
            textDecorationColor: "var(--ds-border-accent-orange, #E06C00)"
        });
        strikenText.setAttribute('style', style);
        // Render striken text fragment
        strikenText.appendChild((0, $5SAOw.DOMSerializer).fromSchema(tr.doc.type.schema).serializeFragment($33fd45b068629a29$var$applyMarkToFragment(conflict?.local.content, tr.doc.type.schema.marks.strike)));
        return strikenText;
    }, {
        side: -1,
        ignoreSelection: false
    });
};





/**
 * We have a couple of nodes that require us to compute style
 * on different elements, ideally all nodes should be able to
 * compute the appropriate styles based on their wrapper.
 */ const $3f8f658555914fb4$var$nestedCases = {
    'tableView-content-wrap': 'table',
    'mediaSingleView-content-wrap': '.rich-media-item',
    'bodiedExtensionView-content-wrap': '.extension-container',
    'multiBodiedExtensionView-content-wrap': '.multiBodiedExtension--container',
    'embedCardView-content-wrap': '.rich-media-item',
    'datasourceView-content-wrap': '.datasourceView-content-inner-wrap'
};
const $3f8f658555914fb4$var$computeNestedStyle = (dom)=>{
    const foundKey = Object.keys($3f8f658555914fb4$var$nestedCases).find((className)=>dom.classList.contains(className));
    const nestedSelector = foundKey && $3f8f658555914fb4$var$nestedCases[foundKey];
    if (nestedSelector) {
        const nestedElement = dom.querySelector(nestedSelector);
        if (nestedElement) return window.getComputedStyle(nestedElement);
    }
};
const $3f8f658555914fb4$var$measureHeight = (style)=>{
    return $3f8f658555914fb4$var$measureValue(style, [
        'height',
        'padding-top',
        'padding-bottom',
        'border-top-width',
        'border-bottom-width'
    ]);
};
const $3f8f658555914fb4$var$measureValue = (style, measureValues)=>{
    const [base, ...contentBoxValues] = measureValues;
    const measures = [
        style.getPropertyValue(base)
    ];
    const boxSizing = style.getPropertyValue('box-sizing');
    if (boxSizing === 'content-box') contentBoxValues.forEach((value)=>{
        measures.push(style.getPropertyValue(value));
    });
    let result = 0;
    for(let i = 0; i < measures.length; i++)result += parseFloat(measures[i]);
    return result;
};
function $3f8f658555914fb4$var$getLayoutModeFromTargetNode(node) {
    let layout;
    if (node.attrs.layout) layout = node.attrs.layout;
    if (node.marks && node.marks.length) layout = (node.marks.find((mark)=>mark.type.name === 'breakout') || {
        attrs: {
            mode: ''
        }
    }).attrs.mode;
    if (node.type.name === 'table' && node.attrs.width) layout = 'fixed-width';
    if ([
        'wide',
        'full-width',
        'fixed-width'
    ].indexOf(layout) === -1) return '';
    return layout;
}
/**
 * Converts a camelCased CSS property name to a hyphenated CSS property name.
 *
 * @param property - CamelCased CSS property name.
 * @returns Hyphenated CSS property name.
 */ function $3f8f658555914fb4$var$hyphenate(property) {
    // Ignored via go/ees005
    return property.replace(/[A-Z]/gu, (match)=>`-${match.toLowerCase()}`).replace(/^ms/u, '-ms');
}
const $3f8f658555914fb4$export$dfadf4096b7e8b0c = (node, pos)=>{
    return (0, $ftzrq.Decoration).widget(pos, (view, getPos)=>{
        const nodeStart = getPos();
        const element = document.createElement('span');
        element.className = 'conflictmarker';
        element.appendChild(document.createElement('span'));
        const dom = nodeStart !== undefined ? view.nodeDOM(nodeStart) : null;
        if (dom instanceof HTMLElement && element.firstChild) {
            const style = $3f8f658555914fb4$var$computeNestedStyle(dom) || window.getComputedStyle(dom);
            const conflictmarker = element.firstChild;
            conflictmarker.style.height = `${$3f8f658555914fb4$var$measureHeight(style)}px`;
            const layoutMode = node && $3f8f658555914fb4$var$getLayoutModeFromTargetNode(node);
            if (nodeStart !== 0 || layoutMode || node?.type.name === 'table') conflictmarker.style.marginTop = style.getPropertyValue('margin-top');
            const conflictMarkerCursorStyles = {
                content: "''",
                position: 'absolute',
                background: "var(--ds-background-accent-red-bolder, #C9372C)",
                width: "var(--ds-space-075, 6px)",
                marginLeft: "var(--ds-space-negative-075, -6px)",
                borderRadius: `${"var(--ds-radius-small, 4px)"} 0 0 ${"var(--ds-radius-small, 4px)"}`
            };
            for (const [rule, value] of Object.entries(conflictMarkerCursorStyles))conflictmarker.style.setProperty($3f8f658555914fb4$var$hyphenate(rule), value);
            conflictmarker.className = 'conflictmarker';
            conflictmarker.setAttribute('data-testid', 'conflictmarker');
        }
        return element;
    }, {
        side: -1
    });
};


const $d80773f42a527d1c$var$getBlockNodeAtPos = (pos, tr)=>{
    const $pos = tr.doc.resolve(pos);
    const node = $pos?.node();
    return node && node.isBlock && !node.isTextblock ? node : null;
};
const $d80773f42a527d1c$var$createInsertedDecoration = (conflict, tr, resolutionMode)=>{
    const node = $d80773f42a527d1c$var$getBlockNodeAtPos(conflict.from + 1, tr);
    if (node) return (0, $3f8f658555914fb4$export$dfadf4096b7e8b0c)(node, conflict.from);
    const styles = {
        textDecoration: 'underline',
        textDecorationStyle: 'dotted',
        textDecorationThickness: "var(--ds-space-025, 2px)",
        textDecorationColor: "var(--ds-border-accent-orange, #E06C00)"
    };
    // Background highlight behavior:
    // - Gate OFF (old behavior): Always show orange background
    // - Gate ON (new behavior): Only show orange background when actively resolving
    if ((0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes')) {
        if (resolutionMode === 'resolving') styles.background = "var(--ds-background-accent-orange-subtlest, #FFF5DB)";
    } else // Old behavior: always show background
    styles.background = "var(--ds-background-accent-orange-subtlest, #FFF5DB)";
    return (0, $ftzrq.Decoration).inline(conflict.from, conflict.to, {
        style: (0, $24P9d.convertToInlineCss)(styles)
    });
};
const $d80773f42a527d1c$var$createSelectedDecoration = (conflict, tr)=>{
    if (conflict.type === 'deleted') return (0, $33fd45b068629a29$export$f34037fb3390566b)(conflict, tr, true);
    const node = $d80773f42a527d1c$var$getBlockNodeAtPos(conflict.from + 1, tr);
    if (node) return (0, $3f8f658555914fb4$export$dfadf4096b7e8b0c)(node, conflict.from);
    return (0, $ftzrq.Decoration).inline(conflict.from, conflict.to, {
        style: (0, $24P9d.convertToInlineCss)({
            background: "var(--ds-background-accent-orange-subtlest-hovered, #FCE4A6)",
            textDecoration: 'underline',
            textDecorationStyle: 'dotted',
            textDecorationThickness: "var(--ds-space-025, 2px)",
            textDecorationColor: "var(--ds-border-accent-orange, #E06C00)"
        })
    });
};
function $d80773f42a527d1c$var$filterUndefined(c) {
    return c !== undefined;
}
const $d80773f42a527d1c$var$createDecorationsFromConflicts = (conflicts, selectedConflict, tr, resolutionMode)=>{
    if (!conflicts) return [];
    if (selectedConflict) {
        const selectedDecoration = $d80773f42a527d1c$var$createSelectedDecoration(selectedConflict, tr);
        const conflictDecorations = [
            ...conflicts.inserted.filter((c)=>c.id !== selectedConflict.id).map((c)=>$d80773f42a527d1c$var$createInsertedDecoration(c, tr, resolutionMode)),
            ...conflicts.deleted.filter((c)=>c.id !== selectedConflict.id).map((c)=>(0, $33fd45b068629a29$export$f34037fb3390566b)(c, tr)).filter($d80773f42a527d1c$var$filterUndefined)
        ];
        if (selectedDecoration) return conflictDecorations.concat(selectedDecoration);
        return conflictDecorations;
    } else return [
        ...conflicts.inserted.map((c)=>$d80773f42a527d1c$var$createInsertedDecoration(c, tr, resolutionMode)),
        ...conflicts.deleted.map((c)=>(0, $33fd45b068629a29$export$f34037fb3390566b)(c, tr)).filter($d80773f42a527d1c$var$filterUndefined)
    ];
};
const $d80773f42a527d1c$var$mapConflict = (change, mapping, type)=>{
    const from = mapping.map(change.from);
    const to = mapping.map(change.to);
    // We've collapsed the change and there's no visible marker to the user this conflict is no longer useful to us
    // These are "orphaned" conflicts similar to orphaned comments and for now we handle by resolving these since there
    // are no appropriate user actions.
    if (type === 'inserted' && from === to) return undefined;
    return {
        ...change,
        from: from,
        to: to
    };
};
const $d80773f42a527d1c$var$findSelectedConflict = (conflict, selection)=>selection.from >= conflict.from && selection.from <= conflict.to || selection.to >= conflict.from && selection.to <= conflict.to;
const $d80773f42a527d1c$var$getSelectedConflict = (conflicts, selection)=>{
    if (!conflicts) return undefined;
    const insertedSelectedConflict = conflicts?.inserted.find((conflict)=>$d80773f42a527d1c$var$findSelectedConflict(conflict, selection));
    const deletedSelectedConflict = conflicts?.deleted.find((conflict)=>$d80773f42a527d1c$var$findSelectedConflict(conflict, selection));
    if (insertedSelectedConflict) return {
        ...insertedSelectedConflict,
        type: 'inserted'
    };
    if (deletedSelectedConflict) return {
        ...deletedSelectedConflict,
        type: 'deleted'
    };
    return undefined;
};
const $d80773f42a527d1c$export$ae829ec7b2625219 = ()=>{
    return new (0, $1S4f7.SafePlugin)({
        key: (0, $cyZvy.conflictResolutionPluginKey),
        state: {
            init: ()=>{
                return {
                    decorations: (0, $ftzrq.DecorationSet).empty,
                    conflicts: undefined,
                    selected: undefined,
                    isNextEnabled: false,
                    isPreviousEnabled: false,
                    resolutionMode: 'viewing'
                };
            },
            apply: (tr, pluginState)=>{
                const meta = tr.getMeta((0, $cyZvy.conflictResolutionPluginKey));
                const navigatedConflict = tr.getMeta('nextConflict');
                // Early escape hatch to avoid running all the code below if not necessary
                if (pluginState.conflicts === undefined && meta === undefined) return pluginState;
                const conflicts = (0, $djYcq.getNewConflicts)(meta, pluginState.conflicts);
                const mappedConflicts = pluginState.conflicts ? {
                    inserted: pluginState.conflicts.inserted.map((c)=>$d80773f42a527d1c$var$mapConflict(c, tr.mapping, 'inserted')).filter($d80773f42a527d1c$var$filterUndefined),
                    deleted: pluginState.conflicts.deleted.map((c)=>$d80773f42a527d1c$var$mapConflict(c, tr.mapping, 'deleted')).filter($d80773f42a527d1c$var$filterUndefined)
                } : undefined;
                const conflictsRemaining = conflicts ?? mappedConflicts;
                // Update resolution mode based on metadata
                let resolutionMode = pluginState.resolutionMode;
                if ((0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes')) {
                    if (meta?.type === 'startResolving') resolutionMode = 'resolving';
                    else if (meta?.type === 'stopResolving') resolutionMode = 'viewing';
                    else if (conflicts && !pluginState.conflicts) // Reset to viewing mode when new conflicts arrive
                    resolutionMode = 'viewing';
                }
                // Only select conflicts if explicitly navigated to OR if actively resolving with cursor selection
                let selectedConflict;
                if ((0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes')) {
                    if (navigatedConflict) selectedConflict = navigatedConflict;
                    else if (resolutionMode === 'resolving') selectedConflict = $d80773f42a527d1c$var$getSelectedConflict(conflictsRemaining, tr.selection);
                } else selectedConflict = navigatedConflict ?? $d80773f42a527d1c$var$getSelectedConflict(conflictsRemaining, tr.selection);
                const decorations = conflicts || selectedConflict || pluginState.selected ? (0, $ftzrq.DecorationSet).create(tr.doc, $d80773f42a527d1c$var$createDecorationsFromConflicts(conflictsRemaining, selectedConflict, tr, resolutionMode)) : pluginState.decorations.map(tr.mapping, tr.doc);
                return {
                    decorations: decorations,
                    conflicts: conflictsRemaining,
                    selected: selectedConflict,
                    isPreviousEnabled: conflictsRemaining && selectedConflict ? (0, $djYcq.getNavigationInfo)(conflictsRemaining, selectedConflict, 'previous').isAbleToNavigate : false,
                    isNextEnabled: conflictsRemaining && selectedConflict ? (0, $djYcq.getNavigationInfo)(conflictsRemaining, selectedConflict, 'next').isAbleToNavigate : false,
                    resolutionMode: resolutionMode
                };
            }
        },
        props: {
            decorations: (state)=>(0, $cyZvy.conflictResolutionPluginKey).getState(state)?.decorations
        }
    });
};









const $751b8c45ea51c6cb$var$LazyContentComponent = /*#__PURE__*/ (0, $42omo.lazy)(async ()=>({
        default: (await (parcelRequire("fEcUb"))).ContentComponent
    }));
const $751b8c45ea51c6cb$var$ContentComponentWrapper = ({ api: api, config: config, editorView: editorView })=>{
    const intl = (0, $1cfRh.default)();
    const lastConflictCount = (0, $42omo.useRef)(0);
    // Watch for conflicts being resolved. This is so we can show the success flag.
    (0, $6qdjm.usePluginStateEffect)(api, [
        'conflictResolutionUI'
    ], ({ conflictResolutionUIState: conflictResolutionUIState })=>{
        if (!(0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes')) return;
        if (!config?.flags) return;
        if (!config?.contentId || !config?.spaceKey) return;
        const currentConflictCount = (conflictResolutionUIState?.conflicts?.inserted?.length ?? 0) + (conflictResolutionUIState?.conflicts?.deleted?.length ?? 0);
        // If we had conflicts and now we don't, show success flag
        if (lastConflictCount.current > 0 && currentConflictCount === 0) (0, $402b4b60c57df829$export$f4728fbe8fc5d546)(config.flags, intl, config.contentId, config.spaceKey);
        lastConflictCount.current = currentConflictCount;
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($751b8c45ea51c6cb$var$LazyContentComponent, {
        api: api,
        editorView: editorView
    }));
};
const $751b8c45ea51c6cb$export$bb9d066eb8005e17 = ({ api: api, config: config })=>{
    return {
        name: 'conflictResolutionUI',
        contentComponent: ({ editorView: editorView })=>{
            if (!editorView) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($751b8c45ea51c6cb$var$ContentComponentWrapper, {
                api: api,
                config: config,
                editorView: editorView
            });
        },
        getSharedState: (state)=>{
            if (!state) return undefined;
            return {
                selected: (0, $cyZvy.conflictResolutionPluginKey).getState(state)?.selected,
                isNextEnabled: (0, $cyZvy.conflictResolutionPluginKey).getState(state)?.isNextEnabled ?? true,
                isPreviousEnabled: (0, $cyZvy.conflictResolutionPluginKey).getState(state)?.isPreviousEnabled ?? true,
                conflicts: (0, $cyZvy.conflictResolutionPluginKey).getState(state)?.conflicts,
                resolutionMode: (0, $cyZvy.conflictResolutionPluginKey).getState(state)?.resolutionMode ?? 'viewing'
            };
        },
        commands: {
            navigateToFirstConflict: ({ tr: tr })=>{
                const conflicts = api?.conflictResolutionUI?.sharedState.currentState()?.conflicts;
                if (conflicts && (conflicts.inserted.length > 0 || conflicts?.deleted.length > 0)) return (0, $djYcq.navigateToAvailable)(undefined, tr, conflicts);
                return null;
            },
            startResolvingConflicts: ({ tr: tr })=>{
                const conflicts = api?.conflictResolutionUI?.sharedState.currentState()?.conflicts;
                // Early exit when we've no conflicts to resolve.
                if (!conflicts || conflicts.inserted.length === 0 && conflicts.deleted.length === 0) return null;
                // First, start resolving mode
                const trWithMode = tr.setMeta((0, $cyZvy.conflictResolutionPluginKey), {
                    type: 'startResolving'
                });
                // Then navigate to first conflict
                const trWithNavigation = (0, $djYcq.navigateToAvailable)(undefined, trWithMode, conflicts);
                return trWithNavigation || trWithMode;
            }
        },
        pmPlugins: ()=>{
            return [
                {
                    name: 'conflictResolutionPlugin',
                    plugin: (0, $d80773f42a527d1c$export$ae829ec7b2625219)
                }
            ];
        },
        usePluginHook: ({ editorView: editorView })=>{
            const lastReconnectionConflictMetadataRef = (0, $42omo.useRef)();
            (0, $6qdjm.usePluginStateEffect)(api, [
                'collabEdit'
            ], ({ collabEditState: collabEditState })=>{
                const { lastReconnectionConflictMetadata: lastReconnectionConflictMetadata } = collabEditState ?? {};
                if (lastReconnectionConflictMetadata && !(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(lastReconnectionConflictMetadataRef.current, lastReconnectionConflictMetadata)) {
                    (0, $djYcq.setMetadata)(editorView, {
                        type: 'update',
                        data: lastReconnectionConflictMetadata
                    }, {
                        api: api
                    });
                    lastReconnectionConflictMetadataRef.current = lastReconnectionConflictMetadata;
                }
            });
        }
    };
};



var $5wfVt = parcelRequire("5wfVt");




const $fe598058b05d810f$var$pluginName = 'ssr-plugin';
const $fe598058b05d810f$var$pmPluginName = 'ssr-disable-transactions';
const $fe598058b05d810f$export$bfca3f3ccfec3116 = ()=>{
    return {
        name: $fe598058b05d810f$var$pluginName,
        pmPlugins () {
            return [
                {
                    name: $fe598058b05d810f$var$pmPluginName,
                    plugin () {
                        return new (0, $1S4f7.SafePlugin)({
                            filterTransaction () {
                                // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
                                return true;
                            }
                        });
                    }
                }
            ];
        }
    };
};



var $adhil = parcelRequire("adhil");

var $1gpr6 = parcelRequire("1gpr6");




const $3c910faa900bb0f6$var$selectDocStart = ()=>({ tr: tr })=>{
        const docStartSelection = (0, $1gpr6.isValidTargetNode)(tr.doc.firstChild) ? new (0, $adhil.GapCursorSelection)(tr.doc.resolve(0)) : (0, $ks2lK.Selection).atStart(tr.doc);
        tr.setSelection(docStartSelection);
        return tr;
    };
const $3c910faa900bb0f6$var$insertNewLineAtDocStart = ()=>({ tr: tr })=>{
        const { paragraph: paragraph, heading: heading } = tr.doc.type.schema.nodes;
        const firstChild = tr.doc.firstChild;
        if (firstChild && [
            paragraph,
            heading
        ].includes(firstChild.type) && !firstChild.childCount) return $3c910faa900bb0f6$var$selectDocStart()({
            tr: tr
        });
        const emptyParagraph = tr.doc.type.schema.nodes.paragraph.create();
        tr.insert(0, emptyParagraph);
        tr.setSelection((0, $ks2lK.TextSelection).near(tr.doc.resolve(0)));
        return tr;
    };
const $3c910faa900bb0f6$export$c7c689ff4e6df96c = ()=>{
    return {
        name: 'pageTitleUtils',
        dependencies: [],
        commands: {
            selectDocStart: $3c910faa900bb0f6$var$selectDocStart,
            insertNewLineAtDocStart: $3c910faa900bb0f6$var$insertNewLineAtDocStart
        }
    };
};


function $83c8a91574f9bbb4$export$7cb04b251abcb35b(options) {
    const { intl: intl, appearance: appearance, prevAppearance: prevAppearance } = options;
    const isNativeEmbeddedLiveDoc = !!options.__livePage && !!options.isEmbeddedConfluence && (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true);
    return (0, $2b80134f192952c5$export$9f1bd789d5e1fd40)({
        intl: // @ts-expect-error — react-intl v5/v7 type mismatch, will be removed when platform upgrades to react-intl v7
        intl,
        isRovoLLMEnabled: options.isRovoLLMEnabled,
        pluginOptions: {
            contentFormat: (0, $6mKj3.expValEquals)('confluence_compact_text_format', 'isEnabled', true) ? {
                initialContentMode: options.contentMode ?? 'standard'
            } : undefined,
            base: {
                __livePage: options.__livePage
            },
            helpDialog: {
                imageUploadProviderExists: false,
                aiEnabled: options.isAIEnabledForContent ?? false
            },
            hyperlink: {
                editorAppearance: appearance,
                linkPicker: options.linking?.linkPicker,
                onClickCallback: options.linking?.smartLinks?.onClickCallback
            },
            quickInsert: {
                emptyStateHandler: options.elementBrowser?.emptyStateHandler,
                quickInsert: options.quickInsert
            },
            placeholder: {
                viewMode: options.viewMode,
                isAIEnabled: options.isAIEnabledForContent ?? false,
                // hide placeholder when (1) experiment enabled (2) not embedded editor & (3) user would see BPQA.
                // match BPQA conditions as defined by shouldRenderBPQA in FullPageEditorComponent
                // in this case, only isCompanyHub is not handled yet by the placeholder plugin
                isPlaceholderHidden: !options.isEmbeddedConfluence && !options.isCompanyHub && options.isRovoLLMEnabled && ((0, $6mKj3.expValEquals)('cwr_blank_object_experiment', 'cohort', 'variant1') || (0, $6mKj3.expValEquals)('cwr_blank_object_experiment', 'cohort', 'variant2')),
                enableLoadingSpinner: options.enablePlaceholderLoadingSpinner,
                isRovoLLMEnabled: options.isRovoLLMEnabled
            },
            selection: {
                __livePage: options.__livePage
            },
            editorDisabled: {
                disabled: options.disabled
            },
            breakout: {
                editorAppearance: appearance
            },
            expand: {
                editorAppearance: appearance,
                __livePage: options.__livePage
            },
            annotation: {
                annotationManager: options.annotationProviders?.annotationManager,
                createCommentExperience: (0, $3YBks.createInlineCommentCompoundExperience),
                selectCommentExperience: (0, $4EKKB.selectInlineCommentCompoundExperience),
                viewInlineCommentTraceUFOPress: ()=>(0, $4TXTZ.default)('view-inline-comment-action')
            },
            media: {
                createCommentExperience: (0, $9wGTI.fg)('confluence_fe_create_inline_comment_exp_coverage_2') ? (0, $3YBks.createInlineCommentCompoundExperience) : undefined,
                editorAppearance: appearance,
                mediaViewerExtensions: options.media?.mediaViewerExtensions
            },
            mentions: {
                handleMentionsChanged: options.handleMentionsChanged,
                currentUserId: options.currentUserId
            },
            table: {
                editorAppearance: appearance,
                prevEditorAppearance: prevAppearance
            },
            tasksAndDecisions: {
                hasEditPermission: options.hasEditPermission,
                requestToEditContent: options.requestToEditContent,
                hasRequestedEditPermission: options.hasRequestedEditPermission
            },
            collabEdit: {
                collabEdit: options.collabEdit,
                __livePage: options.__livePage
            },
            // Remove the options.contextPanelOptions undefined checking after cleaning `platform_editor_ai_object_sidebar_injection` FG
            // and options.contextPanelOptions will be always defined.
            contextPanel: options.contextPanelOptions ? {
                objectSideBar: options.contextPanelOptions.objectSideBar
            } : undefined,
            extension: {
                extensionHandlers: options.extensionHandlers,
                editorAppearance: appearance,
                __rendererExtensionOptions: options.__rendererExtensionOptions,
                getExtensionHeight: options.getExtensionHeight,
                getUnsupportedContent: $7cb36df2e500ad5f$export$d4ded51d0f0bd2df
            },
            layout: {
                editorAppearance: appearance
            },
            card: {
                editorAppearance: appearance,
                linkPicker: options.linking?.linkPicker,
                onClickCallback: options.linking?.smartLinks?.onClickCallback,
                __livePage: options.__livePage,
                CompetitorPrompt: $dXIrr.PromptPopupContainer
            },
            insertBlock: {
                editorAppearance: appearance,
                toolbarButtons: {
                    emoji: {
                        enabled: true,
                        showAt: 'lg'
                    },
                    insert: {
                        enabled: true,
                        showAt: 'lg'
                    },
                    layout: {
                        enabled: true,
                        showAt: 'lg'
                    },
                    media: {
                        enabled: true,
                        showAt: 'lg'
                    },
                    mention: {
                        enabled: true,
                        showAt: 'lg'
                    },
                    table: {
                        enabled: true,
                        showAt: 'md'
                    },
                    taskList: {
                        enabled: true,
                        showAt: 'lg'
                    }
                }
            },
            avatarGroup: {
                // Avatars are moved to Confluence codebase for Edit in Context
                // When Edit in Context is enabled primaryToolbarComponents is undefined
                // For more details please check
                // https://hello.atlassian.net/wiki/spaces/PCG/pages/2851572180/Editor+toolbar+for+live+pages+and+edit+in+context+projects
                collabEdit: options.collabEdit
            },
            codeBidiWarning: {
                editorAppearance: appearance
            },
            referentiality: {
                referentialityContext: options.referentialityContext
            },
            ai: options.editorPluginAIOptions,
            loom: {
                renderButton: options.loomPluginOptions.renderButton
            },
            editorViewMode: {
                viewMode: options.viewMode
            },
            aiDefinitions: options.editorPluginAIDefinitionsConfig,
            selectionMarker: {
                __livePage: options.__livePage ?? false
            },
            engagementPlatform: {
                coordinationClient: options.editorEngagementPlatformPluginConfig.coordinationClient
            },
            selectionExtension: (0, $9wGTI.fg)('platform_editor_controls_selection_extension') ? options.selectionExtensionPluginOptions : {},
            metrics: // eslint-disable-next-line confluence-feature-gating/no-preconditioning
            (0, $6mKj3.expValEquals)('platform_editor_controls', 'cohort', 'variant1') ? {
                userPreferencesProvider: options.userPreferencesProvider
            } : undefined,
            primaryToolbar: {
                contextualFormattingEnabled: options.contextualFormattingEnabled
            },
            selectionToolbar: {
                contextualFormattingEnabled: options.contextualFormattingEnabled,
                // In embedded live doc, the toolbar is always unpinned and the pin option is hidden
                disablePin: isNativeEmbeddedLiveDoc
            },
            userPreferencesPlugin: {
                // In embedded live doc, force the toolbar to start unpinned regardless of any saved user preference
                initialToolbarDockingPosition: isNativeEmbeddedLiveDoc ? 'none' : undefined
            },
            blockMenu: {
                getLinkPath: options.getHeadingLinkPath,
                blockLinkHashPrefix: options.blockLinkHashPrefix
            },
            showDiff: options.showDiffPluginParams,
            syncedBlock: options.syncedBlockProvider && (0, $6mKj3.expValEquals)('platform_synced_block', 'isEnabled', true) ? {
                enableSourceCreation: true,
                syncedBlockRenderer: (0, $hmVoT.getSyncedBlockRenderer)({
                    syncBlockRendererOptions: {
                        eventHandlers: options.syncedBlockEventHandlers,
                        stickyHeaders: {
                            show: true,
                            offsetTop: 0
                        }
                    }
                }),
                syncBlockDataProvider: options.syncedBlockProvider
            } : undefined,
            limitedMode: options.limitedModePluginOptions || {},
            toolbar: {
                contextualFormattingEnabled: 'controlled'
            },
            trackChanges: {
                ButtonWrapper: options.trackChangesPluginOptions?.ButtonWrapper
            }
        },
        providers: {
            // In embedded live doc, we always want the toolbar to be unpinned regardless of saved preferences.
            // Passing undefined for both providers prevents any shared user preference state from affecting
            // the embedded live doc toolbar docking position.
            userPreferencesProvider: isNativeEmbeddedLiveDoc ? undefined : options.userPreferencesProvider,
            userPreferencesProviderNext: isNativeEmbeddedLiveDoc ? undefined : options.userPreferencesProviderNext,
            cardProvider: options.linking?.smartLinks?.provider,
            contextIdentifierProvider: options.contextIdentifierProvider,
            inlineCommentAnnotationProvider: options.annotationProviders?.inlineComment,
            mediaProvider: options.media?.provider,
            syncMediaProvider: options.media?.syncProvider,
            mentionProvider: options.mentionProvider,
            profilecardProvider: options.mention?.profilecardProvider,
            emojiProvider: options.emojiProvider,
            emojiNodeDataProvider: options.emojiNodeDataProvider,
            collabEditProvider: options.collabEdit?.provider,
            autoformattingProvider: options.autoformattingProvider,
            taskDecisionProvider: options.taskDecisionProvider
        },
        enabledOptionalPlugins: {
            limitedMode: false,
            findReplace: Boolean(options.allowFindReplace),
            referentiality: Boolean(options.referentialityContext.plugin),
            loom: options.isLoomPluginEnabled,
            aiDefinitions: options.editorPluginAIDefinitionsEnabled,
            connectivity: options.isDesktop || (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false),
            metrics: (0, $9wGTI.fg)('platform_editor_ease_of_use_metrics'),
            codeBlockAdvanced: true,
            selectionExtension: (0, $6mKj3.expValEquals)('platform_editor_controls', 'cohort', 'variant1'),
            aiExperience: Boolean(options.editorPluginAIOptions.aiGlobalOptIn.status !== 'disabled'),
            interaction: Boolean(options?.__livePage) || (0, $6mKj3.expValEquals)('platform_editor_no_cursor_on_edit_page_init', 'isEnabled', true),
            userPreferences: (0, $9wGTI.fg)('platform_editor_use_preferences_plugin'),
            trackChanges: (0, $9wGTI.fg)('aifc_create_enabled'),
            showDiff: Boolean(options?.showDiffPluginParams) || (0, $9wGTI.fg)('aifc_create_enabled'),
            toolbar: !options?.disableToolbar && ((0, $9wGTI.fg)('aifc_create_enabled') || options.editorPluginAIOptions.aiGlobalOptIn.status !== 'enabled' && (0, $6mKj3.expValEquals)('platform_editor_toolbar_aifc_confluence', 'isEnabled', true)),
            blockMenu: (0, $6mKj3.expValEquals)('platform_editor_block_menu', 'isEnabled', true),
            localId: (0, $9wGTI.fg)('platform_editor_adf_with_localid'),
            aiStreamingOrchestrator: (0, $9wGTI.fg)('aifc_create_enabled'),
            syncedBlock: (0, $6mKj3.expValEquals)('platform_synced_block', 'isEnabled', true),
            floatingToolbar: !options?.disableFloatingToolbar,
            codeBidiWarning: !(0, $6mKj3.expValEquals)('platform_editor_remove_bidi_char_warning', 'isEnabled', true),
            contentFormat: (0, $6mKj3.expValEquals)('confluence_compact_text_format', 'isEnabled', true),
            uiControlRegistry: (0, $6mKj3.expValEquals)('platform_editor_paste_actions_menu', 'isEnabled', true)
        }
    }).add((0, $fe598058b05d810f$export$bfca3f3ccfec3116)).add([
        (0, $61a2a9c96b4df241$export$96df4e1ee1c54b95),
        {
            getHeadingLinkPath: options.getHeadingLinkPath
        }
    ]).add((0, $3c910faa900bb0f6$export$c7c689ff4e6df96c)).add((0, $b6333eeaeea6365c$export$53933ef6873e4a9f)).add((0, $dMGoR.forgeEditorPlugin)).maybeAdd([
        (0, $1d19c6d3b6d5b560$export$ea606e96c5866df5),
        {
            flags: options.flags
        }
    ], options.isDesktop || (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)).maybeAdd([
        (0, $751b8c45ea51c6cb$export$bb9d066eb8005e17),
        {
            flags: options.flags,
            contentId: options.contentId,
            spaceKey: options.spaceKey
        }
    ], options.isDesktop || (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)).add((0, $5wfVt.emptyStatePlugin)).add((0, $iHrpD.legacyContentMacroPlugin)).maybeAdd((0, $616343a1d45d9a96$export$c84116e7ea204952), (0, $6mKj3.expVal)('platform_editor_add_image_editing', 'isEnabled', false)).maybeAdd((0, $8c3629cd1d541fcd$export$d82c0e619eaaa2c2), options.isCompanyHub).maybeAdd([
        (0, $5d6abfec5f8b86f9$export$e4fa509a217898d8),
        {
            contentAri: `ari:cloud:confluence::page/${options.contentId}`
        }
    ], (0, $6mKj3.expVal)('platform_editor_ai_content_suggested_edits', 'isEnabled', false)).maybeAdd([
        (0, $042f40d3cc5075b5$export$90e174b945ae40c7),
        {
            __isRemixHidden: options.__isRemixHidden,
            __isRovoLLMEnabled: options.isRovoLLMEnabled,
            __remixDisabledReason: options.__remixDisabledReason,
            __livePage: options.__livePage,
            createRemixContentComponent: $3c7fc3da09b0bf1b$export$b0964dba0fad52a4,
            diagramPaste: options.moveWhiteboardToPage && options.spaceKey ? {
                getCurrentPageId: ()=>options.contentId,
                duplicateMauiApp: options.duplicateMauiApp,
                moveWhiteboardToPage: options.moveWhiteboardToPage,
                resolveContentSpaceKey: async (contentId)=>{
                    try {
                        const response = await fetch(`/wiki/rest/api/content/${contentId}?expand=space`, {
                            credentials: 'include'
                        });
                        if (!response.ok) return null;
                        const data = await response.json();
                        return data?.space?.key ?? null;
                    } catch  {
                        return null;
                    }
                },
                targetSpaceKey: options.spaceKey
            } : undefined
        }
    ], (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true) && !options.isEmbeddedConfluence).maybeAdd([
        (0, $lGoD9.nativeEmbedsPlugin)
    ], (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true)).maybeAdd((0, $9bdb7ad03a409b2b$export$52b2e012ce18dd1), (0, $6mKj3.expVal)('platform_editor_ai_headingautocomplete', 'isEnabled', false));
}
module.exports["createFullPageEditorPreset"] = $83c8a91574f9bbb4$export$7cb04b251abcb35b;

});

parcelRegister("hcAEn", function(module, exports) {

let $c85ffca229ce5cc3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c85ffca229ce5cc3$var$load("4ZmzZ").then(()=>parcelRequire('6mNEk'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("djYcq", function(module, exports) {

var $kyKWe = parcelRequire("kyKWe");


var $ks2lK = parcelRequire("ks2lK");


var $d925B = parcelRequire("d925B");


var $cyZvy = parcelRequire("cyZvy");

const $ea625f5574c5221d$export$bd9824d426074790 = (api)=>(payload)=>{
        return api?.attachAnalyticsEvent(payload);
    };


const $5899ae1a7b0c1755$export$cb5777189008ecf = (metadata, existingConflicts)=>{
    if (!metadata) return undefined;
    switch(metadata.type){
        // Navigate between conflicts using arrows - doesn't modify conflicts
        case 'navigate':
        // Enter/exit conflict resolution mode - doesn't modify conflicts
        case 'startResolving':
        case 'stopResolving':
            return existingConflicts;
        // Receive new conflicts from server after reconnection
        case 'update':
            return {
                inserted: metadata.data.inserted.map((c)=>({
                        ...c,
                        id: (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))()
                    })),
                deleted: metadata.data.deleted.map((c)=>({
                        ...c,
                        id: (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))()
                    }))
            };
        // User accepts/dismisses a single conflict (removes it from the list)
        case 'resolve':
        // User chooses to keep deleted text (restores it, then removes conflict from the list)
        case 'restore':
            if (!existingConflicts) return existingConflicts;
            return {
                inserted: existingConflicts.inserted.filter((conflict)=>conflict.id !== metadata.data.id),
                deleted: existingConflicts.deleted.filter((conflict)=>conflict.id !== metadata.data.id)
            };
        // User accepts all conflicts at once (clears the entire list)
        case 'resolveAll':
            return {
                inserted: [],
                deleted: []
            };
        default:
            return undefined;
    }
};
const $5899ae1a7b0c1755$export$6804620b9d3be6a7 = (conflicts, selected, direction)=>{
    const allConflicts = [
        ...conflicts?.inserted ?? [],
        ...conflicts?.deleted ?? []
    ].sort((a, b)=>a.from - b.from);
    if (!selected) return {
        isAbleToNavigate: true,
        newConflict: allConflicts.length > 0 ? allConflicts[0] : undefined
    };
    const idx = allConflicts.findIndex((c)=>c.id === selected.id);
    if (direction === 'next') {
        const isAbleToNavigate = idx < allConflicts.length - 1;
        return {
            isAbleToNavigate: isAbleToNavigate,
            newConflict: isAbleToNavigate ? allConflicts[idx + 1] : undefined
        };
    } else {
        const isAbleToNavigate = idx > 0;
        return {
            isAbleToNavigate: isAbleToNavigate,
            newConflict: isAbleToNavigate ? allConflicts[idx - 1] : undefined
        };
    }
};
const $5899ae1a7b0c1755$var$addTypeToConflict = (conflict, conflicts)=>{
    const type = conflicts.deleted.find((c)=>c.id === conflict.id) ? 'deleted' : 'inserted';
    return {
        ...conflict,
        type: type
    };
};
const $5899ae1a7b0c1755$var$navigateToSelection = (meta, tr, conflicts)=>{
    const { isAbleToNavigate: isAbleToNavigate, newConflict: newConflict } = $5899ae1a7b0c1755$export$6804620b9d3be6a7(conflicts, meta.data, meta.direction);
    if (isAbleToNavigate && newConflict) return tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, newConflict.from, newConflict.to)).setMeta('nextConflict', $5899ae1a7b0c1755$var$addTypeToConflict(newConflict, conflicts)).scrollIntoView();
    else return null;
};
const $5899ae1a7b0c1755$export$995f88ef5b52af82 = (currentConflict, tr, conflicts)=>{
    return $5899ae1a7b0c1755$var$navigateToSelection({
        type: 'navigate',
        direction: 'next',
        data: currentConflict
    }, tr, conflicts) ?? $5899ae1a7b0c1755$var$navigateToSelection({
        type: 'navigate',
        direction: 'previous',
        data: currentConflict
    }, tr, conflicts);
};
const $5899ae1a7b0c1755$export$f8685c902e685023 = (editorView, meta, options)=>{
    const { dispatch: dispatch, state: { tr: tr } } = editorView;
    if (meta.type === 'navigate') {
        const pluginState = (0, $cyZvy.conflictResolutionPluginKey).getState(editorView.state);
        if (pluginState?.conflicts) $5899ae1a7b0c1755$var$navigateToSelection(meta, tr, pluginState?.conflicts);
    } else if (meta.type === 'restore') tr.replace(meta.data.from, meta.data.to, meta.data.local);
    else if (meta.type === 'update') (0, $ea625f5574c5221d$export$bd9824d426074790)(options?.api?.analytics?.actions)({
        actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
        attributes: {
            inserted: meta.data.inserted.length,
            deleted: meta.data.deleted.length
        },
        eventType: (0, $d925B.EVENT_TYPE).TRACK,
        action: 'offlineReconnectionConflict'
    })?.(tr);
    else if (meta.type === 'resolve') {
        const pluginState = (0, $cyZvy.conflictResolutionPluginKey).getState(editorView.state);
        if (pluginState?.conflicts) $5899ae1a7b0c1755$export$995f88ef5b52af82(meta.data, tr, pluginState?.conflicts);
    }
    dispatch(tr.setMeta((0, $cyZvy.conflictResolutionPluginKey), meta));
};
module.exports["getNewConflicts"] = $5899ae1a7b0c1755$export$cb5777189008ecf;
module.exports["getNavigationInfo"] = $5899ae1a7b0c1755$export$6804620b9d3be6a7;
module.exports["navigateToAvailable"] = $5899ae1a7b0c1755$export$995f88ef5b52af82;
module.exports["setMetadata"] = $5899ae1a7b0c1755$export$f8685c902e685023;

});

parcelRegister("fEcUb", function(module, exports) {

let $b6449a1e86f5b759$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b6449a1e86f5b759$var$load("4LYSa").then(()=>parcelRequire('50nRh'));

});

parcelRegister("cyZvy", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");

const $6a5fd4c39fa17a5b$export$f4d7eeb0b3cec670 = new (0, $ks2lK.PluginKey)('conflictResolutionPluginKey');
module.exports["conflictResolutionPluginKey"] = $6a5fd4c39fa17a5b$export$f4d7eeb0b3cec670;

});


//# sourceMappingURL=FullPageEditorComponent.4fbe2bb3.js.map
